webpackJsonp([1],{

/***/ "+37F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+4CL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'checkbox-group-modal',

  data: function data() {
    return {
      showModal: false,
      groups: {}
    };
  },
  created: function created() {
    var that = this;
    this.$on('showModal', function (fieldData) {
      that.showModal = true;
      that.groups = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(that.$store.getters.chGroupFields()));
    });
  },


  methods: {
    closeModal: function closeModal() {
      this.showModal = false;
    },
    editGroup: function editGroup(index) {
      this.$bus.emit('checkboxGroupEditModal', index);
      this.showModal = false;
    },
    deleteGroup: function deleteGroup(groupId) {
      var _this = this;

      window.swal({
        title: 'Delete Checkbox Group?',
        text: 'You are about to delete this checkbox group. This action cannot be undone. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (deleted) {
        if (deleted) {
          _this.$store.commit('removeCheckboxGroup', groupId);
          _this.$store.dispatch('saveTemplate');
          var groupsExist = _this.groups;
          delete groupsExist[groupId];
          _this.groups = {};
          _this.groups = groupsExist;
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.groups).length === 0) _this.showModal = false;
          _this.$bus.emit('reloadQuestionnaire');
        }
      });
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$off('showModal');
  }
});

/***/ }),

/***/ "+8cd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormTextarea_vue__ = __webpack_require__("j0cY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03f84b30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormTextarea_vue__ = __webpack_require__("4VaK");
function injectStyle (ssrContext) {
  __webpack_require__("QbSV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03f84b30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormTextarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03f84b30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormTextarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/3Id":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSelect_vue__ = __webpack_require__("sgTc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_728356cb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSelect_vue__ = __webpack_require__("fPTq");
function injectStyle (ssrContext) {
  __webpack_require__("Ndnm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-728356cb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_728356cb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/D84":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget widget-checkbox",attrs:{"data-field":_vm.fieldName,"id":_vm.fieldName}},[_c('input',{class:[_vm.autoWidth ? 'auto-width' : '', _vm.readOnly ? 'readOnly' : ''],attrs:{"type":"checkbox","disabled":!_vm.editable},domProps:{"checked":_vm.value},on:{"change":_vm.onChange}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/FMC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container",style:(_vm.setStyleGlobal)},[_c('div',{staticClass:"modal-header"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",function(){return [_vm._v("\n            Body\n          ")]})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_vm._v("\n            Footer\n          ")]})],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/IWr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RestoreInlineHelpModal_vue__ = __webpack_require__("lPIg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08ec2a81_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RestoreInlineHelpModal_vue__ = __webpack_require__("WKKH");
function injectStyle (ssrContext) {
  __webpack_require__("yT+8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08ec2a81"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RestoreInlineHelpModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08ec2a81_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RestoreInlineHelpModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/Ygi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TooltipIcons_vue__ = __webpack_require__("JZT4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cda0c9da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TooltipIcons_vue__ = __webpack_require__("gsLd");
function injectStyle (ssrContext) {
  __webpack_require__("j9NX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cda0c9da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TooltipIcons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cda0c9da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TooltipIcons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/fB9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/i/V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-login"},[_c('div',{staticClass:"img-login"}),_vm._v(" "),_c('div',{staticClass:"form p-3"},[_vm._m(0),_vm._v(" "),(_vm.alertUserIncorrect)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_c('i',{staticClass:"fas fa-exclamation-circle"}),_vm._v(" The password or email you entered is incorrect\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"email","required":"","placeholder":"Email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),(_vm.alertEmail)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_c('i',{staticClass:"fas fa-exclamation-circle"}),_vm._v(" Email is requerid\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-group input-group-sm mt-3"},[_vm._m(2),_vm._v(" "),((_vm.showPassword ? 'text' : 'password')==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"placeholder":"Password","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.password)?_vm._i(_vm.password,null)>-1:(_vm.password)},on:{"change":function($event){var $$a=_vm.password,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.password=$$a.concat([$$v]))}else{$$i>-1&&(_vm.password=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.password=$$c}}}}):((_vm.showPassword ? 'text' : 'password')==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"placeholder":"Password","type":"radio"},domProps:{"checked":_vm._q(_vm.password,null)},on:{"change":function($event){_vm.password=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"placeholder":"Password","type":_vm.showPassword ? 'text' : 'password'},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"input-group-text btn",attrs:{"type":"button"},on:{"click":function($event){_vm.showPassword = !_vm.showPassword}}},[(!_vm.showPassword)?_c('i',{staticClass:"fas fa-eye"}):_c('i',{staticClass:"fas fa-eye-slash"})])])]),_vm._v(" "),(_vm.alertPassword)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_c('i',{staticClass:"fas fa-exclamation-circle"}),_vm._v(" Password is requerid\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mt-3"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.initLogin}},[_vm._v("\n        Login\n      ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center mb-4"},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("ZzGP"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fas fa-envelope"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fas fa-lock"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/lDL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.hideStyle),attrs:{"id":"menuContainer"}},[_c('div',{attrs:{"id":"toolboxGrabber"},on:{"click":_vm.toggleShowAnnotationMenu}},[(_vm.$store.state.showAnnotationMenu)?_c('i',{staticClass:"fas fa-angle-double-right"}):_c('i',{staticClass:"fas fa-angle-double-left"})]),_vm._v(" "),_c('div',{attrs:{"id":"backgroundWrapper"}},[_c('hr'),_vm._v(" "),_c('div',{attrs:{"id":"templateSettings"}},[_c('h4',[_vm._v("Templates")]),_vm._v(" "),_c('label',{attrs:{"for":"currentTemplate"}},[_vm._v("Current Template:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentTemplateName),expression:"currentTemplateName"}],staticClass:"form-control form-control-sm",attrs:{"id":"currentTemplate"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentTemplateName=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changeTemplate]}},_vm._l((_vm.$store.state.templates),function(template,index){return _c('option',{key:index},[_vm._v("\n          "+_vm._s(template.name)+"\n        ")])}),0),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-light btn-sm btn-block",on:{"click":_vm.showTemplateEditorDialog}},[_vm._v("Template Editor")]),_vm._v(" "),_c('button',{staticClass:"btn btn-light btn-sm btn-block",on:{"click":_vm.showTemplateDuplicateDialog}},[_vm._v("Duplicate Template")]),_vm._v(" "),_c('button',{staticClass:"btn btn-light btn-sm btn-block",on:{"click":_vm.showTemplateAddDialog}},[_vm._v("Add Empty Template")]),_vm._v(" "),_c('button',{staticClass:"btn btn-light btn-sm btn-block",on:{"click":_vm.showTemplateDeleteDialog}},[_vm._v("Delete Template")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/vRh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupEditModal_vue__ = __webpack_require__("sQFY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d1cf946_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupEditModal_vue__ = __webpack_require__("41iR");
function injectStyle (ssrContext) {
  __webpack_require__("R4UY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9d1cf946"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupEditModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d1cf946_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupEditModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "02Rq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox-group-edit-modal"},[_c('div',{staticClass:"modalHeader",staticStyle:{"border-radius":"9px 9px 0px 0px !important"}},[_c('span',{staticClass:"title"},[_vm._v("Manage Widgets")]),_vm._v(" "),_c('span',{staticClass:"btn-close float-right",on:{"click":function($event){return _vm.$emit('close')}}},[_c('i',{staticClass:"fas fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"modalBody"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('search-select',{attrs:{"options":_vm.widgets},on:{"input":_vm.changeWidget},model:{value:(_vm.currentWidget),callback:function ($$v) {_vm.currentWidget=$$v},expression:"currentWidget"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.widgetLabel),expression:"widgetLabel"}],staticClass:"form-control",domProps:{"value":(_vm.widgetLabel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.widgetLabel=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"float-right"},[(_vm.currentWidget !== null)?_c('button',{staticClass:"btn btn-success",on:{"click":_vm.setWidgetData}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Close")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"font14"},[_c('b',[_vm._v("Widget:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"font14"},[_c('b',[_vm._v("Widget Label:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0pNo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "11aq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_vm._v("Loading...")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1Ldq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_editor_inputs_FormSlider__ = __webpack_require__("u6cj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_editor_modals_RestoredFieldsModal__ = __webpack_require__("A2cF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_editor_main_TooltipIcons__ = __webpack_require__("/Ygi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_editor_modals_BarcodeTemplateModal_vue__ = __webpack_require__("MSAx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_editor_modals_GlobalModal_vue__ = __webpack_require__("ROUp");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'menu-top',

  components: {
    FormSlider: __WEBPACK_IMPORTED_MODULE_3__components_editor_inputs_FormSlider__["a" /* default */],
    RestoredFieldsModal: __WEBPACK_IMPORTED_MODULE_4__components_editor_modals_RestoredFieldsModal__["a" /* default */],
    TooltipIcons: __WEBPACK_IMPORTED_MODULE_5__components_editor_main_TooltipIcons__["a" /* default */],
    BarcodeTemplateModal: __WEBPACK_IMPORTED_MODULE_6__components_editor_modals_BarcodeTemplateModal_vue__["a" /* default */],
    GlobalModal: __WEBPACK_IMPORTED_MODULE_7__components_editor_modals_GlobalModal_vue__["a" /* default */]
  },

  data: function data() {
    return {
      scale: '1',
      lastSaved: '',
      currentTemplateName: '',
      modelDisplay: false,
      idDisplay: false,
      tooltipReturnList: false,
      descriptionReturnList: 'Return To Form List',
      leftIconReturnList: 0,
      tooltipShowHide: false,
      descriptionShowHide: 'Tab Indexes or Inputs',
      leftIconShowHide: 0,
      tooltipDragIndex: false,
      descriptionDragIndex: 'Drag Index',
      leftIconDragIndex: 0,
      tooltipResetTabIndexes: false,
      descriptionResetTabIndexes: 'Reset Tab Indexes',
      leftIconResetTabIndexes: 0,
      tooltipCreateField: false,
      descriptionCreateField: 'Create Field',
      leftIconCreateField: 0,
      tooltipSaveTemplate: false,
      descriptionSaveTemplate: 'Save Template Data',
      leftIconSaveTemplate: 0,
      tooltipMultipleSelect: false,
      descriptionMultipleSelect: 'Multiple Select',
      leftIconMultipleSelect: 0,
      tooltipImportModels: false,
      descriptionImportModels: 'Import Models',
      leftIconImportModels: 0,
      tooltipImportAllTranslations: false,
      descriptionImportAllTranslations: 'Import All Translations From Model',
      leftIconImportAllTranslations: 0,
      tooltipRestoreFields: false,
      descriptionRestoreFields: 'Restore Fields',
      leftIconRestoreFields: 0,
      tooltipHighlighter: false,
      descriptionHighlighter: 'Models or Id Fields',
      leftIconHighlighter: 0,
      tooltipBarcodeTemplate: false,
      descriptionBarcodeTemplate: 'Barcode template',
      leftIconBarcodeTemplate: 0,
      tooltipMergeData: false,
      descriptionMergeData: 'Import Data',
      leftIconMergeData: 0,
      tooltipZoom: false,
      descriptionZoom: 'Zoom',
      leftIconZoom: 0,

      isBarcode: false,
      isModal: false,
      isDisableBtnMerge: false,

      newFields: [],
      oldFields: [],
      vPropFields: [],
      isMessageNoMatchForm: false
    };
  },
  mounted: function mounted() {
    this.$bus.on('saveAll', this.calculateLastSaved);
    setInterval(this.calculateLastSaved, 10000);
    this.$store.commit('setLastSaved', Date.now());
    this.calculateLastSaved();
    this.currentTemplateName = this.$store.state.currentTemplateName;
    var that = this;
    this.$bus.on('setCurrentTemplateName', function (templateName) {
      that.currentTemplateName = templateName;
    });

    this.leftIconReturnList = document.getElementById('iconReturnList').offsetLeft;
    this.leftIconShowHide = document.getElementById('iconShowHide').offsetLeft;
    if (document.getElementById('iconDisableDragIndex') != null) this.leftIconDragIndex = document.getElementById('iconDisableDragIndex').offsetLeft;
    if (document.getElementById('iconEnableDragIndex') != null) this.leftIconDragIndex = document.getElementById('iconEnableDragIndex').offsetLeft;
    this.leftIconResetTabIndexes = document.getElementById('iconResetTabIndexes').offsetLeft;
    this.leftIconCreateField = document.getElementById('iconCreateField').offsetLeft;
    this.leftIconSaveTemplate = document.getElementById('iconSaveTemplate').offsetLeft;
    if (document.getElementById('iconDisableMS') != null) this.leftIconMultipleSelect = document.getElementById('iconDisableMS').offsetLeft;
    if (document.getElementById('iconEnableMS') != null) this.leftIconMultipleSelect = document.getElementById('iconEnableMS').offsetLeft;
    this.leftIconImportModels = document.getElementById('iconImportModels').offsetLeft;
    this.leftIconImportAllTranslations = document.getElementById('iconImportAllTranslations').offsetLeft;
    this.leftIconRestoreFields = document.getElementById('iconRestoreFields').offsetLeft;
    this.leftIconHighlighter = document.getElementById('iconHighlighter').offsetLeft;
    this.leftIconBarcodeTemplate = document.getElementById('iconBarcodeTemplate').offsetLeft;
    this.leftIconMergeData = document.getElementById('iconMergeData').offsetLeft;
    this.leftIconZoom = document.getElementById('iconZoom').offsetLeft;
  },


  methods: {
    goToList: function goToList() {
      this.$bus.emit('showList');
    },
    toggleModelDisplay: function toggleModelDisplay() {
      this.modelDisplay = !this.modelDisplay;
      this.$bus.emit('toggleModelDisplay', this.modelDisplay);
    },
    toggleIdDisplay: function toggleIdDisplay() {
      this.idDisplay = !this.idDisplay;
      this.$bus.emit('toggleIdDisplay', this.idDisplay);
    },
    importAllTranslationModel: function importAllTranslationModel() {
      var _this = this;

      var newLabel = '';
      var newText = '';

      var apiUrl = this.$store.state.apiUrl;
      this.axios.get(apiUrl + 'model/list').then(function (response) {
        _this.$store.commit('setModels', response.data);
      });

      var dataFields = this.$store.getters.getAllModels();

      if (dataFields.length === 0) return;

      dataFields.forEach(function (field) {
        var foundModel = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this.$store.getters.searchModels(field.model)));
        if (typeof foundModel._id === 'undefined') return;
        if (typeof foundModel.label === 'undefined' || !foundModel.label.length) {
          newLabel = field.name;
          newText = field.name;
        } else {
          newLabel = foundModel.label;
          newText = foundModel.desc;
        }

        var templateField = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this.$store.getters.currentTemplateField(field.name)));
        if (templateField.questionHelp && templateField.questionHelp !== undefined && templateField.questionHelp !== null && templateField.questionHelp !== '') newText = templateField.questionHelp;

        var translation = {};
        translation.en = {
          label: newLabel,
          text: newText
        };
        _this.$store.commit('setTranslationForId', {
          translation: translation,
          field: field
        });
      });
      this.$store.dispatch('saveTemplatePages');
      this.$bus.emit('updateQuestionnaire');
      this.$bus.emit('setQuestionnairesFields');
    },


    importModels: function importModels() {
      document.getElementById('uploadModels').click();
    },

    handleModels: function handleModels() {
      var files = this.$refs.importedModels.files;

      if (files.length === 0) return false;

      var fr = new FileReader();
      fr.readAsText(files.item(0));

      var that = this;
      fr.onload = function (e) {
        var models = JSON.parse(e.target.result);
        if (models.length === 0) return;

        that.deleteOldAutofillDetails(models);
      };
    },
    deleteOldAutofillDetails: function deleteOldAutofillDetails(models) {
      var _this2 = this;

      var state = this.$store.state;

      this.$store.dispatch('deleteAutofillDetails', {
        autofillId: state.autofillId,
        templateId: state.templates[this.$store.state.currentTemplateName]._id
      }).then(function (response) {
        if (response.data.success === true) {
          _this2.$store.dispatch('getAutofillDetails', _this2.$store.state.autofillId).then(function () {
            _this2.getAutofillDetailsValue(models);
          });
        }
      });
    },
    getAutofillDetailsValue: function getAutofillDetailsValue(models) {
      var _this3 = this;

      var autofillDetailsValue = this.$store.state.autofillDetails.filter(function (a) {
        return a.value !== '';
      });

      autofillDetailsValue.forEach(function (autofillDetailValue) {
        if (models.map(function (a) {
          return a.pdf_field;
        }).indexOf(autofillDetailValue.pdfField) !== -1) {
          _this3.deleteOneAutofillDetail(autofillDetailValue);
        }
      });

      this.saveModelAutofillDetail(models);
    },
    deleteOneAutofillDetail: function deleteOneAutofillDetail(autofillDetail) {
      this.$store.dispatch('deleteAutofillDetail', {
        autofillDetailId: autofillDetail._id
      }).then(function (response) {
        return response;
      });
    },
    saveModelAutofillDetail: function saveModelAutofillDetail(models) {
      var _this4 = this;

      var arrayAutofillDetails = [];
      var state = this.$store.state;

      var templatePages = state.templates[state.currentTemplateName]['pages'];
      var questionnaireFields = state.questionnaires[state.currentTemplateName]['data'];

      models.forEach(function (model, indexModel) {
        var modelReplace = model.pdf_field.replace(/\./g, '_');

        var autofillDetail = {
          autofillId: _this4.$store.state.autofillId,
          templateId: _this4.$store.state.templates[_this4.$store.state.currentTemplateName]._id,
          value: '',
          createdAt: new Date(),
          updatedAt: new Date()

          // COMPARE TEMPLATE

        };__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(templatePages).forEach(function (pageId) {
          if (templatePages[pageId] === null) return;

          if (templatePages[pageId].map(function (a) {
            return a.id;
          }).indexOf(modelReplace) !== -1) {
            autofillDetail.fieldType = templatePages[pageId][templatePages[pageId].map(function (a) {
              return a.id;
            }).indexOf(modelReplace)].type;
          }
        });

        // COMPARE AUTOFILL DETAILS LIST

        autofillDetail.pdfField = model.pdf_field;
        autofillDetail.model = model.model;

        arrayAutofillDetails.push(autofillDetail);

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(questionnaireFields).forEach(function (fieldId) {
          if (questionnaireFields[fieldId].fieldName === modelReplace) {
            questionnaireFields[fieldId].model = model.model;
          }
        });

        // INSERT MANY AUTOFILLDETAILS

        if (indexModel + 1 === models.length) {
          _this4.$store.dispatch('addAutofillDetail', arrayAutofillDetails).then(function (response) {
            if (response.data.success === true) {
              _this4.refreshAutofillModels();

              _this4.$store.commit('setQuestionnaireFields', questionnaireFields);
              _this4.$bus.emit('updateQuestionnaire');
            } else {
              window.vueBus.emit('addNotification', {
                title: 'Import models',
                body: 'No import models.',
                type: 'error'
              });
            }
          });
        }
      });
    },
    refreshAutofillModels: function refreshAutofillModels() {
      var _this5 = this;

      this.$bus.emit('hideEditorFields');
      this.$store.dispatch('getAutofillDetails', this.$store.state.autofillId).then(function () {
        _this5.$store.commit('setModelsAutofillDetails');

        _this5.$bus.emit('hidePageFields');

        window.vueBus.emit('addNotification', {
          title: 'Import models',
          body: 'Succesfully.!',
          type: 'success'
        });
      });
    },


    restoreFieldsDataJson: function restoreFieldsDataJson() {
      document.getElementById('uploadDataFields').click();
    },

    handleDataFields: function handleDataFields() {
      var files = this.$refs.importedDataFields.files;

      if (files.length === 0) return false;

      var fr = new FileReader();
      fr.readAsText(files.item(0));

      var that = this;
      fr.onload = function (e) {
        var objectFile = JSON.parse(e.target.result);
        var fileName = objectFile.filename.split('.')[0];

        var formName = that.$store.state.outputPath.split('/')[4];

        if (fileName === formName) {
          var nameFields = that.$store.getters.getAllFieldNamesFromTemplate();
          var pages = objectFile.pages;
          var templates = that.$store.state.templates;
          var restoredFields = [];

          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(pages).forEach(function (pageId) {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(pages[pageId].pageFields).forEach(function (fieldId) {
              if (nameFields.indexOf(fieldId) === -1) {
                var field = pages[pageId].pageFields[fieldId];

                var newData = {
                  fieldPage: pageId,
                  id: fieldId,
                  name: fieldId,
                  model: '',
                  value: '',
                  type: field.fieldType,
                  tabOrder: field.tabOrder,
                  x: field.x,
                  y: field.y,
                  width: field.width,
                  height: field.height,
                  maskType: '',
                  translations: {}
                };

                if (typeof field.choiceData !== 'undefined' && typeof field.choiceData === 'string') {
                  newData['choiceData'] = field.choiceData.slice(1, -1).split(',');
                }

                templates[that.$store.state.currentTemplateName].pages[pageId].push(newData);

                restoredFields.push(newData);
              }
            });
          });

          if (restoredFields.length > 0) {
            that.$store.commit('setTemplates', templates);
          }

          that.$bus.$emit('showRestoredFieldsModal', restoredFields);
          that.$store.dispatch('saveTemplatePages');
          that.$store.commit('setCurrentTemplateName', 'global');
          that.$store.commit('setCurrentTemplateName', 'default');
        } else {
          that.$bus.$emit('showRestoredFieldsModal', {
            isNotFileName: true
          });
        }
      };
    },


    mergeFieldsData: function mergeFieldsData() {
      document.getElementById('uploadDataMerge').click();
    },

    handleDataMerge: function handleDataMerge() {
      var files = this.$refs.importedDataMerge.files;

      if (files.length === 0) return false;

      var fr = new FileReader();
      fr.readAsText(files.item(0));

      var that = this;

      fr.onload = function (e) {
        var objectFile = JSON.parse(e.target.result);

        that.newFields = [];
        that.oldFields = [];
        that.vPropFields = [];

        that.compareChangesData({
          newData: objectFile
        });

        that.isModal = true;
        that.isDisableBtnMerge = false;
      };
    },
    addField: function addField() {
      this.$store.commit('addField');
      this.$bus.emit('hidePageFields');
      this.$store.dispatch('saveTemplate');
    },
    changeTemplate: function changeTemplate() {
      this.$store.commit('setCurrentTemplateName', this.currentTemplateName);
      this.$bus.emit('setCurrentTemplateName', this.currentTemplateName);
      var that = this;
      this.$store.dispatch('applyTemplate').then(function (result) {
        if (result) {
          that.$bus.emit('addNotification', {
            title: 'Applied Template',
            body: 'Template "' + that.currentTemplateName + '" applied successfully.',
            type: 'success'
          });
        } else {
          that.$bus.emit('addNotification', {
            title: 'Error Applying Template',
            body: 'An error occured while applying the template "' + that.currentTemplateName + '". Please review the data and try again.',
            type: 'error'
          });
        }
      });
    },
    toggleFieldEdit: function toggleFieldEdit() {
      if (this.$store.state.editingFields) {
        this.$store.commit('setShowAnnotationMenu', false);
        this.$store.commit('setDrawAnnotations', false);
        this.$store.commit('setShowBottomMenu', true);
        this.$store.commit('setFieldEditMode', false);
      } else {
        this.$store.commit('setShowAnnotationMenu', false);
        this.$store.commit('setDrawAnnotations', false);
        this.$store.commit('setShowBottomMenu', false);
        this.$bus.emit('hideControls');
        this.$store.commit('setFieldEditMode', true);
      }
    },
    calculateLastSaved: function calculateLastSaved() {
      this.lastSaved = window.moment(this.$store.state.lastSaved).fromNow();
    },
    saveData: function saveData() {
      this.$store.dispatch('saveTemplate');
    },
    toggleAssignIndexes: function toggleAssignIndexes() {
      this.$store.commit('toggleAssigningIndexes');
    },
    toggleDragIndex: function toggleDragIndex() {
      this.$store.commit('toggleDragIndex');
    },
    multipleSelect: function multipleSelect() {
      this.$store.commit('toggleMultipleSelect');
    },
    setScale: function setScale(val) {
      this.$bus.$emit('setPageScale', Number(val));
      this.$store.commit('setPageScale', Number(val));
    },
    toggleShowFields: function toggleShowFields() {
      this.$store.commit('toggleShowFields');
    },
    resetIndexes: function resetIndexes() {
      this.$bus.$emit('showDialog', {
        title: 'Reset All Tab Indexes?',
        desc: 'This action will erase all tab indexes on the current page. Do you want to continue?',
        confirmAction: 'resetTabOrders'
      });
    },
    compareChangesData: function compareChangesData(payload) {
      var _this6 = this;

      var oldData = this.$store.state.templates[this.$store.state.currentTemplateName];

      var existNewField = false;
      var existOldField = false;

      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(payload.newData.pages).length !== __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(oldData.pages).length) {
        this.isMessageNoMatchForm = true;

        return;
      }

      // FIND NEW FIELDS

      var _loop = function _loop(indexData) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(payload.newData.pages[indexData].pageFields).forEach(function (fieldKey) {
          var newPage = payload.newData.pages[indexData].pageFields;
          existNewField = false;

          if (oldData.pages[indexData].map(function (a) {
            return a.id;
          }).indexOf(fieldKey) !== -1) existNewField = true;

          if (existNewField === false) {
            newPage[fieldKey].fieldPage = indexData;

            _this6.newFields.push(newPage[fieldKey]);
          }
        });
      };

      for (var indexData = 1; indexData <= __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(oldData.pages).length; indexData++) {
        _loop(indexData);
      }

      // FIND OLD FIELDS
      console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(oldData.pages).length);

      var _loop2 = function _loop2(indexData) {
        oldData.pages[indexData].forEach(function (oldField) {
          existOldField = false;

          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(payload.newData.pages[indexData].pageFields).indexOf(oldField.id) !== -1) existOldField = true;

          // FIND CHANGE ON VIEW PROPERTIES

          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(payload.newData.pages[indexData].pageFields).forEach(function (newField) {
            if (oldField.id === newField.name) {
              if (oldField.x !== newField.x || oldField.y !== newField.y || oldField.height !== newField.height || oldField.width !== newField.width || oldField.type.toLowerCase() !== newField.fieldType.toLowerCase()) {
                newField.fieldPage = oldField.fieldPage;

                _this6.vPropFields.push(newField);
              }
            }
          });

          if (existOldField === false) _this6.oldFields.push(oldField);
        });
      };

      for (var indexData = 1; indexData <= __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(oldData.pages).length; indexData++) {
        _loop2(indexData);
      }
    },
    mergeData: function mergeData() {
      this.isDisableBtnMerge = true;

      var templates = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.$store.state.templates));

      var oldData = templates[this.$store.state.currentTemplateName];

      // MERGE NEW FIELDS

      this.newFields.forEach(function (newField) {
        var newData = {
          id: newField.name,
          name: newField.name,
          model: '',
          value: '',
          fieldPage: newField.fieldPage,
          type: newField.fieldType.toLowerCase(),
          tabOrder: newField.tabOrder,
          x: newField.x,
          y: newField.y,
          width: newField.width,
          height: newField.height,
          maskType: '',
          translations: {
            en: {
              label: newField.name,
              text: newField.name
            }
          }
        };

        if (typeof newField.choiceData !== 'undefined' && typeof newField.choiceData === 'string') {
          newData['choiceData'] = newField.choiceData.slice(1, -1).split(',');
        }

        oldData.pages[newData.fieldPage].push(newData);
      });

      // DELETE OLD FIELDS

      this.oldFields.forEach(function (oldField) {
        oldData.pages[String(oldField.fieldPage)].forEach(function (field, indexField) {
          if (oldField.id === field.id) oldData.pages[oldField.fieldPage].splice(indexField, 1);
        });
      });

      // MERGE VIEW PROPERTIES

      this.vPropFields.forEach(function (vPropField) {
        oldData.pages[String(vPropField.fieldPage)].forEach(function (field, indexField) {
          if (vPropField.name === field.id) {
            field.x = vPropField.x;
            field.y = vPropField.y;
            field.height = vPropField.height;
            field.width = vPropField.width;
            field.type = vPropField.fieldType;
          }
        });
      });

      templates[this.$store.state.currentTemplateName] = oldData;

      this.$store.commit('setTemplates', templates);

      this.$store.dispatch('saveTemplatePages');

      this.isModal = false;

      this.$bus.emit('hidePageFields');

      this.deleteFieldsQuestionnaire();
    },
    deleteFieldsQuestionnaire: function deleteFieldsQuestionnaire() {
      var _this7 = this;

      var questionnaires = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.$store.state.questionnaires));

      var currentFieldsQuestionnaire = questionnaires[this.$store.state.currentTemplateName].data;

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(currentFieldsQuestionnaire).forEach(function (fieldQKey) {
        if (_this7.oldFields.map(function (a) {
          return a.id;
        }).indexOf(currentFieldsQuestionnaire[fieldQKey].fieldName) !== -1) {
          delete currentFieldsQuestionnaire[fieldQKey];
        }
      });

      questionnaires[this.$store.state.currentTemplateName].data = currentFieldsQuestionnaire;

      this.$store.commit('setQuestionnaires', questionnaires);

      this.$bus.emit('updateQuestionnaire');

      this.$bus.emit('reloadQuestionnaire');
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('saveAll');
    this.$bus.$off('setCurrentTemplateName');

    this.$store.commit('setAutofillDetails', null);
    this.$store.commit('setAutofillId', null);
  }
});

/***/ }),

/***/ "1Q+x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeTravel_vue__ = __webpack_require__("HBWY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_535a31e9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeTravel_vue__ = __webpack_require__("QB3H");
function injectStyle (ssrContext) {
  __webpack_require__("ArBU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-535a31e9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeTravel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_535a31e9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeTravel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1WlR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1d4R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'section-widget',

  props: {
    model: {
      type: String,
      default: ''
    },
    fieldIndex: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    initialValue: {
      type: String,
      required: true
    },
    subSection: {
      type: Boolean,
      default: false
    },
    inlineHelp: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      value: '',
      help: ''
    };
  },
  mounted: function mounted() {
    this.value = this.initialValue;
    this.help = this.inlineHelp;
  }
});

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "26Jz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'max-items-modal',

  data: function data() {
    return {
      maxRoleAddresses: 0,
      maxRolePreviousAddresses: 0,
      maxRolePhones: 0,
      maxRoleJobs: 0,
      maxRoleEducational: 0,
      maxRoleCriminal: 0,
      maxRoleWorkPermit: 0,
      maxRolePassports: 0,
      maxRoleTravel: 0,
      maxRoleUsEntries: 0,
      maxRoleVisa: 0,
      maxRoleMarriage: 0,
      maxRoleFamily: 0,
      maxRoleChild: 0,
      maxRoleSibling: 0,
      maxRoleFamilyOther: 0,
      maxRoleAdvance: 0
    };
  },


  props: {
    role: {
      type: String
    },

    formId: {
      type: String
    },

    maxItems: {
      type: Object
    }
  },

  created: function created() {
    this.getMaxItemsRole();
  },


  methods: {
    getMaxItemsRole: function getMaxItemsRole() {
      if (this.maxItems !== undefined) {
        this.maxRoleAddresses = this.maxItems.address !== null && this.maxItems.address !== undefined ? this.maxItems.address : 0;
        this.maxRolePreviousAddresses = this.maxItems.previousAddress !== null && this.maxItems.previousAddress !== undefined ? this.maxItems.previousAddress : 0;
        this.maxRolePhones = this.maxItems.phones !== null && this.maxItems.phones !== undefined ? this.maxItems.phones : 0;
        this.maxRoleJobs = this.maxItems.jobs !== null && this.maxItems.jobs !== undefined ? this.maxItems.jobs : 0;
        this.maxRoleEducational = this.maxItems.educationalHistory !== null && this.maxItems.educationalHistory !== undefined ? this.maxItems.educationalHistory : 0;
        this.maxRoleCriminal = this.maxItems.criminalHistory !== null && this.maxItems.criminalHistory !== undefined ? this.maxItems.criminalHistory : 0;
        this.maxRoleWorkPermit = this.maxItems.ead !== null && this.maxItems.ead !== undefined ? this.maxItems.ead : 0;
        this.maxRolePassports = this.maxItems.passports !== null && this.maxItems.passports !== undefined ? this.maxItems.passports : 0;
        this.maxRoleTravel = this.maxItems.travelHistory !== null && this.maxItems.travelHistory !== undefined ? this.maxItems.travelHistory : 0;
        this.maxRoleUsEntries = this.maxItems.usEntries !== null && this.maxItems.usEntries !== undefined ? this.maxItems.usEntries : 0;
        this.maxRoleVisa = this.maxItems.visaHistory !== null && this.maxItems.visaHistory !== undefined ? this.maxItems.visaHistory : 0;
        this.maxRoleMarriage = this.maxItems.marriageHistory !== null && this.maxItems.marriageHistory !== undefined ? this.maxItems.marriageHistory : 0;
        this.maxRoleFamily = this.maxItems.familyMembers !== null && this.maxItems.familyMembers !== undefined ? this.maxItems.familyMembers : 0;
        this.maxRoleChild = this.maxItems.familyChild !== null && this.maxItems.familyChild !== undefined ? this.maxItems.familyChild : 0;
        this.maxRoleSibling = this.maxItems.familySibling !== null && this.maxItems.familySibling !== undefined ? this.maxItems.familySibling : 0;
        this.maxRoleFamilyOther = this.maxItems.familyOther !== null && this.maxItems.familyOther !== undefined ? this.maxItems.familyOther : 0;
        this.maxRoleAdvance = this.maxItems.advanceParole !== null && this.maxItems.advanceParole !== undefined ? this.maxItems.advanceParole : 0;
      }
    },
    saveMaxItemsRole: function saveMaxItemsRole() {
      var _this = this;

      var formMaxItemsRole = {};

      formMaxItemsRole[this.role] = {
        address: Number(this.maxRoleAddresses),
        previousAddress: Number(this.maxRolePreviousAddresses),
        phones: Number(this.maxRolePhones),
        jobs: Number(this.maxRoleJobs),
        educationalHistory: Number(this.maxRoleEducational),
        criminalHistory: Number(this.maxRoleCriminal),
        ead: Number(this.maxRoleWorkPermit),
        passports: Number(this.maxRolePassports),
        travelHistory: Number(this.maxRoleTravel),
        usEntries: Number(this.maxRoleUsEntries),
        visaHistory: Number(this.maxRoleVisa),
        marriageHistory: Number(this.maxRoleMarriage),
        familyMembers: Number(this.maxRoleFamily),
        familyChild: Number(this.maxRoleChild),
        familySibling: Number(this.maxRoleSibling),
        familyOther: Number(this.maxRoleFamilyOther),
        advanceParole: Number(this.maxRoleAdvance)
      };

      if (this.formId !== undefined) {
        var formData = {
          formId: this.formId,
          newData: formMaxItemsRole
        };

        var apiUrl = this.$store.state.apiUrl;

        this.axios.post(apiUrl + 'form/update-item', __WEBPACK_IMPORTED_MODULE_0_qs___default.a.parse(formData)).then(function (response) {
          if (response.data.success) {
            _this.$bus.emit('addNotification', {
              title: 'Form Updated',
              body: 'The form was updated successfully.',
              type: 'success'
            });

            _this.$emit('update-maxitems', formData.newData[_this.role]);

            _this.$emit('close');
          } else {
            _this.$bus.emit('addNotification', {
              title: 'Update Error',
              body: 'There was an error updating this form. Please check the data and try again.',
              type: 'success'
            });
          }
        });
      } else {
        this.$emit('update-maxitems', formMaxItemsRole[this.role]);

        this.$emit('close');
      }
    }
  }
});

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3DBJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Fre":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetGroup_vue__ = __webpack_require__("6esR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f6f816f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetGroup_vue__ = __webpack_require__("f+sn");
function injectStyle (ssrContext) {
  __webpack_require__("bq6u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f6f816f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f6f816f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3H5q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComboWidget_vue__ = __webpack_require__("8N8L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65fac084_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComboWidget_vue__ = __webpack_require__("bASS");
function injectStyle (ssrContext) {
  __webpack_require__("otfv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65fac084"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComboWidget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65fac084_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComboWidget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Kon":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormText_vue__ = __webpack_require__("D0T5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b41650_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormText_vue__ = __webpack_require__("oJS0");
function injectStyle (ssrContext) {
  __webpack_require__("dXps")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60b41650"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b41650_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "41iR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModal)?_c('div',{staticClass:"edit-modal"},[_c('div',{staticClass:"modalHeader"},[_c('span',{staticClass:"title"},[_vm._v("Create / Edit")]),_vm._v(" "),_c('span',{staticClass:"btn-close float-right",on:{"click":_vm.closeModal}},[_c('i',{staticClass:"fas fa-times"})])]),_vm._v(" "),_c('center',[(Object.keys(_vm.dataWidget).length)?_c('h2',[_vm._v("Matched Models")]):_vm._e(),_vm._v(" "),_vm._l((_vm.matchedModels),function(field,key){return _c('div',{key:key},[_c('p',{staticClass:"mb-1"},[_vm._v(_vm._s(field.model))])])})],2),_vm._v(" "),_c('div',{staticClass:"modalBody"},[_c('div',{staticClass:"form-group"},[_vm._l((_vm.fields),function(field,fieldKey){return _c('div',{key:fieldKey,staticClass:"widget-input"},[_c('span',{staticClass:"widget-label"},[_vm._v(_vm._s(field.title))]),_vm._v(" "),(field.type === 'combobox')?_c('combo-widget',{key:fieldKey,attrs:{"fieldIndex":fieldKey.toString(),"initialValue":field.newValue.length ? field.newValue : field.originalValue,"editable":field.editable,"fieldName":field.fieldName,"options":field.values}}):(field.type === 'text')?_c('text-widget',{key:fieldKey,attrs:{"fieldIndex":fieldKey.toString(),"initialValue":field.newValue.length ? field.newValue : field.originalValue,"fieldName":field.fieldName,"editable":field.editable}}):(field.type === 'checkbox')?_c('checkbox-widget',{key:fieldKey,attrs:{"fieldIndex":fieldKey.toString(),"initialValue":field.newValue.length ? field.newValue : field.originalValue,"fieldName":field.fieldName,"editable":field.editable}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-subtext"},[_vm._v(_vm._s(field.desc))])],1)}),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msgWidget),expression:"msgWidget"}],staticClass:"form-control form-control-sm",attrs:{"placeholder":"Message from Widget","type":"text","id":"msgForWidget"},domProps:{"value":(_vm.msgWidget)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msgWidget=$event.target.value}}})])],2),_vm._v(" "),_c('div',{staticClass:"button-box float-right"},[_c('button',{staticClass:"btn btn-success",on:{"click":_vm.saveEdit}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.closeModal}},[_vm._v("Cancel")])])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4VaK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-textarea",style:(_vm.style)},[(_vm.$store.state.assigningIndexes)?_c('span',{staticClass:"tab-index",style:(_vm.tabOrderStyle),on:{"click":_vm.inputClick}},[_vm._v("\n    "+_vm._s((_vm.$store.getters.templateTabOrder(_vm.id) > -1) ? _vm.$store.getters.templateTabOrder(_vm.id) : '?')+"\n  ")]):_vm._e(),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"tabindex":_vm.$store.getters.templateTabOrder(_vm.id),"id":_vm.id,"data-model":_vm.model},domProps:{"value":(_vm.value)},on:{"focus":_vm.focusInput,"blur":_vm.noFocus,"contextmenu":_vm.inputClick,"keyup":_vm.showAutocompleteModel,"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4Vh3":
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "5U2H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5VAr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditModal_vue__ = __webpack_require__("SPw3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79967180_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditModal_vue__ = __webpack_require__("t0mM");
function injectStyle (ssrContext) {
  __webpack_require__("xlOv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79967180"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79967180_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5hDI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'text-widget',

  props: {
    fieldIndex: {
      type: String,
      required: true
    },
    initialValue: {
      type: String,
      required: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    autoWidth: {
      type: Boolean,
      default: false
    },
    model: {
      type: String,
      default: ''
    },
    fieldName: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      value: '',
      keyUpTimeout: null
    };
  },
  mounted: function mounted() {
    this.value = this.initialValue;
    var that = this;
    this.$on('setValue', function (val) {
      that.value = val;
    });
  },


  methods: {
    onChange: function onChange(e) {
      if (this.readOnly || !this.editable) return;
      if (this.keyUpTimeout !== null) window.clearTimeout(this.keyUpTimeout);
      this.keyUpTimeout = window.setTimeout(this.emitChange, 500);
    },
    emitChange: function emitChange(e) {
      window.clearTimeout(this.keyUpTimeout);
      this.keyUpTimeout = null;
      this.$parent.$emit('widgetChanged', { index: this.fieldIndex, value: this.value });
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$off('setValue');
  }
});

/***/ }),

/***/ "5qvI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "6WJd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6ZSt":
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ "6dB7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-dialog',

  mounted: function mounted() {
    var that = this;
    this.$bus.on('showDialog', function (data) {
      that.title = data.title;
      that.desc = data.desc;
      if (typeof data.confirmAction !== 'undefined') that.confirmAction = data.confirmAction;
      if (typeof data.cancelAction !== 'undefined') that.cancelAction = data.cancelAction;
      that.showDialog = true;
    });
  },


  methods: {
    confirm: function confirm() {
      if (this.confirmAction.length) this.$bus.emit(this.confirmAction);
      this.showDialog = false;
    },
    cancel: function cancel() {
      if (this.cancelAction.length) this.$bus.emit(this.cancelAction);
      this.showDialog = false;
    }
  },

  data: function data() {
    return {
      title: 'Modal Title',
      desc: 'The description of the modal',
      confirmAction: '',
      cancelAction: '',
      confirmText: 'Confirm',
      cancelText: 'Cancel',
      showDialog: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('showDialog');
  }
});

/***/ }),

/***/ "6esR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_questionnaires_widget_group_GroupEditModal__ = __webpack_require__("/vRh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_questionnaires_widgets_ComboWidget__ = __webpack_require__("3H5q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_questionnaires_widgets_TextWidget__ = __webpack_require__("wjq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_questionnaires_widgets_CheckboxWidget__ = __webpack_require__("Jgco");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'widget-group',

  components: {
    GroupEditModal: __WEBPACK_IMPORTED_MODULE_5__components_questionnaires_widget_group_GroupEditModal__["a" /* default */],
    ComboWidget: __WEBPACK_IMPORTED_MODULE_6__components_questionnaires_widgets_ComboWidget__["a" /* default */],
    TextWidget: __WEBPACK_IMPORTED_MODULE_7__components_questionnaires_widgets_TextWidget__["a" /* default */],
    CheckboxWidget: __WEBPACK_IMPORTED_MODULE_8__components_questionnaires_widgets_CheckboxWidget__["a" /* default */]
  },

  data: function data() {
    return {
      tableView: true,
      columnPriorities: {},
      hiddenColumns: {},
      previousClientSize: -1,
      newRowObject: [],
      currentLowestPriority: 100,

      hotfixInterval: null,
      hotfixCount: 0,
      templateData: {},
      messageWidget: ''
    };
  },


  computed: {
    showHiddenMessage: function showHiddenMessage() {
      return this.tableView && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.hiddenColumns).length > 0;
    }
  },

  props: {
    fieldModel: {
      type: String
    },
    fieldIndex: {
      type: String,
      required: true
    },
    templateObject: {
      type: Object,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$store.state.widgets.forEach(function (widget, index) {
      _this.$store.state.widgets[index]['model'].forEach(function (model) {
        if (model === _this.fieldModel) {
          var widgetData = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this.$store.state.questionnaires[_this.$store.state.currentTemplateName]['properties']['widgetData']));
          __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(widgetData).forEach(function (widgetId) {
            if (widget.fieldName === widgetId) {
              _this.messageWidget = widgetData[widgetId].message;
            }
          });
        }
      });
    });
    if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.templateObject.newValue) === 'object' && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.templateObject.newValue).length) {
      this.templateData = this.templateObject.newValue;
    } else this.templateData = this.templateObject.originalValue;

    this.setupData();

    this.windowResized();
    window.addEventListener('resize', this.windowResized);

    var that = this;
    this.$on('widgetChanged', function (data) {
      that.widgetChanged(data);
    });

    this.$bus.on('msgWidget', function (dataWidget) {
      if (dataWidget.model === _this.fieldModel) that.messageWidget = dataWidget.message;
    });

    this.$on('saveEdit', function (data) {
      that.saveEdit(data);
    });
  },


  methods: {
    setupData: function setupData() {
      var _this2 = this;

      this.templateData.columns.forEach(function (column) {
        _this2.columnPriorities[column.priority] = column.fieldName;
      });

      var newFields = [];

      var _loop = function _loop(index) {
        var fieldObject = _this2.templateData.fields[index];
        var newFieldObject = [];
        _this2.templateData.columns.forEach(function (column) {
          fieldObject.forEach(function (field) {
            if (column.fieldName === field.fieldName) {
              field['type'] = column.type;
              field['values'] = column.values;
              field['title'] = column.title;
              field['desc'] = column.desc;
              newFieldObject.push(field);
            }
          });
        });
        newFields.push(newFieldObject);
      };

      for (var index = 0; index < this.templateData.fields.length; index++) {
        _loop(index);
      }

      if (newFields.length) {
        this.newRowObject = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(newFields[0]));
        this.newRowObject.forEach(function (field) {
          field.newValue = '';
          field.originalValue = '';
        });
      } else {
        var newRowObject = [];
        this.templateData.columns.forEach(function (column) {
          var newRow = {
            approved: false,
            deleted: false,
            desc: column.desc,
            editable: true,
            fieldName: column.fieldName,
            itemId: null,
            model: '',
            newValue: '',
            originalValue: '',
            state: 'OK',
            title: column.title,
            type: column.type,
            values: column.values
          };
          newRowObject.push(newRow);
        });
        this.newRowObject = newRowObject;
      }
      var temp = this.templateData;
      // window.Vue.set(temp, 'fields', newFields)
      this.templateData = temp;

      this.sortRows();
    },
    updateWidget: function updateWidget() {
      var _this3 = this;

      var apiUrl = this.$store.state.apiUrl;
      var requestData = {
        widgetId: this.templateObject.widget_id,
        newData: this.templateData
      };
      var that = this;
      this.axios.post(apiUrl + 'widget/update', requestData).then(function (response) {
        if (response.data.success) that.$store.commit('updateWidget', requestData);else {
          _this3.$bus.emit('addNotification', {
            title: 'Widget Update Error',
            body: 'There was an error updating the widget. Please reload the page and try again',
            type: 'error'
          });
        }
      });
    },
    saveEdit: function saveEdit(data) {
      var tmp = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.templateData));
      var tmpFields = tmp.fields;
      tmpFields[data.index] = data.fields;
      tmp.fields = tmpFields;
      window.Vue.set(this, 'templateData', tmp);
      for (var index = 0; index < data.fields.length; index++) {
        var field = data.fields[index];
        if (!field.newValue.length) continue;
        var refIndex = data.index + ',' + index;
        this.$refs[refIndex][0].$emit('setValue', field.newValue);
      }
      this.sortRows();
      // this.updateWidget()
      this.windowResized();
      this.$parent.$emit('widgetChanged', { index: this.fieldIndex, value: this.templateData });
    },
    sortRows: function sortRows() {
      var _this4 = this;

      var rowUnsortedFields = {};

      var _loop2 = function _loop2(rowIndex) {
        var row = _this4.templateData.fields[rowIndex];
        row.forEach(function (field) {
          if (field.fieldName !== _this4.templateObject.properties.sortedBy.column) return;

          var value = field.newValue.toLowerCase();
          if (!value.length) value = field.originalValue.toLowerCase();

          if (typeof rowUnsortedFields[value] !== 'undefined') rowUnsortedFields[value + '_' + Date.now()] = rowIndex;else rowUnsortedFields[value] = rowIndex;
        });
      };

      for (var rowIndex = 0; rowIndex < this.templateData.fields.length; rowIndex++) {
        _loop2(rowIndex);
      }

      var sortedList = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(rowUnsortedFields).sort();
      if (!this.templateObject.properties.sortedBy.asc) sortedList = sortedList.reverse();

      var newFields = [];
      sortedList.forEach(function (fieldName) {
        var nextRowIndex = rowUnsortedFields[fieldName];
        newFields.push(_this4.templateData.fields[nextRowIndex]);
      });

      // window.Vue.set(this.templateData, 'fields', newFields)
      this.updateDisplay();
      this.toggleColumns();

      window.dispatchEvent(new Event('resize'));
      var that = this;
      this.hotfixInterval = window.setInterval(function () {
        window.dispatchEvent(new Event('resize'));
        that.hotfixCount++;
        if (that.hotfixCount >= 10) window.clearInterval(that.hotfixInterval);
      }, 10);
    },
    widgetChanged: function widgetChanged(data) {
      var index = data.index.split(',');
      var fields = this.templateData.fields;
      fields[index[0]][index[1]]['newValue'] = data.value;
      // window.Vue.set(this.templateObject, 'fields', fields)
      // this.updateWidget()
      // this.$parent.$emit('widgetChanged', {index: this.fieldIndex, value: this.templateData})
    },
    windowResized: function windowResized() {
      var container = this.$el;
      if (container.clientWidth <= 580) {
        this.tableView = false;
        return;
      }

      this.tableView = true;
      this.toggleColumns();
    },
    addRow: function addRow() {
      var tmp = this.templateData;
      tmp.fields.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.newRowObject)));
      this.templateData = tmp;
      var that = this;
      setTimeout(function () {
        that.hideAfterAdd();
      }, 100);
      this.$parent.$emit('widgetChanged', { index: this.fieldIndex, value: this.templateData });
    },
    hideAfterAdd: function hideAfterAdd() {
      var tableRows = document.getElementsByTagName('tr');
      var lastRow = tableRows[tableRows.length - 1];

      this.editWidget(lastRow.getAttribute('data-objectkey'));

      var dataColumns = lastRow.getElementsByTagName('td');
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(dataColumns), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var column = _step.value;

          var fieldname = column.getAttribute('data-fieldname');
          if (fieldname === null || !fieldname.length) continue;
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.hiddenColumns).indexOf(fieldname) !== -1) {
            column.classList.add('hidden');
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    deleteRow: function deleteRow(index) {
      var _this5 = this;

      window.swal({
        title: 'Delete Row?',
        text: 'Are you sure you want to delete this row from ' + this.templateObject.properties.title + '?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (deleted) {
        if (deleted) {
          window.Vue.delete(_this5.templateData.fields, index);
          _this5.updateDisplay();
          // this.updateWidget()
          _this5.$parent.$emit('widgetChanged', { index: _this5.fieldIndex, value: _this5.templateData });
        }
      });
    },
    updateDisplay: function updateDisplay() {
      for (var rowIndex = 0; rowIndex < this.templateData.fields.length; rowIndex++) {
        var fieldRow = this.templateData.fields[rowIndex];
        for (var fieldIndex = 0; fieldIndex < fieldRow.length; fieldIndex++) {
          var field = fieldRow[fieldIndex];
          var value = field.newValue;
          if (!value.length) value = field.originalValue;
          var refIndex = rowIndex + ',' + fieldIndex;
          if (typeof this.$refs[refIndex] !== 'undefined') {
            this.$refs[refIndex][0].$emit('setValue', value);
          }
        }
      }
    },
    toggleColumns: function toggleColumns() {
      var container = this.$el;

      var tableRows = document.getElementsByTagName('tr');
      if (tableRows.length <= 1) return;
      var topRow = tableRows[1];
      var rowRect = topRow.getBoundingClientRect();

      if (container.clientWidth < rowRect.width) {
        var hiddenOffset = rowRect.width - container.clientWidth;
        var offsetWidth = rowRect.width - hiddenOffset;

        var dataColumns = topRow.getElementsByTagName('td');
        if (dataColumns[dataColumns.length - 1] === undefined) return;
        var lastColRect = dataColumns[dataColumns.length - 1].getBoundingClientRect();

        if (lastColRect.left + lastColRect.width > offsetWidth) {
          // const amountOffscreen = (lastColRect.left + lastColRect.width) - offsetWidth
          var lowestIndex = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.columnPriorities).sort().pop();
          if (lowestIndex === undefined) return;
          var lowestPriority = this.columnPriorities[lowestIndex];
          var lowestElems = document.querySelectorAll('[data-fieldname="' + lowestPriority + '"]');
          this.currentLowestPriority = lowestIndex - 1;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(lowestElems), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var elem = _step2.value;

              elem.classList.add('hidden');
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          window.Vue.set(this.hiddenColumns, lowestIndex.toString(), this.columnPriorities[lowestIndex]);
          window.Vue.delete(this.columnPriorities, lowestIndex);
        }
      }

      if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.hiddenColumns) && container.clientWidth > this.previousClientSize) {
        var highestIndex = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.hiddenColumns).sort().reverse().pop();
        var highestPriority = this.hiddenColumns[highestIndex];
        var highestElems = document.querySelectorAll('[data-fieldname="' + highestPriority + '"]');
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(highestElems), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _elem = _step3.value;

            _elem.classList.remove('hidden');
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        window.Vue.set(this.columnPriorities, highestIndex, this.hiddenColumns[highestIndex]);
        window.Vue.delete(this.hiddenColumns, highestIndex);
        this.previousClientSize = container.clientWidth;
        this.toggleColumns();
      }

      this.previousClientSize = container.clientWidth;
    },
    editWidget: function editWidget(index) {
      var _this6 = this;

      if (this.templateData.fields[index] === undefined) return;
      var fieldData = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.templateData.fields[index]));

      fieldData.forEach(function (field) {
        _this6.templateData.columns.forEach(function (column) {
          if (field.fieldName === column.fieldName) {
            field['type'] = column.type;
            field['values'] = column.values;
            field['title'] = column.title;
          }
        });
      });

      this.$refs.editModal.$emit('showModal', {
        index: index,
        fields: fieldData
      });
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$off('widgetChanged');
    this.$bus.$off('msgWidget');
    this.$off('saveEdit');
  }
});

/***/ }),

/***/ "6gZS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "72RX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7FVO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7gPc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'checkbox-group-edit-modal',

  data: function data() {
    return {
      fieldId: '',
      showModal: false,
      editName: '',
      editLabel: '',
      editHelp: '',
      // editMaxChecked: 1,
      checkboxList: []
    };
  },
  mounted: function mounted() {
    var that = this;
    this.$bus.on('checkboxGroupEditModal', function (fieldId) {
      that.fieldId = fieldId;
      var storeGroup = that.$store.state.templates[that.$store.state.currentTemplateName]['chGroups'][fieldId];
      that.editName = storeGroup.name;
      that.editLabel = storeGroup.title;
      that.editHelp = storeGroup.desc;
      // that.editMaxChecked = that.$store.getters.fieldGroupMaxFields(storeGroup.fieldId)
      that.checkboxList = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(that.$store.getters.orderFieldGroupFields(storeGroup.checkboxes)));
      that.showModal = true;
    });
  },


  methods: {
    closeModal: function closeModal() {
      this.showModal = false;
    },
    editFormField: function editFormField(index) {
      this.$bus.emit('openFieldMenu', {
        id: index
      });
      this.showModal = false;
    },
    deleteCheckboxGroupCheck: function deleteCheckboxGroupCheck(index) {
      this.$store.commit('deleteExistOnCheckboxGroups', index);
      this.$bus.emit('reloadQuestionnaire');
      this.$store.dispatch('saveTemplate');
      // this.$bus.emit('updateQuestionnaire')
      var list = [];
      list = this.checkboxList;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(list).forEach(function (id) {
        if (id === index) delete list[id];
      });

      this.checkboxList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.checkboxList, list);
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.checkboxList).length === 0) this.showModal = false;
    },
    move: function move(moveIndex, up) {
      var tmpContainer = {};
      var targetIndex = -1;
      var keys = [];
      keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.checkboxList);

      for (var index = 0; index < keys.length; index++) {
        tmpContainer[index] = keys[index];
        if (moveIndex === keys[index]) targetIndex = index;
      }

      if (targetIndex === -1) return;
      if (up && targetIndex - 1 < 0) return;
      if (!up && targetIndex + 1 > keys.length - 1) return;
      var newTarget = up ? targetIndex - 1 : targetIndex + 1;

      var tmpCheckboxList = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.checkboxList));

      tmpCheckboxList[moveIndex].tabOrder = tmpCheckboxList[keys[newTarget]].tabOrder;
      tmpCheckboxList[keys[newTarget]].tabOrder = tmpCheckboxList[moveIndex].tabOrder;

      keys.splice(newTarget < 0 ? keys.length + newTarget : newTarget, 0, keys.splice(targetIndex, 1)[0]);

      var newData = {};
      for (var _index = 0; _index < keys.length; _index++) {
        var element = keys[_index];
        newData[element] = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(tmpCheckboxList[element]));
      }

      this.checkboxList = newData;

      this.$store.commit('setCheckboxGroupFields', {
        nameGroup: this.fieldId,
        checkboxes: this.checkboxList
      });

      this.$store.dispatch('saveTemplate');
    },
    saveEdit: function saveEdit() {
      this.$store.commit('editCheckboxGroup', {
        index: this.fieldId,
        name: this.editName,
        label: this.editLabel,
        help: this.editHelp
      });

      var that = this;
      window.tmpTimeout = setTimeout(function () {
        // that.$store.commit('setGroupFieldMaxChecked', {
        //   index: that.fieldId,
        //   maxChecked: Number(that.editMaxChecked)
        // })
        clearTimeout(window.tmpTimeout);
        that.$store.dispatch('saveTemplate');
        // that.$bus.emit('updateQuestionnaire')
        that.$bus.emit('reloadQuestionnaire');
      }, 1000);
      this.showModal = false;
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('checkboxGroupEditModal');
  }
});

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "8CZR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8N8L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'combo-widget',

  props: {
    fieldIndex: {
      type: String,
      required: true
    },
    initialValue: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    autoWidth: {
      type: Boolean,
      default: false
    },
    model: {
      type: String,
      default: ''
    },
    fieldName: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      value: ''
    };
  },
  mounted: function mounted() {
    this.value = this.initialValue;
    var that = this;
    this.$on('setValue', function (val) {
      that.value = val;
    });
  },


  methods: {
    onChange: function onChange(e) {
      this.$parent.$emit('widgetChanged', { index: this.fieldIndex, value: this.value });
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$off('setValue');
  }
});

/***/ }),

/***/ "8OsN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCheckbox_vue__ = __webpack_require__("8aPW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17d79afa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCheckbox_vue__ = __webpack_require__("jWvQ");
function injectStyle (ssrContext) {
  __webpack_require__("5U2H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17d79afa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCheckbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17d79afa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCheckbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8YCc":
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ "8aPW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'form-checkbox',

  data: function data() {
    return {
      checked: false,
      valueModel: ''
    };
  },


  props: ['id', 'width', 'height', 'left', 'top', 'model', 'tabOrder', 'value', 'model', 'listOfficialModels'],

  watch: {
    model: function model(val) {
      this.valueModel = val;
    }
  },

  computed: {
    style: function style() {
      var styleStr = 'position: absolute;';
      styleStr += 'width: ' + this.width + 'px;';
      styleStr += 'height: ' + this.height + 'px;';
      styleStr += 'left: ' + this.left + 'px;';
      styleStr += 'top: ' + this.top + 'px;';
      return styleStr;
    },
    checkStyle: function checkStyle() {
      var marginScales = {
        1: 0,
        2: 5,
        3: 10,
        4: 15,
        5: 20,
        6: 25,
        7: 30,
        8: 35,
        9: 40,
        10: 45,
        11: 50
      };
      return 'transform: scale(' + this.$store.state.pageScale + ');margin:' + marginScales[this.$store.state.pageScale] + 'px;' + 'position:absolute;top:0;left:0;';
    },
    tabOrderStyle: function tabOrderStyle() {
      var tabStyleStr = '';
      tabStyleStr += 'width: ' + 20 * this.$store.state.pageScale + 'px;';
      tabStyleStr += 'height: ' + 20 * this.$store.state.pageScale + 'px;';
      tabStyleStr += 'font-size: ' + 14 * this.$store.state.pageScale + 'px;';
      tabStyleStr += 'left: -' + 25 * this.$store.state.pageScale + 'px;';
      return tabStyleStr;
    },
    inputStyle: function inputStyle() {
      return this.model !== '' && this.listOfficialModels.length > 0 && this.listOfficialModels.map(function (a) {
        return a.model;
      }).indexOf(this.valueModel) === -1 ? 'font-size:' + this.displayFontSize + 'px;position:absolute;top:0;left:0;outline:red solid 1px;' : 'font-size:' + this.displayFontSize + 'px;position:absolute;top:0;left:0;';
    }
  },

  mounted: function mounted() {
    this.valueModel = this.model;
  },


  methods: {
    toggleCheck: function toggleCheck() {
      var highlighted = document.querySelectorAll('.id-highlight');
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(highlighted), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var highlight = _step.value;

          highlight.classList.remove('id-highlight');
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var chGroupKey = this.$store.getters.checkboxGroup(this.id);

      if (this.value === 'on') this.checked = false;else this.checked = true;

      this.$store.commit('setCheckboxGroupCheck', {
        id: this.id,
        checked: this.checked,
        chGroupKey: chGroupKey
      });

      this.$store.dispatch('saveTemplate');

      this.$store.commit('setCurrentTemplateName', 'global');
      this.$store.commit('setCurrentTemplateName', 'default');

      this.focusInput();
    },
    inputClick: function inputClick(e) {
      e.preventDefault();
      this.$bus.emit('openFieldMenu', {
        id: this.id,
        pos: { x: e.pageX, y: e.pageY },
        tabOrder: this.tabOrder
      });
    },
    focusInput: function focusInput() {
      this.$bus.emit('scrollToElement', this.id);
    }
  }
});

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "9dYb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showInlineHelp)?_c('div',{staticClass:"inline-help-modal"},[_c('div',{staticClass:"modalHeader",staticStyle:{"border-radius":"9px 9px 0px 0px !important"}},[_c('span',{staticClass:"title"},[_vm._v("Question Help")]),_vm._v(" "),_c('span',{staticClass:"btn-close float-right",on:{"click":_vm.closeModal}},[_c('i',{staticClass:"fas fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"modalBody"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.separatorSelected),expression:"separatorSelected"}],staticClass:"tool",attrs:{"id":"separator"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.separatorSelected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.optionsSeparator),function(option,index){return _c('option',{key:index},[_vm._v("\n            "+_vm._s(option)+"\n        ")])}),0),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toLabel),expression:"toLabel"}],staticClass:"tool",attrs:{"id":"labelRange","type":"text","bind":_vm.parseText},domProps:{"value":(_vm.toLabel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.toLabel=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.checkBoxExcludeModel)?_c('div',[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked),expression:"checked"}],attrs:{"id":"excludeModelFields","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checked)?_vm._i(_vm.checked,null)>-1:(_vm.checked)},on:{"change":function($event){var $$a=_vm.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked=$$c}}}})]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.text))])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.indiceProcessing)?_c('h1',{staticClass:"msg-process"},[_vm._v(_vm._s(_vm.msgProcessing))]):_vm._e(),_vm._v(" "),_c('spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"spinner"}),_vm._v(" "),(_vm.inResult)?_c('div',{attrs:{"id":"result-inline-help"}},[(_vm.label !== '' && _vm.loading === false && _vm.inlineHelp !== '')?_c('label',{attrs:{"for":"textLabel"}},[_vm._v("Label:")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"resalt",attrs:{"id":"textLabel"}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.inlineHelp !== '' && _vm.loading === false)?_c('label',{attrs:{"for":"textInlineHelp"}},[_vm._v("Inline Help:")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"resalt",attrs:{"id":"textInlineHelp"}},[_vm._v(_vm._s(_vm.inlineHelp))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"button-box float-right"},[(_vm.btnParse && _vm.toLabel !== '')?_c('button',{staticClass:"btn btn-success",on:{"click":_vm.parseData}},[_vm._v("Parse")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"button-finish"},[(_vm.btnFinish && _vm.loading === false)?_c('button',{staticClass:"btn btn-primary btn-lg btn-block",on:{"click":_vm.closeModal}},[_vm._v("Finish")]):_vm._e()])],1)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"separator"}},[_c('b',[_vm._v("Separator")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"labelRange"}},[_c('b',[_vm._v("Label Range")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"excludeModelFields"}},[_c('b',[_vm._v("Exlude Model Fields")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A+FN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A2cF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RestoredFieldsModal_vue__ = __webpack_require__("e8pP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ecf83ed_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RestoredFieldsModal_vue__ = __webpack_require__("N7ac");
function injectStyle (ssrContext) {
  __webpack_require__("7FVO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ecf83ed"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RestoredFieldsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ecf83ed_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RestoredFieldsModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AAp8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"masterright"},[_c('div',{style:(_vm.hideStyle),attrs:{"id":"side-menu"}},[_c('div',{attrs:{"id":"pages"}},_vm._l((_vm.$store.getters.totalPages()),function(n){return _c('div',{key:n,staticClass:"page"},[_c('strong',{staticClass:"numpagespace"},[_vm._v(_vm._s(n))]),_vm._v(" "),_c('img',{staticClass:"imgpages",attrs:{"src":_vm.getImagePath(n)},on:{"click":function($event){return _vm.switchPage(n)}}})])}),0),_vm._v(" "),_c('div',{attrs:{"id":"show-hide"},on:{"click":_vm.toggleShowPageList}},[(_vm.$store.state.showPageList)?_c('i',{staticClass:"fas fa-angle-double-left"}):_c('i',{staticClass:"fas fa-angle-double-right"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AGU5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bcryptjs__ = __webpack_require__("vlDJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bcryptjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bcryptjs__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'list-view',

  data: function data() {
    return {
      email: null,
      password: null,
      showPassword: false,
      alertPassword: false,
      alertEmail: false,
      alertUserIncorrect: false
      // year: new Date().getFullYear()
    };
  },


  methods: {
    initLogin: function initLogin() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var dbUser, validatePassword, newAccess;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.validateInputs()) {
                  _context.next = 21;
                  break;
                }

                _context.next = 3;
                return _this.getUser();

              case 3:
                dbUser = _context.sent;

                if (!(dbUser !== null)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 7;
                return _this.comparePassword(dbUser.password);

              case 7:
                validatePassword = _context.sent;

                if (!validatePassword) {
                  _context.next = 17;
                  break;
                }

                _context.next = 11;
                return _this.getAccessToken();

              case 11:
                newAccess = _context.sent;

                _this.$store.commit('setAuthentication', {
                  email: newAccess.email,
                  accessToken: newAccess.accessToken
                });
                localStorage.setItem('accesToken', newAccess.accessToken);
                // Go Home
                _this.$router.push('/');
                _context.next = 18;
                break;

              case 17:
                _this.alertUserIncorrect = true;

              case 18:
                _context.next = 21;
                break;

              case 20:
                _this.alertUserIncorrect = true;

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getUser: function getUser() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', _this2.axios.post(_this2.$store.state.apiUrl + 'get-user-by-email', {
                  email: _this2.email
                }).then(function (response) {
                  return response.data.data;
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getAccessToken: function getAccessToken() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', _this3.axios.post(_this3.$store.state.apiUrl + 'kento', {
                  email: _this3.email
                }).then(function (response) {
                  return response.data.data;
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    validateInputs: function validateInputs() {
      this.alertEmail = this.email === null || this.email === '';
      this.alertPassword = this.password === null || this.password === '';

      return this.alertEmail === false && this.alertPassword === false;
    },
    comparePassword: function comparePassword(encryptedPassword) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2_bcryptjs___default.a.compare(_this4.password, encryptedPassword);

              case 3:
                return _context4.abrupt('return', _context4.sent);

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4['catch'](0);

                console.error('Fail compare password', _context4.t0);
                return _context4.abrupt('return', false);

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 6]]);
      }))();
    }

    // async encryptPassword () {
    //   try {
    //     let password = 'Prima1234!'
    //     const encryptedPassword = await bcrypt.hash(password, 10)

    //     console.log('Contraseña encriptada: ', encryptedPassword)
    //   } catch (error) {
    //     console.error('Error al encriptar y guardar la contraseña:', error)
    //   }
    // }

  }
});

/***/ }),

/***/ "ArBU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B+oi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxGroupModal_vue__ = __webpack_require__("+4CL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18e3af6c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckboxGroupModal_vue__ = __webpack_require__("hL3L");
function injectStyle (ssrContext) {
  __webpack_require__("Jg/M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18e3af6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxGroupModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18e3af6c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckboxGroupModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BARx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showSelectDialog)?_c('div',{staticClass:"modal-dialog myModalD"},[_c('div',{staticClass:"modalHeader"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('span',{staticClass:"btn-close float-right",on:{"click":_vm.closeModal}},[_c('i',{staticClass:"fas fa-times"})])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.desc))]),_vm._v(" "),(Object.keys(_vm.objectFields).length > 0)?_c('div',[_c('div',{staticClass:"combo-ms form-group"},[_c('h4',[_vm._v("Update Prefix")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefix),expression:"prefix"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Type prefix"},domProps:{"value":(_vm.prefix)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prefix=$event.target.value}}}),_vm._v(" "),_c('div',[(_vm.visiblePrefixButton)?_c('button',{class:_vm.buttonUpdatePrefix,on:{"click":_vm.updatePrefixMultiple}},[_vm._v(_vm._s(_vm.textButton))]):_vm._e(),_vm._v(_vm._s(_vm.spaceOnPrefix)+"\n      ")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"combo-ms form-group space-combo"},[_c('h4',[_vm._v("Update Model")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Type model"},domProps:{"value":(_vm.model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.model=$event.target.value}}}),_vm._v(" "),_c('div',[_c('button',{class:_vm.buttonUpdateModel,on:{"click":_vm.updateModelMultiple}},[_vm._v(_vm._s(_vm.textButton))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"combo-ms form-group space-combo"},[_c('h4',[_vm._v("Field Group")]),_vm._v(" "),(Object.keys(_vm.fieldNames).length)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldGroup),expression:"fieldGroup"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.fieldGroup=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changeGroup]}},[_c('option',{attrs:{"value":"none"}},[_vm._v("None")]),_vm._v(" "),_vm._l((_vm.fieldNames),function(name,index){return _c('option',{key:index,domProps:{"value":index}},[_vm._v(_vm._s(name))])})],2):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":_vm.createFieldGroup}},[_vm._v("New Group")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"combo-ms form-group space-combo"},[_c('h4',[_vm._v("Checkbox Group")]),_vm._v(" "),(Object.keys(_vm.checkboxNames).length)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxGroup),expression:"checkboxGroup"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.checkboxGroup=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changeCheckboxGroup]}},[_c('option',{attrs:{"value":"none"}},[_vm._v("None")]),_vm._v(" "),_vm._l((_vm.checkboxNames),function(name,index){return _c('option',{key:index,domProps:{"value":index}},[_vm._v(_vm._s(name))])})],2):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":_vm.createCheckboxGroup}},[_vm._v("New Group")])]),_vm._v(" "),_c('hr'),_vm._v(" "),(Object.keys(_vm.sectionNames).length > 0)?_c('div',{staticClass:"combo-ms form-group"},[_c('h4',[_vm._v("Add to Section")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sectionName),expression:"sectionName"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sectionName=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.addToSection]}},[_c('option',{attrs:{"value":"none"}},[_vm._v("None")]),_vm._v(" "),_vm._l((_vm.sectionNames),function(section,index){return _c('option',{key:index,domProps:{"value":index}},[_vm._v(_vm._s(section.originalValue))])})],2),_vm._v(" "),_c('hr')]):_c('div',[_c('h4',[_vm._v("No Sections")])])]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Byux":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.drawStyle),attrs:{"id":"multipleSelect"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C8WD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CFYr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'side-menu-page-list',

  methods: {
    getImagePath: function getImagePath(index) {
      return this.$store.state.outputPath + '/thumbnails/' + index + '.png';
    },
    switchPage: function switchPage(pageNum) {
      this.$store.commit('setDisablePageNavigation', true);
      this.$store.commit('setCurrentPage', pageNum);
      this.$bus.emit('pageChange', pageNum);
      this.$store.commit('setShowPageList', false);
      this.$bus.emit('hidePageFields');
      this.visible = false;
    },
    toggleShowPageList: function toggleShowPageList() {
      this.$store.commit('toggleShowPageList');
    }
  },

  computed: {
    hideStyle: function hideStyle() {
      return this.$store.state.showPageList ? 'left:0;' : '';
    }
  }
});

/***/ }),

/***/ "CXgT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tree-view',

  data: function data() {
    return {
      expanded: false
    };
  },


  props: {
    isChild: {
      type: Boolean,
      default: false
    },

    isParent: {
      type: Boolean,
      default: false
    }
  },

  mounted: function mounted() {
    if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$store.state.roleTreeData).length) this.processData();
  },


  methods: {
    toggleExpand: function toggleExpand() {
      this.expanded = !this.expanded;
    },
    addItem: function addItem(item) {
      this.$parent.$emit('addItem', item);
    },
    processData: function processData() {
      var treeData = {};
      var modelData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.state.models));
      modelData.forEach(function (model) {
        if (typeof treeData[model.category] === 'undefined') treeData[model.category] = { items: [], subname: '', subItems: [] };
        if (model.subcategory !== undefined) {
          if (model.subcategory.length) {
            treeData[model.category].subname = model.subcategory;
          }
        }
        var newItem = {
          prefix: model.prefix,
          type: model.type,
          field: model.field,
          label: model.label,
          properties: model.properties,
          route: model.route,
          command: model.command
        };

        if (model.subcategory !== undefined) {
          if (model.subcategory.length) {
            treeData[model.category].subItems.push(newItem);
          }
        } else treeData[model.category].items.push(newItem);
      });
      this.$store.commit('setRoleTreeData', treeData);
    }
  }
});

/***/ }),

/***/ "D0T5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_editor_js__ = __webpack_require__("fBKx");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'form-text',

  mounted: function mounted() {
    this.$bus.$on('setPageScale', this.scaleText);

    this.indiceScroll = 0;
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_editor_js__["a" /* default */]],

  data: function data() {
    return {
      displayFontSize: 12,
      indiceScroll: 0
    };
  },


  methods: {
    noFocus: function noFocus() {
      this.$bus.emit('scrollToElement', this.id);

      this.hideAutocomplete();
    },
    focusInput: function focusInput() {
      var highlighted = document.querySelectorAll('.id-highlight');
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(highlighted), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var highlight = _step.value;

          highlight.classList.remove('id-highlight');
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$bus.emit('scrollToElement', this.id);
    },
    inputClick: function inputClick(e) {
      e.preventDefault();
      this.$bus.emit('openFieldMenu', {
        id: this.id,
        pos: { x: e.pageX, y: e.pageY },
        tabOrder: this.$store.getters.templateTabOrder(this.id)
      });
    },
    scaleText: function scaleText(e) {
      if (typeof e !== 'number') this.setAutocompleteModel();

      if (!this.value.length) {
        this.displayFontSize = this.fontSize;
        return;
      }
      var input = document.getElementById(this.id);
      var div = document.getElementById('hidden-' + this.id);
      if (div === null) return;
      if (div.offsetWidth >= input.offsetWidth) {
        this.displayFontSize--;
      } else if (div.offsetWidth <= input.offsetWidth && this.displayFontSize < this.fontSize) {
        this.displayFontSize++;
      }
    }
  },

  props: ['id', 'width', 'height', 'left', 'top', 'fontSize', 'model'],

  computed: {
    style: function style() {
      var styleStr = 'position: absolute;';
      styleStr += 'width: ' + this.width + 'px;';
      styleStr += 'height: ' + this.height + 'px;';
      styleStr += 'left: ' + this.left + 'px;';
      styleStr += 'top: ' + this.top + 'px;';
      styleStr += 'font-size: ' + this.fontSize + 'px;';
      return styleStr;
    },
    tabOrderStyle: function tabOrderStyle() {
      var tabStyleStr = '';
      tabStyleStr += 'width: ' + 20 * this.$store.state.pageScale + 'px;';
      tabStyleStr += 'height: ' + 20 * this.$store.state.pageScale + 'px;';
      tabStyleStr += 'font-size: ' + 14 * this.$store.state.pageScale + 'px;';
      tabStyleStr += 'left: -' + 25 * this.$store.state.pageScale + 'px;';
      return tabStyleStr;
    },
    fieldClass: function fieldClass() {
      var fieldData = this.$store.getters.currentTemplateField(this.id);
      var maskType = fieldData['maskType'];
      if (maskType === undefined || !maskType.length) return '';
      return 'mask-' + maskType.toLowerCase().replace(/ /g, '-').replace(/[()]/g, '');
    },
    inputStyle: function inputStyle() {
      return this.model !== '' && this.value && this.value.indexOf('#') === -1 && this.value.indexOf('+') === -1 && this.value.indexOf('(') === -1 && this.value.indexOf(')') === -1 && this.listOfficialModels.length > 0 && this.listOfficialModels.map(function (a) {
        return a.model;
      }).indexOf(this.value) === -1 ? 'font-size:' + this.displayFontSize + 'px;position:absolute;top:0;left:0;outline:red solid 1px;' : 'font-size:' + this.displayFontSize + 'px;position:absolute;top:0;left:0;';
    },
    hiddenDiv: function hiddenDiv() {
      return 'display:inline-block;z-index:-1;opacity:0;font-size:' + this.displayFontSize + 'px;';
    },
    getMask: function getMask() {
      var fieldData = this.$store.getters.currentTemplateField(this.id);
      var maskType = fieldData['maskType'];
      if (maskType === 'Phone (US)') return '(###) ###-####';
      if (maskType === 'Phone (International)') return '+## ### #######';
      if (maskType === 'Email Address') return 'A@A';
      if (maskType === 'Zip Code') return '#####?-####';
      if (maskType === 'Date') return '##/##/####';
      if (maskType === 'Date (ISO 8601)') return '####/##/##';
      if (maskType === 'Alien Number') return '###-###-###';
      if (maskType === 'EIN') return '##-#######';
      if (maskType === 'Social Security Number') return '###-##-####';
      if (maskType === 'US Dollars') return '$#,###,###.##';
      return '';
    }
  }
});

/***/ }),

/***/ "D848":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuBottom_vue__ = __webpack_require__("ej7N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c448e2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuBottom_vue__ = __webpack_require__("GCnO");
function injectStyle (ssrContext) {
  __webpack_require__("/fB9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c448e2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuBottom_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c448e2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuBottom_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DLiC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('list-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFormList === true),expression:"isFormList === true"}],staticStyle:{"height":"100%"}}),_vm._v(" "),(_vm.isFormList === false)?_c('editor-questionnaire-view'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DNKF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddFormModal_vue__ = __webpack_require__("WkqJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_233d90b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddFormModal_vue__ = __webpack_require__("Od8b");
function injectStyle (ssrContext) {
  __webpack_require__("GlUz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-233d90b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddFormModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_233d90b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddFormModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DfGl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModal)?_c('div',{staticClass:"upload-tooltips-modal"},[_c('div',{staticClass:"modalHeader"},[_c('span',{staticClass:"title"},[_vm._v("Upload Tooltips")]),_vm._v(" "),_c('span',{staticClass:"btn-close float-right",on:{"click":_vm.closeModal}},[_c('i',{staticClass:"fas fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"modalBody"},[_c('p',{staticClass:"font14"},[_vm._v("\n      Select a TSV file for import. The tooltip data will be saved to the current template.\n      This will also generate a default localization for all fields, replacing the localization in the current language.\n      Tooltips will be automatically assigned to generated questionnaire fields. This data will replace any questionnaire data currently saved to the template.\n    ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.uploadLanguage),expression:"uploadLanguage"}],staticClass:"form-control form-control-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.uploadLanguage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.languages),function(language,index){return _c('option',{key:index,attrs:{"name":language.code},domProps:{"value":language.code}},[_vm._v("\n        "+_vm._s(language.code)+" - "+_vm._s(language.name)+"\n      ")])}),0),_vm._v(" "),_c('div',{staticClass:"uploaderBox"},[_vm._m(1),_vm._v(" "),_c('input',{attrs:{"accept":".tsv","type":"file","id":"selectFilesTooltips","value":"Import"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-upload",on:{"click":_vm.getJsonFile}},[_vm._v("Upload Template")])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"small"},[_c('b',[_vm._v("Tooltip Language")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"w-100 small",attrs:{"for":"selectFilesTooltips"}},[_c('b',[_vm._v("Tooltip TSV file")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E+bu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_EditorView__ = __webpack_require__("rxau");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_QuestionnaireView__ = __webpack_require__("koX5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_questionnaires_Spinner_vue__ = __webpack_require__("Qm8n");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'editor-questionnaire-view',

  components: {
    EditorView: __WEBPACK_IMPORTED_MODULE_0__views_EditorView__["a" /* default */],
    QuestionnaireView: __WEBPACK_IMPORTED_MODULE_1__views_QuestionnaireView__["a" /* default */],

    FSpinner: __WEBPACK_IMPORTED_MODULE_2__components_questionnaires_Spinner_vue__["a" /* default */]
  },

  created: function created() {
    var _this = this;

    this.$store.dispatch('getAutofill', this.$store.state.currentFormId).then(function (response) {
      if (response.data.length > 0) {
        var autofillId = response.data[0]._id;

        _this.$store.dispatch('getAutofillDetails', autofillId).then(function () {
          _this.$store.dispatch('getOfficialModel');
        });
      } else {
        _this.$store.commit('setAutofillDetails', []);
        _this.$store.commit('setOfficialModels', []);
      }
    });
  }
});

/***/ }),

/***/ "E26X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalTemplateEditor_vue__ = __webpack_require__("LrLJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3806a8ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalTemplateEditor_vue__ = __webpack_require__("FBdk");
function injectStyle (ssrContext) {
  __webpack_require__("0pNo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3806a8ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalTemplateEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3806a8ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalTemplateEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EFdF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"benchView"}},[_c('menu-top'),_vm._v(" "),_c('side-menu-page-list'),_vm._v(" "),_c('side-menu-toolbox'),_vm._v(" "),_c('page-background'),_vm._v(" "),_c('page-fields'),_vm._v(" "),(_vm.$store.state.dragIndex)?_c('drag-index'):_vm._e(),_vm._v(" "),(_vm.$store.state.multipleSelect)?_c('multiple-select'):_vm._e(),_vm._v(" "),_c('modal-dialog'),_vm._v(" "),_c('multiple-select-dialog'),_vm._v(" "),_c('modal-edit-field'),_vm._v(" "),_c('modal-template-editor'),_vm._v(" "),_c('modal-add-template'),_vm._v(" "),_c('modal-duplicate-template'),_vm._v(" "),_c('modal-delete-template'),_vm._v(" "),_c('annotations'),_vm._v(" "),_c('global-tooltip'),_vm._v(" "),_c('menu-bottom'),_vm._v(" "),_c('notifications')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EZkO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnnotationControls_vue__ = __webpack_require__("wXzL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_305ed689_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnnotationControls_vue__ = __webpack_require__("sx2R");
function injectStyle (ssrContext) {
  __webpack_require__("tNxN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-305ed689"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnnotationControls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_305ed689_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnnotationControls_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Edzi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MaxItemsModal__ = __webpack_require__("fzij");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__searchSelect_SearchSelect_vue__ = __webpack_require__("QiEr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_qs__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'edit-form-modal',

  data: function data() {
    return {
      formId: '',
      jsonData: {},
      formIndex: null,

      invalidFields: [],
      globalTemplate: {},
      totalPages: 0,
      totalFields: 0,

      name: '',
      title: '',
      viewer_url: '',
      status: 'DEV',
      revisionDate: '',
      expirationDate: '',
      displayRevisionDate: '',
      displayExpirationDate: '',
      primaId: '',
      version: 0,
      practiceArea: 'Immigration',
      role1: '',
      prefix1: '',
      role2: '',
      prefix2: '',
      role3: '',
      prefix3: '',
      role4: '',
      prefix4: '',
      role5: '',
      prefix5: '',
      role6: '',
      prefix6: '',
      role7: '',
      prefix7: '',
      role8: '',
      prefix8: '',

      practiceAreaSections: [],
      practiceAreaSection: '',

      isMaxItemsModal: false,
      currentRole: '',
      maxItems: {},

      enableForQ: false,
      showDialog: false,
      titleModal: '',
      descModal: '',
      confrirmText: '',
      cancelText: '',
      confirmAction: '',

      autofillId: null,

      isReplacedTemplate: false,

      tagsFormInternal: [],

      tagsFormPA: [],

      practiceAreaTag: [],
      internalTag: [],

      massiveJsonData: [],
      massiveFormIds: [],
      massiveFormDataBulk: [],
      contFormsBulkAction: 0,
      isBulkAction: false,

      contDefaultGlobal: 0,

      dataUrls: [],

      formData: null
    };
  },


  components: {
    MaxItemsModal: __WEBPACK_IMPORTED_MODULE_6__MaxItemsModal__["a" /* default */],
    SearchSelect: __WEBPACK_IMPORTED_MODULE_7__searchSelect_SearchSelect_vue__["a" /* default */]
  },

  mounted: function mounted() {
    var _this = this;

    var that = this;

    this.$bus.on('deleteOldTemplates', function () {
      that.deleteOldTemplates();
    });

    this.$on('setId', function (formId) {
      this.resetFields();
      this.formId = formId;
      this.formIndex = this.$store.getters.formIndex(formId);
      this.setFields(this.$store.state.forms[this.formIndex]);
    });

    this.$bus.on('setPracticeAreaSections', function () {
      _this.$store.state.practiceAreas.forEach(function (practiceArea) {
        if (_this.practiceArea === practiceArea.name) _this.practiceAreaSections = practiceArea.sections;
      });

      if (_this.practiceAreaSections === undefined) {
        _this.practiceAreaSections = _this.$store.state.practiceAreas[4].sections;
      }

      _this.practiceAreaSection = _this.practiceAreaSections[0];
      _this.setFields(_this.$store.state.forms[_this.formIndex]);

      _this.getFormTags();
    });

    this.isReplacedTemplate = false;

    // BULK ACTIONS UPDATE TEMPLATES

    this.$bus.on('updateTemplatesMassive', function (payload) {
      _this.iterationFormsToAddJSON(payload);
    });
  },


  methods: {
    getDataJson: function getDataJson(dataUrl) {
      return this.axios.get(this.$store.state.apiUrl + 'data/json?pathData=' + dataUrl).then(function (response) {
        return response;
      });
    },
    timeout: function timeout(ms) {
      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    iterationFormsToAddJSON: function iterationFormsToAddJSON(payload) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _loop, contData;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _loop(contData) {
                  var formData, dataUrl, dataJson;
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _loop$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          formData = _this2.$store.state.forms.filter(function (a) {
                            return a._id === payload.formsCheckedList[contData]._id;
                          })[0];
                          dataUrl = formData.viewer_url + '/data.json';
                          // let dataUrl = formData.viewer_url.replace('immigration/', '') + '/data.json'

                          _context.next = 4;
                          return _this2.getDataJson(dataUrl);

                        case 4:
                          dataJson = _context.sent;

                          if (!(dataJson.data && dataJson.data !== undefined && dataJson.data !== null && dataJson.data.filename)) {
                            _context.next = 16;
                            break;
                          }

                          formData = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(formData));
                          formData.noData = false;
                          _this2.formId = formData._id;
                          _this2.jsonData = dataJson.data;
                          _this2.formData = {
                            formId: formData._id,
                            newData: formData
                          };

                          _context.next = 13;
                          return _this2.getTemplates();

                        case 13:

                          _this2.$bus.emit('setFormUpdated');

                          // await this.timeout(5000)
                          _context.next = 19;
                          break;

                        case 16:
                          _this2.$bus.emit('addNotification', {
                            title: 'Add JSON from GitHub repository',
                            body: 'There was an error updating this form. Please check the data and try again.',
                            type: 'error'
                          });

                          _this2.$bus.emit('setFormUpdated');

                          _this2.$bus.emit('setFormInvalidPath', formData);

                        case 19:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _loop, _this2);
                });
                contData = 0;

              case 2:
                if (!(contData < payload.formsCheckedList.length)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.delegateYield(_loop(contData), 't0', 4);

              case 4:
                contData++;
                _context2.next = 2;
                break;

              case 7:

                _this2.$store.commit('updateForm', {
                  formId: _this2.formId,
                  newData: _this2.formData.newData
                });

                _this2.isReplacedTemplate = false;
                _this2.formData = null;

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    updateTemplatesPages: function updateTemplatesPages(templates) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
        templates.forEach(function (template) {
          _this3.updateTemplatePages(template._id).then(function (responseTemplate) {
            if (responseTemplate.data.success) {
              window.vueBus.emit('addNotification', {
                title: 'Templates Saved',
                body: 'Replaced template information succesfully.',
                type: 'success'
              });

              _this3.contDefaultGlobal++;

              _this3.$store.dispatch('getQuestionnaire', template._id).then(function (responseQuestionnaire) {
                if (responseQuestionnaire.data.length > 0 && responseQuestionnaire.data[0] !== undefined && responseQuestionnaire.data[0] !== null) {
                  var questionnaireId = responseQuestionnaire.data[0]._id;

                  _this3.$store.dispatch('deleteQuestionnaire', questionnaireId).then(function (responseDeleteQuestionnaire) {
                    resolve(true);
                  });
                } else resolve(true);
              });

              _this3.uploadDefaultQuestionnaire(template._id);

              if (_this3.contDefaultGlobal >= 2) {
                _this3.contDefaultGlobal = 0;

                resolve(true);
              }
            } else {
              window.vueBus.emit('addNotification', {
                title: 'Template Save Error',
                body: 'There was an error updating the template. Please review the data and try again',
                type: 'error'
              });

              resolve(false);
            }
          });
        });
      });
    },
    getFormTags: function getFormTags() {
      var _this4 = this;

      // GET FORM TAGS

      this.$store.dispatch('getFormTags', {
        tagType: 'practiceArea'
      }).then(function (response) {
        if (response.data !== undefined && response.data !== null) _this4.tagsFormPA = response.data;
      });

      this.$store.dispatch('getFormTags', {
        tagType: 'internal'
      }).then(function (response) {
        if (response.data !== undefined && response.data !== null) _this4.tagsFormInternal = response.data;
      });
    },
    confirm: function confirm() {
      this[this.confirmAction]();
      this.showDialog = false;
    },
    cancel: function cancel() {
      this.showDialog = false;
    },
    setFields: function setFields(formData) {
      var _this5 = this;

      if (formData === undefined) return;
      this.name = formData.name;
      this.title = formData.title;
      this.viewer_url = formData.viewer_url;
      this.status = formData.status;
      this.revisionDate = formData.revisionDate;
      this.expirationDate = formData.expirationDate;
      this.displayRevisionDate = window.moment.utc(formData.revisionDate).format('MM/DD/YYYY');
      this.displayExpirationDate = window.moment.utc(formData.expirationDate).format('MM/DD/YYYY');
      this.updatedAt = window.moment.utc(formData.updatedAt).format('MM/DD/YYYY');
      this.version = formData.version;
      this.primaId = formData.primaId;
      this.practiceArea = formData.practiceArea === 'Migration' || formData.practiceArea === undefined ? 'Immigration' : formData.practiceArea;
      this.enableForQ = formData.enableForQuestionnaire;
      this.practiceAreaTag = formData.practiceAreaTag;
      this.internalTag = formData.internalTag;

      this.$store.state.practiceAreas.forEach(function (practiceArea) {
        if (formData.practiceArea === practiceArea.name) _this5.practiceAreaSections = practiceArea.sections;else if (formData.practiceArea === 'Migration' || formData.practiceArea === undefined) _this5.$store.state.practiceAreas[4].sections;
      });
      this.practiceAreaSection = formData.practiceArea === 'Migration' || formData.practiceArea === undefined ? this.$store.state.practiceAreas[4].sections[0] : formData.practiceAreaSection;
      if (formData.properties !== undefined) {
        var stateRoles = this.$store.state.formRoles;

        // SET ASSIGNED ROLES

        // ROLE1
        this.role1 = stateRoles.filter(function (a) {
          return a._id === formData.properties.role1;
        })[0] !== undefined ? stateRoles.filter(function (a) {
          return a._id === formData.properties.role1;
        })[0] : stateRoles[0];
        this.prefix1 = formData.properties.prefix1 !== '0' ? formData.properties.prefix1 : '';

        // ROLE2
        this.role2 = stateRoles.filter(function (a) {
          return a._id === formData.properties.role2;
        })[0] !== undefined ? stateRoles.filter(function (a) {
          return a._id === formData.properties.role2;
        })[0] : stateRoles[0];
        this.prefix2 = formData.properties.prefix2 !== '0' ? formData.properties.prefix2 : '';

        // ROLE3
        this.role3 = stateRoles.filter(function (a) {
          return a._id === formData.properties.role3;
        })[0] !== undefined ? stateRoles.filter(function (a) {
          return a._id === formData.properties.role3;
        })[0] : stateRoles[0];
        this.prefix3 = formData.properties.prefix3 !== '0' ? formData.properties.prefix3 : '';

        // ROLE4
        this.role4 = stateRoles.filter(function (a) {
          return a._id === formData.properties.role4;
        })[0] !== undefined ? stateRoles.filter(function (a) {
          return a._id === formData.properties.role4;
        })[0] : stateRoles[0];
        this.prefix4 = formData.properties.prefix4 !== '0' ? formData.properties.prefix4 : '';

        // ROLE5
        this.role5 = stateRoles.filter(function (a) {
          return a._id === formData.properties.role5;
        })[0] !== undefined ? stateRoles.filter(function (a) {
          return a._id === formData.properties.role5;
        })[0] : stateRoles[0];
        this.prefix5 = formData.properties.prefix5 !== '0' ? formData.properties.prefix5 : '';

        // ROLE6
        this.role6 = stateRoles.filter(function (a) {
          return a._id === formData.properties.role6;
        })[0] !== undefined ? stateRoles.filter(function (a) {
          return a._id === formData.properties.role6;
        })[0] : stateRoles[0];
        this.prefix6 = formData.properties.prefix6 !== '0' ? formData.properties.prefix6 : '';

        // ROLE7
        this.role7 = stateRoles.filter(function (a) {
          return a._id === formData.properties.role7;
        })[0] !== undefined ? stateRoles.filter(function (a) {
          return a._id === formData.properties.role7;
        })[0] : stateRoles[0];
        this.prefix7 = formData.properties.prefix7 !== '0' ? formData.properties.prefix7 : '';

        // ROLE8
        this.role8 = stateRoles.filter(function (a) {
          return a._id === formData.properties.role8;
        })[0] !== undefined ? stateRoles.filter(function (a) {
          return a._id === formData.properties.role8;
        })[0] : stateRoles[0];
        this.prefix8 = formData.properties.prefix8 !== '0' ? formData.properties.prefix8 : '';
      }
    },
    resetFields: function resetFields() {
      this.formIndex = null;
      this.formId = '';
      this.invalidFields = [];
      this.globalTemplate = {};
      this.name = '';
      this.title = '';
      this.viewer_url = '';
      this.status = 'DEV';
      this.revisionDate = '';
      this.expirationDate = '';
      this.displayRevisionDate = '';
      this.displayExpirationDate = '';
      this.version = 0;
      this.primaId = '';
      this.practiceArea = 'Immigration';
      this.practiceAreaSection = '';
      this.role1 = '';
      this.prefix1 = '';
      this.role2 = '';
      this.prefix2 = '';
      this.role3 = '';
      this.prefix3 = '';
      this.role4 = '';
      this.prefix4 = '';
      this.role5 = '';
      this.prefix5 = '';
      this.role6 = '';
      this.prefix6 = '';
      this.role7 = '';
      this.prefix7 = '';
      this.role8 = '';
      this.prefix8 = '';
      this.enableForQ = false;
      this.maxItems = {};
      this.practiceAreaTag = [];
      this.internalTag = [];
    },
    closeModal: function closeModal() {
      this.totalPages = 0;
      this.totalFields = 0;
      this.isReplacedTemplate = false;
      this.$parent.$emit('closeModal');
    },
    getJsonFile: function getJsonFile() {
      var files = document.getElementById('selectFilesEdit').files;

      if (files.length !== 1) {
        return false;
      }

      var fr = new FileReader();
      fr.readAsText(files.item(0));

      var that = this;
      fr.onload = function (e) {
        that.jsonData = JSON.parse(e.target.result);
        that.showDialog = true;
        that.titleModal = 'Replace Templates?';
        that.descModal = 'You are about to replace the default and global templates for this form. Do you want to continue?';
        that.confirmText = 'Confirm';
        that.cancelText = 'Cancel';
        that.confirmAction = 'getTemplates';
      };
    },
    getTemplates: function getTemplates() {
      var _this6 = this;

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this6.$store.dispatch('getTemplates', _this6.formId).then(function (response) {
          if (response.data.length > 0) {
            _this6.isReplacedTemplate = true;

            var templates = response.data;

            _this6.updateTemplatesPages(templates).then(function (responseUpdateTemplates) {
              if (_this6.formData !== null) {
                _this6.formUpdate(_this6.formData).then(function (responseFormUpdate) {
                  if (responseFormUpdate.data.success) {
                    _this6.$bus.emit('addNotification', {
                      title: 'Form Updated',
                      body: 'The form was updated successfully.',
                      type: 'success'
                    });

                    resolve(true);
                  } else {
                    _this6.$bus.emit('addNotification', {
                      title: 'Update Error',
                      body: 'There was an error updating this form. Please check the data and try again.',
                      type: 'error'
                    });

                    resolve(false);
                  }
                });
              }
            });
          } else resolve(true);
        });
      });
    },
    getOldTemplates: function getOldTemplates() {
      var _this7 = this;

      this.$store.dispatch('getTemplates', this.formId).then(function (response) {
        if (response.data.length > 0) {
          _this7.deleteOldQuestionnaires(response.data.map(function (a) {
            return a._id;
          }));
          _this7.getAutofillId();
        }
      });
    },
    deleteOldQuestionnaires: function deleteOldQuestionnaires(templateIds) {
      var _this8 = this;

      templateIds.forEach(function (templateId) {
        _this8.$store.dispatch('getQuestionnaire', templateId).then(function (response) {
          if (response.data.length > 0 && response.data[0] !== undefined && response.data[0] !== null) {
            var questionnaireId = response.data[0]._id;

            _this8.$store.dispatch('deleteQuestionnaire', questionnaireId).then(function (response) {
              console.log('Delete Old questionnaires');
              console.log(response);
            });
          }
        });
      });
    },
    getAutofillId: function getAutofillId() {
      var _this9 = this;

      this.$store.dispatch('getAutofill', this.formId).then(function (response) {
        if (response.data.length > 0) {
          _this9.autofillId = response.data[0]._id;

          _this9.deleteOldTemplates();
        }
      });
    },
    deleteOldTemplates: function deleteOldTemplates() {
      var _this10 = this;

      this.createTemplate();

      this.$store.dispatch('deleteOldTemplates', this.formId).then(function (response) {
        if (response.data.success) {
          _this10.uploadDefaultTemplate();
        } else {
          _this10.$bus.emit('addNotification', {
            title: 'Template Error',
            body: 'There was an error removing the current global template. Please try again.',
            type: 'error'
          });
        }
      });
    },
    updateTemplatePages: function updateTemplatePages(templateId) {
      var pages = {};
      this.totalPages = 0;
      this.totalFields = 0;

      for (var pageNum in this.jsonData['pages']) {
        if (this.jsonData.pages.hasOwnProperty(pageNum)) {
          this.totalPages++;
          var pageFields = this.jsonData.pages[pageNum]['pageFields'];

          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(pageFields).length === 0) pages[pageNum] = [];

          for (var fieldName in pageFields) {
            if (pageFields.hasOwnProperty(fieldName)) {
              var field = pageFields[fieldName];

              if (typeof pages[pageNum] === 'undefined') {
                pages[pageNum] = [];
              }

              var newData = {
                id: fieldName,
                name: fieldName,
                model: '',
                value: '',
                type: field.fieldType.toLowerCase(),
                tabOrder: field.tabOrder,
                x: field.x,
                y: field.y,
                width: field.width,
                height: field.height,
                maskType: '',
                translations: {}
              };

              if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(field.choiceData) !== undefined && typeof field.choiceData === 'string') {
                newData['choiceData'] = field.choiceData.slice(1, -1).split(',');
              }

              pages[pageNum].push(newData);
              this.totalFields++;
            }
          }
        }
      }

      var postData = {
        templateId: templateId,
        newData: pages
      };

      return this.axios.post(this.$store.state.apiUrl + 'template/update-pages', postData).then(function (response) {
        return response;
      });
    },
    createTemplate: function createTemplate() {
      var templateData = {
        formId: this.formId,
        filename: this.jsonData['filename'],
        name: 'default',
        pages: {},
        fieldGroups: {}
      };

      for (var pageNum in this.jsonData['pages']) {
        if (this.jsonData.pages.hasOwnProperty(pageNum)) {
          this.totalPages++;
          var pageFields = this.jsonData.pages[pageNum]['pageFields'];

          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(pageFields).length === 0) templateData.pages[pageNum] = [];

          for (var fieldName in pageFields) {
            if (pageFields.hasOwnProperty(fieldName)) {
              var field = pageFields[fieldName];

              if (typeof templateData.pages[pageNum] === 'undefined') {
                templateData.pages[pageNum] = [];
              }

              var newData = {
                id: fieldName,
                name: fieldName,
                model: '',
                value: '',
                type: field.fieldType.toLowerCase(),
                tabOrder: field.tabOrder,
                x: field.x,
                y: field.y,
                width: field.width,
                height: field.height,
                maskType: '',
                translations: {}
              };

              if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(field.choiceData) !== undefined && typeof field.choiceData === 'string') {
                newData['choiceData'] = field.choiceData.slice(1, -1).split(',');
              }

              templateData.pages[pageNum].push(newData);
              this.totalFields++;
            }
          }
        }
      }

      this.globalTemplate = templateData;
    },
    uploadDefaultQuestionnaire: function uploadDefaultQuestionnaire(templateId) {
      var _this11 = this;

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this11.$store.dispatch('uploadDefaultQuestionnaire', templateId).then(function (response) {
          if (response.data.success) {
            _this11.$store.commit('addQuestionnaire', {
              '_id': response.data.id,
              templateId: templateId
            });

            _this11.$store.commit('addQuestionnaire', {
              index: 'default',
              data: {
                '_id': response.data.id,
                templateId: templateId,
                data: {}
              }
            });

            resolve(true);
          } else {
            _this11.$bus.emit('addNotification', {
              title: 'Questionnaire Error',
              body: 'There was an error adding the default questionnaire to this form. Please review the data and try again',
              type: 'error'
            });

            resolve(true);
          }
        });

        _this11.$store.commit('setLastSaved', Date.now());
      });
    },
    uploadDefaultTemplate: function uploadDefaultTemplate() {
      var _this12 = this;

      this.$store.dispatch('uploadTemplate', this.globalTemplate).then(function (response) {
        if (response.data.success) {
          var templateId = response.data.id;
          _this12.uploadDefaultQuestionnaire(templateId);

          // REPLACE OLD TEMPLATE ID ON AUTOFILL
          _this12.updateAutofill(templateId);
        } else {
          _this12.$bus.emit('addNotification', {
            title: 'Template Error',
            body: 'There was an error adding the new default template to this form. Please review the data and try again',
            type: 'error'
          });
        }
      });
      this.$store.commit('setLastSaved', Date.now());
    },
    updateAutofill: function updateAutofill(templateId) {
      this.$store.dispatch('updateAutofill', {
        autofillId: this.autofillId,
        newData: {
          templateId: templateId
        }
      }).then(function (response) {
        console.log('Update autofill');
        console.log(response);
      });
    },
    uploadGlobalTemplate: function uploadGlobalTemplate() {
      var _this13 = this;

      this.globalTemplate['name'] = 'global';

      this.$store.dispatch('uploadTemplate', this.globalTemplate).then(function (response) {
        if (response.data.success) {
          _this13.$bus.emit('addNotification', {
            title: 'Template Updated',
            body: 'The global and default template were updated successfully.',
            type: 'success'
          });
        } else {
          _this13.$bus.emit('addNotification', {
            title: 'Template Error',
            body: 'There was an error adding the new global template to this form. Please review the data and try again',
            type: 'error'
          });
        }
      });
    },
    uploadForm: function uploadForm() {
      var _this14 = this;

      var formData = {
        formId: this.formId,
        newData: {
          name: this.name,
          title: this.title,
          viewer_url: this.viewer_url,
          status: this.status,
          revisionDate: new Date(this.displayRevisionDate),
          expirationDate: new Date(this.displayExpirationDate),
          version: this.version,
          primaId: this.primaId,
          practiceArea: this.practiceArea,
          enableForQuestionnaire: this.enableForQ,
          practiceAreaSection: this.practiceAreaSection,
          properties: {
            role1: this.role1._id !== undefined ? this.role1._id : '',
            prefix1: this.prefix1,
            role2: this.role2._id !== undefined ? this.role2._id : '',
            prefix2: this.prefix2,
            role3: this.role3._id !== undefined ? this.role3._id : '',
            prefix3: this.prefix3,
            role4: this.role4._id !== undefined ? this.role4._id : '',
            prefix4: this.prefix4,
            role5: this.role5._id !== undefined ? this.role5._id : '',
            prefix5: this.prefix5,
            role6: this.role6._id !== undefined ? this.role6._id : '',
            prefix6: this.prefix6,
            role7: this.role7._id !== undefined ? this.role7._id : '',
            prefix7: this.prefix7,
            role8: this.role8._id !== undefined ? this.role8._id : '',
            prefix8: this.prefix8
          },
          maxItems: this.$store.state.forms[this.formIndex].maxItems,
          practiceAreaTag: this.practiceAreaTag,
          internalTag: this.internalTag
        }
      };

      this.formUpdate(formData).then(function (responseFormUpdate) {
        if (responseFormUpdate.data.success) {
          _this14.$bus.emit('addNotification', {
            title: 'Form Updated',
            body: 'The form was updated successfully.',
            type: 'success'
          });
          _this14.$store.commit('updateForm', formData);

          _this14.isReplacedTemplate = false;
          _this14.closeModal();

          _this14.$bus.emit('getFormList');
        } else {
          _this14.$bus.emit('addNotification', {
            title: 'Update Error',
            body: 'There was an error updating this form. Please check the data and try again.',
            type: 'error'
          });

          // resolve(false)
        }
      });
    },
    formUpdate: function formUpdate(formData) {
      var apiUrl = this.$store.state.apiUrl;

      return this.axios.post(apiUrl + 'form/update', __WEBPACK_IMPORTED_MODULE_8_qs___default.a.parse(formData)).then(function (response) {
        return response;
      });
    },
    setPracticeAreaSections: function setPracticeAreaSections(e) {
      var _this15 = this;

      this.$store.state.practiceAreas.forEach(function (practiceArea) {
        if (e.target.value === practiceArea.name) _this15.practiceAreaSections = practiceArea.sections;
      });

      if (this.practiceAreaSections !== undefined) this.practiceAreaSection = this.practiceAreaSections[0];
    },
    selectPracticeAreaSection: function selectPracticeAreaSection(section) {
      if (section === this.practiceAreaSection) return true;
    },
    showMaxItemsModal: function showMaxItemsModal(role) {
      this.currentRole = '';
      this.maxItems = this.$store.state.forms[this.formIndex].maxItems !== undefined ? this.$store.state.forms[this.formIndex].maxItems[role] : {};
      this.isMaxItemsModal = true;

      this.currentRole = role;
    },
    updateMaxItems: function updateMaxItems(maxItems) {
      if (this.$store.state.forms[this.formIndex].maxItems === undefined) this.$store.state.forms[this.formIndex].maxItems = {};
      this.$store.state.forms[this.formIndex].maxItems[this.currentRole] = maxItems;
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('deleteOldTemplates');
    this.$off('setId');
    this.$bus.$off('setPracticeAreaSections');
    this.$bus.$off('updateTemplatesMassive');
  }
});

/***/ }),

/***/ "Eu1a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__searchSelect_SearchSelect_vue__ = __webpack_require__("QiEr");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'questionnaire-tags',

  data: function data() {
    return {
      tagsForm: [],
      tags: [],
      actionTags: [],
      selectedTags: {},
      isVisible: true,
      checkboxes: [],
      isAddAction: true,
      isForceShow: false,
      isModel: false,
      messageForceModel: 'Force to show field with model.',
      selectOptions: []
    };
  },


  components: {
    SearchSelect: __WEBPACK_IMPORTED_MODULE_2__searchSelect_SearchSelect_vue__["a" /* default */]
  },

  props: {
    fieldGroupId: {
      type: String
    },

    fieldData: {
      type: Object
    },

    isGroupActions: {
      type: Boolean,
      default: false
    }
  },

  created: function created() {
    if (this.fieldData) {
      if (this.fieldData.model !== '') this.isModel = true;

      this.isVisible = this.fieldData.tagVisibled ? this.fieldData.tagVisible : true;

      if (this.fieldData.forceShow === true) {
        this.isForceShow = true;

        this.messageForceModel = 'Hide field with model.';
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.fieldGroupId) {
      var checkboxGroup = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.$store.state.templates[this.$store.state.currentTemplateName]['checkboxGroups'][this.fieldGroupId]));

      this.tags = checkboxGroup.tags ? checkboxGroup.tags : [];

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(checkboxGroup.fields).forEach(function (fieldKey) {
        if (checkboxGroup.fields[fieldKey].type === 'checkbox') {
          checkboxGroup.fields[fieldKey].label = checkboxGroup.fields[fieldKey].translations.en.label + ' ( ' + checkboxGroup.fields[fieldKey].id + ' )';
          _this.checkboxes.push(checkboxGroup.fields[fieldKey]);
        }
      });

      this.isVisible = checkboxGroup.tagVisible !== undefined ? checkboxGroup.tagVisible : true;

      this.actionTags = this.$store.getters.getActionTags(this.fieldGroupId);
    } else if (this.fieldData && this.fieldData.type === 'select') {
      this.selectOptions = this.fieldData.choiceData;
      this.actionTags = this.fieldData.actionTags;
      this.tags = this.fieldData.tags ? JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.fieldData.tags)) : [];
    } else if (this.fieldData) {
      this.tags = this.fieldData.tags ? JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.fieldData.tags)) : [];

      this.actionTags = this.fieldData.actionTags;
    }

    this.tagsForm = this.$store.getters.getFormTags();
  },


  methods: {
    setTags: function setTags(e) {
      var tagAdded = e.pop();
      var isNew = true;

      if (tagAdded !== undefined) {
        tagAdded = tagAdded.label !== undefined ? tagAdded.label : tagAdded;

        this.tags.forEach(function (tag) {
          if (tag === tagAdded) isNew = false;
        });

        if (isNew === true) {
          if (tagAdded !== undefined) {
            this.tags.push(tagAdded);

            this.setTagsDb();

            this.tagsForm = this.$store.getters.getFormTags();
          }
        }
      } else {
        this.isVisible = true;

        this.deleteTag(0);
      }
    },
    deleteTag: function deleteTag(index) {
      this.tags.splice(index, 1);

      this.setTagsDb();

      this.tagsForm = this.$store.getters.getFormTags();
    },
    editTag: function editTag(index) {
      document.getElementById(index + 'inputTag').classList.remove('hide');
      document.getElementById(index + 'tag').classList.add('hide');
    },
    changeTag: function changeTag(index) {
      var _this2 = this;

      var newValue = document.getElementById(index + 'inputTag').value;

      var tmpTags = [];

      tmpTags = this.tags;

      tmpTags[index] = newValue;

      this.tags = [];

      tmpTags.forEach(function (tag) {
        _this2.tags.push(tag);
      });

      document.getElementById(index + 'inputTag').classList.add('hide');
      document.getElementById(index + 'tag').classList.remove('hide');

      this.setTagsDb();

      this.tagsForm = this.$store.getters.getFormTags();
    },
    actions: function actions(payload) {
      if (payload.show === true) {
        document.getElementById(payload.index + 'deleteTag').classList.remove('hide');
        document.getElementById(payload.index + 'editTag').classList.remove('hide');
      } else {
        document.getElementById(payload.index + 'deleteTag').classList.add('hide');
        document.getElementById(payload.index + 'editTag').classList.add('hide');
      }
    },
    setTagsDb: function setTagsDb() {
      var _this3 = this;

      var checkboxGroup = null;

      if (this.fieldGroupId) checkboxGroup = this.$store.state.templates[this.$store.state.currentTemplateName]['checkboxGroups'][this.fieldGroupId];

      if (this.fieldGroupId) {
        if (!checkboxGroup.tags) checkboxGroup.tags = [];
        if (!checkboxGroup.actionTags) checkboxGroup.actionTags = [];

        checkboxGroup.tags = this.tags;
        checkboxGroup.actionTags = this.actionTags;

        this.$store.commit('editFieldGroup', {
          index: this.fieldGroupId,
          name: checkboxGroup.name,
          label: checkboxGroup.title,
          help: checkboxGroup.desc,
          tags: checkboxGroup.tags,
          actionTags: checkboxGroup.actionTags,
          tagVisible: this.isVisible
        });
      } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.fieldData).length > 0) {
        if (!this.fieldData.tags) this.fieldData.tags = [];

        this.fieldData.tags = this.tags;

        this.fieldData.actionTags = this.actionTags;

        this.fieldData.tagVisible = this.isVisible;

        this.$store.commit('setTemplateFieldPage', this.fieldData);

        var questionnaires = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.$store.state.questionnaires));

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(questionnaires[this.$store.state.currentTemplateName].data).forEach(function (fieldKey) {
          if (!questionnaires[_this3.$store.state.currentTemplateName].data[fieldKey].tags) {
            questionnaires[_this3.$store.state.currentTemplateName].data[fieldKey].tags = [];
          }

          var fieldId = _this3.fieldData.fieldName !== undefined ? _this3.fieldData.fieldName : _this3.fieldData.id;

          if (questionnaires[_this3.$store.state.currentTemplateName].data[fieldKey].fieldName === fieldId) {
            questionnaires[_this3.$store.state.currentTemplateName].data[fieldKey].tags = _this3.tags;

            questionnaires[_this3.$store.state.currentTemplateName].data[fieldKey].actionTags = _this3.actionTags;

            questionnaires[_this3.$store.state.currentTemplateName].data[fieldKey].tagVisible = _this3.isVisible;

            if (_this3.fieldData.forceShow !== undefined) questionnaires[_this3.$store.state.currentTemplateName].data[fieldKey].forceShow = _this3.fieldData.forceShow;
          }

          // Assign tags to field group fields
          if (questionnaires[_this3.$store.state.currentTemplateName].data[fieldKey].checkboxes && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(questionnaires[_this3.$store.state.currentTemplateName].data[fieldKey].checkboxes).length > 0) {
            var checkboxes = questionnaires[_this3.$store.state.currentTemplateName].data[fieldKey].checkboxes;

            var changeFieldGroupFields = false;

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(checkboxes).forEach(function (fieldChKey) {
              if (!checkboxes[fieldChKey].tags) checkboxes[fieldChKey].tags = [];

              var fieldId = _this3.fieldData.fieldName ? _this3.fieldData.fieldName : _this3.fieldData.id;

              if (checkboxes[fieldChKey].id === fieldId) {
                changeFieldGroupFields = true;

                checkboxes[fieldChKey].tags = _this3.tags;

                checkboxes[fieldChKey].actionTags = _this3.actionTags;

                checkboxes[fieldChKey].tagVisible = _this3.isVisible;

                if (_this3.fieldData.forceShow) checkboxes[fieldChKey].forceShow = _this3.fieldData.forceShow;

                questionnaires[_this3.$store.state.currentTemplateName].data[fieldKey].checkboxes = checkboxes;
              }
            });

            if (changeFieldGroupFields) {
              _this3.$store.commit('editFieldGroup', {
                index: questionnaires[_this3.$store.state.currentTemplateName].data[fieldKey].fieldName,
                name: questionnaires[_this3.$store.state.currentTemplateName].data[fieldKey].name,
                label: questionnaires[_this3.$store.state.currentTemplateName].data[fieldKey].title,
                help: questionnaires[_this3.$store.state.currentTemplateName].data[fieldKey].desc,
                checkboxes: questionnaires[_this3.$store.state.currentTemplateName].data[fieldKey].checkboxes
              });
            }
          }
        });

        this.$store.commit('setQuestionnaires', questionnaires);
        this.$bus.emit('updateQuestionnaire');
      }

      setTimeout(function () {
        _this3.$store.dispatch('saveTemplate');
        _this3.$bus.emit('reloadQuestionnaire');
        _this3.initVisible();
      }, 400);
    },
    addActionTag: function addActionTag() {
      this.isAddAction = false;

      var objTag = {
        value: 'off',
        action: 'show',
        tags: []
      };

      if (this.fieldGroupId) objTag.checkbox = this.checkboxes[0];else objTag.select = this.selectOptions[0];

      if (this.actionTags === undefined) this.actionTags = [];

      this.actionTags.push(objTag);
    },
    setTagsToAction: function setTagsToAction(payload) {
      if (payload.tags.length === 0) this.actionTags.splice(payload.index, 1);

      this.isAddAction = true;

      this.setTagsDb();
    },
    setVisiblity: function setVisiblity() {
      var isChecked = document.getElementById('visibleQuestionnaire').checked;

      this.isVisible = isChecked;

      this.setTagsDb();

      this.tagsForm = this.$store.getters.getFormTags();
    },
    initVisible: function initVisible() {
      var _this4 = this;

      var isVisible = true;

      if (this.fieldGroupId !== undefined) {
        var questionnairesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.$store.state.questionnaires[this.$store.state.currentTemplateName].data));

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(questionnairesData).forEach(function (fieldKey) {
          if (questionnairesData[fieldKey].fieldName === _this4.fieldGroupId) {
            if (questionnairesData[fieldKey].tagVisible === false) isVisible = false;
          }
        });
      } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.fieldData).length > 0) {
        if (this.fieldData.tagVisible === false) isVisible = false;
      }

      this.isVisible = isVisible;
    },
    controlAction: function controlAction(payload) {
      this.actionTags[payload.index][payload.type] = payload.value;

      this.setTagsDb();
    },
    setForceModel: function setForceModel() {
      this.isForceShow = !this.isForceShow;

      this.messageForceModel = this.isForceShow === true ? 'Hide field with model.' : 'Force to show field with model.';

      this.fieldData.forceShow = this.isForceShow;

      this.setTagsDb();
    }
  }
});

/***/ }),

/***/ "FBdk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog)?_c('div',{staticClass:"modal-dialog myDialogM",attrs:{"id":"modalTemplate"}},[_c('div',{staticClass:"modalHeader"},[_c('span',{staticClass:"title"},[_vm._v("Template Editor")]),_vm._v(" "),_c('span',{staticClass:"btn-close float-right",on:{"click":_vm.closeModal}},[_c('i',{staticClass:"fas fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"modalBody"},[_c('div',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"templateSelect"}},[_vm._v("Template")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentTemplateName),expression:"currentTemplateName"}],staticClass:"form-control form-control-sm",attrs:{"id":"templateSelect"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentTemplateName=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changeTemplate]}},_vm._l((_vm.$store.state.templates),function(template,index){return _c('option',{key:index},[_vm._v("\n            "+_vm._s(template.name)+"\n          ")])}),0)])]),_vm._v(" "),_c('hr'),_vm._v(" "),(Object.keys(_vm.$store.state.templates[_vm.$store.state.currentTemplateName]).length)?_c('v-client-table',{attrs:{"data":_vm.$store.getters.templateFields(),"columns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"page",fn:function(props){return [_vm._v("\n        "+_vm._s(props.row.page)+"\n      ")]}},{key:"id",fn:function(props){return [_vm._v("\n        "+_vm._s(props.row.id)+"\n        "),(_vm.$store.state.currentTemplateName !== 'global')?_c('button',{staticClass:"btn btn-danger float-right",on:{"click":function($event){return _vm.setEditRow(props.row)}}},[_vm._v("Edit")]):_c('button',{staticClass:"btn btn-secondary float-right",on:{"click":function($event){return _vm.setEditRow(props.row)}}},[_vm._v("View")])]}},{key:"model",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.row.model))])]}},{key:"value",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.row.value))])]}},{key:"type",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.row.type))])]}}],null,false,825189069)}):_vm._e()],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FZ2H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditorQuestionnaireView_vue__ = __webpack_require__("E+bu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_412ee70d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditorQuestionnaireView_vue__ = __webpack_require__("vEa5");
function injectStyle (ssrContext) {
  __webpack_require__("bytR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-412ee70d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditorQuestionnaireView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_412ee70d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditorQuestionnaireView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FhrZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'multiple-select-dialog',

  data: function data() {
    return {
      title: 'Modal Title',
      desc: 'The description of the modal',
      confirmAction: '',
      cancelAction: '',
      textButton: 'Update',
      cancelText: 'Cancel',
      showSelectDialog: false,
      dataFields: [],
      objectFields: {},
      prefix: '',
      model: '',
      buttonUpdatePrefix: 'btn btn-primary active',
      buttonUpdateModel: 'btn btn-primary active',
      visiblePrefixButton: false,
      visibleModelButton: false,
      fieldNames: [],
      checkboxNames: [],
      currentFieldGroup: 'none',
      currentCheckboxGroup: 'none',
      fieldGroup: 'none',
      checkboxGroup: 'none',
      sectionNames: {},
      sectionName: ''
    };
  },
  mounted: function mounted() {
    var that = this;
    this.$bus.on('showSelectDialog', function (data) {
      that.dataFields = data.dataFields;
      that.title = data.title;
      that.desc = data.desc;
      that.showSelectDialog = true;
      that.setSelectFields();
      that.fieldNames = that.$store.getters.groupFieldNames();
      that.checkboxNames = that.$store.getters.chGroupCheckboxNames();
      that.getSections();
    });
  },


  computed: {
    spaceOnPrefix: function spaceOnPrefix() {
      var prefix = this.prefix;
      if (prefix.trim() !== '') this.visiblePrefixButton = true;else this.visiblePrefixButton = false;
    }
  },

  methods: {
    addToSection: function addToSection(e) {
      this.$store.commit('addFieldsToSection', {
        sectionIndex: e.target.value,
        dataFields: this.objectFields
      });
      // this.$bus.emit('updateQuestionnaire')
      this.$bus.emit('reloadQuestionnaire');
    },
    getSections: function getSections() {
      var sections = this.$store.getters.getSections();
      this.sectionNames = sections;
    },
    changeCheckboxGroup: function changeCheckboxGroup(e) {
      var _this = this;

      if (e.target.value === this.currentCheckboxGroup) return;

      if (e.target.value !== 'none') {
        var dataFields = this.objectFields;

        var arrayTabsOrder = [];
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(dataFields).forEach(function (fieldId) {
          arrayTabsOrder.push(dataFields[fieldId].tabOrder);
        });

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(dataFields).forEach(function (fieldId) {
          _this.$store.commit('deleteExistOnCheckboxGroups', dataFields[fieldId].name);
          var fieldData = _this.$store.getters.getTemplateData(dataFields[fieldId].name);
          _this.$store.commit('addCheckboxToGroup', {
            index: e.target.value,
            fieldId: dataFields[fieldId].name,
            dataField: fieldData
          });
        });
      } else {
        this.$store.commit('removeCheckboxGroup', this.currentCheckboxGroup);
      }

      this.currentCheckboxGroup = e.target.value;

      this.$store.dispatch('saveTemplate');
      // this.$bus.emit('updateQuestionnaire')
      this.$bus.emit('reloadQuestionnaire');
      this.checkboxNames = this.$store.getters.chGroupCheckboxNames();
    },
    changeGroup: function changeGroup(e) {
      var _this2 = this;

      if (e.target.value === this.currentFieldGroup) return;

      if (e.target.value !== 'none') {
        var dataFields = this.objectFields;

        var arrayTabsOrder = [];
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(dataFields).forEach(function (fieldId) {
          arrayTabsOrder.push(dataFields[fieldId].tabOrder);
        });

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(dataFields).forEach(function (fieldId) {
          _this2.$store.commit('deleteExistOnFieldGroups', dataFields[fieldId].name);
          var fieldData = _this2.$store.getters.getTemplateData(dataFields[fieldId].name);
          _this2.$store.commit('addFieldToGroup', {
            index: e.target.value,
            fieldId: dataFields[fieldId].name,
            dataField: fieldData
          });
        });
      } else {
        this.$store.commit('removeFieldGroup', this.currentFieldGroup);
      }

      this.currentFieldGroup = e.target.value;

      this.$store.dispatch('saveTemplate');
      // this.$bus.emit('updateQuestionnaire')
      this.$bus.emit('reloadQuestionnaire');
      this.fieldNames = this.$store.getters.groupFieldNames();
    },
    createCheckboxGroup: function createCheckboxGroup() {
      var _this3 = this;

      var dataFields = this.objectFields;
      var baseGroup = {};
      var arrayTabsOrder = [];
      // let checkboxes = {}
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(dataFields).forEach(function (fieldId) {
        arrayTabsOrder.push(dataFields[fieldId].tabOrder);
      });
      var menorTab = Math.min.apply(null, arrayTabsOrder);

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(dataFields).forEach(function (fieldId) {
        if (dataFields[fieldId].type !== 'checkbox') {
          window.swal({
            title: 'Only select Checkbox for this function',
            text: 'Are you sure you want to continue?',
            icon: 'warning',
            buttons: true,
            dangerMode: true
          });

          var highlighted = document.querySelectorAll('.id-highlight');
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(highlighted), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var highlight = _step.value;

              highlight.classList.remove('id-highlight');
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this3.prefix = '';
          _this3.model = '';
          _this3.dataFields = [];
          _this3.objectFields = {};
          _this3.showSelectDialog = false;
          _this3.fieldGroup = 'none';
          _this3.checkboxGroup = 'none';
          _this3.currentFieldGroup = 'none';
          _this3.currentCheckboxGroup = 'none';
          return;
        }
        if (dataFields[fieldId].tabOrder === menorTab) baseGroup = dataFields[fieldId];

        // checkboxes[dataFields[fieldId].id] = dataFields[fieldId]

        _this3.$store.commit('deleteExistOnCheckboxGroups', dataFields[fieldId].name);
      });

      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(baseGroup).length === 0) return;

      var checkboxes = this.$store.getters.orderFieldGroupFields(dataFields);

      var newGroupId = Math.random().toString(36).split('.')[1];
      var newGroup = {
        name: 'New Group - ' + newGroupId,
        fieldAdd: baseGroup.id,
        title: baseGroup.translations['en'].label,
        desc: baseGroup.translations['en'].text,
        checked: [],
        checkboxes: checkboxes,
        tabOrder: baseGroup.tabOrder,
        page: baseGroup.fieldPage
      };

      this.$store.dispatch('createCheckboxGroup', {
        index: newGroupId,
        data: newGroup
      });
      this.checkboxNames = this.$store.getters.chGroupCheckboxNames();
      var newId = this.$store.getters.checkboxGroup(baseGroup.name);
      this.checkboxGroup = newId;
      this.currentCheckboxGroup = newId;
      this.$store.dispatch('saveTemplate');
    },
    createFieldGroup: function createFieldGroup() {
      var _this4 = this;

      var dataFields = this.objectFields;
      var baseGroup = {};
      var arrayTabsOrder = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(dataFields).forEach(function (fieldId) {
        arrayTabsOrder.push(dataFields[fieldId].tabOrder);
      });
      var menorTab = Math.min.apply(null, arrayTabsOrder);

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(dataFields).forEach(function (fieldId) {
        var isWidget = _this4.$store.getters.getIfExistFieldOnWidget(dataFields[fieldId].name);
        if (isWidget) {
          window.swal({
            title: 'Some fields you chose belong to a widget',
            text: 'Fields belong to widgets do not add to Field-Group',
            icon: 'warning',
            buttons: true,
            dangerMode: true
          }).then(function (deleted) {
            if (!deleted) _this4.closeModal();
          });

          delete dataFields[fieldId];

          return;
        }

        if (dataFields[fieldId].tabOrder === menorTab) baseGroup = dataFields[fieldId];

        _this4.$store.commit('deleteExistOnFieldGroups', dataFields[fieldId].name);
      });

      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(baseGroup).length === 0) return;

      var newGroupId = Math.random().toString(36).split('.')[1];
      var newFields = this.$store.getters.orderFieldGroupFields(dataFields);
      var newGroup = {
        name: 'New Group - ' + newGroupId,
        fieldAdd: baseGroup.id,
        title: baseGroup.translations['en'].label,
        desc: baseGroup.translations['en'].text,
        checked: [],
        fields: newFields,
        tabOrder: baseGroup.tabOrder,
        page: baseGroup.fieldPage
      };

      this.$store.dispatch('createFieldGroup', {
        index: newGroupId,
        data: newGroup
      });
      this.fieldNames = this.$store.getters.groupFieldNames();
      var newId = this.$store.getters.fieldGroup(baseGroup.name);
      this.fieldGroup = newId;
      this.currentfieldGroup = newId;
      this.$bus.emit('setOnlyFieldGroup', newGroupId);
      this.$store.dispatch('saveTemplate');
    },
    updatePrefixMultiple: function updatePrefixMultiple() {
      var that = this;
      var prefix = this.prefix;
      this.buttonUpdatePrefix = 'btn btn-primary disabled';
      this.textButton = 'Processing...';
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(that.objectFields).forEach(function (fieldIndex) {
          var data = {
            fieldName: that.objectFields[fieldIndex].name,
            prefix: prefix.trim()
          };
          that.$store.commit('updatePrefixTemplate', data);
          that.$store.commit('updatePrefixQuestionnaire', data);
        });
        that.$store.dispatch('saveTemplate');
        that.buttonUpdatePrefix = 'btn btn-primary active';
        that.textButton = 'Update';
        that.prefix = '';
      }, 1000);
    },
    updateModelMultiple: function updateModelMultiple() {
      var that = this;
      var model = this.model;
      this.buttonUpdateModel = 'btn btn-primary disabled';
      this.textButton = 'Processing...';
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(that.objectFields).forEach(function (fieldIndex) {
          var data = {
            fieldName: that.objectFields[fieldIndex].name,
            model: model.trim()
          };
          that.$store.commit('updateModelTemplate', data);
          that.$store.commit('updateModelQuestionnaire', data);
        });
        that.$store.dispatch('saveTemplate');
        that.buttonUpdateModel = 'btn btn-primary active';
        that.textButton = 'Update';
        that.model = '';
        var currentTemplate = that.$store.state.currentTemplateName;
        that.$store.commit('setCurrentTemplateName', 'global');
        that.$bus.emit('setCurrentTemplateName', 'global');
        that.$store.commit('setCurrentTemplateName', currentTemplate);
        that.$bus.emit('setCurrentTemplateName', currentTemplate);
        that.$store.commit('setLastSaved', Date.now());
      }, 1000);
    },
    setSelectFields: function setSelectFields() {
      var _this5 = this;

      this.dataFields.forEach(function (field, index) {
        _this5.objectFields[index] = field;
      });
    },
    closeModal: function closeModal() {
      var highlighted = document.querySelectorAll('.id-highlight');
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(highlighted), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var highlight = _step2.value;

          highlight.classList.remove('id-highlight');
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.prefix = '';
      this.model = '';
      this.dataFields = [];
      this.objectFields = {};
      this.showSelectDialog = false;
      this.fieldGroup = 'none';
      this.checkboxGroup = 'none';
      this.currentFieldGroup = 'none';
      this.currentCheckboxGroup = 'none';
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('showSelectDialog');
  }
});

/***/ }),

/***/ "Frkg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FieldGroupEditModal_vue__ = __webpack_require__("gFR7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec7c12ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FieldGroupEditModal_vue__ = __webpack_require__("eAa5");
function injectStyle (ssrContext) {
  __webpack_require__("I82z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ec7c12ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FieldGroupEditModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec7c12ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FieldGroupEditModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GCnO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.showBottomMenu),expression:"$store.state.showBottomMenu"}],attrs:{"id":"col-12"}},[_c('div',{staticClass:"down-menu"},[_c('button',{staticClass:"btn btn-sm buttonFooter",attrs:{"disabled":_vm.$store.state.disablePageNavigation},on:{"click":_vm.firstPage}},[_c('i',{staticClass:"fas fa-chevron-circle-left"}),_vm._v(" First")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm buttonFooter",attrs:{"disabled":_vm.$store.state.disablePageNavigation},on:{"click":_vm.prevPage}},[_c('i',{staticClass:"fas fa-chevron-left"}),_vm._v(" Prev")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm buttonFooter",attrs:{"disabled":_vm.$store.state.disablePageNavigation},on:{"click":_vm.nextPage}},[_vm._v("Next "),_c('i',{staticClass:"fas fa-chevron-right"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm buttonFooter",attrs:{"disabled":_vm.$store.state.disablePageNavigation},on:{"click":_vm.lastPage}},[_vm._v("Last "),_c('i',{staticClass:"fas fa-chevron-circle-right"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentPage),expression:"currentPage"}],staticClass:"text",attrs:{"disabled":_vm.$store.state.disablePageNavigation,"type":"number","min":"1","max":"99","maxlength":"2"},domProps:{"value":(_vm.currentPage)},on:{"change":_vm.setPage,"input":function($event){if($event.target.composing){ return; }_vm.currentPage=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"numPage"},[_vm._v(" of "+_vm._s(_vm.$store.state.totalPages))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GGn3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ABGroupWatchers_vue__ = __webpack_require__("RmLz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a4de84f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ABGroupWatchers_vue__ = __webpack_require__("ilIk");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ABGroupWatchers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a4de84f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ABGroupWatchers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GlUz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gz7E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:('top:' + (_vm.data.top + 25) + 'px;left:' + _vm.data.left + 'px;'),attrs:{"id":"autocomplete-model"}},[(_vm.isSpinner === true)?_c('div',[_c('center',[_c('div',{staticClass:"lds-hourglass"})])],1):_c('div',{staticStyle:{"padding-right":"10px","padding-top":"10px"}},[(_vm.list.length === 0)?_c('label',{staticStyle:{"padding-left":"10px"}},[_vm._v("\n      No match models\n      "),_c('ul',[_c('li',{staticClass:"itemModel",on:{"click":function($event){return _vm.setOfficialModel(_vm.model)}}},[_vm._v("\n          Create New Model "),_c('i',{staticClass:"fas fa-plus"})])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H/zd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuTop_vue__ = __webpack_require__("1Ldq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_725cd012_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuTop_vue__ = __webpack_require__("stxC");
function injectStyle (ssrContext) {
  __webpack_require__("Y2R0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-725cd012"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuTop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_725cd012_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuTop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HBWY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// https://stackoverflow.com/a/41375717
// Need to take state snapshots of the data I care about
// Build a middleware plugin for vuex to manage history

var keyOrder = {
  undefined: 1,
  props: 2,
  computed: 3,
  state: 1,
  getters: 2
};

/* harmony default export */ __webpack_exports__["a"] = ({
  /* eslint-disable no-new */
  name: 'time-travel',

  mounted: function mounted() {
    this.startState = window._.cloneDeep(this.$store.state);
    this.$store.subscribe(this.stateChange);
  },
  data: function data() {
    return {
      startState: {},
      stateHistory: [],

      watchedMutations: ['setTabOrder', 'setFieldType', 'setFieldDisplayType', 'setDocumentPageFields']
    };
  },


  methods: {
    stateChange: function stateChange(mutation) {
      if (mutation.type === 'setState') return;
      if (mutation.type === 'setLastSaved') this.$bus.emit('saveAll');else this.stateHistory.push({ mutation: mutation.type, state: window._.cloneDeep(this.$store.state) });
    },
    undo: function undo() {
      console.log('Undo');
      var lastState = this.stateHistory[this.stateHistory.length - 1];
      console.log(lastState.mutation);

      this.stateHistory.pop();
      this.$store.commit('setState', this.stateHistory[this.stateHistory.length - 1].state);
      this.$bus.emit('historyChange');
      // new window.Toast({message: 'Undid state ' + lastState.mutation})
    },
    redo: function redo() {
      this.$bus.emit('historyChange');
    },
    getKeys: function getKeys(state) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state).sort(function (a, b) {
        return (keyOrder[a] || a.charCodeAt(0) + 999) - (keyOrder[b] || b.charCodeAt(0) + 999);
      });
    },
    toDisplayType: function toDisplayType(type, asClass) {
      return type === 'undefined' ? 'data' : asClass ? type.replace(/\s/g, '-') : type;
    }
  }
});

/***/ }),

/***/ "HahR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-add-template',

  data: function data() {
    return {
      showDialog: false,
      templateName: ''
    };
  },
  mounted: function mounted() {
    var that = this;
    this.$bus.on('showTemplateAddDialog', function () {
      that.showDialog = true;
    });
  },


  methods: {
    closeModal: function closeModal() {
      this.showDialog = false;
      this.templateName = '';
    },
    addTemplate: function addTemplate() {
      var _this = this;

      var templateData = {
        formId: this.$store.state.currentFormId,
        name: this.templateName,
        pages: {}
      };

      for (var i = 1; i < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.state.templates['global']['pages']).length + 1; i++) {
        templateData.pages[i] = [];
      }

      var apiUrl = this.$store.state.apiUrl;
      this.axios.post(apiUrl + 'template/add', templateData).then(function (response) {
        if (response.data.success) {
          templateData['_id'] = response.data.id;

          _this.axios.post(apiUrl + 'questionnaire/add', { templateId: response.data.id }).then(function (response) {
            if (response.data.success) {
              templateData['questionnaire_id'] = response.data.id;
              _this.$store.commit('addTemplate', {
                id: templateData.name,
                data: templateData
              });

              _this.$store.commit('addQuestionnaire', {
                index: templateData.name,
                data: {
                  '_id': response.data.id,
                  templateId: templateData['_id'],
                  data: {}
                }
              });

              _this.$bus.emit('addNotification', {
                title: 'Template Created',
                body: 'The template was created successfully',
                type: 'success'
              });

              // Reactivity Hacks
              _this.$store.commit('setShowAnnotationMenu', true);
              _this.$store.commit('setDrawAnnotations', true);
              _this.$store.commit('setShowBottomMenu', false);
              _this.$store.commit('setShowAnnotationMenu', false);
              _this.$store.commit('setDrawAnnotations', false);
              _this.$store.commit('setShowBottomMenu', true);
              _this.closeModal();
            } else {
              _this.$bus.emit('addNotification', {
                title: 'Template Questionnaire Error',
                body: 'There was an error creating the template questionnaire. Please review the data and try again',
                type: 'error'
              });
            }
          });
        } else {
          _this.$bus.emit('addNotification', {
            title: 'Template Error',
            body: 'There was an error creating the template. Please review the data and try again',
            type: 'error'
          });
        }
      });
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('showTemplateAddDialog');
  }
});

/***/ }),

/***/ "Hjgw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HoAF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.disableSelect),expression:"disableSelect"}],staticClass:"search-select"},[_c('div',{staticClass:"input-select"},[(_vm.multiple)?_c('div',{staticClass:"multiple-select",on:{"click":_vm.enableSelect}},[_vm._l((_vm.multipleOpt),function(opt,index){return (_vm.multipleOpt.length > 0)?_c('span',{staticClass:"select-tag"},[(_vm.label != null)?_c('span',[_vm._v(_vm._s(opt[_vm.label]))]):_c('span',[_vm._v(_vm._s(opt))]),_vm._v(" "),_c('div',{staticClass:"close-tag",on:{"click":function($event){$event.stopPropagation();return _vm.removeOption(index)}}},[_vm._v("x")])]):_vm._e()}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],staticClass:"input-tag",attrs:{"type":"text"},domProps:{"value":(_vm.keyword)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.enterOption(_vm.keyword)},"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}})],2):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.keyword)},on:{"click":_vm.enableSelect,"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-angle-down icon",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),(_vm.showResultSearch)?_c('div',{staticClass:"result-search"},[(_vm.filteredOptions.length > 0)?_c('div',[_c('ul',_vm._l((_vm.filteredOptions),function(option){return _c('li',{on:{"click":function($event){return _vm.selectOption(option)}}},[(_vm.label != null)?_c('span',[_vm._v(_vm._s(option[_vm.label]))]):_c('span',[_vm._v(_vm._s(option))])])}),0)]):_c('div',{staticStyle:{"padding":"5px 15px"}},[_vm._v("\n      No results\n    ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I/4s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageBackground_vue__ = __webpack_require__("u20J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e4e2df4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageBackground_vue__ = __webpack_require__("MhtQ");
function injectStyle (ssrContext) {
  __webpack_require__("6gZS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e4e2df4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageBackground_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e4e2df4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageBackground_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I82z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_qs__);







__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);

var debug = "production" !== 'production';
// console.log(apiUrl)

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store({
  strict: debug,

  state: {
    // Add url
    // apiUrl: 'http://localhost:3001/api/',
    apiUrl: '/api/',
    // apiUrl: 'http://159.65.33.26:3001/api/',
    // apiUrl: 'https://159.65.33.26:3001/api/',
    viewerStaticUrl: '/static/output/',

    practiceAreas: [],
    formRoles: [],
    forms: [],
    currentTemplateName: 'default',
    currentFormId: null,
    templates: {},
    questionnaires: {},
    models: [],
    widgets: [],

    roleTreeData: {},

    pageScale: 1,
    pageWidth: 612,
    pageHeight: 792,
    fontSize: 12,
    fileCurrentPage: 1,
    totalPages: 0,
    outputPath: '',
    annotations: [],
    lastSaved: 0,
    currentLocale: 'en',

    editingFields: false,
    drawingAnnotation: false,
    dragIndex: false,
    multipleSelect: false,
    disablePageNavigation: false,
    assigningIndexes: false,
    showFields: false,
    showPageList: false,
    showAnnotationMenu: false,
    showBottomMenu: true,
    showAnnotations: false,
    selectedQuestionnaireField: '',

    abFieldsWatcher: [],

    autofillDetails: null,
    autofillId: null,

    officialModels: null,
    allOfficialModels: null,

    allFilters: [],

    user: {
      email: null,
      accessToken: null
    }
  },

  actions: {
    applyTemplate: function applyTemplate(_ref) {
      var commit = _ref.commit,
          state = _ref.state;

      // let invalidFields = []
      // if (typeof state.templates[state.currentTemplateName]['pages'] === 'undefined' || !Object.keys(state.templates[state.currentTemplateName]['pages']).length) return true

      // for (const page in state.templates[state.currentTemplateName]['pages']) {
      // if (state.currentTemplate['pages'].hasOwnProperty(page)) {
      // const pageFields = state.currentTemplate['pages'][page]
      // pageFields.forEach(field => {

      //   if (typeof state.documentFields[page]['pageFields'][field.id] === 'undefined') {
      //     invalidFields.push(field.id)
      //     return
      //   } else {
      //     let fieldData = JSON.parse(JSON.stringify(state.documentFields[page]['pageFields'][field.id]))
      //     Object.assign(fieldData, field)

      //     commit('setDocumentPageField', {
      //       id: field.id,
      //       page: page,
      //       data: fieldData
      //     })

      //     if (page === state.fileCurrentPage) {
      //       commit('setField', {
      //         id: field.id,
      //         data: fieldData
      //       })
      //     }
      //   }
      // })
      // }
      // }

      // if (invalidFields.length) return false
      return true;
    },
    getFormList: function getFormList(_ref2, data) {
      var commit = _ref2.commit,
          state = _ref2.state;

      var apiUrl = state.apiUrl;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(apiUrl + 'form/list', {
        data: data
      }).then(function (response) {
        return response.data;
      });
    },
    createFieldGroup: function createFieldGroup(_ref3, data) {
      var commit = _ref3.commit,
          state = _ref3.state;

      commit('addFieldGroup', data);
    },
    createCheckboxGroup: function createCheckboxGroup(_ref4, data) {
      var commit = _ref4.commit,
          state = _ref4.state;

      commit('addCheckboxGroup', data);
    },
    saveTemplatePages: function saveTemplatePages(_ref5) {
      var commit = _ref5.commit,
          state = _ref5.state;

      var apiUrl = state.apiUrl;

      var pages = state.templates[state.currentTemplateName]['pages'];

      var postData = {
        templateId: state.templates[state.currentTemplateName]['_id'],
        newData: pages
      };

      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(apiUrl + 'template/update-pages', postData).then(function (response) {
        if (response.data.success) {
          window.vueBus.emit('addNotification', {
            title: 'Templates Saved',
            body: 'All templates were saved successfully',
            type: 'success'
          });
        } else {
          window.vueBus.emit('addNotification', {
            title: 'Template Save Error',
            body: 'There was an error updating the template. Please review the data and try again',
            type: 'error'
          });
        }
      });
      commit('setLastSaved', Date.now());
    },
    saveTemplate: function saveTemplate(_ref6) {
      var commit = _ref6.commit,
          state = _ref6.state;

      var apiUrl = state.apiUrl;

      var currentPage = state.templates[state.currentTemplateName]['pages'][state.fileCurrentPage];

      var postData = {
        templateId: state.templates[state.currentTemplateName]['_id'],
        page: state.fileCurrentPage,
        newData: currentPage,
        checkboxGroups: state.templates[state.currentTemplateName]['checkboxGroups'],
        chGroups: state.templates[state.currentTemplateName]['chGroups'],
        widgetLabels: state.templates[state.currentTemplateName].widgetLabels !== undefined ? state.templates[state.currentTemplateName].widgetLabels : {}
      };

      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(apiUrl + 'template/update-field', postData).then(function (response) {
        if (response.data.success) {
          window.vueBus.emit('addNotification', {
            title: 'Templates Saved',
            body: 'All templates were saved successfully',
            type: 'success'
          });
        } else {
          window.vueBus.emit('addNotification', {
            title: 'Template Save Error',
            body: 'There was an error updating the template. Please review the data and try again',
            type: 'error'
          });
        }
      });
      commit('setLastSaved', Date.now());
    },
    resetIndexes: function resetIndexes(_ref7) {
      var commit = _ref7.commit,
          state = _ref7.state;

      commit('resetTabOrders');
      return true;
    },

    // GET AUTOFILL

    getAutofill: function getAutofill(_ref8, formId) {
      var commit = _ref8.commit,
          state = _ref8.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.get(state.apiUrl + 'autofill/form-id/?formId=' + formId).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // INSERT AUTOFILL

    addAutofill: function addAutofill(_ref9, autofill) {
      var commit = _ref9.commit,
          state = _ref9.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(state.apiUrl + 'autofill/add', autofill).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // UPDATE AUTOFILL

    updateAutofill: function updateAutofill(_ref10, payload) {
      var commit = _ref10.commit,
          state = _ref10.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(state.apiUrl + 'autofill/update', payload).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // GET AUTOFILL DETAILS

    getAutofillDetails: function getAutofillDetails(_ref11, autofillId) {
      var commit = _ref11.commit,
          state = _ref11.state;

      commit('setAutofillId', autofillId);

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.get(state.apiUrl + 'autofillDetails/autofill-id/?autofillId=' + autofillId).then(function (response) {
        commit('setAutofillDetails', response.data);
      }).catch(function (error) {
        return error;
      });
    },

    // INSERT AUTOFILL DETAILS

    addAutofillDetail: function addAutofillDetail(_ref12, autofillDetail) {
      var commit = _ref12.commit,
          state = _ref12.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(state.apiUrl + 'autofillDetails/add', autofillDetail).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // UPDATE AUTOFILL DETAILS

    updateAutofillDetail: function updateAutofillDetail(_ref13, payload) {
      var commit = _ref13.commit,
          state = _ref13.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(state.apiUrl + 'autofillDetails/update', payload).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // UPDATE AUTOFILL DETAILS

    deleteAutofillDetails: function deleteAutofillDetails(_ref14, payload) {
      var commit = _ref14.commit,
          state = _ref14.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(state.apiUrl + 'autofillDetails/delete', payload).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // DELETE ONE AUTOFILLDETAILL

    deleteAutofillDetail: function deleteAutofillDetail(_ref15, payload) {
      var commit = _ref15.commit,
          state = _ref15.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.delete(state.apiUrl + 'autofillDetail/delete-one/' + payload.autofillDetailId).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // GET TEMPLATES

    getTemplates: function getTemplates(_ref16, formId) {
      var commit = _ref16.commit,
          state = _ref16.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.get(state.apiUrl + 'template/list/' + formId).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },
    deleteOldTemplates: function deleteOldTemplates(_ref17, formId) {
      var commit = _ref17.commit,
          state = _ref17.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(state.apiUrl + 'template/delete-default/' + formId).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },
    uploadTemplate: function uploadTemplate(_ref18, globalTemplate) {
      var commit = _ref18.commit,
          state = _ref18.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(state.apiUrl + 'template/add', globalTemplate).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },
    uploadDefaultQuestionnaire: function uploadDefaultQuestionnaire(_ref19, templateId) {
      var commit = _ref19.commit,
          state = _ref19.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(state.apiUrl + 'questionnaire/add', { templateId: templateId }).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // GET QUESTIONNAIRES

    getQuestionnaire: function getQuestionnaire(_ref20, templateId) {
      var commit = _ref20.commit,
          state = _ref20.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.get(state.apiUrl + 'questionnaire/list/' + templateId).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // DELETE QUESTIONNAIRE

    deleteQuestionnaire: function deleteQuestionnaire(_ref21, questionnaireId) {
      var commit = _ref21.commit,
          state = _ref21.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(state.apiUrl + 'questionnaire/delete/' + questionnaireId).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // GET OFFICIAL MODEL

    getOfficialModel: function getOfficialModel(_ref22) {
      var commit = _ref22.commit,
          state = _ref22.state;

      var modelList = state.autofillDetails.map(function (a) {
        return a.model;
      });

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(state.apiUrl + 'official-model/find-list/', { modelList: modelList }).then(function (response) {
        commit('setOfficialModels', response.data);
      }).catch(function (error) {
        return error;
      });
    },

    // GET OFFICIAL MODEL

    getAllOfficialModels: function getAllOfficialModels(_ref23) {
      var commit = _ref23.commit,
          state = _ref23.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.get(state.apiUrl + 'official-model/list/').then(function (response) {
        commit('setAllOfficialModels', response.data);
      }).catch(function (error) {
        return error;
      });
    },

    // DID YOU MEAN OFFICIAL MODEL

    didYouMeanOfficialModel: function didYouMeanOfficialModel(_ref24, model) {
      var commit = _ref24.commit,
          state = _ref24.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.get(state.apiUrl + 'official-model/did-you-mean/?model=' + model).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // INSERT OFFICIAL MODEL

    addOfficialModel: function addOfficialModel(_ref25, newOfficialModel) {
      var commit = _ref25.commit,
          state = _ref25.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(state.apiUrl + 'official-model/add', newOfficialModel).then(function (response) {
        if (response.data.success === true) {
          commit('setAllOfficialModels', response.data.list);
        }
      }).catch(function (error) {
        return error;
      });
    },

    // INSERT BARCODE TEMPLATE

    addBarcodeTemplate: function addBarcodeTemplate(_ref26, barcodeTemplate) {
      var commit = _ref26.commit,
          state = _ref26.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(state.apiUrl + 'barcode/add', barcodeTemplate).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // GET BARCODE TEMPLATE FOR FORMID

    getListBarcodeTemplate: function getListBarcodeTemplate(_ref27) {
      var commit = _ref27.commit,
          state = _ref27.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.get(state.apiUrl + 'barcode/list/?formId=' + state.templates[state.currentTemplateName].formId).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // GET BARCODE TEMPLATE FOR _ID

    getBarcodeTemplate: function getBarcodeTemplate(_ref28, barcodeId) {
      var commit = _ref28.commit,
          state = _ref28.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.get(state.apiUrl + 'barcode/' + barcodeId).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // UPDATE BARCODE TEMPLATE FOR _ID

    updateBarcodeTemplate: function updateBarcodeTemplate(_ref29, barcodeTemplate) {
      var commit = _ref29.commit,
          state = _ref29.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(state.apiUrl + 'barcode/update', barcodeTemplate).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // DELETE BARCODE TEMPLATE

    deleteBarcodeTemplate: function deleteBarcodeTemplate(_ref30, barcodeId) {
      var commit = _ref30.commit,
          state = _ref30.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(state.apiUrl + 'barcode/delete/' + barcodeId).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // GET FORM TAGS
    getFormTags: function getFormTags(_ref31, payload) {
      var commit = _ref31.commit,
          state = _ref31.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.get(state.apiUrl + 'form/tags/?tagType=' + payload.tagType).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // ADD ROLES

    addRole: function addRole(_ref32, newRole) {
      var commit = _ref32.commit,
          state = _ref32.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(state.apiUrl + 'role/add', newRole).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // UPDATE ROLES

    updateRole: function updateRole(_ref33, payload) {
      var commit = _ref33.commit,
          state = _ref33.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(state.apiUrl + 'role/update', payload).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // ADD MODEL

    addModel: function addModel(_ref34, newModel) {
      var commit = _ref34.commit,
          state = _ref34.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(state.apiUrl + 'model/add', newModel).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // UPDATE MODELS

    updateModel: function updateModel(_ref35, payload) {
      var commit = _ref35.commit,
          state = _ref35.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(state.apiUrl + 'model/update', payload).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // UPDATE FORM

    updateForm: function updateForm(_ref36, payload) {
      var commit = _ref36.commit,
          state = _ref36.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(state.apiUrl + 'form/update', __WEBPACK_IMPORTED_MODULE_5_qs___default.a.parse(payload.formData)).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    },

    // Validate Token

    validateAccessToken: function validateAccessToken(_ref37, accessToken) {
      var commit = _ref37.commit,
          state = _ref37.state;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(state.apiUrl + 'validate-kento', {
        accessToken: accessToken
      }).then(function (response) {
        return response.data;
      });
    },

    // Get Official Models Modal
    getOfficialModelsList: function getOfficialModelsList(_ref38, data) {
      var commit = _ref38.commit,
          state = _ref38.state;

      var apiUrl = state.apiUrl;

      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(apiUrl + 'official-model/list-j', {
        data: data
      }).then(function (response) {
        return response.data;
      });
    }
  },

  mutations: {
    setAllFilters: function setAllFilters(state, payload) {
      state.allFilters = payload.filters;
    },

    setBlankFilters: function setBlankFilters(state, payload) {
      state.allFilters = [];
    },

    setOfficialModel: function setOfficialModel(state, payload) {
      state.templates[state.currentTemplateName].pages[payload.page].forEach(function (field, index) {
        if (payload.fieldId === field.id) {
          state.templates[state.currentTemplateName].pages[payload.page][index].model = payload.model;
        }
      });
    },

    setAllOfficialModels: function setAllOfficialModels(state, officialModels) {
      state.allOfficialModels = officialModels;
    },
    setOfficialModels: function setOfficialModels(state, officialModels) {
      state.officialModels = officialModels;
    },
    setAutofillId: function setAutofillId(state, autofillId) {
      state.autofillId = autofillId;
    },
    setAutofillDetails: function setAutofillDetails(state, data) {
      state.autofillDetails = data;
    },
    setPagesTemplate: function setPagesTemplate(state, pages) {
      state.templates[state.currentTemplateName].pages = pages;
    },
    setModelsAutofillDetails: function setModelsAutofillDetails(state) {
      var pages = state.templates[state.currentTemplateName]['pages'];
      state.templates[state.currentTemplateName]['pages'] = {};

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(pages).forEach(function (pageKey, indexPage) {
        if (pages[pageKey] === null) return;

        pages[pageKey].forEach(function (field, index) {
          if (field === null || field.id === undefined) return;

          var pdfFieldName = field.id.replace(/]_/g, '].');
          pages[pageKey][index].model = '';

          if (state.autofillDetails.map(function (a) {
            return a.pdfField;
          }).indexOf(pdfFieldName) !== -1) {
            pages[pageKey][index].model = state.autofillDetails[state.autofillDetails.map(function (a) {
              return a.pdfField;
            }).indexOf(pdfFieldName)].model;
          }
        });

        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(pages).length === indexPage + 1) {
          state.templates[state.currentTemplateName]['pages'] = pages;
        }
      });
    },
    setRoleTreeData: function setRoleTreeData(state, data) {
      state.roleTreeData = data;
    },
    addField: function addField(state) {
      var fieldId = 'newField-' + Date.now();
      var tmp = state.templates;
      tmp[state.currentTemplateName]['pages'][state.fileCurrentPage].push({
        width: 50,
        height: 50,
        x: 50,
        y: 50,
        tabOrder: -1,
        maskType: '',
        id: fieldId,
        name: fieldId,
        model: '',
        type: 'text',
        fieldPage: state.fileCurrentPage
      });

      state.templates = tmp;
    },
    deleteForm: function deleteForm(state, formId) {
      var tmp = state.forms;
      var deleteIndex = null;
      for (var i = 0; i < tmp.length; i++) {
        if (tmp[i]['_id'] === formId) {
          deleteIndex = i;
          i = tmp.length + 1;
        }
      }
      tmp.splice(deleteIndex, 1);
      state.forms = tmp;
    },
    updateForm: function updateForm(state, formData) {
      var tmp = state.forms;
      var updateIndex = null;
      for (var i = 0; i < tmp.length; i++) {
        if (tmp[i]['_id'] === formData.formId) {
          updateIndex = i;
          i = tmp.length + 1;
        }
      }
      if (updateIndex !== null) {
        formData.newData['_id'] = formData.formId;
        __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(tmp, updateIndex, formData.newData);
        state.forms = tmp;
      }
    },
    deleteField: function deleteField(state, fieldIndex) {
      var tmp = state.templates;
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].delete(tmp[state.currentTemplateName]['pages'][state.fileCurrentPage], fieldIndex);
      state.templates = tmp;
    },
    resetTabOrders: function resetTabOrders(state) {
      var tmp = state.templates;
      tmp[state.currentTemplateName]['pages'][state.fileCurrentPage].forEach(function (field, index) {
        tmp[state.currentTemplateName]['pages'][state.fileCurrentPage][index]['tabOrder'] = -1;
      });
      state.templates = tmp;
    },
    setModels: function setModels(state, models) {
      state.models = models;
    },
    setAbFieldWatcher: function setAbFieldWatcher(state, payload) {
      if (payload === undefined) return;

      payload.forEach(function (abFieldWatcher) {
        var abWatcher = {
          label: abFieldWatcher
        };

        if (state.abFieldsWatcher.map(function (a) {
          return a.label;
        }).indexOf(abFieldWatcher) === -1) state.abFieldsWatcher.push(abWatcher);
      });
    },
    resetAbFieldsWatcher: function resetAbFieldsWatcher(state) {
      state.abFieldsWatcher = [];
    },
    setSelectedQuestionnaireField: function setSelectedQuestionnaireField(state, fielName) {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.questionnaires[state.currentTemplateName]['data']).forEach(function (fieldId) {
        if (state.questionnaires[state.currentTemplateName]['data'][fieldId]['fieldName'] === fielName) {
          state.selectedQuestionnaireField = fieldId;
        }
      });
    },
    setCurrentLocale: function setCurrentLocale(state, locale) {
      state.currentLocale = locale;
    },
    setFieldEditMode: function setFieldEditMode(state, mode) {
      state.editingFields = mode;
    },
    setShowBottomMenu: function setShowBottomMenu(state, show) {
      state.showBottomMenu = show;
    },
    setTemplates: function setTemplates(state, templates) {
      state.templates = templates;
    },
    setTemplateFieldPage: function setTemplateFieldPage(state, fieldData) {
      var templatePages = state.templates[state.currentTemplateName].pages;
      if (templatePages === undefined) return;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(templatePages).forEach(function (pageId) {
        if (templatePages[pageId] === null) return;
        templatePages[pageId].forEach(function (field, index) {
          if (field === null) return;
          if (field.id === fieldData.id) {
            templatePages[pageId][index] = fieldData;
          }
        });
      });
      state.templates[state.currentTemplateName].pages = templatePages;
    },
    setCurrentTemplateData: function setCurrentTemplateData(state, template) {
      state.templates[state.currentTemplateName] = template;
    },
    setQuestionnaireFieldSelectedEmpty: function setQuestionnaireFieldSelectedEmpty(state) {
      state.selectedQuestionnaireField = '';
    },
    setTemplateFieldQuestionText: function setTemplateFieldQuestionText(state, fieldData) {
      var tmp = state.templates;
      if (fieldData.index === undefined) return;
      tmp[state.currentTemplateName]['pages'][fieldData.page][fieldData.index]['questionTitle'] = fieldData.title;
      tmp[state.currentTemplateName]['pages'][fieldData.page][fieldData.index]['questionHelp'] = fieldData.helpText;
    },
    setCurrentTemplateField: function setCurrentTemplateField(state, fieldData) {
      var tmp = state.templates;
      tmp[state.currentTemplateName]['pages'][fieldData.page][fieldData.index] = fieldData.data;
      state.templates = tmp;
    },
    setTemplateField: function setTemplateField(state, fieldData) {
      var tmp = state.templates;
      var onlyField = false;

      tmp[fieldData.templateName]['pages'][fieldData.page].forEach(function (field, index) {
        if (field !== null) {
          if (field.id === fieldData.fieldId) {
            if (onlyField === false) {
              tmp[fieldData.templateName]['pages'][fieldData.page][index] = fieldData.data;

              onlyField = true;
            } else {
              tmp[fieldData.templateName]['pages'][fieldData.page].splice(index, 1);
            }
          }
        } else {
          tmp[fieldData.templateName]['pages'][fieldData.page].splice(index, 1);
        }
      });
      state.templates = tmp;
    },
    addTemplate: function addTemplate(state, templateData) {
      var tmp = state.templates;
      tmp[templateData.id] = templateData.data;
      state.templates = tmp;
    },
    removeTemplate: function removeTemplate(state, templateId) {
      var tmp = state.templates;
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].delete(tmp, templateId);
      state.templates = tmp;
    },
    setCurrentFormId: function setCurrentFormId(state, formId) {
      state.currentFormId = formId;
    },
    setOutputPath: function setOutputPath(state, path) {
      state.outputPath = path;
    },
    setPracticeAreas: function setPracticeAreas(state, practiceAreas) {
      state.practiceAreas = practiceAreas;
    },
    setFormRoles: function setFormRoles(state, roles) {
      state.formRoles = roles.sort(function (a, b) {
        var nameA = a.name.toUpperCase(); // ignore upper and lowercase
        var nameB = b.name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });

      state.formRoles.unshift({
        name: 'None'
      });
    },
    setForms: function setForms(state, forms) {
      state.forms = forms;
    },
    setCurrentTemplateName: function setCurrentTemplateName(state, templateName) {
      state.currentTemplateName = templateName;
    },
    setCurrentTemplate: function setCurrentTemplate(state, templateName) {
      state.currentTemplate = state.templates[templateName];
    },
    addForm: function addForm(state, formData) {
      state.forms.push(formData);
    },
    setState: function setState(state, stateData) {
      state = stateData;
    },
    setSelected: function setSelected(state, selectedData) {
      state.annotations[selectedData['index']]['selected'] = selectedData['val'];
    },
    setLastSaved: function setLastSaved(state, timestamp) {
      state.lastSaved = timestamp;
    },
    setAnnotations: function setAnnotations(state, annotations) {
      state.annotations = annotations;
    },
    setShowAnnotations: function setShowAnnotations(state, show) {
      state.showAnnotations = show;
    },
    setAnnotationDataKey: function setAnnotationDataKey(state, annotationData) {
      var tmp = state.annotations;
      tmp[annotationData.index]['data'][annotationData.key] = annotationData.value;
      state.annotations = tmp;
    },
    setAnnotationData: function setAnnotationData(state, annotationData) {
      var tmp = state.annotations;
      tmp[annotationData.index]['data'] = annotationData.data;
      state.annotations = tmp;
    },
    setAnnotationPosition: function setAnnotationPosition(state, annotationData) {
      var tmp = state.annotations;
      tmp[annotationData.index]['x'] = annotationData.pos.x;
      tmp[annotationData.index]['y'] = annotationData.pos.y;
      state.annotations = tmp;
    },
    setAnnotationSize: function setAnnotationSize(state, annotationData) {
      var tmp = state.annotations;
      tmp[annotationData.index]['width'] = annotationData.size.width;
      tmp[annotationData.index]['height'] = annotationData.size.height;
      state.annotations = tmp;
    },
    setAnnotationRotation: function setAnnotationRotation(state, rotationData) {
      var tmp = state.annotations;
      tmp[rotationData.index]['rotation'] = rotationData.amount;
      state.annotations = tmp;
    },
    addAnnotation: function addAnnotation(state, annotation) {
      var tmp = state.annotations;
      tmp.push(annotation);
      state.annotations = tmp;
    },
    removeAnnotation: function removeAnnotation(state, index) {
      state.annotations.splice(index, 1);
    },
    setDocumentPageAnnotations: function setDocumentPageAnnotations(state, annotationData) {
      var tmp = state.documentFields;
      tmp[annotationData.index]['pageAnnotations'] = annotationData.data;
      state.documentFields = tmp;
    },
    setPageWidth: function setPageWidth(state, width) {
      state.pageWidth = width;
    },
    setPageHeight: function setPageHeight(state, height) {
      state.pageHeight = height;
    },
    setPageScale: function setPageScale(state, scale) {
      state.pageScale = scale;
    },
    setFontSize: function setFontSize(state, size) {
      state.fontSize = size;
    },
    setTotalPages: function setTotalPages(state, total) {
      state.totalPages = total;
    },
    setCurrentPage: function setCurrentPage(state, pageNum) {
      state.fileCurrentPage = pageNum;
    },
    setDisablePageNavigation: function setDisablePageNavigation(state, disable) {
      state.disablePageNavigation = disable;
    },
    setDrawAnnotations: function setDrawAnnotations(state, draw) {
      state.drawingAnnotation = draw;
    },
    toggleAssigningIndexes: function toggleAssigningIndexes(state) {
      state.assigningIndexes = !state.assigningIndexes;
    },
    setAssigningIndexes: function setAssigningIndexes(state, assign) {
      state.assigningIndexes = assign;
    },
    setShowFields: function setShowFields(state, show) {
      state.showFields = show;
    },
    toggleShowFields: function toggleShowFields(state) {
      state.showFields = !state.showFields;
    },
    setShowPageList: function setShowPageList(state, show) {
      state.showPageList = show;
    },
    toggleShowPageList: function toggleShowPageList(state) {
      state.showPageList = !state.showPageList;
    },
    setShowAnnotationMenu: function setShowAnnotationMenu(state, show) {
      state.showAnnotationMenu = show;
    },
    toggleDragIndex: function toggleDragIndex(state) {
      state.dragIndex = !state.dragIndex;
    },
    toggleMultipleSelect: function toggleMultipleSelect(state) {
      state.multipleSelect = !state.multipleSelect;
    },
    setDragIndex: function setDragIndex(state, index) {
      state.dragIndex = index;
    },
    setMultipleSelect: function setMultipleSelect(state, index) {
      state.multipleSelect = index;
    },
    setTabOrder: function setTabOrder(state, fieldData) {
      state.templates[state.currentTemplateName]['pages'][state.fileCurrentPage].forEach(function (field, index) {
        if (field.id === fieldData.id) {
          var tmp = state.templates;
          tmp[state.currentTemplateName]['pages'][state.fileCurrentPage][index]['tabOrder'] = fieldData.index;
          state.templates = tmp;
          return;
        }
      });
    },
    setQuestionnaires: function setQuestionnaires(state, questionnaires) {
      state.questionnaires = {};
      state.questionnaires = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, state.questionnaires, questionnaires);
    },
    setQuestionnaireFields: function setQuestionnaireFields(state, questionnaireFields) {
      state.questionnaires[state.currentTemplateName].data = {};
      state.questionnaires[state.currentTemplateName].data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, state.questionnaires[state.currentTemplateName].data, questionnaireFields);
    },
    addQuestionnaire: function addQuestionnaire(state, questionnaireData) {
      state.questionnaires[questionnaireData.index] = questionnaireData.data;
    },
    setWidgets: function setWidgets(state, widgets) {
      state.widgets = widgets;
    },
    updateWidget: function updateWidget(state, widgetData) {
      var widgets = state.widgets;

      widgets.forEach(function (widget, index) {
        if (widget._id === widgetData.widgetId) {
          widgets[index].newValue = widgetData.newData;
          return;
        }
      });

      state.widgets = widgets;
    },
    setFieldGroups: function setFieldGroups(state, fieldGroups) {
      state.templates[state.currentTemplateName]['checkboxGroups'] = fieldGroups;
    },
    setCheckboxGroups: function setCheckboxGroups(state, checkboxGroups) {
      state.templates[state.currentTemplateName]['chGroups'] = checkboxGroups;
    },
    setFieldGroupFields: function setFieldGroupFields(state, dataGroup) {
      state.templates[state.currentTemplateName]['checkboxGroups'][dataGroup.nameGroup].fields = {};
      state.templates[state.currentTemplateName]['checkboxGroups'][dataGroup.nameGroup].fields = dataGroup.fields;
      var questionnaireFields = state.questionnaires[state.currentTemplateName].data;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaireFields).forEach(function (fieldId) {
        if (questionnaireFields[fieldId].fieldName === dataGroup.nameGroup) questionnaireFields[fieldId].checkboxes = dataGroup.fields;
      });

      state.questionnaires[state.currentTemplateName].data = questionnaireFields;
    },
    setCheckboxGroupFields: function setCheckboxGroupFields(state, dataGroup) {
      state.templates[state.currentTemplateName]['chGroups'][dataGroup.nameGroup].checkboxes = dataGroup.checkboxes;
    },
    addFieldGroup: function addFieldGroup(state, groupData) {
      if (typeof state.templates[state.currentTemplateName]['checkboxGroups'] === 'undefined' || state.templates[state.currentTemplateName]['checkboxGroups'] === null) state.templates[state.currentTemplateName]['checkboxGroups'] = {};
      groupData.data['fieldId'] = groupData.index;
      state.templates[state.currentTemplateName]['checkboxGroups'][groupData.index] = groupData.data;
    },
    addCheckboxGroup: function addCheckboxGroup(state, groupData) {
      if (typeof state.templates[state.currentTemplateName]['chGroups'] === 'undefined' || state.templates[state.currentTemplateName]['chGroups'] === null) state.templates[state.currentTemplateName]['chGroups'] = {};
      groupData.data['fieldId'] = groupData.index;
      state.templates[state.currentTemplateName]['chGroups'][groupData.index] = groupData.data;
    },
    addFieldToGroup: function addFieldToGroup(state, fieldData) {
      var tmpTemplate = state.templates[state.currentTemplateName];
      var tmpQuestionnaireFields = state.questionnaires[state.currentTemplateName].data;
      if (tmpTemplate['checkboxGroups'][fieldData.index]['fields'] === undefined) {
        tmpTemplate['checkboxGroups'][fieldData.index].fields = {};
      }
      tmpTemplate['checkboxGroups'][fieldData.index]['fields'][fieldData.fieldId] = fieldData.dataField;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(tmpQuestionnaireFields).forEach(function (fieldId) {
        if (tmpQuestionnaireFields[fieldId].fieldName === fieldData.index) {
          tmpQuestionnaireFields[fieldId].checkboxes[fieldData.fieldId] = fieldData.dataField;
        }
        if (tmpQuestionnaireFields[fieldId].fieldName === fieldData.fieldId) delete tmpQuestionnaireFields[fieldId];
      });
      state.templates[state.currentTemplateName] = tmpTemplate;
      state.questionnaires[state.currentTemplateName].data = tmpQuestionnaireFields;
    },
    addCheckboxToGroup: function addCheckboxToGroup(state, fieldData) {
      var tmpTemplate = state.templates[state.currentTemplateName];
      if (tmpTemplate['chGroups'][fieldData.index]['checkboxes'] === undefined) {
        tmpTemplate['chGroups'][fieldData.index].checkboxes = {};
      }
      tmpTemplate['chGroups'][fieldData.index]['checkboxes'][fieldData.fieldId] = fieldData.dataField;

      state.templates[state.currentTemplateName] = tmpTemplate;
    },
    removeFieldFromGroup: function removeFieldFromGroup(state, fieldData) {
      var tmpTemplate = state.templates[state.currentTemplateName];
      delete tmpTemplate['checkboxGroups'][fieldData.index]['fields'][fieldData.fieldId];
      var questionnaire = state.questionnaires[state.currentTemplateName]['data'];
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaire).forEach(function (field) {
        if (questionnaire[field].fieldName === fieldData.index) {
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaire[field].checkboxes).forEach(function (fieldName) {
            if (fieldData.fieldId === fieldName) delete questionnaire[field].checkboxes[fieldName];
          });
          if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaire[field].checkboxes).length === 0) delete questionnaire[field];
        }
      });
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(tmpTemplate['checkboxGroups'][fieldData.index]['fields']).length === 0) {
        delete tmpTemplate['checkboxGroups'][fieldData.index];
      }
      state.templates[state.currentTemplateName] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, state.templates[state.currentTemplateName], tmpTemplate);
      state.questionnaires[state.currentTemplateName]['data'] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, state.questionnaires[state.currentTemplateName]['data'], questionnaire);
    },
    removeCheckboxFromGroup: function removeCheckboxFromGroup(state, fieldData) {
      var tmpTemplate = state.templates[state.currentTemplateName];
      delete tmpTemplate['chGroups'][fieldData.index]['checkboxes'][fieldData.fieldId];

      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(tmpTemplate['chGroups'][fieldData.index]['checkboxes']).length === 0) {
        delete tmpTemplate['chGroups'][fieldData.index];
      }
      state.templates[state.currentTemplateName] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, state.templates[state.currentTemplateName], tmpTemplate);
    },
    editFieldGroup: function editFieldGroup(state, groupData) {
      var tmpTemplate = state.templates[state.currentTemplateName];
      var tmpQuestionnaireFields = state.questionnaires[state.currentTemplateName].data;
      if (groupData.name !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['name'] = groupData.name;
      if (groupData.label !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['title'] = groupData.label;
      if (groupData.help !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['desc'] = groupData.help;
      if (groupData.prefix !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['prefix'] = groupData.prefix;
      if (groupData.tabOrder !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['tabOrder'] = groupData.tabOrder;
      if (groupData.indent !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['indent'] = groupData.indent;
      if (groupData.abQuestion !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['abQuestion'] = groupData.abQuestion;
      if (groupData.tags !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['tags'] = groupData.tags;
      if (groupData.tagVisible !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['tagVisible'] = groupData.tagVisible;
      if (groupData.page !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['page'] = groupData.page;
      if (groupData.maxChecked !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['maxChecked'] = groupData.maxChecked;
      if (groupData.checkboxes !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['fields'] = groupData.checkboxes;
      if (groupData.watchers !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['watchers'] = groupData.watchers;
      state.templates[state.currentTemplateName] = tmpTemplate;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(tmpQuestionnaireFields).forEach(function (fieldId) {
        if (tmpQuestionnaireFields[fieldId].fieldName === groupData.index) {
          if (groupData.name !== undefined) tmpQuestionnaireFields[fieldId].name = groupData.name;
          if (groupData.label !== undefined) tmpQuestionnaireFields[fieldId].title = groupData.label;
          if (groupData.help !== undefined) tmpQuestionnaireFields[fieldId].desc = groupData.help;
          if (groupData.prefix !== undefined) tmpQuestionnaireFields[fieldId].prefix = groupData.prefix;
          if (groupData.indent !== undefined) tmpQuestionnaireFields[fieldId].indent = groupData.indent;
          if (groupData.abQuestion !== undefined) tmpQuestionnaireFields[fieldId].abQuestion = groupData.abQuestion;
          if (groupData.tags !== undefined) tmpQuestionnaireFields[fieldId].tags = groupData.tags;
          if (groupData.tagVisible !== undefined) tmpQuestionnaireFields[fieldId].tagVisible = groupData.tagVisible;
          if (groupData.page !== undefined) tmpQuestionnaireFields[fieldId].page = groupData.page;
          if (groupData.maxChecked !== undefined) tmpQuestionnaireFields[fieldId].maxChecked = groupData.maxChecked;
          if (groupData.watchers !== undefined) tmpQuestionnaireFields[fieldId].watchers = groupData.watchers;
        }
      });
      state.questionnaires[state.currentTemplateName].data = tmpQuestionnaireFields;
    },
    editCheckboxGroup: function editCheckboxGroup(state, groupData) {
      var tmpTemplate = state.templates[state.currentTemplateName];
      tmpTemplate['chGroups'][groupData.index]['name'] = groupData.name;
      tmpTemplate['chGroups'][groupData.index]['title'] = groupData.label;
      tmpTemplate['chGroups'][groupData.index]['desc'] = groupData.help;
      state.templates[state.currentTemplateName] = tmpTemplate;
    },
    editFieldGroupFieldLabel: function editFieldGroupFieldLabel(state, groupData) {
      var tmpTemplate = state.templates[state.currentTemplateName];
      var tmpQuestionnaireFields = state.questionnaires[state.currentTemplateName].data;
      tmpTemplate['checkboxGroups'][groupData.index]['fields'][groupData.fieldId].label = groupData.fieldLabel;
      state.templates[state.currentTemplateName] = tmpTemplate;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(tmpQuestionnaireFields).forEach(function (fieldId) {
        if (tmpQuestionnaireFields[fieldId].fieldName === groupData.index) {
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(tmpQuestionnaireFields[fieldId].checkboxes).forEach(function (fieldName) {
            if (fieldName === groupData.fieldId) {
              tmpQuestionnaireFields[fieldId].checkboxes[fieldName].translations.en.label = groupData.fieldLabel;
              tmpQuestionnaireFields[fieldId].checkboxes[fieldName].translations.en.text = groupData.fieldDesc;
            }
          });
        }
      });
    },
    removeFieldGroup: function removeFieldGroup(state, groupId) {
      var tmpTemplate = state.templates[state.currentTemplateName];
      delete tmpTemplate['checkboxGroups'][groupId];
      state.templates[state.currentTemplateName] = tmpTemplate;
      var questionnaire = state.questionnaires[state.currentTemplateName]['data'];
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaire).forEach(function (field) {
        if (questionnaire[field].fieldName === groupId) delete questionnaire[field];
      });
      state.questionnaires[state.currentTemplateName]['data'] = questionnaire;
    },
    removeCheckboxGroup: function removeCheckboxGroup(state, groupId) {
      var tmpTemplate = state.templates[state.currentTemplateName];
      delete tmpTemplate['chGroups'][groupId];
      state.templates[state.currentTemplateName] = tmpTemplate;
    },
    removeFieldGroupFromQuestionnaire: function removeFieldGroupFromQuestionnaire(state, groupId) {
      var questionnaire = state.questionnaires[state.currentTemplateName]['data'];
      state.templates[state.currentTemplateName].checkboxGroups[groupId].hide = true;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaire).forEach(function (field) {
        if (questionnaire[field].fieldName === groupId) delete questionnaire[field];
      });
      state.questionnaires[state.currentTemplateName]['data'] = questionnaire;
    },
    setGroupFieldMaxChecked: function setGroupFieldMaxChecked(state, fieldData) {
      for (var index = 0; index < __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.questionnaires[state.currentTemplateName].data).length; index++) {
        var dIndex = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.questionnaires[state.currentTemplateName].data)[index];
        var field = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.questionnaires[state.currentTemplateName].data[dIndex]));
        if (field.fieldName === fieldData.index) {
          var tmpQuestionnaire = state.questionnaires[state.currentTemplateName];
          tmpQuestionnaire['data'][dIndex]['maxChecked'] = fieldData.maxChecked;
          state.questionnaires[state.currentTemplateName] = tmpQuestionnaire;
        }
      }
    },
    setCheckboxGroupCheck: function setCheckboxGroupCheck(state, payload) {
      var templateCurrentPage = state.templates[state.currentTemplateName].pages[state.fileCurrentPage];
      var chGroups = state.templates[state.currentTemplateName].chGroups;
      var checkboxNames = [];

      if (payload.chGroupKey !== null && payload.chGroupKey !== undefined) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(chGroups[payload.chGroupKey].checkboxes).forEach(function (checkboxId) {
          if (payload.checked && payload.id !== checkboxId) {
            chGroups[payload.chGroupKey].checkboxes[checkboxId].value = '';

            checkboxNames.push(checkboxId);
          }
        });

        state.templates[state.currentTemplateName].chGroups = chGroups;
      }

      templateCurrentPage.forEach(function (checkbox, index) {
        if (checkbox !== null && checkbox.id === payload.id) {
          if (payload.checked) {
            checkbox.value = 'on';
          } else {
            checkbox.value = '';
          }

          templateCurrentPage[index] = checkbox;
        } else if (checkbox !== null && checkboxNames.indexOf(checkbox.id) !== -1) {
          checkbox.value = '';

          templateCurrentPage[index] = checkbox;
        }
      });

      state.templates[state.currentTemplateName].pages[state.fileCurrentPage] = templateCurrentPage;
    },
    orderSectionField: function orderSectionField(state, newId) {
      var newData = [];
      var indiceSection = false;
      var questionnaireFields = state.questionnaires[state.currentTemplateName].data;
      if (state.selectedQuestionnaireField === '') return;
      var sectionField = questionnaireFields[newId];
      delete questionnaireFields[newId];
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaireFields).forEach(function (fieldId) {
        if (questionnaireFields[fieldId].fieldName === questionnaireFields[state.selectedQuestionnaireField].fieldName && indiceSection === false) {
          newData.push(sectionField);
          newData.push(state.questionnaires[state.currentTemplateName].data[state.selectedQuestionnaireField]);
          indiceSection = true;
        } else {
          newData.push(state.questionnaires[state.currentTemplateName].data[fieldId]);
        }
      });
      if (indiceSection === false) newData.push(sectionField);

      var objFields = {};

      newData.forEach(function (field, index) {
        objFields[index + '-' + Math.random().toString(36).split('.')[1]] = field;
      });

      state.questionnaires[state.currentTemplateName]['data'] = objFields;
      state.selectedQuestionnaireField = '';
    },
    addSectionField: function addSectionField(state, fieldData) {
      var newIndex = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.questionnaires[state.currentTemplateName]['data']).length + '-' + Math.random().toString(36).split('.')[1];
      var newField = {
        type: 'section',
        fieldName: newIndex,
        state: 'OK',
        originalValue: fieldData.label,
        newValue: '',
        itemId: 23,
        model: '',
        deleted: false,
        approved: true,
        editable: true,
        subSection: fieldData.subSection,
        values: [],
        page: state.questionnaires[state.currentTemplateName].data[state.selectedQuestionnaireField].page,
        tabOrder: state.questionnaires[state.currentTemplateName].data[state.selectedQuestionnaireField].tabOrder - 1,
        title: fieldData.index,
        desc: 'Default inline help text',
        prefix: fieldData.prefix
      };
      state.questionnaires[state.currentTemplateName]['data'][newIndex] = newField;
      this.commit('orderSectionField', newIndex);
    },
    removeSection: function removeSection(state, fieldId) {
      var tmpQuestionnaire = state.questionnaires[state.currentTemplateName].data;

      if (tmpQuestionnaire[fieldId] !== undefined) delete tmpQuestionnaire[fieldId];else {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(tmpQuestionnaire).forEach(function (fieldKey) {
          if (tmpQuestionnaire[fieldKey].fieldName === fieldId) {
            delete tmpQuestionnaire[fieldKey];
          }
        });
      }

      state.questionnaires[state.currentTemplateName].data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, state.questionnaires[state.currentTemplateName].data, tmpQuestionnaire);
    },
    editSectionField: function editSectionField(state, fieldData) {
      var tmpQuestionnaire = state.questionnaires[state.currentTemplateName];
      tmpQuestionnaire['checkboxGroups'][fieldData.index]['name'] = fieldData.data;
      state.questionnaires[state.currentTemplateName] = tmpQuestionnaire;
    },
    changeInlineHelp: function changeInlineHelp(state, dataInlineHelp) {
      var questionnaireFields = state.questionnaires[state.currentTemplateName]['data'];
      if (questionnaireFields[dataInlineHelp.questionnaireId] !== undefined) {
        if (questionnaireFields[dataInlineHelp.questionnaireId].checkboxes) {
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaireFields[dataInlineHelp.questionnaireId].checkboxes).forEach(function (fieldName) {
            if (fieldName === dataInlineHelp.name) {
              if (questionnaireFields[dataInlineHelp.questionnaireId].checkboxes[fieldName].translations === undefined) {
                var translations = {};
                var en = {};
                en.label = dataInlineHelp.label;
                en.text = dataInlineHelp.inlineHelp;
                translations.en = en;
                questionnaireFields[dataInlineHelp.questionnaireId].checkboxes[fieldName].translations = translations;
              }
              questionnaireFields[dataInlineHelp.questionnaireId].checkboxes[fieldName].translations.en.label = dataInlineHelp.label;
              questionnaireFields[dataInlineHelp.questionnaireId].checkboxes[fieldName].translations.en.text = dataInlineHelp.inlineHelp;
            }
          });
        } else if (questionnaireFields[dataInlineHelp.questionnaireId].type !== 'section') {
          questionnaireFields[dataInlineHelp.questionnaireId].title = dataInlineHelp.label;
          questionnaireFields[dataInlineHelp.questionnaireId].desc = dataInlineHelp.inlineHelp;
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaireFields).forEach(function (fieldId) {
          if (questionnaireFields[fieldId].fieldName === dataInlineHelp.name) {
            questionnaireFields[fieldId].title = dataInlineHelp.label;
            questionnaireFields[fieldId].desc = dataInlineHelp.inlineHelp;
          }
        });
      }
      var templatePages = state.templates[state.currentTemplateName]['pages'];
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(templatePages).forEach(function (pageId) {
        if (templatePages[pageId] === null) return;
        templatePages[pageId].forEach(function (pageData, index) {
          if (pageData === null || pageData === undefined) return;
          if (pageData.name === dataInlineHelp.name) {
            if (pageData.translations) {
              var en = {
                label: dataInlineHelp.label,
                text: dataInlineHelp.inlineHelp
              };
              pageData['translations'].en = en;
            }
            pageData.questionHelp = dataInlineHelp.inlineHelp;
            templatePages[pageId][index] = pageData;
          }
        });
      });

      state.templates[state.currentTemplateName]['pages'] = templatePages;
      state.questionnaires[state.currentTemplateName]['data'] = questionnaireFields;
    },

    saveInlineHelpDb: function saveInlineHelpDb(state) {
      var postData = {
        questionnaireId: state.questionnaires[state.currentTemplateName]._id,
        newData: state.questionnaires[state.currentTemplateName]
      };
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.post(state.apiUrl + 'questionnaire/update', postData).then(function (response) {
        if (response.data.success) {
          return;
        }
      });
    },

    deleteExistOnFieldGroups: function deleteExistOnFieldGroups(state, fieldName) {
      if (state.templates[state.currentTemplateName]['checkboxGroups'] === undefined || state.templates[state.currentTemplateName]['checkboxGroups'] === null) return;
      var questionnaireFields = state.questionnaires[state.currentTemplateName].data;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.templates[state.currentTemplateName]['checkboxGroups']).forEach(function (group) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.templates[state.currentTemplateName]['checkboxGroups'][group]['fields']).forEach(function (checkbox) {
          if (checkbox === fieldName) {
            delete state.templates[state.currentTemplateName]['checkboxGroups'][group]['fields'][checkbox];
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaireFields).forEach(function (fieldId) {
              if (questionnaireFields[fieldId].checkboxes) {
                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaireFields[fieldId].checkboxes).forEach(function (fieldGroupFieldName) {
                  if (fieldGroupFieldName === fieldName) delete questionnaireFields[fieldId].checkboxes[fieldGroupFieldName];
                });
                if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaireFields[fieldId].checkboxes).length === 0) delete questionnaireFields[fieldId];
              }
            });
          }
          if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.templates[state.currentTemplateName]['checkboxGroups'][group]['fields']).length === 0) {
            delete state.templates[state.currentTemplateName]['checkboxGroups'][group];
          }
        });
      });
      state.questionnaires[state.currentTemplateName].data = questionnaireFields;
    },

    deleteExistOnCheckboxGroups: function deleteExistOnCheckboxGroups(state, fieldName) {
      if (state.templates[state.currentTemplateName]['chGroups'] === undefined || state.templates[state.currentTemplateName]['chGroups'] === null) return;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.templates[state.currentTemplateName]['chGroups']).forEach(function (group) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.templates[state.currentTemplateName]['chGroups'][group]['checkboxes']).forEach(function (checkbox) {
          if (checkbox === fieldName) {
            delete state.templates[state.currentTemplateName]['chGroups'][group]['checkboxes'][checkbox];
          }

          if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.templates[state.currentTemplateName]['chGroups'][group]['checkboxes']).length === 0) {
            delete state.templates[state.currentTemplateName]['chGroups'][group];
          }
        });
      });
    },

    setMessageWidgetData: function setMessageWidgetData(state, foundWidget) {
      if (state.questionnaires[state.currentTemplateName] === undefined) return;
      if (state.questionnaires[state.currentTemplateName]['properties'] === undefined) {
        var widgetData = {};
        var message = {};
        message = {
          message: ''
        };
        widgetData[foundWidget.fieldName] = message;
        var properties = {
          widgetData: widgetData
        };

        state.questionnaires[state.currentTemplateName].properties = properties;
      } else {
        var _widgetData = state.questionnaires[state.currentTemplateName]['properties']['widgetData'];

        var indiceWidget = 0;
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_widgetData).forEach(function (nameWidget) {
          if (nameWidget === foundWidget.fieldName) indiceWidget++;
        });
        if (indiceWidget === 0) {
          var _message = {};
          _message = {
            message: ''
          };
          state.questionnaires[state.currentTemplateName].properties['widgetData'][foundWidget.fieldName] = _message;
        }
      }
    },
    saveMsgWidget: function saveMsgWidget(state, dataWidget) {
      state.widgets.forEach(function (widget, index) {
        state.widgets[index]['model'].forEach(function (model) {
          if (model === dataWidget.model) {
            var widgetData = state.questionnaires[state.currentTemplateName]['properties']['widgetData'];
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(widgetData).forEach(function (widgetId) {
              if (widget.fieldName === widgetId) state.questionnaires[state.currentTemplateName]['properties']['widgetData'][widgetId].message = dataWidget.msg;
            });
          }
        });
      });
    },
    updatePrefixTemplate: function updatePrefixTemplate(state, data) {
      var templatePages = state.templates[state.currentTemplateName]['pages'];
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(templatePages).forEach(function (pageId) {
        if (templatePages[pageId] === null) return;
        templatePages[pageId].forEach(function (field, index) {
          if (data.fieldName === field.name) {
            field.prefix = data.prefix;
            templatePages[pageId][index] = field;
          }
        });
      });
      state.templates[state.currentTemplateName]['pages'] = templatePages;
    },
    updatePrefixQuestionnaire: function updatePrefixQuestionnaire(state, data) {
      if (state.questionnaires[state.currentTemplateName] && state.questionnaires[state.currentTemplateName] !== null) {
        var questionnaireFields = state.questionnaires[state.currentTemplateName]['data'];
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaireFields).forEach(function (fieldIndex) {
          if (data.fieldName === questionnaireFields[fieldIndex].fieldName) {
            questionnaireFields[fieldIndex].prefix = data.prefix;
          }
        });
        state.questionnaires[state.currentTemplateName]['data'] = questionnaireFields;
      }
    },
    updateModelTemplate: function updateModelTemplate(state, data) {
      var templatePages = state.templates[state.currentTemplateName]['pages'];
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(templatePages).forEach(function (pageId) {
        if (templatePages[pageId] === null) return;
        templatePages[pageId].forEach(function (field, index) {
          if (data.fieldName === field.name) {
            field.model = data.model;
            templatePages[pageId][index] = field;
          }
        });
      });
      state.templates[state.currentTemplateName]['pages'] = templatePages;
    },
    updateModelQuestionnaire: function updateModelQuestionnaire(state, data) {
      var questionnaireFields = state.questionnaires[state.currentTemplateName]['data'];
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaireFields).forEach(function (fieldIndex) {
        if (data.fieldName === questionnaireFields[fieldIndex].fieldName) {
          questionnaireFields[fieldIndex].model = data.model;
        }
      });
      state.questionnaires[state.currentTemplateName]['data'] = questionnaireFields;
    },
    setTranslation: function setTranslation(state) {
      var templatePages = state.templates[state.currentTemplateName]['pages'];

      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(templatePages).length === 0) return;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(templatePages).forEach(function (pageId) {
        if (templatePages[pageId] === null) return;
        if (templatePages[pageId].length === 0) return;

        templatePages[pageId].forEach(function (fieldPage, index) {
          if (fieldPage === null || fieldPage === undefined) return;
          if (!fieldPage.translations || fieldPage.translations === null) {
            var en = {
              label: fieldPage.name,
              text: fieldPage.name
            };
            fieldPage.translations = {};
            fieldPage.translations.en = en;
            templatePages[pageId][index] = fieldPage;
          }
          if (!fieldPage.importedInlineHelp || fieldPage.importedInlineHelp === null) {
            fieldPage.importedInlineHelp = {};
            fieldPage.importedInlineHelp.en = fieldPage.translations.en;
            templatePages[pageId][index] = fieldPage;
          }
        });
      });
      state.templates[state.currentTemplateName]['pages'] = templatePages;
    },
    setFieldPage: function setFieldPage(state) {
      var templatePages = state.templates[state.currentTemplateName]['pages'];

      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(templatePages).length === 0) return;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(templatePages).forEach(function (pageId) {
        if (templatePages[pageId] === null) return;
        if (templatePages[pageId].length === 0) return;

        templatePages[pageId].forEach(function (fieldPage, index) {
          if (fieldPage === null || fieldPage === undefined) return;
          if (!fieldPage.fieldPage || fieldPage.fieldPage === null) {
            fieldPage.fieldPage = pageId;
            templatePages[pageId][index] = fieldPage;
          }
        });
      });
      state.templates[state.currentTemplateName]['pages'] = templatePages;
    },
    setTranslationForId: function setTranslationForId(state, dataTranslation) {
      var templatePages = state.templates[state.currentTemplateName]['pages'];
      var questionnaireFields = state.questionnaires[state.currentTemplateName]['data'];
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(templatePages).length === 0 || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaireFields).length === 0 || !dataTranslation.field || !dataTranslation.translation) return;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(templatePages).forEach(function (pageId) {
        if (templatePages[pageId] === null) return;
        templatePages[pageId].forEach(function (fieldPage, index) {
          if (fieldPage === null || fieldPage === undefined) return;
          if (fieldPage.name === dataTranslation.field.name) {
            fieldPage.translations = dataTranslation.translation;
            templatePages[pageId][index] = fieldPage;
          }
        });
      });
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaireFields).forEach(function (fieldId) {
        if (questionnaireFields[fieldId].fieldName === dataTranslation.field.name) {
          questionnaireFields[fieldId].title = dataTranslation.translation.en.label;
          questionnaireFields[fieldId].desc = dataTranslation.translation.en.text;
        }
      });
      state.templates[state.currentTemplateName]['pages'] = templatePages;
      state.questionnaires[state.currentTemplateName]['data'] = questionnaireFields;
    },
    addFieldsToSection: function addFieldsToSection(state, dataAddToSection) {
      var questionnaireFields = state.questionnaires[state.currentTemplateName].data;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaireFields).forEach(function (fieldId) {
        if (fieldId === dataAddToSection.sectionIndex) {
          if (!questionnaireFields[fieldId].fieldsAdded) questionnaireFields[fieldId].fieldsAdded = {};
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(dataAddToSection.dataFields).forEach(function (index) {
            questionnaireFields[fieldId].fieldsAdded[dataAddToSection.dataFields[index].name] = dataAddToSection.dataFields[index].id;
          });
        }
      });
      state.questionnaires[state.currentTemplateName].data = questionnaireFields;
    },
    setFieldsAddedToSection: function setFieldsAddedToSection(state, dataAddToSection) {
      var questionnaireFields = state.questionnaires[state.currentTemplateName].data;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaireFields).forEach(function (fieldId) {
        if (fieldId === dataAddToSection.sectionIndex) {
          questionnaireFields[fieldId].fieldsAdded = dataAddToSection.dataFields;
        }
      });
      state.questionnaires[state.currentTemplateName].data = questionnaireFields;
    },
    editSection: function editSection(state, dataSection) {
      var questionnaireFields = state.questionnaires[state.currentTemplateName].data;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaireFields).forEach(function (fieldId) {
        if (fieldId === dataSection.index) {
          questionnaireFields[fieldId].fieldName = dataSection.name;
          questionnaireFields[fieldId].originalValue = dataSection.label;
          questionnaireFields[fieldId].desc = dataSection.help;
          questionnaireFields[fieldId].prefix = dataSection.prefix;
        }
      });
      state.questionnaires[state.currentTemplateName].data = questionnaireFields;
    },
    setPropsFieldGroups: function setPropsFieldGroups(state) {
      var templatesPages = state.templates[state.currentTemplateName].pages;
      var templatesGroups = state.templates[state.currentTemplateName].checkboxGroups;
      if (templatesGroups === null || templatesGroups === undefined) return;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(templatesGroups).forEach(function (groupName) {
        if (templatesGroups[groupName].fields) {
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(templatesGroups[groupName].fields).forEach(function (fieldName) {
            if (!templatesGroups[groupName].fields[fieldName].tabOrder || templatesGroups[groupName].fields[fieldName].tabOrder === undefined || templatesGroups[groupName].fields[fieldName].tabOrder === null) {
              if (templatesGroups[groupName].fields[fieldName].tabOrder === 0) return;
              __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(templatesPages).forEach(function (pageId) {
                templatesPages[pageId].forEach(function (field) {
                  if (field.name === fieldName) {
                    templatesGroups[groupName].fields[fieldName] = {};
                    templatesGroups[groupName].fields[fieldName] = field;
                  }
                });
              });
            }
            if (!templatesGroups[groupName].fields[fieldName].translations || templatesGroups[groupName].fields[fieldName].translations === undefined || templatesGroups[groupName].fields[fieldName].translations === null) {
              __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(templatesPages).forEach(function (pageId) {
                templatesPages[pageId].forEach(function (field) {
                  if (field.name === fieldName) {
                    templatesGroups[groupName].fields[fieldName] = {};
                    templatesGroups[groupName].fields[fieldName] = field;
                  }
                });
              });
            }
          });
        }
      });
      state.templates[state.currentTemplateName].pages = templatesPages;
      state.templates[state.currentTemplateName].checkboxGroups = templatesGroups;
    },
    setQuestionnairePageAndTabOrder: function setQuestionnairePageAndTabOrder(state) {
      if (state.questionnaires[state.currentTemplateName] !== undefined) {
        var questionnaireFields = state.questionnaires[state.currentTemplateName].data;
        var templatePages = state.templates[state.currentTemplateName].pages;

        var objFields = {};
        questionnaireFields.forEach(function (field, index) {
          objFields[index] = field;
        });
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(objFields).forEach(function (fieldId) {
          if (objFields[fieldId].type === 'section') return;
          if (!objFields[fieldId].page || !objFields[fieldId].tabOrder) {
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(templatePages).forEach(function (pageId) {
              if (templatePages[pageId] === null) return;
              templatePages[pageId].forEach(function (field) {
                if (field !== null && field.name === objFields[fieldId].fieldName) {
                  objFields[fieldId].page = field.fieldPage;
                  objFields[fieldId].tabOrder = field.tabOrder;
                }
              });
            });
          }
        });

        state.questionnaires[state.currentTemplateName].data = objFields;
      }
    },
    cleanMatchedIndexOnWidget: function cleanMatchedIndexOnWidget(state) {
      var widgets = state.widgets;

      widgets.forEach(function (widget, index) {
        widget.matchedIndex = [];
        widgets[index] = widget;
      });

      state.widgets = widgets;
    },
    deleteQuestionnaireField: function deleteQuestionnaireField(state, fieldName) {
      if (state.questionnaires[state.currentTemplateName] && state.questionnaires[state.currentTemplateName] !== null) {
        var questionnaireFields = state.questionnaires[state.currentTemplateName].data;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaireFields).forEach(function (fieldId) {
          if (questionnaireFields[fieldId] === null || questionnaireFields[fieldId] === undefined) return;
          if (questionnaireFields[fieldId].fieldName === fieldName) delete questionnaireFields[fieldId];
        });

        state.questionnaires[state.currentTemplateName].data = questionnaireFields;
      }
    },
    updateQuestionnaireField: function updateQuestionnaireField(state, data) {
      if (state.questionnaires[state.currentTemplateName] === undefined) return;

      var updatedFieldData = data.dataField;

      var questionnaireFields = state.questionnaires[state.currentTemplateName].data;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaireFields).forEach(function (fieldId) {
        if (questionnaireFields[fieldId] === null || questionnaireFields[fieldId] === undefined) return;
        if (questionnaireFields[fieldId].fieldName === data.name) {
          var newField = questionnaireFields[fieldId];
          newField.type = updatedFieldData.type;
          newField.model = updatedFieldData.model;
          newField.maxCharacter = Number(updatedFieldData.maxCharacter);
          newField.title = updatedFieldData.translations[state.currentLocale]['label'];
          newField.desc = updatedFieldData.translations[state.currentLocale]['text'];

          if (newField.type === 'textarea') newField.type = 'text';else if (newField.type === 'radio') newField.type = 'checkbox';else if (newField.type === 'button') newField.type = 'checkbox';else if (newField.type === 'select') {
            newField.type = 'combobox';
            newField.values = updatedFieldData.choiceData;
          }
          questionnaireFields[fieldId] = newField;
        } else if (questionnaireFields[fieldId].checkboxes) {
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaireFields[fieldId].checkboxes).forEach(function (fieldKey) {
            if (fieldKey === data.name) {
              var _newField = questionnaireFields[fieldId].checkboxes[fieldKey];
              _newField.type = updatedFieldData.type;
              _newField.model = updatedFieldData.model;
              _newField.maxCharacter = Number(updatedFieldData.maxCharacter);
              _newField.title = updatedFieldData.translations[state.currentLocale]['label'];
              _newField.desc = updatedFieldData.translations[state.currentLocale]['text'];

              if (_newField.type === 'textarea') _newField.type = 'text';else if (_newField.type === 'radio') _newField.type = 'checkbox';else if (_newField.type === 'button') _newField.type = 'checkbox';else if (_newField.type === 'select') {
                _newField.type = 'combobox';
                _newField.values = updatedFieldData.choiceData;
              }
              questionnaireFields[fieldId].checkboxes[fieldKey] = _newField;
            }
          });
        }
      });

      state.questionnaires[state.currentTemplateName].data = questionnaireFields;
    },
    setAuthentication: function setAuthentication(state, user) {
      state.user = user;
    }
  },

  getters: {
    getIfExistFieldOnWidget: function getIfExistFieldOnWidget(state) {
      return function (fieldName) {
        var widgets = state.widgets;

        var isWidget = null;

        widgets.forEach(function (widget) {
          if (widget.matchedIndex === undefined) return;
          widget.matchedIndex.forEach(function (field) {
            if (field.fieldName === fieldName) isWidget = true;
          });
        });

        return isWidget;
      };
    },

    getMatchedWidgetFields: function getMatchedWidgetFields(state) {
      return function (widgetId) {
        var fields = null;
        var widgets = state.widgets;

        widgets.forEach(function (widget) {
          if (widget._id === widgetId) fields = widget.matchedIndex;
        });

        return fields;
      };
    },

    getIdWidgetGroup: function getIdWidgetGroup(state) {
      return function (fieldName) {
        var widgets = state.widgets;
        var nameWidget = null;

        widgets.forEach(function (widget) {
          if (widget.matchedIndex === undefined) return;
          widget.matchedIndex.forEach(function (widgetField) {
            if (fieldName === widgetField.fieldName) nameWidget = widget._id;
          });
        });

        return nameWidget;
      };
    },

    getWidgetModels: function getWidgetModels(state) {
      return function (widgetId) {
        var models = null;
        var widgets = state.widgets;

        widgets.forEach(function (widget) {
          if (widget._id === widgetId) models = widget.model;
        });

        return models;
      };
    },

    getTemplateDataForModel: function getTemplateDataForModel(state) {
      return function (arrayFoundWidget) {
        var arrayModels = [];

        arrayFoundWidget.forEach(function (foundWidget) {
          foundWidget.matchedModels.forEach(function (model) {
            arrayModels.push(model);
          });
        });

        var arrayFields = [];
        var templatePages = state.templates[state.currentTemplateName].pages;
        if (templatePages === undefined || templatePages === null) return;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(templatePages).forEach(function (pageId) {
          if (templatePages[pageId] === null) return;
          templatePages[pageId].forEach(function (field) {
            if (field === null || field === undefined) return;
            if (field.model === '') return;
            if (arrayModels.indexOf(field.model) !== -1) {
              arrayFields.push(field);
            }
          });
        });

        return arrayFields;
      };
    },

    getSections: function getSections(state) {
      return function () {
        var foundSections = {};
        var questionnaireFields = state.questionnaires[state.currentTemplateName].data;
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaireFields).forEach(function (fieldId) {
          if (fieldId === undefined || fieldId === null) return;
          if (questionnaireFields[fieldId].type === null || questionnaireFields[fieldId].type === undefined) return;
          if (questionnaireFields[fieldId].type === 'section') foundSections[fieldId] = questionnaireFields[fieldId];
        });
        return foundSections;
      };
    },

    getAllModels: function getAllModels(state) {
      return function () {
        var templatePages = state.templates[state.currentTemplateName]['pages'];
        var dataFields = [];

        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(templatePages).length === 0) return;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(templatePages).forEach(function (pageId) {
          if (templatePages[pageId] === null) return;
          templatePages[pageId].forEach(function (fieldPage) {
            if (fieldPage === null || fieldPage === undefined || fieldPage.model === null || fieldPage.model === undefined) return;
            if (fieldPage.model !== '') dataFields.push(fieldPage);
          });
        });
        return dataFields;
      };
    },

    orderFieldsForPage: function orderFieldsForPage(state) {
      return function (questionnaireFields) {
        var dataFields = questionnaireFields;
        var newDataFields = [];
        var objFields = {};
        var tmpTabOrder = -1;
        var tmpPage = -1;
        var nameInsert = [];
        var contFields = 0;
        while (newDataFields.length < dataFields.length) {
          contFields++;
          questionnaireFields.forEach(function (field, index) {
            if (!field.page) {
              dataFields.splice(index, 1);
              return;
            } else if (!field.tabOrder) {
              dataFields.splice(index, 1);
              return;
            } else {
              if (tmpPage === -1 && nameInsert.indexOf(field.fieldName) === -1) {
                tmpPage = parseInt(field.page);
                tmpTabOrder = field.tabOrder;
              }
              if (tmpPage > parseInt(field.page) && nameInsert.indexOf(field.fieldName) === -1) {
                tmpPage = parseInt(field.page);
                tmpTabOrder = field.tabOrder;
              }
            }
          });
          questionnaireFields.forEach(function (field, index) {
            if (!field.page) dataFields.splice(index, 1);else if (!field.tabOrder) dataFields.splice(index, 1);else {
              if (tmpPage === parseInt(field.page) && tmpTabOrder > field.tabOrder && nameInsert.indexOf(field.fieldName) === -1) {
                tmpTabOrder = field.tabOrder;
              }
            }
          });
          questionnaireFields.forEach(function (field, index) {
            if (!field.page) dataFields.splice(index, 1);else if (!field.tabOrder) dataFields.splice(index, 1);else if (field === null) dataFields.splice(index, 1);else {
              if (parseInt(field.page) === tmpPage && field.tabOrder === tmpTabOrder && nameInsert.indexOf(field.fieldName) === -1) {
                newDataFields.push(field);
                nameInsert.push(field.fieldName);
                tmpTabOrder = -1;
                tmpPage = -1;
              }
            }
          });
          if (contFields > newDataFields.length) newDataFields.push({ fieldName: 'null' });
        }
        newDataFields.forEach(function (field, index) {
          objFields[index + '-' + Math.random().toString(36).split('.')[1]] = field;
        });
        return objFields;
      };
    },

    templateFields: function templateFields(state) {
      return function () {
        var fieldList = [];

        var _loop = function _loop(page) {
          if (state.templates[state.currentTemplateName]['pages'].hasOwnProperty(page)) {
            var fields = state.templates[state.currentTemplateName]['pages'][page];
            fields.forEach(function (field) {
              field['page'] = page;
              fieldList.push(field);
            });
          }
        };

        for (var page in state.templates[state.currentTemplateName]['pages']) {
          _loop(page);
        }

        return fieldList;
      };
    },

    formIndex: function formIndex(state) {
      return function (formId) {
        for (var i = 0; i < state.forms.length; i++) {
          var form = state.forms[i];
          if (form._id === formId) return i;
        }
        return null;
      };
    },

    templateFieldById: function templateFieldById(state) {
      return function (fieldId) {
        var fieldData = {};

        var _loop2 = function _loop2(pageIndex) {
          if (state.templates[state.currentTemplateName]['pages'].hasOwnProperty(pageIndex)) {
            var page = state.templates[state.currentTemplateName]['pages'][pageIndex];
            if (page === null) return 'continue';
            page.forEach(function (field) {
              if (field === null) return;
              if (field.id === fieldId) {
                fieldData = field;
                fieldData['fieldPage'] = pageIndex;
                return;
              }
            });
          }
        };

        for (var pageIndex in state.templates[state.currentTemplateName]['pages']) {
          var _ret2 = _loop2(pageIndex);

          if (_ret2 === 'continue') continue;
        }
        return fieldData;
      };
    },

    templateField: function templateField(state) {
      return function (templateName, fieldId, page) {
        var fieldData = {};
        state.templates[templateName]['pages'][page].forEach(function (field, index) {
          if (field.id === fieldId) {
            fieldData = field;
            return;
          }
        });
        return fieldData;
      };
    },

    templateFieldByModel: function templateFieldByModel(state) {
      return function (model) {
        var fieldId = null;
        state.templates[state.currentTemplateName]['pages'][state.fileCurrentPage].forEach(function (field, index) {
          if (field.model === model) {
            fieldId = field.id;
          }
        });
        return fieldId;
      };
    },

    currentTemplateField: function currentTemplateField(state) {
      return function (fieldId) {
        var fieldData = {};
        state.templates[state.currentTemplateName]['pages'][state.fileCurrentPage].forEach(function (field, index) {
          if (field === null) return;
          if (field.id === fieldId) {
            fieldData = field;
            return;
          }
        });
        return fieldData;
      };
    },

    templateFieldIndex: function templateFieldIndex(state) {
      return function (templateName, fieldId, page) {
        var fieldIndex = null;

        if (state.templates[templateName]['pages'][page] === undefined) return;
        state.templates[templateName]['pages'][page].forEach(function (field, index) {
          if (field === null) return;
          if (field.id === fieldId) fieldIndex = index;
        });
        return fieldIndex;
      };
    },

    currentTemplateFieldIndex: function currentTemplateFieldIndex(state) {
      return function (fieldId, page) {
        var fieldIndex = null;
        if (state.templates[state.currentTemplateName]['pages'][page] === undefined) return;
        state.templates[state.currentTemplateName]['pages'][page].forEach(function (field, index) {
          if (field === null) return;
          if (field.id === fieldId) fieldIndex = index;
        });
        return fieldIndex;
      };
    },

    fieldTooltip: function fieldTooltip(state) {
      return function (page, fieldIndex) {
        var localization = 'No localization text specified for this language.';
        if (typeof state.templates[state.currentTemplateName]['pages'][page][fieldIndex].translations !== 'undefined' && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.templates[state.currentTemplateName]['pages'][page][fieldIndex].translations).length && typeof state.templates[state.currentTemplateName]['pages'][page][fieldIndex].translations[state.currentLocale] !== 'undefined') {
          localization = state.templates[state.currentTemplateName]['pages'][page][fieldIndex].translations[state.currentLocale];
        }
        var fieldLabel = localization.label;
        var fieldText = localization.text;
        var fieldTabOrder = state.templates[state.currentTemplateName]['pages'][page][fieldIndex]['tabOrder'];
        if (typeof fieldLabel === 'undefined' || !fieldLabel.length) fieldLabel = state.templates[state.currentTemplateName]['pages'][page][fieldIndex]['name'];
        if (typeof fieldText === 'undefined' || !fieldText.length) fieldText = 'No help text provided for this language';
        return { name: fieldLabel, text: fieldText, tabOrder: fieldTabOrder };
      };
    },

    templateTabOrder: function templateTabOrder(state) {
      return function (fieldName) {
        var tabOrder = -1;
        state.templates[state.currentTemplateName]['pages'][state.fileCurrentPage].forEach(function (field, index) {
          if (field === null) return;
          if (field.id === fieldName) tabOrder = field.tabOrder;
        });
        return tabOrder;
      };
    },

    tabOrder: function tabOrder(state) {
      return function (fieldData) {
        var tabOrder = -1;
        state.templates[state.currentTemplateName]['pages'][fieldData.pageNum].forEach(function (field, index) {
          if (field.id === fieldData.fieldId) {
            tabOrder = field.tabOrder;
            return;
          }
        });
        return tabOrder;
      };
    },

    templateModel: function templateModel(state) {
      return function (fieldName) {
        var model = '';
        state.templates[state.currentTemplateName]['pages'][state.fileCurrentPage].forEach(function (field, index) {
          if (field === null) return;
          if (field.id === fieldName) model = field.model;
        });
        return model;
      };
    },

    searchModels: function searchModels(state) {
      return function (targetModel) {
        var foundModel = {};
        var newTarget = '';
        for (var index = 0; index < targetModel.length; index++) {
          if (isNaN(targetModel.charAt(index))) newTarget += targetModel.charAt(index);else newTarget += '#';
        }

        state.models.forEach(function (model) {
          var computedModel = model.type + model.prefix + model.field;
          if (computedModel === newTarget) {
            foundModel = model;
            return;
          }
        });
        return foundModel;
      };
    },

    // tabOrderExists: (state) => (tabOrder) => {
    //   for (const key in state.fields) {
    //     if (state.fields.hasOwnProperty(key)) {
    //       const field = state.fields[key]
    //       if (Number(field['tabOrder']) === Number(tabOrder)) return true
    //     }
    //   }
    //   return false
    // },

    topTabOrder: function topTabOrder(state) {
      return function () {
        var top = -1;
        for (var i = 0; i < state.templates[state.currentTemplateName]['pages'][state.fileCurrentPage].length; i++) {
          var field = state.templates[state.currentTemplateName]['pages'][state.fileCurrentPage][i];
          if (field['tabOrder'] > top) top = Number(field['tabOrder']);
        }
        return top > -1 ? top : 0;
      };
    },

    fileCurrentPage: function fileCurrentPage(state) {
      return function () {
        return state.fileCurrentPage;
      };
    },

    pageSvg: function pageSvg(state) {
      return function () {
        console.log(state.outputPath);
        return state.outputPath + '/svg/' + state.fileCurrentPage + '.svg';
      };
    },

    pageScale: function pageScale(state) {
      return function () {
        return state.pageScale;
      };
    },

    fontScale: function fontScale(state) {
      return function () {
        return state.fontSize * state.pageScale;
      };
    },

    fontSize: function fontSize(state) {
      return function () {
        return state.fontSize;
      };
    },

    pageWidth: function pageWidth(state) {
      return function () {
        return state.pageWidth * state.pageScale;
      };
    },

    pageHeight: function pageHeight(state) {
      return function () {
        return state.pageHeight * state.pageScale;
      };
    },

    totalPages: function totalPages(state) {
      return function () {
        return state.totalPages;
      };
    },

    annotationRotation: function annotationRotation(state) {
      return function (index) {
        return state.annotations[index]['rotation'];
      };
    },

    pageAnnotations: function pageAnnotations(state) {
      return function (page) {
        return [];
        // if (typeof state.documentFields[page] === 'undefined') return []
        // if (typeof state.documentFields[page]['pageAnnotations'] === 'undefined') return []
        // return state.documentFields[page]['pageAnnotations']
      };
    },

    modelWidget: function modelWidget(state) {
      return function (model) {
        var foundWidget = null;
        state.widgets.forEach(function (widget) {
          if (widget.model.indexOf(model) !== -1) {
            foundWidget = widget;
            return;
          }
        });
        return foundWidget;
      };
    },

    groupFieldNames: function groupFieldNames(state) {
      return function () {
        var names = {};
        for (var key in state.templates[state.currentTemplateName]['checkboxGroups']) {
          if (state.templates[state.currentTemplateName]['checkboxGroups'].hasOwnProperty(key)) {
            names[key] = state.templates[state.currentTemplateName]['checkboxGroups'][key]['name'];
          }
        }
        return names;
      };
    },

    chGroupCheckboxNames: function chGroupCheckboxNames(state) {
      return function () {
        var names = {};
        for (var key in state.templates[state.currentTemplateName]['chGroups']) {
          if (state.templates[state.currentTemplateName]['chGroups'].hasOwnProperty(key)) {
            names[key] = state.templates[state.currentTemplateName]['chGroups'][key]['name'];
          }
        }
        return names;
      };
    },

    groupFields: function groupFields(state) {
      return function () {
        if (typeof state.templates[state.currentTemplateName]['checkboxGroups'] === 'undefined') return {};
        return state.templates[state.currentTemplateName]['checkboxGroups'];
      };
    },

    chGroupFields: function chGroupFields(state) {
      return function () {
        if (typeof state.templates[state.currentTemplateName]['chGroups'] === 'undefined') return {};
        return state.templates[state.currentTemplateName]['chGroups'];
      };
    },

    fieldGroup: function fieldGroup(state) {
      return function (fieldId) {
        var foundKey = null;

        var _loop3 = function _loop3(key) {
          if (state.templates[state.currentTemplateName]['checkboxGroups'].hasOwnProperty(key)) {
            var group = state.templates[state.currentTemplateName]['checkboxGroups'][key];
            if (group.fields !== undefined) {
              __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(group.fields).forEach(function (field) {
                if (field === fieldId) {
                  foundKey = key;
                  return;
                }
              });
            }
          }
        };

        for (var key in state.templates[state.currentTemplateName]['checkboxGroups']) {
          _loop3(key);
        }
        return foundKey;
      };
    },

    checkboxGroup: function checkboxGroup(state) {
      return function (fieldId) {
        var foundKey = null;

        var _loop4 = function _loop4(key) {
          if (state.templates[state.currentTemplateName]['chGroups'].hasOwnProperty(key)) {
            var group = state.templates[state.currentTemplateName]['chGroups'][key];
            if (group.checkboxes !== undefined) {
              __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(group.checkboxes).forEach(function (field) {
                if (field === fieldId) {
                  foundKey = key;
                  return;
                }
              });
            }
          }
        };

        for (var key in state.templates[state.currentTemplateName]['chGroups']) {
          _loop4(key);
        }
        return foundKey;
      };
    },

    fieldGroupMaxFields: function fieldGroupMaxFields(state) {
      return function (fieldName) {
        for (var key in state.questionnaires[state.currentTemplateName].data) {
          if (state.questionnaires[state.currentTemplateName].data.hasOwnProperty(key)) {
            var field = state.questionnaires[state.currentTemplateName].data[key];
            if (field.fieldName === fieldName) {
              return field.maxChecked;
            }
          }
        }
        return null;
      };
    },

    searchQuestionnaire: function searchQuestionnaire(state) {
      return function (fieldId) {
        if (state.questionnaires[state.currentTemplateName] === undefined) return;

        var questionnaireField = null;
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.questionnaires[state.currentTemplateName]['data']).forEach(function (field) {
          if (state.questionnaires[state.currentTemplateName]['data'][field].fieldName === fieldId) questionnaireField = false;
        });
        return questionnaireField;
      };
    },

    getTemplateData: function getTemplateData(state) {
      return function (fieldName) {
        var template = state.templates[state.currentTemplateName]['pages'];
        var fieldData = null;
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(template).forEach(function (pageId) {
          if (template[pageId] === null) return;
          template[pageId].forEach(function (field) {
            if (field === null) return;
            if (field.name === fieldName) fieldData = field;
          });
        });
        return fieldData;
      };
    },

    addFieldQuestionnaire: function addFieldQuestionnaire(state) {
      return function (field) {
        if (field === null || state.questionnaires[state.currentTemplateName] === undefined) return;
        var newField = {};
        // let existingModels = []
        var newId = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.questionnaires[state.currentTemplateName]['data']).length + '-' + Math.random().toString(36).split('.')[1];
        // if (field.model.length && existingModels.indexOf(field.model) !== -1) return
        newField = {
          type: field.type,
          fieldName: field.id,
          state: 'OK',
          originalValue: typeof field.value !== 'undefined' && field.value.length ? field.value : '',
          newValue: '',
          itemId: 23,
          model: field.model,
          deleted: false,
          approved: true,
          editable: true,
          values: [],
          title: field.id,
          desc: 'Default inline help text',
          tabOrder: field.tabOrder,
          page: field.fieldPage,
          maxCharacter: Number(field.maxCharacter)
        };

        if (field.forceShow !== undefined) newField.forceShow = field.forceShow;

        if (field.tagVisible !== undefined) newField.tagVisible = field.tagVisible;

        if (typeof field.translations !== 'undefined') {
          if (typeof field.translations[state.currentLocale] !== 'undefined') {
            newField.title = field.translations[state.currentLocale]['label'];
            newField.desc = field.translations[state.currentLocale]['text'];
          }
        }
        if (newField.type === 'textarea') newField.type = 'text';else if (newField.type === 'radio') newField.type = 'checkbox';else if (newField.type === 'button') newField.type = 'checkbox';else if (newField.type === 'select') {
          newField.type = 'combobox';
          newField.values = field.choiceData;
        }

        var tmpQuestionnaires = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.questionnaires));

        tmpQuestionnaires[state.currentTemplateName].data[newId] = newField;

        return tmpQuestionnaires;
      };
    },

    getInlineHelp: function getInlineHelp(state) {
      return function (dataText) {
        var validate = __webpack_require__("ZZjE");

        var constraints = {
          text: {
            presence: { message: 'is required text' },
            length: {
              minimum: 3
            }
          }
        };
        var validationResults = validate(dataText, constraints);
        if (validationResults) return validationResults;
        var objLabel = null;
        var label = '';
        var inlineHelp = '';
        var from = null;
        var to = null;
        if (state.currentTemplateName !== 'global') {
          var arrayText = dataText.text.split(dataText.separator);
          var size = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(dataText.toLabel).length;
          if (size === 1) {
            from = parseInt(dataText.toLabel);
            to = from;
          } else {
            from = parseInt(dataText.toLabel.substring(0, 1));
            to = parseInt(dataText.toLabel.substring(2));
          }
          if (from < 1 || to < 1 || from > arrayText.length || from > to) return;
          for (var subIndiceArray = from - 1; subIndiceArray < to; subIndiceArray++) {
            if (subIndiceArray + 1 === to) {
              label = label + arrayText[subIndiceArray];
            } else {
              label = label + arrayText[subIndiceArray] + '.';
            }
          }
          for (var _subIndiceArray = to; _subIndiceArray < arrayText.length; _subIndiceArray++) {
            if (_subIndiceArray + 1 === arrayText.length) {
              inlineHelp = inlineHelp + arrayText[_subIndiceArray];
            } else {
              inlineHelp = inlineHelp + arrayText[_subIndiceArray] + '.';
            }
          }
          objLabel = {
            label: label,
            inlineHelp: inlineHelp
          };
        }
        return objLabel;
      };
    },

    getAllQuestionnaireFileds: function getAllQuestionnaireFileds(state) {
      return function () {
        var dataAllInlineHelp = [];
        var questionnaireFields = state.questionnaires[state.currentTemplateName]['data'];
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaireFields).forEach(function (field) {
          if (questionnaireFields[field].checkboxes) {
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaireFields[field].checkboxes).forEach(function (fieldName) {
              var fieldData = {
                questionnaireId: field,
                name: fieldName,
                desc: questionnaireFields[field].checkboxes[fieldName].translations.en.text,
                model: questionnaireFields[field].checkboxes[fieldName].model
              };
              dataAllInlineHelp.push(fieldData);
            });
          } else {
            var fieldData = {
              questionnaireId: field,
              name: questionnaireFields[field].fieldName,
              desc: questionnaireFields[field].desc,
              model: questionnaireFields[field].model
            };
            dataAllInlineHelp.push(fieldData);
          }
        });
        return dataAllInlineHelp;
      };
    },

    getInlineHelpFromTemplate: function getInlineHelpFromTemplate(state) {
      return function (nameFieldQuestionnaire) {
        var fieldDescTemplate = null;
        var pages = state.templates[state.currentTemplateName]['pages'];
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(pages).forEach(function (page) {
          if (pages[page] === undefined) return;
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(pages[page]).forEach(function (field) {
            if (pages[page][field] === null || pages[page][field] === undefined) return;
            var nameField = pages[page][field].name;
            if (nameField === nameFieldQuestionnaire) {
              if (pages[page][field]['importedInlineHelp'] === undefined || pages[page][field]['importedInlineHelp'] === null) return;
              fieldDescTemplate = pages[page][field]['importedInlineHelp']['en'];
            }
          });
        });
        return fieldDescTemplate;
      };
    },

    getFieldNamesFromFieldGroup: function getFieldNamesFromFieldGroup(state) {
      return function (groupId) {
        var nameFields = null;
        if (groupId !== undefined && groupId !== null) {
          if (state.templates[state.currentTemplateName]['checkboxGroups'][groupId] === undefined) return;
          if (state.templates[state.currentTemplateName]['checkboxGroups'][groupId]['fields'] === undefined) return;
          nameFields = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.templates[state.currentTemplateName]['checkboxGroups'][groupId]['fields']);
        }
        return nameFields;
      };
    },

    orderFieldGroupFields: function orderFieldGroupFields(state) {
      return function (dataFields) {
        var arrayTabsOrder = [];
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(dataFields).forEach(function (fieldId) {
          arrayTabsOrder.push(dataFields[fieldId].tabOrder);
        });

        var newFields = {};

        var _loop5 = function _loop5() {
          var menorTab = Math.min.apply(null, arrayTabsOrder);
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(dataFields).forEach(function (fieldId) {
            if (dataFields[fieldId].tabOrder === menorTab) {
              newFields[dataFields[fieldId].id] = dataFields[fieldId];
            }
          });
          var index = arrayTabsOrder.indexOf(menorTab);
          arrayTabsOrder.splice(index, 1);
        };

        while (arrayTabsOrder.length !== 0) {
          _loop5();
        }

        return newFields;
      };
    },

    getAllFieldNamesFromTemplate: function getAllFieldNamesFromTemplate(state) {
      return function () {
        var nameFields = [];
        var templatePages = state.templates[state.currentTemplateName].pages;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(templatePages).forEach(function (pageId) {
          if (templatePages[pageId] === null) return;
          templatePages[pageId].forEach(function (field) {
            if (field !== null) {
              nameFields.push(field.id);
            }
          });
        });

        return nameFields;
      };
    },

    getFormTags: function getFormTags(state) {
      return function () {
        var tags = [];
        var template = state.templates[state.currentTemplateName];

        // Template tags

        var templatePages = template.pages;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(templatePages).forEach(function (pageId) {
          if (templatePages[pageId] === null) return;
          templatePages[pageId].forEach(function (field) {
            if (field !== null && field !== undefined) {
              if (field.tags === undefined) field.tags = [];

              field.tags.forEach(function (tag) {
                var exist = false;

                tags.forEach(function (tagNext) {
                  if (tag === tagNext) exist = true;
                });

                if (exist === false) tags.push(tag);
              });
            }
          });
        });

        // Checkbox Group tags

        var checkboxGroups = template.checkboxGroups;

        if (checkboxGroups !== undefined && checkboxGroups !== null) {
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(checkboxGroups).forEach(function (checkboxGroupKey) {
            if (checkboxGroups[checkboxGroupKey] === null) return;

            if (checkboxGroups[checkboxGroupKey].tags === undefined) checkboxGroups[checkboxGroupKey].tags = [];

            checkboxGroups[checkboxGroupKey].tags.forEach(function (tag) {
              var exist = false;

              tags.forEach(function (tagNext) {
                if (tag === tagNext) exist = true;
              });

              if (exist === false) tags.push(tag);
            });
          });
        }

        // Questionnaire tags

        if (state.questionnaires[state.currentTemplateName] === undefined) return;

        var questionnaireFields = state.questionnaires[state.currentTemplateName].data;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionnaireFields).forEach(function (fieldKey) {
          if (questionnaireFields[fieldKey].tags === undefined) return;

          questionnaireFields[fieldKey].tags.forEach(function (tag) {
            var exist = false;

            tags.forEach(function (tagNext) {
              if (tag === tagNext) exist = true;
            });

            if (exist === false) tags.push(tag);
          });
        });

        return tags;
      };
    },

    getActionTags: function getActionTags(state) {
      return function (checkboxGroupId) {
        var actionTags = [];
        var template = state.templates[state.currentTemplateName];

        var checkboxGroups = template.checkboxGroups;

        if (checkboxGroups[checkboxGroupId] === null) return;

        if (checkboxGroups[checkboxGroupId].actionTags !== undefined) actionTags = checkboxGroups[checkboxGroupId].actionTags;

        return actionTags;
      };
    },

    isAuthenticated: function isAuthenticated(state) {
      return state.user;
    }
  }
}));

/***/ }),

/***/ "IdK9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_editor_main_MenuTop__ = __webpack_require__("H/zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_editor_main_GlobalTooltip__ = __webpack_require__("jGWI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_editor_main_MenuBottom__ = __webpack_require__("D848");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_editor_main_SideMenuPageList__ = __webpack_require__("Zoia");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_editor_main_SideMenuToolbox__ = __webpack_require__("eeQv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_editor_main_Annotations__ = __webpack_require__("NiOx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_editor_TimeTravel__ = __webpack_require__("1Q+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_editor_main_PageBackground__ = __webpack_require__("I/4s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_editor_main_PageFields__ = __webpack_require__("sv8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_editor_main_DragIndex__ = __webpack_require__("qxRI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_editor_main_MultipleSelect__ = __webpack_require__("kIlm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_editor_modals_ModalDialog__ = __webpack_require__("v+gJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_editor_modals_MultipleSelectDialog__ = __webpack_require__("RYsz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_editor_modals_ModalAddTemplate__ = __webpack_require__("mQ5X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_editor_modals_ModalDuplicateTemplate__ = __webpack_require__("lst1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_editor_modals_ModalDeleteTemplate__ = __webpack_require__("Jf+Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_editor_modal_edit_ModalEditField__ = __webpack_require__("gUy7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_editor_modals_ModalTemplateEditor__ = __webpack_require__("E26X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_editor_main_Notifications__ = __webpack_require__("gbl9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'editor-view',

  components: {
    MenuTop: __WEBPACK_IMPORTED_MODULE_0__components_editor_main_MenuTop__["a" /* default */],
    GlobalTooltip: __WEBPACK_IMPORTED_MODULE_1__components_editor_main_GlobalTooltip__["a" /* default */],
    MenuBottom: __WEBPACK_IMPORTED_MODULE_2__components_editor_main_MenuBottom__["a" /* default */],
    SideMenuPageList: __WEBPACK_IMPORTED_MODULE_3__components_editor_main_SideMenuPageList__["a" /* default */],
    SideMenuToolbox: __WEBPACK_IMPORTED_MODULE_4__components_editor_main_SideMenuToolbox__["a" /* default */],
    Annotations: __WEBPACK_IMPORTED_MODULE_5__components_editor_main_Annotations__["a" /* default */],
    TimeTravel: __WEBPACK_IMPORTED_MODULE_6__components_editor_TimeTravel__["a" /* default */],

    PageBackground: __WEBPACK_IMPORTED_MODULE_7__components_editor_main_PageBackground__["a" /* default */],
    PageFields: __WEBPACK_IMPORTED_MODULE_8__components_editor_main_PageFields__["a" /* default */],
    DragIndex: __WEBPACK_IMPORTED_MODULE_9__components_editor_main_DragIndex__["a" /* default */],
    MultipleSelect: __WEBPACK_IMPORTED_MODULE_10__components_editor_main_MultipleSelect__["a" /* default */],
    ModalDialog: __WEBPACK_IMPORTED_MODULE_11__components_editor_modals_ModalDialog__["a" /* default */],
    MultipleSelectDialog: __WEBPACK_IMPORTED_MODULE_12__components_editor_modals_MultipleSelectDialog__["a" /* default */],
    ModalAddTemplate: __WEBPACK_IMPORTED_MODULE_13__components_editor_modals_ModalAddTemplate__["a" /* default */],
    ModalDuplicateTemplate: __WEBPACK_IMPORTED_MODULE_14__components_editor_modals_ModalDuplicateTemplate__["a" /* default */],
    ModalDeleteTemplate: __WEBPACK_IMPORTED_MODULE_15__components_editor_modals_ModalDeleteTemplate__["a" /* default */],
    ModalEditField: __WEBPACK_IMPORTED_MODULE_16__components_editor_modal_edit_ModalEditField__["a" /* default */],
    ModalTemplateEditor: __WEBPACK_IMPORTED_MODULE_17__components_editor_modals_ModalTemplateEditor__["a" /* default */],
    Notifications: __WEBPACK_IMPORTED_MODULE_18__components_editor_main_Notifications__["a" /* default */]
  },

  methods: {
    handleMouseDown: function handleMouseDown(e) {
      if (e.keyCode === 83 && (navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey)) {
        e.preventDefault();
        this.$bus.emit('saveTriggered');
      }
    }
  },

  mounted: function mounted() {
    document.addEventListener('keydown', this.handleMouseDown, false);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.handleMouseDown, false);
  }
});

/***/ }),

/***/ "ImuZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'annotation-image',

  props: ['index', 'name', 'width', 'height', 'rotation', 'selected'],

  data: function data() {
    return {
      moveMode: false,
      resizeMode: false,
      rotateMode: false
    };
  },


  computed: {
    elStyle: function elStyle() {
      return 'width:' + this.width + 'px;height:' + this.height + 'px; transform: rotate(' + this.rotation + 'deg);';
    }
  },

  methods: {
    showControls: function showControls() {
      if (this.moveMode || this.resizeMode) return;
      var elPos = this.$el.getBoundingClientRect();
      this.$bus.emit('showAnnotationControls', {
        index: this.index,
        type: 'image',
        x: elPos.left,
        y: elPos.top + elPos.height
      });
    },
    keyPress: function keyPress(e) {
      if (!this.moveMode && !this.resizeMode && !this.rotateMode) return this.removeListeners();
      var keyCode = e.code;
      if (this.moveMode || this.resizeMode) {
        if (keyCode === 'Enter' || keyCode === 'NumpadEnter' || keyCode === 'Escape') {
          this.stopElementUpdates();
        }
      } else if (this.rotateMode) {
        if (keyCode !== 'ArrowLeft' && keyCode !== 'ArrowRight') return;
        var rotation = this.$store.getters.annotationRotation(this.index);
        if (keyCode === 'ArrowLeft') rotation -= 5;else if (keyCode === 'ArrowRight') rotation += 5;
        this.$store.commit('setAnnotationRotation', { index: this.index, amount: rotation });
      }
    }
  }
});

/***/ }),

/***/ "J/re":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J1/8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JOsq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree-view-element"},[_vm._l((_vm.$store.state.roleTreeData),function(catData,catName){return [_c('div',{staticClass:"tree-root",on:{"click":_vm.toggleExpand}},[(!_vm.expanded)?_c('i',{staticClass:"fas fa-plus"}):_c('i',{staticClass:"fas fa-minus"}),_vm._v(" "),_c('span',{staticClass:"font14"},[_vm._v(_vm._s(catName))])])]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JUe8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_select_dist_vue_select_css__ = __webpack_require__("R870");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_select_dist_vue_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_select_dist_vue_select_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'widget-labels-modal',

  data: function data() {
    return {
      currentWidget: {},
      widgetLabel: '',
      maxItems: '',
      widgets: [{
        label: 'Names',
        value: 'names'
      }, {
        label: 'Email',
        value: 'email'
      }, {
        label: 'Biographic',
        value: 'biographic'
      }, {
        label: 'Additional',
        value: 'additional'
      }, {
        label: 'Immigration',
        value: 'immigration'
      }, {
        label: 'Visa Petitions',
        value: 'visaPetitions'
      }, {
        label: 'Addresses',
        value: 'addresses'
      }, {
        label: 'Previous Addresses',
        value: 'previousAddresses'
      }, {
        label: 'Phones',
        value: 'phones'
      }, {
        label: 'Jobs',
        value: 'jobs'
      }, {
        label: 'Educational History',
        value: 'educationalHistory'
      }, {
        label: 'Criminal History',
        value: 'criminalHistory'
      }, {
        label: 'Work Permit',
        value: 'eads'
      }, {
        label: 'Passport',
        value: 'passport'
      }, {
        label: 'Travel History',
        value: 'travelHistory'
      }, {
        label: 'US Entries',
        value: 'usEntries'
      }, {
        label: 'Visa History',
        value: 'visaHistory'
      }, {
        label: 'Marriage History',
        value: 'marriageHistory'
      }, {
        label: 'Family Members',
        value: 'familyMembers'
      }, {
        label: 'Advance Parole',
        value: 'advanceParole'
      }]
    };
  },


  components: {
    vSelect: __WEBPACK_IMPORTED_MODULE_0_vue_select__["default"]
  },

  mounted: function mounted() {
    this.currentWidget = this.widgets[0];

    var currentTemplate = this.$store.state.templates[this.$store.state.currentTemplateName];

    if (currentTemplate.widgetLabels !== undefined && currentTemplate.widgetLabels !== null) {
      if (currentTemplate.widgetLabels[this.currentWidget.value] !== undefined) {
        this.widgetLabel = currentTemplate.widgetLabels[this.currentWidget.value].label !== undefined ? currentTemplate.widgetLabels[this.currentWidget.value].label : '';
      }
    }
  },


  methods: {
    setWidgetData: function setWidgetData() {
      var _this = this;

      var currentTemplate = this.$store.state.templates[this.$store.state.currentTemplateName];

      if (currentTemplate.widgetLabels === undefined || currentTemplate.widgetLabels === null) currentTemplate.widgetLabels = {};

      currentTemplate.widgetLabels[this.currentWidget.value] = {
        label: this.widgetLabel
      };

      this.$store.commit('setCurrentTemplateData', currentTemplate);

      setTimeout(function () {
        _this.$store.dispatch('saveTemplate');

        _this.$emit('close');
      }, 300);
    },
    changeWidget: function changeWidget() {
      var currentTemplate = this.$store.state.templates[this.$store.state.currentTemplateName];

      if (currentTemplate.widgetLabels !== undefined && currentTemplate.widgetLabels !== null) {
        if (currentTemplate.widgetLabels[this.currentWidget.value] !== undefined) {
          this.widgetLabel = currentTemplate.widgetLabels[this.currentWidget.value].label !== undefined ? currentTemplate.widgetLabels[this.currentWidget.value].label : '';
        } else this.widgetLabel = '';
      }
    }
  }
});

/***/ }),

/***/ "JZT4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    descriptionIcons: {
      type: String
    },
    left: {
      type: Number
    }
  }
});

/***/ }),

/***/ "Jb7u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jf+Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDeleteTemplate_vue__ = __webpack_require__("TLDX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15da961a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalDeleteTemplate_vue__ = __webpack_require__("YevJ");
function injectStyle (ssrContext) {
  __webpack_require__("RTVT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15da961a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDeleteTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15da961a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalDeleteTemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jg/M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jgco":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxWidget_vue__ = __webpack_require__("kBYB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f54eac8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckboxWidget_vue__ = __webpack_require__("/D84");
function injectStyle (ssrContext) {
  __webpack_require__("lHOH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f54eac8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxWidget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f54eac8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckboxWidget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JhrX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KEp1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxGroupEditModal_vue__ = __webpack_require__("7gPc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64971079_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckboxGroupEditModal_vue__ = __webpack_require__("gavN");
function injectStyle (ssrContext) {
  __webpack_require__("Ks5T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64971079"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxGroupEditModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64971079_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckboxGroupEditModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KV46":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionWidget_vue__ = __webpack_require__("1d4R");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf3c794c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionWidget_vue__ = __webpack_require__("nQFH");
function injectStyle (ssrContext) {
  __webpack_require__("Jb7u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bf3c794c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionWidget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf3c794c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionWidget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KYqO":
/***/ (function(module, exports) {

module.exports = {"_from":"elliptic@^6.5.3","_id":"elliptic@6.5.4","_inBundle":false,"_integrity":"sha512-iLhC6ULemrljPZb+QutR5TQGB+pdW6KGD5RSegS+8sorOZT+rdQFbsQFJgvN3eRqNALqJer4oQ16YvJHlU8hzQ==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"elliptic@^6.5.3","name":"elliptic","escapedName":"elliptic","rawSpec":"^6.5.3","saveSpec":null,"fetchSpec":"^6.5.3"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.4.tgz","_shasum":"da37cebd31e79a1367e941b592ed1fbebd58abbb","_spec":"elliptic@^6.5.3","_where":"/srv/primafacie-viewver/node_modules/browserify-sign","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"bundleDependencies":false,"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"},"deprecated":false,"description":"EC cryptography","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.4"}

/***/ }),

/***/ "Ks5T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L84T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible && !_vm.$store.state.drawingAnnotation),expression:"visible && !$store.state.drawingAnnotation"}],attrs:{"id":"globalTooltip"},on:{"mouseover":function($event){_vm.visible = true},"mouseout":function($event){_vm.visible = false}}},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.tooltipData.name))]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.tooltipData.text))]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v("Tab order: "+_vm._s(_vm.tooltipData.tabOrder))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "La9k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'form-slider',

  props: {
    val: {
      type: Number,
      default: 0
    },

    min: {
      type: Number,
      default: 1
    },

    max: {
      type: Number,
      default: 3
    },

    step: {
      type: Number,
      default: 0.25
    },

    width: {
      type: Number,
      default: 130
    },

    height: {
      type: Number,
      default: 20
    }
  },

  data: function data() {
    return {
      value: 0
    };
  },


  computed: {
    style: function style() {
      var styleStr = '';
      styleStr += 'width: ' + this.width + 'px;';
      styleStr += 'height: ' + this.height + 'px;';
      return styleStr;
    }
  },

  methods: {
    valueUpdate: function valueUpdate(e) {
      this.$emit('form-slider-changed', this.value);
    }
  }
});

/***/ }),

/***/ "LbmV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LoMM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"annotation annotationTextarea",style:(_vm.rotateStyle)},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"annotationEl",style:(_vm.getStyle),attrs:{"id":'annotationTextarea-' + _vm.index,"readonly":_vm.readOnly},domProps:{"value":(_vm.value)},on:{"click":_vm.showControls,"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LrLJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-template-editor',

  data: function data() {
    return {
      showDialog: false,
      currentTemplateName: '',

      columns: ['page', 'id', 'model', 'value', 'type'],
      options: {
        highlightMatches: true
      }
    };
  },
  mounted: function mounted() {
    var that = this;
    this.$bus.on('showTemplateEditorDialog', function () {
      that.currentTemplateName = that.$store.state.currentTemplateName;
      that.showDialog = true;
    });
    this.$bus.on('setCurrentTemplateName', function (templateName) {
      that.currentTemplateName = templateName;
    });
    this.$bus.on('closeModal', function () {
      that.closeModal();
    });
  },


  methods: {
    setEditRow: function setEditRow(rowData) {
      var fieldData = this.$store.getters.templateField(this.currentTemplateName, rowData.id, rowData.page);

      if (rowData.page !== this.$store.state.fileCurrentPage) {
        this.$store.commit('setCurrentPage', rowData.page);
        this.$bus.emit('pageChange', rowData.page);
      }

      this.$bus.emit('openFieldMenu', {
        id: fieldData.id,
        pos: { x: fieldData.x, y: fieldData.y },
        tabOrder: fieldData.tabOrder
      });
      this.closeModal();
    },
    closeModal: function closeModal() {
      this.$store.commit('setShowBottomMenu', true);
      this.showDialog = false;
    },
    changeTemplate: function changeTemplate() {
      this.$store.commit('setCurrentTemplateName', this.currentTemplateName);
      this.$bus.emit('setCurrentTemplateName', this.currentTemplateName);
      var that = this;
      this.$store.dispatch('applyTemplate').then(function (result) {
        if (result) {
          that.$bus.emit('addNotification', {
            title: 'Applied Template',
            body: 'Template "' + that.currentTemplateName + '" applied successfully.',
            type: 'success'
          });
        } else {
          that.$bus.emit('addNotification', {
            title: 'Error Applying Template',
            body: 'An error occured while applying the template "' + that.currentTemplateName + '". Please review the data and try again.',
            type: 'error'
          });
        }
      });
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('showTemplateEditorDialog');
    this.$bus.$off('setCurrentTemplateName');
    this.$bus.$off('closeModal');
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcfd8be6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("p/r/");
function injectStyle (ssrContext) {
  __webpack_require__("C8WD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcfd8be6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MSAx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarcodeTemplateModal_vue__ = __webpack_require__("PpZK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28c1d7ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BarcodeTemplateModal_vue__ = __webpack_require__("hRS4");
function injectStyle (ssrContext) {
  __webpack_require__("Q+GX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28c1d7ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarcodeTemplateModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28c1d7ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BarcodeTemplateModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MSKw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MhtQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"id":"backgroundImage","src":_vm.$store.getters.pageSvg(),"width":_vm.$store.getters.pageWidth(),"height":_vm.$store.getters.pageHeight(),"draggable":"false"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N7ac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRestoredFields)?_c('div',{attrs:{"id":"restoreFieldList"}},[_c('div',{staticClass:"header",staticStyle:{"margin-top":"20px"}},[_c('h3',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('span',{attrs:{"id":"btn-close"},on:{"click":_vm.colseRestoredFieldsModal}},[_c('i',{staticClass:"fas fa-window-close"})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.fieldsList),function(field,index){return (_vm.fieldsList.length > 0)?[_c('div',{key:index},[_c('ul',[_c('label',{attrs:{"for":""}},[_vm._v("Page: "+_vm._s(field.fieldPage))]),_vm._v(" "),_c('li',[_vm._v("\n          "+_vm._s(field.name)+"\n        ")])])])]:_vm._e()})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bus__ = __webpack_require__("fC7K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_tables_2__ = __webpack_require__("e9ss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_clipboard2__ = __webpack_require__("wvfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_v_mask__ = __webpack_require__("1I9z");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












window.sweetAlert = __WEBPACK_IMPORTED_MODULE_8_sweetalert___default.a;
window.swAlert = __WEBPACK_IMPORTED_MODULE_10_sweetalert2__["default"];

window.Vue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"];

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_6_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_tables_2__["ClientTable"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_bus__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_9_vue_clipboard2___default.a.config.autoSetContainer = true; // add this line
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_clipboard2___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('mask', __WEBPACK_IMPORTED_MODULE_11_v_mask__["a" /* VueMaskDirective */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('capitalize', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "NJ5a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ndnm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NiOx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Annotations_vue__ = __webpack_require__("t6RW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bb38413_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Annotations_vue__ = __webpack_require__("Ttnt");
function injectStyle (ssrContext) {
  __webpack_require__("lSQg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bb38413"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Annotations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bb38413_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Annotations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NwBc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O5dt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OJSY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditFormModal_vue__ = __webpack_require__("Edzi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_091d571e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditFormModal_vue__ = __webpack_require__("eQkI");
function injectStyle (ssrContext) {
  __webpack_require__("JhrX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-091d571e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditFormModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_091d571e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditFormModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OcME":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadTooltipsModal_vue__ = __webpack_require__("u5It");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b7df495_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadTooltipsModal_vue__ = __webpack_require__("DfGl");
function injectStyle (ssrContext) {
  __webpack_require__("p3tc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b7df495"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadTooltipsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b7df495_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadTooltipsModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Od8b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12",attrs:{"id":"addFormModal","tabindex":"-1"}},[_c('div',{staticClass:"header"},[_c('span',{staticClass:"title"},[_vm._v("Add Form")]),_vm._v(" "),_c('span',{staticClass:"btn-close float-right",on:{"click":_vm.closeModal}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"forms-wrapper"},[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],class:['form-control', _vm.invalidFields.indexOf('name') === -1 ? '' : 'invalid'],attrs:{"type":"text","id":"name","placeholder":"Name of the form"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"title"}},[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],class:['form-control', _vm.invalidFields.indexOf('title') === -1 ? '' : 'invalid'],attrs:{"type":"text","id":"title","placeholder":"Title of the form"},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"viewer-url"}},[_vm._v("Viewer URL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.viewer_url),expression:"viewer_url"}],class:['form-control', _vm.invalidFields.indexOf('viewer_url') === -1 ? '' : 'invalid'],attrs:{"type":"text","id":"viewer_url","placeholder":"The path to the SVG and thumbnail output"},domProps:{"value":(_vm.viewer_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.viewer_url=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"status"}},[_vm._v("Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"DEV"}},[_vm._v("DEV")]),_vm._v(" "),_c('option',{attrs:{"value":"Enabled"}},[_vm._v("Enabled")]),_vm._v(" "),_c('option',{attrs:{"value":"Disabled"}},[_vm._v("Disabled")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"revision-date"}},[_vm._v("Revision Date")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"},{name:"model",rawName:"v-model",value:(_vm.revisionDate),expression:"revisionDate"}],class:['form-control', _vm.invalidFields.indexOf('revisionDate') === -1 ? '' : 'invalid'],attrs:{"type":"text","id":"revisionDate","placeholder":"01/31/2018"},domProps:{"value":(_vm.revisionDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.revisionDate=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"expiration-date"}},[_vm._v("Expiration Date")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"},{name:"model",rawName:"v-model",value:(_vm.expirationDate),expression:"expirationDate"}],class:['form-control', _vm.invalidFields.indexOf('expirationDate') === -1 ? '' : 'invalid'],attrs:{"type":"text","id":"expirationDate","placeholder":"12/31/2018"},domProps:{"value":(_vm.expirationDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.expirationDate=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"version"}},[_vm._v("Version")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.version),expression:"version"}],class:['form-control', _vm.invalidFields.indexOf('version') === -1 ? '' : 'invalid'],attrs:{"type":"number","id":"version"},domProps:{"value":(_vm.version)},on:{"input":function($event){if($event.target.composing){ return; }_vm.version=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"library"}},[_vm._v("Library")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.practiceArea),expression:"practiceArea"}],staticClass:"form-control",attrs:{"id":"library"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.practiceArea=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.setPracticeAreaSections]}},_vm._l((_vm.$store.state.practiceAreas),function(area,index){return _c('option',{key:index,domProps:{"value":area.name}},[_vm._v("\n                "+_vm._s(area.name)+"\n              ")])}),0)])]),_vm._v(" "),(!Object.keys(_vm.globalTemplate).length)?_c('div',{staticClass:"col-sm-4"},[_c('input',{attrs:{"accept":".json","type":"file","id":"selectFiles","value":"Import"}}),_vm._v(" "),_c('input',{staticClass:"btn btn-info",attrs:{"type":"button","value":"Upload Template"},on:{"click":_vm.getJsonFile}})]):_c('div',{staticClass:"col-sm-4"},[_c('h4',[_vm._v("Global Template Ready")]),_vm._v(" "),_c('p',[_vm._v("Processed "+_vm._s(_vm.totalFields)+" fields in "+_vm._s(_vm.totalPages)+" pages.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"primaId"}},[_vm._v("Prima ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.primaId),expression:"primaId"}],class:['form-control', _vm.invalidFields.indexOf('primaId') === -1 ? '' : 'invalid'],attrs:{"type":"number","id":"primaId"},domProps:{"value":(_vm.primaId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.primaId=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-between"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"practice-area-section"}},[_vm._v("Sections")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.practiceAreaSection),expression:"practiceAreaSection"}],staticClass:"form-control",attrs:{"id":"practice-area-section"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.practiceAreaSection=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.practiceAreaSections),function(section,index){return _c('option',{key:index,domProps:{"value":section,"selected":_vm.selectPracticeAreaSection(section)}},[_vm._v("\n                "+_vm._s(section)+"\n              ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"enable-for-questionnaire"}},[_vm._v("Enable for Questionnaire")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{attrs:{"id":"enable-for-questionnaire","type":"checkbox"},domProps:{"checked":_vm.enableForQ},on:{"click":function($event){_vm.enableForQ = !_vm.enableForQ}}})])])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-between"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"practice-area-tag"}},[_vm._v("Practice Area")]),_vm._v(" "),_c('search-select',{attrs:{"multiple":true,"options":_vm.tagsFormPA},model:{value:(_vm.practiceAreaTag),callback:function ($$v) {_vm.practiceAreaTag=$$v},expression:"practiceAreaTag"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 pull-right"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"internal-tag"}},[_vm._v("Internal Tag")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('search-select',{attrs:{"taggable":true,"multiple":true,"options":_vm.tagsFormInternal},model:{value:(_vm.internalTag),callback:function ($$v) {_vm.internalTag=$$v},expression:"internalTag"}})],1)])])]),_vm._v(" "),_c('h2',[_vm._v("Roles")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"role"}},[_vm._v("Role")]),_vm._v(" "),_c('search-select',{attrs:{"id":"addFormRole1","label":"name","options":_vm.$store.state.formRoles},model:{value:(_vm.role1),callback:function ($$v) {_vm.role1=$$v},expression:"role1"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"prefix"}},[_vm._v("Prefix")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefix1),expression:"prefix1"}],staticClass:"form-control",attrs:{"type":"text","id":"prefix"},domProps:{"value":(_vm.prefix1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prefix1=$event.target.value}}})])]),_vm._v(" "),(_vm.role1 !== '' && _vm.role1 !== '0' && _vm.role1._id !== undefined)?_c('div',{staticClass:"col-sm-2",staticStyle:{"margin-top":"12px"}},[_c('label'),_vm._v(" "),_c('input',{staticClass:"btn btn-sm btn-primary btn-block",attrs:{"type":"button","value":"Max Items","id":"maxRole"},on:{"click":function($event){return _vm.showMaxItemsModal('role1')}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"role2"}},[_vm._v("Role 2")]),_vm._v(" "),_c('search-select',{attrs:{"id":"addFormRole2","label":"name","options":_vm.$store.state.formRoles},model:{value:(_vm.role2),callback:function ($$v) {_vm.role2=$$v},expression:"role2"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"prefix2"}},[_vm._v("Prefix 2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefix2),expression:"prefix2"}],staticClass:"form-control",attrs:{"type":"text","id":"prefix2"},domProps:{"value":(_vm.prefix2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prefix2=$event.target.value}}})])]),_vm._v(" "),(_vm.role2 !== '' && _vm.role2 !== '0' && _vm.role2._id !== undefined)?_c('div',{staticClass:"col-sm-2",staticStyle:{"margin-top":"12px"}},[_c('label'),_vm._v(" "),_c('input',{staticClass:"btn btn-sm btn-primary btn-block",attrs:{"type":"button","value":"Max Items","id":"maxRole2"},on:{"click":function($event){return _vm.showMaxItemsModal('role2')}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"role3"}},[_vm._v("Role 3")]),_vm._v(" "),_c('search-select',{attrs:{"id":"addFormRole3","label":"name","options":_vm.$store.state.formRoles},model:{value:(_vm.role3),callback:function ($$v) {_vm.role3=$$v},expression:"role3"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"prefix3"}},[_vm._v("Prefix 3")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefix3),expression:"prefix3"}],staticClass:"form-control",attrs:{"type":"text","id":"prefix3"},domProps:{"value":(_vm.prefix3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prefix3=$event.target.value}}})])]),_vm._v(" "),(_vm.role3 !== '' && _vm.role3 !== '0' && _vm.role3._id !== undefined)?_c('div',{staticClass:"col-sm-2",staticStyle:{"margin-top":"12px"}},[_c('label'),_vm._v(" "),_c('input',{staticClass:"btn btn-sm btn-primary btn-block",attrs:{"type":"button","value":"Max Items","id":"maxRole3"},on:{"click":function($event){return _vm.showMaxItemsModal('role3')}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"role4"}},[_vm._v("Role 4")]),_vm._v(" "),_c('search-select',{attrs:{"id":"addFormRole4","label":"name","options":_vm.$store.state.formRoles},model:{value:(_vm.role4),callback:function ($$v) {_vm.role4=$$v},expression:"role4"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"prefix4"}},[_vm._v("Prefix 4")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefix4),expression:"prefix4"}],staticClass:"form-control",attrs:{"type":"text","id":"prefix4"},domProps:{"value":(_vm.prefix4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prefix4=$event.target.value}}})])]),_vm._v(" "),(_vm.role4 !== '' && _vm.role4 !== '0' && _vm.role4._id !== undefined)?_c('div',{staticClass:"col-sm-2",staticStyle:{"margin-top":"12px"}},[_c('label'),_vm._v(" "),_c('input',{staticClass:"btn btn-sm btn-primary btn-block",attrs:{"type":"button","value":"Max Items","id":"maxRole4"},on:{"click":function($event){return _vm.showMaxItemsModal('role4')}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"role5"}},[_vm._v("Role 5")]),_vm._v(" "),_c('search-select',{attrs:{"id":"addFormRole5","label":"name","options":_vm.$store.state.formRoles},model:{value:(_vm.role5),callback:function ($$v) {_vm.role5=$$v},expression:"role5"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"prefix5"}},[_vm._v("Prefix 5")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefix5),expression:"prefix5"}],staticClass:"form-control",attrs:{"type":"text","id":"prefix5"},domProps:{"value":(_vm.prefix5)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prefix5=$event.target.value}}})])]),_vm._v(" "),(_vm.role5 !== '' && _vm.role5 !== '0' && _vm.role5._id !== undefined)?_c('div',{staticClass:"col-sm-2",staticStyle:{"margin-top":"12px"}},[_c('label',{attrs:{"for":""}}),_vm._v(" "),_c('input',{staticClass:"btn btn-sm btn-primary btn-block",attrs:{"type":"button","value":"Max Items","id":"maxRole5"},on:{"click":function($event){return _vm.showMaxItemsModal('role5')}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"role6"}},[_vm._v("Role 6")]),_vm._v(" "),_c('search-select',{attrs:{"id":"addFormRole6","label":"name","options":_vm.$store.state.formRoles},model:{value:(_vm.role6),callback:function ($$v) {_vm.role6=$$v},expression:"role6"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"prefix6"}},[_vm._v("Prefix 6")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefix6),expression:"prefix6"}],staticClass:"form-control",attrs:{"type":"text","id":"prefix6"},domProps:{"value":(_vm.prefix6)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prefix6=$event.target.value}}})])]),_vm._v(" "),(_vm.role6 !== '' && _vm.role6 !== '0' && _vm.role6._id !== undefined)?_c('div',{staticClass:"col-sm-2",staticStyle:{"margin-top":"12px"}},[_c('label',{attrs:{"for":""}}),_vm._v(" "),_c('input',{staticClass:"btn btn-sm btn-primary btn-block",attrs:{"type":"button","value":"Max Items","id":"maxRole6"},on:{"click":function($event){return _vm.showMaxItemsModal('role6')}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"role7"}},[_vm._v("Role 7")]),_vm._v(" "),_c('search-select',{attrs:{"id":"addFormRole7","label":"name","options":_vm.$store.state.formRoles},model:{value:(_vm.role7),callback:function ($$v) {_vm.role7=$$v},expression:"role7"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"prefix7"}},[_vm._v("Prefix 7")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefix7),expression:"prefix7"}],staticClass:"form-control",attrs:{"type":"text","id":"prefix7"},domProps:{"value":(_vm.prefix7)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prefix7=$event.target.value}}})])]),_vm._v(" "),(_vm.role7 !== '' && _vm.role7 !== '0' && _vm.role7._id !== undefined)?_c('div',{staticClass:"col-sm-2",staticStyle:{"margin-top":"12px"}},[_c('label',{attrs:{"for":""}}),_vm._v(" "),_c('input',{staticClass:"btn btn-sm btn-primary btn-block",attrs:{"type":"button","value":"Max Items","id":"maxRole7"},on:{"click":function($event){return _vm.showMaxItemsModal('role7')}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"role"}},[_vm._v("Role 8")]),_vm._v(" "),_c('search-select',{attrs:{"id":"addFormRole8","label":"name","options":_vm.$store.state.formRoles},model:{value:(_vm.role8),callback:function ($$v) {_vm.role8=$$v},expression:"role8"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"prefix8"}},[_vm._v("Prefix 8")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefix8),expression:"prefix8"}],staticClass:"form-control",attrs:{"type":"text","id":"prefix8"},domProps:{"value":(_vm.prefix8)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prefix8=$event.target.value}}})])]),_vm._v(" "),(_vm.role8 !== '' && _vm.role8 !== '0' && _vm.role8._id !== undefined)?_c('div',{staticClass:"col-sm-2",staticStyle:{"margin-top":"12px"}},[_c('label',{attrs:{"for":""}}),_vm._v(" "),_c('input',{staticClass:"btn btn-sm btn-primary btn-block",attrs:{"type":"button","value":"Max Items","id":"maxRole8"},on:{"click":function($event){return _vm.showMaxItemsModal('role8')}}})]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":_vm.uploadForm}},[_vm._v("Add Form")]),_vm._v(" "),_c('div',{staticClass:"scroll-padding"})]),_vm._v(" "),(_vm.isMaxItemsModal === true)?_c('max-items-modal',{attrs:{"role":_vm.currentRole,"maxItems":_vm.maxItems},on:{"close":function($event){_vm.isMaxItemsModal = false},"update-maxitems":_vm.updateMaxItems}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PpZK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'barcode-template-modal',

  data: function data() {
    return {
      barcodeEditIndex: null,
      barcodeId: '',
      barcodeModel: '',
      isAddBarcode: false,
      pdfFieldBarcode: '',
      pageBarcode: this.$store.state.fileCurrentPage,

      listBarcode: [],

      isDeleteBarcode: false,
      deleteBarcodeIndex: null,
      deleteBarcodeId: '',

      typeModal: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch('getListBarcodeTemplate').then(function (response) {
      _this.listBarcode = response.data;
    });
  },


  methods: {
    addBarcodeModal: function addBarcodeModal() {
      this.typeModal = 'Add';
      this.isAddBarcode = true;
      this.barcodeId = '';
      this.barcodeModel = '';
      this.pdfFieldBarcode = '';
      this.pageBarcode = this.$store.state.fileCurrentPage;
    },
    addBarcodeTemplate: function addBarcodeTemplate() {
      var _this2 = this;

      if (this.barcodeId !== '') this.editBarcode();else {
        var barcodeTemplate = {
          formId: this.$store.state.templates[this.$store.state.currentTemplateName].formId,
          page: this.pageBarcode,
          pdfFieldBarcode: this.pdfFieldBarcode,
          model: this.barcodeModel
        };

        this.$store.dispatch('addBarcodeTemplate', barcodeTemplate).then(function (response) {
          if (response.data.success === true) {
            _this2.$bus.emit('addNotification', {
              title: 'Barcode Template',
              body: 'Barcode saved succesfully.',
              type: 'success'
            });

            barcodeTemplate._id = response.data.barcodeId;

            _this2.listBarcode.push(barcodeTemplate);

            _this2.isAddBarcode = false;
          } else {
            _this2.$bus.emit('addNotification', {
              title: 'Barcode Template',
              body: 'Ocurred an error.',
              type: 'error'
            });
          }
        });
      }
    },
    editBarcode: function editBarcode() {
      var _this3 = this;

      var barcodeTemplate = {
        _id: this.barcodeId,
        formId: this.$store.state.templates[this.$store.state.currentTemplateName].formId,
        page: this.pageBarcode,
        pdfFieldBarcode: this.pdfFieldBarcode,
        model: this.barcodeModel
      };

      this.$store.dispatch('updateBarcodeTemplate', barcodeTemplate).then(function (response) {
        if (response.data.success === true) {
          _this3.$bus.emit('addNotification', {
            title: 'Barcode Template',
            body: 'Barcode updated succesfully.',
            type: 'success'
          });

          _this3.listBarcode[_this3.barcodeEditIndex] = barcodeTemplate;

          _this3.barcodeEditIndex = null;
          _this3.barcodeId = '';
          _this3.isAddBarcode = false;
        } else {
          _this3.$bus.emit('addNotification', {
            title: 'Barcode Template',
            body: 'Ocurred an error.',
            type: 'error'
          });
        }
      });
    },
    getBarcode: function getBarcode(payload) {
      var _this4 = this;

      this.$store.dispatch('getBarcodeTemplate', payload.barcodeId).then(function (response) {
        if (response.data.length > 0) {
          var editBarcode = response.data[0];

          _this4.barcodeEditIndex = payload.index;
          _this4.barcodeId = editBarcode._id;
          _this4.pageBarcode = editBarcode.page;
          _this4.pdfFieldBarcode = editBarcode.pdfFieldBarcode;
          _this4.barcodeModel = editBarcode.model;

          _this4.typeModal = 'Edit';

          _this4.isAddBarcode = true;
        } else {
          _this4.$bus.emit('addNotification', {
            title: 'Barcode Template',
            body: 'Ocurred an error.',
            type: 'error'
          });
        }
      });
    },
    deleteBarcode: function deleteBarcode(payload) {
      this.deleteBarcodeIndex = payload.index;
      this.deleteBarcodeId = payload.barcodeId;

      this.isDeleteBarcode = true;
    },
    confirmDelete: function confirmDelete() {
      var _this5 = this;

      this.$store.dispatch('deleteBarcodeTemplate', this.deleteBarcodeId).then(function (response) {
        if (response.data.success === true) {
          _this5.listBarcode.splice(_this5.deleteBarcodeIndex, 1);

          _this5.$bus.emit('addNotification', {
            title: 'Barcode Template',
            body: 'Barcode template deleted succesfully.',
            type: 'success'
          });

          _this5.deleteBarcodeIndex = null;
          _this5.deleteBarcodeId = '';
          _this5.isDeleteBarcode = false;
        } else {
          _this5.$bus.emit('addNotification', {
            title: 'Barcode Template',
            body: 'Ocurred an error.',
            type: 'error'
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "Pyam":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q+GX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q7/M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnnotationHighlight_vue__ = __webpack_require__("XLA1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c79c504_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnnotationHighlight_vue__ = __webpack_require__("TQq5");
function injectStyle (ssrContext) {
  __webpack_require__("toJk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c79c504"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnnotationHighlight_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c79c504_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnnotationHighlight_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QB3H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ( true)?_c('div',{attrs:{"id":"timeTravel"}},[_c('button',{on:{"click":_vm.undo}},[_vm._v("Undo")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QClc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QDfD":
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ "QWxQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'section-modal',

  data: function data() {
    return {
      showModal: false,
      editSection: '',
      addModel: false,
      editSubSection: false,
      editing: false,
      editKey: '',
      sections: []
    };
  },
  mounted: function mounted() {
    var that = this;
    this.$on('showModal', function () {
      that.editSection = '';
      that.editSubSection = false;
      that.showModal = true;
      that.editing = false;
      that.sections = [];

      // sections created
      var questionnaireData = that.$store.state.questionnaires[that.$store.state.currentTemplateName].data;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(questionnaireData).forEach(function (fieldKey) {
        if (questionnaireData[fieldKey].type === 'section') that.sections.push(questionnaireData[fieldKey]);
      });
    });

    this.$on('showEditModal', function (data) {
      that.editSection = data.section;
      that.editSubSection = data.subSection;
      that.showModal = true;
      that.editing = true;
      that.editKey = data.index;
    });

    document.addEventListener('keyup', this.keyCheck);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keyup', this.keyCheck, false);

    this.$off('showModal');
    this.$off('showEditModal');
  },


  methods: {
    keyCheck: function keyCheck(evt) {
      if (evt.keyCode === 27) this.closeModal();
    },
    closeModal: function closeModal() {
      this.showModal = false;
    },
    addSection: function addSection() {
      this.$store.commit('addSectionField', {
        label: this.editSection,
        subSection: this.editSubSection
      });
      this.$store.dispatch('saveTemplate');
      this.$bus.emit('reloadQuestionnaire');
      this.closeModal();
    },
    saveSection: function saveSection() {
      this.$store.commit('editSectionField', {
        index: this.editKey,
        label: this.editSection,
        subSection: this.editSubSection
      });
    },
    editSectionGroup: function editSectionGroup(payload) {
      this.$bus.$emit('sectionEditModal', payload);
    },
    deleteSection: function deleteSection(sectionName, index) {
      this.sections.splice(index, 1);

      this.$bus.$emit('removeSection', sectionName);
    }
  }
});

/***/ }),

/***/ "QbSV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qi2M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog)?_c('div',{staticClass:"modal-dialog myModal-dialog",attrs:{"id":"modalAddTemplate"}},[_c('div',{staticClass:"modalHeader"},[_c('span',{staticClass:"title"},[_vm._v("Add Empty Template")]),_vm._v(" "),_c('span',{staticClass:"btn-close float-right",on:{"click":_vm.closeModal}},[_c('i',{staticClass:"fas fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"modalBody"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.templateName),expression:"templateName"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","id":"templateName"},domProps:{"value":(_vm.templateName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.templateName=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":_vm.addTemplate}},[_vm._v("Add")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.closeModal}},[_vm._v("Cancel")])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"font14",attrs:{"for":"templateName"}},[_c('b',[_vm._v("Template Name")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QiEr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchSelect_vue__ = __webpack_require__("VT/1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23b1309f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchSelect_vue__ = __webpack_require__("HoAF");
function injectStyle (ssrContext) {
  __webpack_require__("mV8n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23b1309f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23b1309f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Qm8n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spinner_vue__ = __webpack_require__("bUew");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a16fb2bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__ = __webpack_require__("11aq");
function injectStyle (ssrContext) {
  __webpack_require__("J1/8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a16fb2bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QvN3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R4UY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R870":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ROUp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalModal_vue__ = __webpack_require__("T64h");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0556f358_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalModal_vue__ = __webpack_require__("/FMC");
function injectStyle (ssrContext) {
  __webpack_require__("J/re")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0556f358"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0556f358_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RTVT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RYsz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultipleSelectDialog_vue__ = __webpack_require__("FhrZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6653e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultipleSelectDialog_vue__ = __webpack_require__("BARx");
function injectStyle (ssrContext) {
  __webpack_require__("jv/H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b6653e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultipleSelectDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6653e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultipleSelectDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RmLz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__searchSelect_SearchSelect_vue__ = __webpack_require__("QiEr");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ab-group-watchers',

  data: function data() {
    return {
      valueVisibleAb: true,
      valueOnAb: true,
      watchers: []
    };
  },


  props: {
    isGroup: {
      type: Boolean,
      default: false
    },

    fieldData: {
      type: Object
    }
  },

  components: {
    SearchSelect: __WEBPACK_IMPORTED_MODULE_2__searchSelect_SearchSelect_vue__["a" /* default */]
  },

  created: function created() {
    this.watchers = this.fieldData.watchers;
    this.valueVisibleAb = this.fieldData.tagVisible !== undefined ? this.fieldData.tagVisible : true;
  },


  methods: {
    setVisibility: function setVisibility() {
      var _this = this;

      this.valueVisibleAb = !this.valueVisibleAb;

      if (this.isGroup === true) {
        this.$store.commit('editFieldGroup', {
          index: this.fieldData.index,
          tagVisible: this.valueVisibleAb
        });
      } else {
        this.fieldData.tagVisible = this.valueVisibleAb;

        this.$store.commit('setTemplateFieldPage', this.fieldData);

        var questionnaires = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.$store.state.questionnaires));

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(questionnaires[this.$store.state.currentTemplateName].data).forEach(function (fieldKey) {
          var fieldId = _this.fieldData.fieldName !== undefined ? _this.fieldData.fieldName : _this.fieldData.id;

          if (questionnaires[_this.$store.state.currentTemplateName].data[fieldKey].fieldName === fieldId) {
            questionnaires[_this.$store.state.currentTemplateName].data[fieldKey].tagVisible = _this.valueVisibleAb;
          }

          // Assign tags to field group fields

          if (questionnaires[_this.$store.state.currentTemplateName].data[fieldKey].checkboxes !== undefined && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(questionnaires[_this.$store.state.currentTemplateName].data[fieldKey].checkboxes).length > 0) {
            var checkboxes = questionnaires[_this.$store.state.currentTemplateName].data[fieldKey].checkboxes;

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(checkboxes).forEach(function (fieldChKey) {
              var fieldId = _this.fieldData.fieldName !== undefined ? _this.fieldData.fieldName : _this.fieldData.id;

              if (checkboxes[fieldChKey].id === fieldId) {
                checkboxes[fieldChKey].tagVisible = _this.valueVisibleAb;
              }
            });
          }
        });

        this.$store.commit('setQuestionnaires', questionnaires);
      }

      this.$bus.emit('updateQuestionnaire');
      this.$store.dispatch('saveTemplate');
    },
    setTagWatcher: function setTagWatcher(watchers) {
      if (watchers.length > 0) {
        // watchers[(watchers.length - 1)].value = this.valueOnAb
        watchers[watchers.length - 1] = { label: watchers[watchers.length - 1], value: this.valueOnAb, visible: this.valueVisibleAb
          // watchers[(watchers.length - 1)].visible = this.valueVisibleAb
        };
      }

      this.watchers = watchers;

      this.fieldData.watchers = watchers;

      if (this.isGroup === true) this.setWatcherToGroup(watchers);else this.setWatcherToField(watchers);
    },
    setWatcherToField: function setWatcherToField(watchers) {
      var _this2 = this;

      this.$store.commit('setTemplateFieldPage', this.fieldData);

      var tmpQuestionnaires = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.$store.state.questionnaires));

      if (this.fieldData.fieldName !== undefined) this.fieldData.id = this.fieldData.fieldName;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(tmpQuestionnaires.default.data).forEach(function (fieldKey) {
        if (tmpQuestionnaires.default.data[fieldKey] === null || tmpQuestionnaires.default.data[fieldKey] === undefined) return;

        if (tmpQuestionnaires.default.data[fieldKey].fieldName === _this2.fieldData.id) {
          tmpQuestionnaires.default.data[fieldKey].watchers = watchers;

          _this2.$store.commit('setQuestionnaires', tmpQuestionnaires);

          _this2.$store.dispatch('saveTemplate');
          _this2.$bus.emit('reloadQuestionnaire');
        }
      });
    },
    setWatcherToGroup: function setWatcherToGroup(watchers) {
      this.$store.commit('editFieldGroup', this.fieldData);

      this.$store.dispatch('saveTemplate');
    }
  }
});

/***/ }),

/***/ "SAdT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayoutView_vue__ = __webpack_require__("kZJi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16a7d928_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayoutView_vue__ = __webpack_require__("DLiC");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayoutView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16a7d928_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayoutView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SPw3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'edit-modal',

  mounted: function mounted() {
    var that = this;
    this.$on('showModal', function (fieldData) {
      that.key = fieldData.key;
      that.field = fieldData.data;
      that.fieldTitle = that.field.title;
      that.fieldDesc = that.field.desc;
      that.fieldModel = that.field.model;
      that.fieldName = that.field.fieldDisplayName;
      that.showModal = true;
    });

    this.$on('widgetChanged', function (data) {
      that.widgetChanged(data);
    });

    document.addEventListener('keyup', this.keyCheck);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keyup', this.keyCheck, false);

    this.$off('showModal');
    this.$off('widgetChanged');
  },
  data: function data() {
    return {
      key: '',
      showModal: false,
      fieldTitle: '',
      fieldDesc: '',
      fieldModel: '',
      fieldName: '',
      field: {}
    };
  },


  methods: {
    keyCheck: function keyCheck(evt) {
      if (evt.keyCode === 27) this.closeModal();
    },
    widgetChanged: function widgetChanged(data) {
      console.log(data);
      this.field.newValue = data.value;
    },
    editFormField: function editFormField() {
      this.showModal = false;
      this.$bus.emit('openFieldMenu', {
        id: this.field.fieldName,
        page: this.field.page
      });
    },
    saveField: function saveField() {
      this.field.title = this.fieldTitle;
      this.field.name = this.fieldName;
      this.field.desc = this.fieldDesc;
      this.field.model = this.fieldModel;
      this.$parent.$emit('saveEdit', {
        key: this.key,
        data: this.field
      });
      this.showModal = false;
    },
    closeModal: function closeModal() {
      this.showModal = false;
    }
  }
});

/***/ }),

/***/ "T64h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'global-modal',

  props: {
    width: {
      type: Number
    },

    height: {
      type: Number
    }
  },

  computed: {
    setStyleGlobal: function setStyleGlobal() {
      return 'width:' + this.width + '% !important;height:' + this.height + '% !important;';
    }
  }
});

/***/ }),

/***/ "TLDX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-delete-template',

  data: function data() {
    return {
      showDialog: false,
      template: {}
    };
  },
  mounted: function mounted() {
    var that = this;
    this.$bus.on('showTemplateDeleteDialog', function () {
      that.showDialog = true;
    });
  },


  methods: {
    deleteTemplate: function deleteTemplate() {
      var _this = this;

      if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.template).length) {
        this.$bus.emit('addNotification', {
          title: 'Template Delete Error',
          body: 'No template was selected. Please try again',
          type: 'error'
        });
        return;
      }

      var keepGoing = true;
      if (this.$store.state.templates[this.$store.state.currentTemplateName]['_id'] === this.template.id) {
        this.$store.commit('setCurrentTemplateName', 'global');
        this.$bus.emit('setCurrentTemplateName', 'global');
        var that = this;
        this.$store.dispatch('applyTemplate').then(function (result) {
          if (!result) {
            that.$bus.emit('addNotification', {
              title: 'Error Applying Global Template',
              body: 'An error occured while applying the global template. Please try again.',
              type: 'error'
            });
            keepGoing = false;
          }
        });
      }

      if (!keepGoing) return;

      var apiUrl = this.$store.state.apiUrl;
      this.axios.post(apiUrl + 'template/delete/' + this.template.id).then(function (response) {
        if (response.data.success) {
          _this.$store.commit('removeTemplate', _this.template.name);
          if (typeof _this.$store.state.questionnaires[_this.template.name] !== 'undefined') {
            var questionnaire = _this.$store.state.questionnaires[_this.template.name];
            _this.axios.post(apiUrl + 'questionnaire/delete/' + questionnaire._id).then(function (response) {
              if (response.data.success) {
                _this.$bus.emit('addNotification', {
                  title: 'Template Deleted',
                  body: 'The template was deleted successfully',
                  type: 'success'
                });
                _this.closeModal();
              } else {
                _this.$bus.emit('addNotification', {
                  title: 'Template Questionnaire Delete Error',
                  body: 'There was an error deleting the templates questionnaire. Please review the data and try again',
                  type: 'error'
                });
              }
            });
          } else {
            _this.$bus.emit('addNotification', {
              title: 'Template Deleted',
              body: 'The template was deleted successfully',
              type: 'success'
            });
            _this.closeModal();
          }
        } else {
          _this.$bus.emit('addNotification', {
            title: 'Template Delete Error',
            body: 'There was an error deleting the template. Please review the data and try again',
            type: 'error'
          });
        }
      });
      this.$store.commit('setLastSaved', Date.now());
    },
    closeModal: function closeModal() {
      this.showDialog = false;
      this.template = {};
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('showTemplateDeleteDialog');
  }
});

/***/ }),

/***/ "TPvD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModal)?_c('div',{staticClass:"field-group-modal"},[_c('div',{staticClass:"modalHeader",staticStyle:{"border-radius":"9px 9px 0px 0px !important"}},[_c('span',{staticClass:"title"},[_vm._v("Manage Field Groups")]),_vm._v(" "),_c('span',{staticClass:"btn-close float-right",on:{"click":_vm.closeModal}},[_c('i',{staticClass:"fas fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"modalBody"},[_c('table',{staticClass:"table table-bordered table-striped table-hover table-sm"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.groups),function(group,index){return (group.fields !== undefined)?_c('tr',{key:index},[_c('td',[_vm._v(_vm._s(group.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(group.title))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(group.desc))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(Object.keys(group.fields).length))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$store.getters.fieldGroupMaxFields(group.fieldId))+"\n          ")]),_c('td',[_c('button',{staticClass:"btn btn-sm btn-light",on:{"click":function($event){return _vm.editGroup(index)}}},[_vm._v("Edit")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.deleteGroup(index)}}},[_vm._v("Delete")]),_vm._v(" "),(group.hide === true)?_c('button',{staticClass:"btn btn-sm btn-light",on:{"click":function($event){return _vm.sendToQuestionnaire(group.fieldId)}}},[_vm._v("Send to Questionnaire")]):_vm._e()])]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"button-box float-right mb-3 mr-0"},[_c('button',{staticClass:"btn btn-secondary",on:{"click":_vm.closeModal}},[_vm._v("Close")])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Label")]),_vm._v(" "),_c('th',[_vm._v("Help Text")]),_vm._v(" "),_c('th',[_vm._v("# Fields")]),_vm._v(" "),_c('th',[_vm._v("Max Checked")]),_vm._v(" "),_c('th',[_vm._v("Actions")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TQq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"annotation annotation-highlight",style:(_vm.getStyle),on:{"click":_vm.showControls}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TXPm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'multiple-select',

  data: function data() {
    return {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      drawing: false,
      currentMatches: []
    };
  },
  mounted: function mounted() {
    this.$bus.on('confirmTabOrderUpdate', this.confirmIndexUpdate);
    this.$bus.on('cancelTabOrderUpdate', this.cancelIndexUpdate);
    document.onmousedown = this.mouseDown; // TODO: Move this to draw mode toggle
  },


  computed: {
    drawStyle: function drawStyle() {
      if (!this.drawing) return 'top:' + (this.y - 55) + 'px;left:' + this.x + 'px;';else return 'display:block;top:' + (this.y - 55) + 'px;left:' + this.x + 'px;width:' + this.width + 'px;height:' + this.height + 'px;';
    }
  },

  methods: {
    mouseCoords: function mouseCoords(e) {
      var posx = -1;
      var posy = -1;
      if (e.pageX || e.pageY) {
        posx = e.clientX;
        posy = e.clientY;
      }
      return { x: posx, y: posy };
    },
    mouseDown: function mouseDown(ev) {
      if (this.drawing || !this.$store.state.multipleSelect) return; // TODO: Draw mode
      var coords = this.mouseCoords(ev);
      this.x = coords.x;
      this.y = coords.y;
      this.width = 0;
      this.height = 0;
      this.drawing = true;
      document.onmousemove = this.mouseUpdate;
      document.onmouseup = this.mouseUp;
    },
    mouseUpdate: function mouseUpdate(ev) {
      var coords = this.mouseCoords(ev);
      if (this.drawing) {
        this.width = coords.x - this.x;
        this.height = coords.y - this.y;
      } else {
        this.x = coords.x;
        this.y = coords.y;
      }
    },
    mouseUp: function mouseUp(ev) {
      this.drawing = false;
      document.onmouseup = null;
      document.onmousemove = null;
      this.calculateFields();
    },
    compare: function compare(a, b) {
      if (a.y1 < b.y1) return -1;
      if (a.y1 > b.y1) return 1;
      if (a.y1 === b.y1 && a.x1 < b.x1) return -1;
      if (a.y1 === b.y1 && a.x1 > b.x1) return 1;
      return 0;
    },
    calculateFields: function calculateFields() {
      var _this = this;

      var pos = {
        x: this.x,
        y: this.y
      };
      var region = {
        x1: pos.x,
        y1: pos.y,
        x2: pos.x + this.width,
        y2: pos.y + this.height
      };
      this.currentMatches = [];

      this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][this.$store.state.fileCurrentPage].forEach(function (element) {
        if (element !== null && document.getElementById(element.id) !== null) {
          var elRect = document.getElementById(element.id).getBoundingClientRect();

          var elRegion = {
            fieldName: element.id,
            x1: Number(elRect.left + window.scrollX),
            y1: Number(elRect.top + window.scrollY),
            x2: Number(elRect.left + window.scrollX + elRect.width),
            y2: Number(elRect.top + window.scrollY + elRect.height)
          };

          if (elRegion.x1 >= region.x1 && elRegion.x1 <= region.x2 && elRegion.x2 <= region.x2) {
            if (elRegion.y1 >= region.y1 && elRegion.y2 <= region.y2 && elRegion.y2 <= region.y2) {
              _this.currentMatches.push(element);
              var targetEl = document.getElementById(element.name);
              if (targetEl === null) return;
              targetEl.classList.add('id-highlight');
            }
          }
        }
      });
      if (!this.currentMatches.length) return;
      this.$store.commit('setMultipleSelect', false);
      this.currentMatches = this.currentMatches.sort(this.compare);
      this.$bus.emit('showSelectDialog', {
        dataFields: this.currentMatches,
        title: 'Multiple Select Fields',
        desc: 'You are about to update ' + this.currentMatches.length + ' fields.'
      });
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('confirmTabOrderUpdate');
    this.$bus.$off('cancelTabOrderUpdate');
  }
});

/***/ }),

/***/ "TsMP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'side-menu-toolbox',

  beforeMount: function beforeMount() {
    this.$store.commit('setShowAnnotationMenu', false);
    this.$store.commit('setDrawAnnotations', false);
  },
  mounted: function mounted() {
    this.getTemplates();
    var that = this;
    this.$bus.on('setCurrentTemplateName', function (templateName) {
      that.currentTemplateName = templateName;
    });
  },
  data: function data() {
    return {
      currentTemplateName: '',
      showAnnotations: true,
      currentMode: 'text',
      fonts: [{ name: 'Arial', fallback: 'Helvetica', type: 'sans-serif' }, { name: 'Arial Black', fallback: 'Gadget', type: 'sans-serif' }, { name: 'Comic Sans MS', fallback: '', type: 'cursive' }, { name: 'Impact', fallback: 'Charcoal', type: 'sans-serif' }, { name: 'Lucida Sans Unicode', fallback: 'Lucida Grande', type: 'sans-serif' }, { name: 'Tahoma', fallback: 'Geneva', type: 'sans-serif' }, { name: 'Trebuchet MS', fallback: 'Helvetica', type: 'sans-serif' }, { name: 'Verdana', fallback: 'Geneva', type: 'sans-serif' }, { name: 'Georgia', fallback: '', type: 'serif' }, { name: 'Palatino Linotype', fallback: 'Palatino', type: 'serif' }, { name: 'Times New Roman', fallback: 'Times', type: 'serif' }, { name: 'Lucida Console', fallback: '', type: 'monospace' }, { name: 'Courier New', fallback: 'Courier', type: 'monospace' }]
    };
  },


  methods: {
    changeTemplate: function changeTemplate() {
      this.$store.commit('setCurrentTemplateName', this.currentTemplateName);
      this.$bus.emit('setCurrentTemplateName', this.currentTemplateName);
      var that = this;
      this.$store.dispatch('applyTemplate').then(function (result) {
        if (result) {
          that.$bus.emit('addNotification', {
            title: 'Applied Template',
            body: 'Template "' + that.currentTemplateName + '" applied successfully.',
            type: 'success'
          });
        } else {
          that.$bus.emit('addNotification', {
            title: 'Error Applying Template',
            body: 'An error occured while applying the template "' + that.currentTemplateName + '". Please review the data and try again.',
            type: 'error'
          });
        }
      });
    },
    getTemplates: function getTemplates() {
      var _this = this;

      var apiUrl = this.$store.state.apiUrl;
      this.axios.get(apiUrl + 'template/list/' + this.$store.state.currentFormId).then(function (response) {
        var templates = response.data;
        _this.$store.commit('setTemplates', {});
        templates.forEach(function (template) {
          _this.$store.commit('addTemplate', {
            id: template.name,
            data: template
          });
        });

        _this.$store.commit('setCurrentTemplateName', 'default');
        _this.currentTemplateName = _this.$store.state.currentTemplateName;
        if (_this.$store.state.templates[_this.$store.state.currentTemplateName] === undefined) return;
        _this.$store.commit('setTotalPages', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this.$store.state.templates[_this.$store.state.currentTemplateName]['pages']).length);
        _this.$store.commit('setShowFields', true);
        _this.$store.commit('setTranslation');
        _this.$store.commit('setFieldPage');
        _this.$store.commit('setPropsFieldGroups');

        // SET MODELS FROM AUTOFILL DETAILS

        var autofillId = _this.$store.state.autofillId;

        if (autofillId === null) {
          var autofill = {
            formId: _this.$store.state.currentFormId,
            templateId: _this.$store.state.templates[_this.$store.state.currentTemplateName]['_id'],
            name: 'global',
            caseTypeId: 0,
            createdAt: new Date(),
            updatedAt: new Date()
          };

          _this.$store.dispatch('addAutofill', autofill).then(function (response) {
            var autofillId = response.data.autofillId;

            _this.$store.commit('setAutofillId', autofillId);
          });
        } else _this.$store.commit('setModelsAutofillDetails');

        _this.getTemplateQuestionnaires();
        _this.$bus.emit('hidePageFields');
      });
    },
    getTemplateQuestionnaires: function getTemplateQuestionnaires() {
      var _this2 = this;

      var newQuestionnaires = {};
      var apiUrl = this.$store.state.apiUrl;

      var _loop = function _loop(templateIndex) {
        if (_this2.$store.state.templates.hasOwnProperty(templateIndex)) {
          var template = _this2.$store.state.templates[templateIndex];
          _this2.axios.get(apiUrl + 'questionnaire/list/' + template._id).then(function (response) {
            if (response.status !== 200) return;
            if (!response.data.length) return;
            newQuestionnaires[templateIndex] = response.data[0];
            _this2.$store.commit('setQuestionnaires', JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newQuestionnaires)));
            _this2.$store.commit('setQuestionnairePageAndTabOrder');
            if (_this2.$store.state.templates[templateIndex].name === 'default') _this2.$bus.emit('reloadQuestionnaire');
          });
        }
      };

      for (var templateIndex in this.$store.state.templates) {
        _loop(templateIndex);
      }
    },
    showTemplateAddDialog: function showTemplateAddDialog() {
      this.$store.commit('setShowAnnotationMenu', false);
      this.$store.commit('setDrawAnnotations', false);
      this.$store.commit('setShowBottomMenu', true);
      this.$bus.emit('hideControls');
      this.$bus.emit('showTemplateAddDialog');
    },
    showTemplateDuplicateDialog: function showTemplateDuplicateDialog() {
      this.$store.commit('setShowAnnotationMenu', false);
      this.$store.commit('setDrawAnnotations', false);
      this.$store.commit('setShowBottomMenu', true);
      this.$bus.emit('hideControls');
      this.$bus.emit('showTemplateDuplicateDialog');
    },
    showTemplateDeleteDialog: function showTemplateDeleteDialog() {
      this.$store.commit('setShowAnnotationMenu', false);
      this.$store.commit('setDrawAnnotations', false);
      this.$store.commit('setShowBottomMenu', true);
      this.$bus.emit('hideControls');
      this.$bus.emit('showTemplateDeleteDialog');
    },
    showTemplateEditorDialog: function showTemplateEditorDialog() {
      this.$store.commit('setShowAnnotationMenu', false);
      this.$store.commit('setDrawAnnotations', false);
      this.$store.commit('setShowBottomMenu', false);
      this.$bus.emit('hideControls');
      this.$bus.emit('showTemplateEditorDialog');
    },
    annotationMode: function annotationMode(mode) {
      this.$bus.$emit('setAnnotationMode', mode);
      this.currentMode = mode;
    },
    toggleShowAnnotationMenu: function toggleShowAnnotationMenu() {
      if (this.$store.state.showAnnotationMenu) {
        this.$store.commit('setShowAnnotationMenu', false);
        this.$store.commit('setDrawAnnotations', false);
        this.$store.commit('setShowBottomMenu', true);
      } else {
        this.currentTemplateName = this.$store.state.currentTemplateName;
        this.$store.commit('setShowAnnotationMenu', true);
        this.$store.commit('setDrawAnnotations', true);
        this.$store.commit('setShowBottomMenu', false);
        this.$bus.emit('hideControls');
        this.$bus.emit('closeModal');
      }
    },
    toggleShowAnnotations: function toggleShowAnnotations() {
      this.$store.commit('setShowAnnotations', !this.showAnnotations);
      this.$store.commit('setShowBottomMenu', this.showAnnotations);
    }
  },

  computed: {
    hideStyle: function hideStyle() {
      return this.$store.state.showAnnotationMenu ? 'right:0;' : '';
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('setCurrentTemplateName');
  }
});

/***/ }),

/***/ "Ttnt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.showAnnotations)?_c('div',{class:[_vm.$store.state.drawingAnnotation ? 'showOverlay' : ''],style:(_vm.$store.state.drawingAnnotation ? '' : 'pointer-events:none;'),attrs:{"id":"annotations"}},[_c('annotation-controls'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.drawMode),expression:"drawMode"}],style:(_vm.currentAnnotationStyle),attrs:{"id":"currentAnnotation","draggable":"false"}},[(this.currentAnnotation.type === 'text')?_c('textarea'):(this.currentAnnotation.type === 'highlight')?_c('div'):_c('img',{attrs:{"draggable":"false","src":'/static/' + this.currentAnnotation.type + '.svg'}})]),_vm._v(" "),_vm._l((_vm.$store.state.annotations),function(annotation,index){return _c('div',{key:index,staticClass:"annotationDisplay",style:('left:' + annotation.x + 'px;top:' + annotation.y + 'px;width:' + annotation.width + 'px;height:' + annotation.height + 'px;'),attrs:{"id":'annotationDisplay-' + index,"rotation":annotation.rotation}},[(annotation.type === 'text')?_c('annotation-textarea',{attrs:{"id":'annotation-' + index,"index":index,"width":annotation.width,"height":annotation.height,"rotation":annotation.rotation,"storeData":annotation.data}}):(annotation.type === 'highlight')?_c('annotation-highlight',{attrs:{"id":'annotation-' + index,"index":index,"width":annotation.width,"height":annotation.height,"rotation":annotation.rotation}}):_c('annotation-image',{attrs:{"id":'annotation-' + index,"selected":annotation.selected,"name":annotation.type,"index":index,"width":annotation.width,"height":annotation.height,"rotation":annotation.rotation}})],1)})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UFk9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:('top:' +  (_vm.data.top + 25) + 'px;left:' + _vm.data.left + 'px;'),attrs:{"id":"autocomplete-model"}},[(_vm.isSpinner === true)?_c('div',[_c('center',[_c('div',{staticClass:"lds-hourglass"})])],1):_c('div',{staticStyle:{"padding-right":"10px","padding-top":"10px"}},[_c('ul',[_c('li',{staticClass:"itemModel",on:{"click":function($event){return _vm.setOfficialModel('')}}},[_vm._v("\n        None\n      ")])]),_vm._v(" "),(_vm.list.length === 0)?_c('label',{staticStyle:{"padding-left":"10px"}},[_vm._v("\n      No match models\n      "),_c('ul',[_c('li',{staticClass:"itemModel",on:{"click":function($event){return _vm.setOfficialModel(_vm.model)}}},[_vm._v("\n          Create New Model "),_c('i',{staticClass:"fas fa-plus"})])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(model,indexModel){return _c('ul',{key:indexModel},[_c('li',{staticClass:"itemModel",on:{"click":function($event){return _vm.setOfficialModel(model)}}},[_vm._v("\n        "+_vm._s(model)+"\n      ")])])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "US1G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V3jz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6xl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionModal_vue__ = __webpack_require__("QWxQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b00f2c2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionModal_vue__ = __webpack_require__("x46k");
function injectStyle (ssrContext) {
  __webpack_require__("hkvO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b00f2c2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b00f2c2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VT/1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_click_outside__ = __webpack_require__("4RmS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_v_click_outside__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SelectComponent',
  data: function data() {
    return {
      keyword: null,
      multipleOpt: [],
      optionSelected: null,
      filteredOptions: [],
      showResultSearch: false
    };
  },


  props: {
    value: {
      type: Array | String | Number | JSON | null
    },
    options: {
      type: Array
    },
    label: {
      type: String,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    taggable: {
      type: Boolean,
      default: false
    }
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_2_v_click_outside___default.a.directive
  },

  watch: {
    keyword: function keyword(val) {
      this.filterOptions(val);
    },
    value: function value() {
      this.setValue();
    }
  },

  mounted: function mounted() {
    this.setValue();
  },


  methods: {
    enableSelect: function enableSelect() {
      if (this.keyword == null) this.keyword = '';
      this.showResultSearch = true;
    },
    disableSelect: function disableSelect() {
      this.showResultSearch = false;
    },
    filterOptions: function filterOptions(keyword) {
      var _this = this;

      if (keyword.length > 0) {
        this.filteredOptions = this.options.filter(function (option) {
          return _this.label != null ? option[_this.label].toLowerCase().startsWith(keyword.toLowerCase()) : option.toLowerCase().startsWith(keyword.toLowerCase());
        });

        if (this.filteredOptions.length === 0 && this.taggable === true) {
          this.filteredOptions = this.label != null ? [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, this.label, keyword)] : [keyword];
        }
      } else {
        this.filteredOptions = this.options;
      }
    },
    selectOption: function selectOption(option) {
      if (this.multiple === true) {
        this.keyword = '';
        this.multipleOpt.push(option);
        this.$emit('input', this.multipleOpt);
      } else {
        this.keyword = this.label != null ? option[this.label] : option;
        this.optionSelected = option;
        this.$emit('input', this.optionSelected);
      }
      this.disableSelect();
    },
    removeOption: function removeOption(index) {
      if (this.multipleOpt.length > 0) {
        this.multipleOpt.splice(index, 1);
        this.$emit('input', this.multipleOpt);
      }
    },
    setValue: function setValue() {
      if (this.value != null) {
        var typeData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.value);

        // Array o JSON
        if (typeData === 'object') {
          if (Array.isArray(this.value)) {
            this.multipleOpt = this.value;
          } else {
            this.keyword = this.value[this.label];
            this.optionSelected = this.value;
          }
        }

        // String o Number
        if (typeData === 'string' || typeData === 'number') {
          this.keyword = this.value;
          this.optionSelected = this.value;
        }
      }
    },
    enterOption: function enterOption(keyword) {
      if (this.taggable === true) {
        this.selectOption(keyword);
      }
    }
  }
});

/***/ }),

/***/ "VTGV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget widget-text",attrs:{"data-field":_vm.fieldName,"id":_vm.fieldName}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],class:['form-control form-control-sm', _vm.autoWidth ? 'auto-width' : ''],attrs:{"type":"text","disabled":!_vm.editable,"readonly":_vm.readOnly && _vm.editable},domProps:{"value":(_vm.value)},on:{"keyup":_vm.onChange,"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WKKH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showInlineHelp)?_c('div',{staticClass:"restore-inline-help-modal"},[_c('div',{staticClass:"modalHeader"},[_c('span',{staticClass:"title"},[_vm._v("Question Help")]),_vm._v(" "),_c('span',{staticClass:"btn-close float-right",on:{"click":_vm.closeModal}},[_c('i',{staticClass:"fas fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"modalBody"},[(_vm.indiceProcessing)?_c('h1',{staticClass:"msg-process"},[_vm._v(_vm._s(_vm.msgProcessing))]):_vm._e(),_vm._v(" "),_c('spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]}),_vm._v(" "),_c('div',{staticClass:"button-box"},[(_vm.btnFinish && _vm.loading === false)?_c('button',{staticClass:"btn btn-primary btn-lg btn-block",on:{"click":_vm.closeModal}},[_vm._v("Finish")]):_vm._e()])],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WkqJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MaxItemsModal__ = __webpack_require__("fzij");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__searchSelect_SearchSelect_vue__ = __webpack_require__("QiEr");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'add-form-modal',

  data: function data() {
    return {
      jsonData: {},

      globalTemplate: {},
      totalPages: 0,
      totalFields: 0,

      invalidFields: [],

      name: '',
      title: '',
      viewer_url: '',
      status: 'DEV',
      revisionDate: '',
      expirationDate: '',
      version: 0,
      primaId: '',
      practiceArea: 'Immigration',
      practiceAreaSections: [],
      practiceAreaSection: '',
      role1: 'None',
      prefix1: '',
      role2: 'None',
      prefix2: '',
      role3: 'None',
      prefix3: '',
      role4: 'None',
      prefix4: '',
      role5: 'None',
      prefix5: '',
      role6: 'None',
      prefix6: '',
      role7: 'None',
      prefix7: '',
      role8: 'None',
      prefix8: '',

      isMaxItemsModal: false,
      currentRole: '',
      maxItems: {},
      allRolesMaxItems: {},

      enableForQ: false,

      tagsFormPA: [],
      tagsFormInternal: [],

      practiceAreaTag: [],
      internalTag: [],

      formDataBulk: null,

      massiveFormIds: [],
      massiveJsonData: [],
      massiveFormDataBulk: [],
      isBulkAction: false,
      contFormsBulkAction: 0
    };
  },


  props: {
    formData: {
      type: Object
      // required: true
    }
  },

  components: {
    MaxItemsModal: __WEBPACK_IMPORTED_MODULE_1__MaxItemsModal__["a" /* default */],
    SearchSelect: __WEBPACK_IMPORTED_MODULE_2__searchSelect_SearchSelect_vue__["a" /* default */]
  },

  mounted: function mounted() {
    var _this = this;

    this.$store.state.practiceAreas.forEach(function (practiceArea) {
      if (_this.practiceArea === practiceArea.name) _this.practiceAreaSections = practiceArea.sections;
    });

    if (this.practiceAreaSections === undefined) {
      this.practiceAreaSections = this.$store.state.practiceAreas[4].sections;
    }

    this.practiceAreaSection = this.practiceAreaSections[0];

    this.getFormTags();
  },


  methods: {
    getFormTags: function getFormTags() {
      var _this2 = this;

      // GET FORM TAGS

      this.$store.dispatch('getFormTags', {
        tagType: 'practiceArea'
      }).then(function (response) {
        if (response.data !== undefined && response.data !== null) _this2.tagsFormPA = response.data;
      });

      this.$store.dispatch('getFormTags', {
        tagType: 'internal'
      }).then(function (response) {
        if (response.data !== undefined && response.data !== null) _this2.tagsFormInternal = response.data;
      });
    },
    closeModal: function closeModal() {
      this.$parent.$emit('closeModal');
    },
    getJsonFile: function getJsonFile() {
      var files = document.getElementById('selectFiles').files;

      if (files.length !== 1) {
        return false;
      }

      var fr = new FileReader();
      fr.readAsText(files.item(0));

      var that = this;
      fr.onload = function (e) {
        that.jsonData = JSON.parse(e.target.result);
        that.createTemplate();
      };
    },
    createTemplate: function createTemplate() {
      var templateData = {
        formId: null,
        filename: this.jsonData['filename'],
        name: 'default',
        pages: {},
        fieldGroups: {}
      };

      for (var pageNum in this.jsonData['pages']) {
        if (this.jsonData.pages.hasOwnProperty(pageNum)) {
          this.totalPages++;
          var pageFields = this.jsonData.pages[pageNum]['pageFields'];

          if (typeof templateData.pages[pageNum] === 'undefined') {
            templateData.pages[pageNum] = [];
          }

          for (var fieldName in pageFields) {
            if (pageFields.hasOwnProperty(fieldName)) {
              var field = pageFields[fieldName];

              var newData = {
                id: fieldName,
                name: fieldName,
                model: '',
                value: '',
                type: field.fieldType.toLowerCase(),
                tabOrder: field.tabOrder,
                x: field.x,
                y: field.y,
                width: field.width,
                height: field.height,
                maskType: '',
                translations: {}
              };

              if (typeof field.choiceData !== 'undefined' && typeof field.choiceData === 'string') {
                newData['choiceData'] = field.choiceData.slice(1, -1).split(',');
              }

              templateData.pages[pageNum].push(newData);
              this.totalFields++;
            }
          }
        }
      }

      this.globalTemplate = templateData;
    },
    uploadDefaultTemplate: function uploadDefaultTemplate() {
      var _this3 = this;

      var apiUrl = this.$store.state.apiUrl;

      if (!this.globalTemplate.pages) {
        this.globalTemplate.name = 'default';
      }

      this.axios.post(apiUrl + 'template/add', this.globalTemplate).then(function (response) {
        if (response.data.success) {
          _this3.uploadDefaultQuestionnaire(response.data.id);
        } else {
          _this3.$bus.emit('addNotification', {
            title: 'Template Error',
            body: 'There was an error adding the default template to this form. Please review the data and try again',
            type: 'error'
          });
        }
      });
      this.$store.commit('setLastSaved', Date.now());
    },
    uploadDefaultQuestionnaire: function uploadDefaultQuestionnaire(templateId) {
      var _this4 = this;

      var apiUrl = this.$store.state.apiUrl;
      this.axios.post(apiUrl + 'questionnaire/add', { templateId: templateId }).then(function (response) {
        if (response.data.success) {
          _this4.$store.commit('addQuestionnaire', {
            '_id': response.data.id,
            templateId: templateId
          });

          _this4.$store.commit('addQuestionnaire', {
            index: 'default',
            data: {
              '_id': response.data.id,
              templateId: templateId,
              data: {}
            }
          });

          _this4.uploadGlobalTemplate();
          console.log('Success!');
        } else {
          _this4.$bus.emit('addNotification', {
            title: 'Questionnaire Error',
            body: 'There was an error adding the default questionnaire to this form. Please review the data and try again',
            type: 'error'
          });
        }
      });
      this.$store.commit('setLastSaved', Date.now());
    },
    uploadGlobalTemplate: function uploadGlobalTemplate() {
      var _this5 = this;

      this.globalTemplate['name'] = 'global';
      var apiUrl = this.$store.state.apiUrl;
      this.axios.post(apiUrl + 'template/add', this.globalTemplate).then(function (response) {
        if (response.data.success) {
          _this5.$bus.emit('addNotification', {
            title: 'Form Created',
            body: 'The form was created successfully',
            type: 'success'
          });
          _this5.$parent.$emit('closeModal');
        } else {
          _this5.$bus.emit('addNotification', {
            title: 'Template Error',
            body: 'There was an error adding the global template to this form. Please review the data and try again',
            type: 'error'
          });
        }
      });
    },
    uploadForm: function uploadForm() {
      var _this6 = this;

      var formData = {
        id: this.$store.state.forms.length + 1,
        name: this.name,
        title: this.title,
        viewer_url: this.viewer_url,
        status: this.status,
        revisionDate: new Date(this.revisionDate),
        expirationDate: new Date(this.expirationDate),
        version: this.version,
        primaId: this.primaId,
        practiceArea: this.practiceArea,
        enableForQuestionnaire: this.enableForQ,
        practiceAreaSection: this.practiceAreaSection,
        pages: this.jsonData.pages,
        properties: {
          role1: this.role1._id !== undefined ? this.role1._id : '',
          prefix1: this.prefix1,
          role2: this.role2._id !== undefined ? this.role2._id : '',
          prefix2: this.prefix2,
          role3: this.role3._id !== undefined ? this.role3._id : '',
          prefix3: this.prefix3,
          role4: this.role4._id !== undefined ? this.role4._id : '',
          prefix4: this.prefix4,
          role5: this.role5._id !== undefined ? this.role5._id : '',
          prefix5: this.prefix5,
          role6: this.role6._id !== undefined ? this.role6._id : '',
          prefix6: this.prefix6,
          role7: this.role7._id !== undefined ? this.role7._id : '',
          prefix7: this.prefix7,
          role8: this.role8._id !== undefined ? this.role8._id : '',
          prefix8: this.prefix8
        },
        maxItems: this.allRolesMaxItems,
        practiceAreaTag: this.practiceAreaTag,
        internalTag: this.internalTag
      };

      this.invalidFields = [];

      if (formData.name === '' || formData.viewer_url === '' || formData.title === '') {
        window.vueBus.emit('addNotification', {
          title: 'New Form',
          body: 'Incomplete information.',
          type: 'warm'
        });
      } else {
        var apiUrl = this.$store.state.apiUrl;

        if (formData.pages === undefined || formData.pages === null || formData.pages.length === 0) formData.noData = true;

        this.axios.post(apiUrl + 'form/add', formData).then(function (response) {
          _this6.$bus.emit('getFormList');
          _this6.handleAddForm(formData, response);
        });
      }
    },
    handleAddForm: function handleAddForm(formData, response) {
      if (response.data.success) {
        // console.log('FormId', response.data.formId)

        this.globalTemplate.formId = response.data.formId;
        formData['_id'] = response.data.formId;
        this.$store.commit('addForm', formData);
        this.uploadDefaultTemplate();
      } else {
        var errorData = response.data.message;

        if (errorData.name === 'ValidationError') {
          this.invalidFields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(errorData.errors);

          for (var key in errorData.errors) {
            if (errorData.errors.hasOwnProperty(key)) {
              var error = errorData.errors[key];
              var errorTitle = 'Input Error';
              var errorBody = '';
              if (error.kind === 'minlength') {
                errorTitle = key.toUpperCase() + ' Length Error';
                errorBody = key.toUpperCase() + ' must be at least 2 characters.';
              }

              if (!errorBody.length) {
                errorTitle = 'Validation Error: ' + error.kind;
                errorBody = error.message;
              }

              this.$bus.emit('addNotification', {
                title: errorTitle,
                body: errorBody,
                type: 'error'
              });
            }
          }
        }
      }
      this.$store.commit('setLastSaved', Date.now());
    },
    setPracticeAreaSections: function setPracticeAreaSections(e) {
      var _this7 = this;

      this.$store.state.practiceAreas.forEach(function (practiceArea) {
        if (e.target.value === practiceArea.name) _this7.practiceAreaSections = practiceArea.sections;
      });

      if (this.practiceAreaSections !== undefined) this.practiceAreaSection = this.practiceAreaSections[0];
    },
    selectPracticeAreaSection: function selectPracticeAreaSection(section) {
      if (section === this.practiceAreaSection) return true;
    },
    showMaxItemsModal: function showMaxItemsModal(role) {
      this.currentRole = '';
      this.maxItems = this.allRolesMaxItems[role];
      this.isMaxItemsModal = true;

      this.currentRole = role;
    },
    updateMaxItems: function updateMaxItems(maxItems) {
      this.allRolesMaxItems[this.currentRole] = maxItems;
    }
  }
});

/***/ }),

/***/ "XLA1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'annotation-highlight',

  props: ['index', 'width', 'height'],

  computed: {
    getStyle: function getStyle() {
      return 'width:' + this.width + 'px;height:' + this.height + 'px;';
    }
  },

  methods: {
    showControls: function showControls() {
      var elPos = this.$el.getBoundingClientRect();
      this.$bus.emit('showAnnotationControls', {
        index: this.index,
        type: 'textarea',
        x: elPos.left,
        y: elPos.top + elPos.height
      });
    }
  }
});

/***/ }),

/***/ "XUo2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y2R0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_EditorQuestionnaireView__ = __webpack_require__("FZ2H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_LayoutView__ = __webpack_require__("SAdT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_LoginView__ = __webpack_require__("qAPS");



var _this = this;




// import EditorView from '@/views/EditorView'

// import ListView from '@/views/ListView'



__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

// Rutas
var routes = [{
  path: '/',
  name: 'LayoutView',
  component: __WEBPACK_IMPORTED_MODULE_6__views_LayoutView__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/editor/:formId',
  name: 'EditorQuestionnaireView',
  component: __WEBPACK_IMPORTED_MODULE_5__views_EditorQuestionnaireView__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/login',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_7__views_LoginView__["a" /* default */]
}];

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  routes: routes
});

// authentication
router.beforeEach(function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    var isAuthenticated, accessToken, validate;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!to.matched.some(function (record) {
              return record.meta.requiresAuth;
            })) {
              _context.next = 14;
              break;
            }

            isAuthenticated = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.isAuthenticated;
            accessToken = isAuthenticated.accessToken ? isAuthenticated.accessToken : localStorage.getItem('accesToken');

            if (!(accessToken !== null)) {
              _context.next = 9;
              break;
            }

            _context.next = 6;
            return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('validateAccessToken', accessToken);

          case 6:
            _context.t0 = _context.sent;
            _context.next = 10;
            break;

          case 9:
            _context.t0 = { success: false };

          case 10:
            validate = _context.t0;

            if (validate.success === true) next();else next('/login');
            _context.next = 15;
            break;

          case 14:
            next();

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YevJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog)?_c('div',{staticClass:"modal-dialog myMoDi",attrs:{"id":"modalDeleteTemplate"}},[_c('div',{staticClass:"modalHeader"},[_c('span',{staticClass:"title"},[_vm._v("Delete Template")]),_vm._v(" "),_c('span',{staticClass:"btn-close float-right",on:{"click":_vm.closeModal}},[_c('i',{staticClass:"fas fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"modalBody"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"duplicateSource"}},[_vm._v("Template:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template),expression:"template"}],staticClass:"form-control form-control-sm",attrs:{"id":"duplicateSource"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.template=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.$store.state.templates),function(template,index){return (template.name !== 'global')?_c('option',{key:index,domProps:{"value":{id:template._id,name:template.name}}},[_vm._v("\n          "+_vm._s(template.name)+"\n        ")]):_vm._e()}),0)]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.deleteTemplate}},[_vm._v("Delete")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",on:{"click":_vm.closeModal}},[_vm._v("Cancel")])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZNkg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZarL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{attrs:{"id":"modalEditField"}},[_c('div',{staticClass:"modalHeader"},[_c('span',{staticClass:"title"},[_vm._v("Edit Form Field")]),_vm._v(" "),_c('span',{staticClass:"btn-close float-right",on:{"click":_vm.closeModal}},[_c('i',{staticClass:"fas fa-times"})])]),_vm._v(" "),(_vm.$store.state.currentTemplateName === 'global')?_c('div',{staticClass:"globalAlert"},[_vm._v("You are currently viewing the global template. The global template cannot be modified.")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modalBody"},[_c('div',{staticClass:"row modal-section"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldData.id),expression:"fieldData.id"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.fieldData.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fieldData, "id", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldData.type),expression:"fieldData.type"}],staticClass:"form-control form-control-sm",attrs:{"id":"type","disabled":_vm.$store.state.currentTemplateName === 'global'},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.fieldData, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"text"}},[_vm._v("Text")]),_vm._v(" "),_c('option',{attrs:{"value":"checkbox"}},[_vm._v("Checkbox")]),_vm._v(" "),_c('option',{attrs:{"value":"select"}},[_vm._v("Dropdown")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[(_vm.fieldData.type === 'select')?_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.choiceData),expression:"choiceData"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":_vm.$store.state.currentTemplateName === 'global'},domProps:{"value":(_vm.choiceData)},on:{"input":function($event){if($event.target.composing){ return; }_vm.choiceData=$event.target.value}}})]):_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldData.maskType),expression:"fieldData.maskType"}],staticClass:"form-control form-control-sm",attrs:{"id":"inputMask","disabled":_vm.$store.state.currentTemplateName === 'global' || _vm.fieldData.type !== 'text'},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.fieldData, "maskType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.maskTypes),function(field){return _c('option',{key:field.maskType,domProps:{"value":field.maskType,"selected":field.maskType === _vm.fieldData.maskType}},[_vm._v("\n              "+_vm._s(field.maskType)+"\n            ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldData.tabOrder),expression:"fieldData.tabOrder"}],class:['form-control form-control-sm', _vm.validTabIndex ? '' : 'invalid'],attrs:{"type":"number","min":"-1","id":"tabIndex","disabled":_vm.$store.state.currentTemplateName === 'global'},domProps:{"value":(_vm.fieldData.tabOrder)},on:{"change":_vm.validateTabIndex,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fieldData, "tabOrder", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_vm._m(5),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldData.x),expression:"fieldData.x"}],staticClass:"form-control form-control-sm",attrs:{"type":"number","disabled":_vm.$store.state.currentTemplateName === 'global'},domProps:{"value":(_vm.fieldData.x)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fieldData, "x", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_vm._m(6),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldData.y),expression:"fieldData.y"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":_vm.$store.state.currentTemplateName === 'global'},domProps:{"value":(_vm.fieldData.y)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fieldData, "y", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_vm._m(7),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldData.width),expression:"fieldData.width"}],staticClass:"form-control form-control-sm",attrs:{"type":"number","disabled":_vm.$store.state.currentTemplateName === 'global'},domProps:{"value":(_vm.fieldData.width)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fieldData, "width", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_vm._m(8),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldData.height),expression:"fieldData.height"}],staticClass:"form-control form-control-sm",attrs:{"type":"number","disabled":_vm.$store.state.currentTemplateName === 'global'},domProps:{"value":(_vm.fieldData.height)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fieldData, "height", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_vm._m(9),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-success btnNewGroup",on:{"click":_vm.createFieldGroup}},[_vm._v("New Group")]),_vm._v(" "),(Object.keys(_vm.fieldNames).length)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldGroup),expression:"fieldGroup"}],staticClass:"form-control form-control-sm",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.fieldGroup=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changeGroup]}},[_c('option',{attrs:{"value":"none"}},[_vm._v("None")]),_vm._v(" "),_vm._l((_vm.fieldNames),function(name,index){return _c('option',{key:index,domProps:{"value":index}},[_vm._v(_vm._s(name))])})],2):_vm._e()]),_vm._v(" "),(_vm.isCheckbox)?_c('div',{staticClass:"form-group"},[_vm._m(10),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-success btnNewGroup",on:{"click":_vm.createCheckboxGroup}},[_vm._v("New Group")]),_vm._v(" "),(Object.keys(_vm.checkboxNames).length)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkboxGroup),expression:"checkboxGroup"}],staticClass:"form-control form-control-sm",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.checkboxGroup=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changeCheckboxGroup]}},[_c('option',{attrs:{"value":"none"}},[_vm._v("None")]),_vm._v(" "),_vm._l((_vm.checkboxNames),function(name,index){return _c('option',{key:index,domProps:{"value":index}},[_vm._v(_vm._s(name))])})],2):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_vm._m(11),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldData.prefix),expression:"fieldData.prefix"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":_vm.$store.state.currentTemplateName === 'global'},domProps:{"value":(_vm.fieldData.prefix)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fieldData, "prefix", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_vm._m(12),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldData.model),expression:"fieldData.model"}],staticClass:"form-control form-control-sm",attrs:{"id":"txtFieldModel","type":"text","disabled":_vm.$store.state.currentTemplateName === 'global'},domProps:{"value":(_vm.fieldData.model)},on:{"keyup":_vm.setAutocompleteModel,"blur":_vm.hideAutocompleteModel,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fieldData, "model", $event.target.value)}}}),_vm._v(" "),(_vm.isAutocompleteModel === true && (this.fieldData.value === '' || this.fieldData.value === undefined || this.fieldData.value === null))?_c('autocomplete-model',{attrs:{"data":_vm.autocompleteModelData,"model":_vm.autocompleteModel},on:{"set-model-value":_vm.setModelValue}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_vm._m(13),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldData.value),expression:"fieldData.value"}],staticClass:"form-control form-control-sm",attrs:{"id":"txtFieldValue","type":"text","disabled":_vm.$store.state.currentTemplateName === 'global'},domProps:{"value":(_vm.fieldData.value)},on:{"change":_vm.changeValueEdit,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fieldData, "value", $event.target.value)}}})])]),_vm._v(" "),(_vm.fieldData.model !== undefined && _vm.fieldData.model !== null && _vm.fieldData.model !== '')?_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_vm._m(14),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{attrs:{"id":"noReverseCheck","type":"checkbox"},domProps:{"checked":_vm.fieldData.noReverse},on:{"change":function($event){_vm.fieldData.noReverse === undefined ? _vm.fieldData.noReverse = true : _vm.fieldData.noReverse = !_vm.fieldData.noReverse}}})])]):_vm._e(),_vm._v(" "),(_vm.fieldData.type === 'text')?_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_vm._m(15),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldData.maxCharacter),expression:"fieldData.maxCharacter"}],staticClass:"form-control form-control-sm",attrs:{"id":"txtFieldValue","type":"text","disabled":_vm.$store.state.currentTemplateName === 'global'},domProps:{"value":(_vm.fieldData.maxCharacter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fieldData, "maxCharacter", $event.target.value)}}})])]):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('localizations',{ref:"localizations",attrs:{"fieldId":_vm.fieldData.id,"currentModel":_vm.editorText,"translations":_vm.translations}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row modal-section",attrs:{"id":"modalSectionEdit"}},[_c('h2',{staticClass:"ml-3 w-100"},[_vm._v("Model")]),_vm._v(" "),_c('div',{staticClass:"col-sm-3",attrs:{"id":"panelModelSearch"}},[_vm._m(16),_vm._v(" "),_c('tree-view')],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6",attrs:{"id":"panelModelEdit"}},[_c('h2',[_vm._v("Model Editor")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.editorText),expression:"editorText"}],staticClass:"form-control form-control-sm",attrs:{"id":"modelEdit","disabled":_vm.$store.state.currentTemplateName === 'global'},domProps:{"value":(_vm.editorText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editorText=$event.target.value}}}),_vm._v(" "+_vm._s(_vm.setModelChange)+"\n        "),_c('h2',[_vm._v("Preview")]),_vm._v(" "),_c('div',{attrs:{"id":"editPreview"}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3",attrs:{"id":"panelModelFunctions"}},[_c('h2',[_vm._v("Functions & Operators")]),_vm._v(" "),_c('function-toolbox')],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row modal-section",attrs:{"id":"sectionQuestionnaireTags"}},[_c('div',{staticClass:"col-sm-12"},[_c('questionnaire-tags',{attrs:{"fieldData":_vm.fieldData}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row modal-section",attrs:{"id":"AbGroupWatchersField"}},[_c('div',{staticClass:"col-sm-12"},[_c('ab-group-watchers',{attrs:{"isGroup":false,"fieldData":_vm.fieldData}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-center"},[(
          _vm.$store.state.currentTemplateName !== 'global' &&
          _vm.showResetField
        )?_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.confirmResetField}},[_vm._v("\n        Reset Field\n      ")]):_vm._e(),_vm._v(" "),(
          _vm.$store.state.currentTemplateName !== 'global' &&
          _vm.showSendQuestionnaire === null &&
          _vm.fieldGroup === 'none'
        )?_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.sendQuestionnaireField}},[_vm._v("\n        Send to Questionnaire\n      ")]):_vm._e(),_vm._v(" "),(_vm.$store.state.currentTemplateName !== 'global')?_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.confirmDeleteField}},[_vm._v("\n        Delete Field\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"margin-bottom":"60px"}},[_c('div',{staticClass:"float-right"},[(_vm.$store.state.currentTemplateName !== 'global')?_c('button',{staticClass:"btn btn-success",attrs:{"id":"btnSave"},on:{"click":_vm.saveField}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),(_vm.$store.state.currentTemplateName !== 'global')?_c('button',{staticClass:"btn btn-danger",attrs:{"id":"btnSave"},on:{"click":_vm.cancelField}},[_vm._v("Cancel")]):_vm._e()])])],1)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"usr"}},[_c('b',[_vm._v("Field ID")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"usr"}},[_c('b',[_vm._v("Type")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"usr"}},[_c('b',[_vm._v("Dropdown Options (separate with | character)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"usr"}},[_c('b',[_vm._v("Input Mask")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"usr"}},[_c('b',[_vm._v("Tab Index")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"usr"}},[_c('b',[_vm._v("X Position")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"usr"}},[_c('b',[_vm._v("Y Position")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"usr"}},[_c('b',[_vm._v("Width")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"usr"}},[_c('b',[_vm._v("Height")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticStyle:{"width":"30%"}},[_c('b',[_vm._v("Field Group")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticStyle:{"width":"30%"}},[_c('b',[_vm._v("Checkbox Group")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"prefix"}},[_c('b',[_vm._v("Prefix")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"model"}},[_c('b',[_vm._v("Model")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"model"}},[_c('b',[_vm._v("Value")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"model"}},[_c('b',[_vm._v("No reverse")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"model"}},[_c('b',[_vm._v("Max Length")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group input-group-sm search-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"modelSearch","placeholder":"Search"}}),_vm._v(" "),_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text input-group-addon"},[_c('i',{staticClass:"fas fa-search"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZdWi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZjLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_editor_modals_ModalDialog__ = __webpack_require__("v+gJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_grid_AddFormModal__ = __webpack_require__("DNKF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_form_grid_EditFormModal__ = __webpack_require__("OJSY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_editor_main_Notifications__ = __webpack_require__("gbl9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_editor_modals_GlobalModal_vue__ = __webpack_require__("ROUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_questionnaires_Spinner_vue__ = __webpack_require__("Qm8n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_searchSelect_SearchSelect_vue__ = __webpack_require__("QiEr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_editor_modal_edit_CreateButtonModel_vue__ = __webpack_require__("sVsC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_good_table_dist_vue_good_table_css__ = __webpack_require__("gfot");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_good_table_dist_vue_good_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_good_table_dist_vue_good_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_good_table__ = __webpack_require__("31fY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_export_to_csv__ = __webpack_require__("GRIg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_export_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_export_to_csv__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'list-view',

  data: function data() {
    return {
      moment: window.moment,

      deleteId: null,

      addFormModalVisible: false,
      editFormModalVisible: false,

      // VUE-GOOD-TABLE

      isLoading: false,
      columns: [{
        label: 'Q',
        field: 'enableForQuestionnaire', // Campo para el ordenamiento
        sortable: true,
        hidden: false,
        columnSlot: 'iconEnableForQuestionnaire' // Identificador del slot
      }, {
        label: 'Name',
        field: 'name',
        filterOptions: {
          enabled: true,
          placeholder: 'Filter Name',
          trigger: 'input'
        },
        hidden: false,
        columnSlot: 'name'
      }, {
        label: 'Actions',
        field: 'actions',
        html: true,
        hidden: false
      }, {
        label: 'Title',
        field: 'title',
        filterOptions: {
          enabled: true,
          placeholder: 'Filter Title',
          trigger: 'input'
        },
        hidden: false,
        columnSlot: 'title'
      }, {
        label: 'Library',
        field: 'practiceArea',
        filterOptions: {
          enabled: true,
          placeholder: 'Filter Library',
          trigger: 'input'
        },
        hidden: false
      }, {
        label: 'Section',
        field: 'practiceAreaSection',
        filterOptions: {
          enabled: true,
          placeholder: 'Filter Section',
          trigger: 'input'
        },
        hidden: false
      }, {
        label: 'Practice Area',
        field: 'practiceAreaTag',
        filterOptions: {
          enabled: true,
          placeholder: 'Filter Practice Area',
          trigger: 'input'
        },
        hidden: false
      }, {
        label: 'Internal Tags',
        field: 'internalTag',
        filterOptions: {
          enabled: true,
          placeholder: 'Filter Internal Tag',
          trigger: 'input'
        },
        hidden: false
      }, {
        label: 'Version',
        field: 'version',
        type: 'number',
        filterOptions: {
          enabled: true,
          placeholder: 'Filter Version',
          trigger: 'input'
        },
        hidden: false
      }, {
        label: 'Expiration Date',
        field: 'expirationDate',
        type: 'number',
        filterOptions: {
          enabled: true,
          placeholder: 'Filter Expiration Date',
          trigger: 'input'
        },
        hidden: false
      }, {
        label: 'Revision Date',
        field: 'revisionDate',
        type: 'number',
        filterOptions: {
          enabled: true,
          placeholder: 'Filter Revision Date',
          trigger: 'input'
        },
        hidden: true
      }, {
        label: 'Status',
        field: 'status',
        filterOptions: {
          enabled: true,
          placeholder: 'Filter Status',
          trigger: 'input'
        },
        hidden: false
      }, {
        label: 'Viewer Url',
        field: 'viewer_url',
        filterOptions: {
          enabled: true,
          placeholder: 'Filter Viewer Url',
          trigger: 'input'
        },
        hidden: true
      }, {
        label: 'Last Updated',
        field: 'updatedAt',
        type: 'number',
        filterOptions: {
          enabled: true,
          placeholder: 'Filter Last Updated',
          trigger: 'input'
        },
        hidden: true
      }, {
        label: 'DB ID',
        field: '_id',
        sortable: true,
        hidden: true
      }],
      rows: null,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: ''
        },
        page: 1,
        perPage: 20
      },

      // END VUE-GOOD-TABLE

      timeSearch: null,

      actualVersion: '0.097',

      isModal: false,
      duplicateFormName: '',
      duplicateFormId: '',
      isDisableBtnClone: false,

      apiUrl: this.$store.state.apiUrl,

      isModalRoles: false,
      isModalModels: false,

      roles: null,
      models: null,

      isDisableBtnSaveRoles: false,

      rolesToUpdate: [],
      newRolesToSave: [],
      modelsToUpdate: [],
      newModelsToSave: [],
      contUpdates: 0,
      contInserts: 0,

      isModalMassUpdate: false,
      passwordToAddJson: '',
      passToAddJson: 'factory',
      isInvalidPassword: false,

      bulkActionsModalLabel: '',

      isAddDataJSON: false,
      isEnableDisable: false,
      isAddInternalTag: false,
      isSpinnerMassUpdate: false,

      internalTagsForForms: [],
      tagsFormInternal: [],

      isAddSection: false,

      allSections: [],

      sectionBulkAction: '',

      labelButtonBulkAction: '',
      isAddLibrary: '',

      libraryBulkAction: '',
      isAddPracticeArea: false,
      practiceAreaForForms: [],
      practiceAreas: [],

      isAddRevisionDate: false,

      revisionDateBulkAction: '',

      isAddExpirationDate: false,
      expirationDateBulkAction: '',

      isAddVersion: false,
      versionBulkAction: '',

      formsUpdated: 0,
      formsToUpdate: 0,

      formsInvalidPath: [],

      formData: null,

      // VUE-GOOD-TABLE-MODALS

      isLoadingOModels: false,
      columnsOModels: [{
        label: 'Model',
        field: 'model',
        /*  filterOptions: {
            enabled: true,
            placeholder: 'Filter Model',
            trigger: 'input'
          }, */
        hidden: false /* ,
                      {
                       label: 'Actions',
                       field: 'actions',
                       html: true,
                       hidden: false
                      } */
      }],
      rowsOModels: null,
      totalRecordsOModels: 0,
      serverParamsOModels: {
        columnFilters: {},
        sort: {
          field: '',
          type: ''
        },
        page: 1,
        perPage: 20
      },
      isAutocompleteModel: false,
      autocompleteModelData: null,
      autocompleteModel: '',
      listOfficialModels: [],
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight

      // END VUE-GOOD-TABLE-MODALS
    };
  },


  components: {
    ModalDialog: __WEBPACK_IMPORTED_MODULE_5__components_editor_modals_ModalDialog__["a" /* default */],
    AddFormModal: __WEBPACK_IMPORTED_MODULE_6__components_form_grid_AddFormModal__["a" /* default */],
    EditFormModal: __WEBPACK_IMPORTED_MODULE_7__components_form_grid_EditFormModal__["a" /* default */],
    Notifications: __WEBPACK_IMPORTED_MODULE_8__components_editor_main_Notifications__["a" /* default */],
    GlobalModal: __WEBPACK_IMPORTED_MODULE_9__components_editor_modals_GlobalModal_vue__["a" /* default */],
    FSpinner: __WEBPACK_IMPORTED_MODULE_10__components_questionnaires_Spinner_vue__["a" /* default */],
    SearchSelect: __WEBPACK_IMPORTED_MODULE_11__components_searchSelect_SearchSelect_vue__["a" /* default */],
    VueGoodTable: __WEBPACK_IMPORTED_MODULE_14_vue_good_table__["a" /* VueGoodTable */],
    CreateButtonModel: __WEBPACK_IMPORTED_MODULE_12__components_editor_modal_edit_CreateButtonModel_vue__["a" /* default */]
  },

  computed: {
    updateScreenSize: function updateScreenSize() {
      var _this = this;

      return function () {
        _this.screenWidth = window.innerWidth;
        _this.screenHeight = window.innerHeight;
      };
    }
  },

  watch: {
    filterGrid: function filterGrid(val) {
      // this.getCountForms()

      this.getFormList();
    },
    passwordToAddJson: function passwordToAddJson(val) {
      this.isInvalidPassword = false;
    }
  },

  created: function created() {
    var _this2 = this;

    // FORMS UPDATED

    this.$bus.on('setFormUpdated', function () {
      _this2.formsUpdated++;
    });

    // FORM INVALID PATH

    this.$bus.on('setFormInvalidPath', function (form) {
      _this2.formsInvalidPath.push(form);
    });

    // CLOSE BULK ACTION MODAL

    this.$bus.on('closeBulkActionsModal', function () {
      _this2.closeBulkActionsModal();
    });

    // GET FORM LIST
    this.$bus.on('getFormList', function () {
      _this2.isLoading = true;
      _this2.getFormList();
    });

    // GET FORM LIST
    this.$bus.on('closeCreateButtonModels', function () {
      _this2.closeCreateButtonModels();
    });

    window.addEventListener('resize', this.updateScreenSize);
  },
  mounted: function mounted() {
    this.$store.commit('setAutofillId', null);
    this.$store.commit('setAutofillDetails', null);
    this.$store.commit('setOfficialModels', null);
    this.$store.commit('setCurrentPage', 1);

    var that = this;

    this.getModels();
    this.getData();

    this.$on('closeModal', function () {
      that.addFormModalVisible = false;
      that.editFormModalVisible = false;
    });

    this.$bus.on('confirmFormDelete', this.deleteForm);
  },


  methods: {
    deleteForm: function deleteForm() {
      var _this3 = this;

      var apiUrl = this.$store.state.apiUrl;
      this.axios.get(apiUrl + 'form/' + this.deleteId + '/delete').then(function (response) {
        if (response.data.success) {
          _this3.$store.commit('deleteForm', _this3.deleteId);
          window.Sweetalert2.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'The form was deleted successfully.',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 1200
          });

          _this3.isLoading = true;
          _this3.getFormList();
        } else {
          window.Sweetalert2.fire({
            toast: true,
            position: 'top-end',
            icon: 'warning',
            title: 'There was an error deleting the form.',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 1200
          });
        }
      });
    },
    confirmDelete: function confirmDelete(deleteId) {
      var _this4 = this;

      window.Sweetalert2.fire({
        title: 'Delete Form?',
        text: 'You are about to delete this form and all of its templates. Do you want to continue?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(function (result) {
        if (result.isConfirmed) {
          _this4.deleteId = deleteId;
          _this4.deleteForm();
        }
      });
    },
    showEditFormModal: function showEditFormModal(formId) {
      this.editFormModalVisible = true;
      this.$refs.editModal.$emit('setId', formId);
      this.$bus.emit('setPracticeAreaSections');
    },
    getModels: function getModels() {
      var _this5 = this;

      var apiUrl = this.$store.state.apiUrl;
      this.axios.get(apiUrl + 'model/list').then(function (response) {
        _this5.$store.commit('setModels', response.data);
      });
    },
    getData: function getData() {
      var _this6 = this;

      var apiUrl = this.$store.state.apiUrl;

      // this.getCountForms()

      this.getFormList();

      this.axios.get(apiUrl + 'role/list').then(function (response) {
        _this6.$store.commit('setFormRoles', response.data);
      });

      this.axios.get(apiUrl + 'practice-area').then(function (response) {
        _this6.$store.commit('setPracticeAreas', response.data);
      });
    },
    showAddFormModal: function showAddFormModal() {
      this.addFormModalVisible = true;
    },
    openModalDuplicateForm: function openModalDuplicateForm(formId, formName) {
      this.isModal = true;
      this.isDisableBtnClone = false;

      this.duplicateFormId = formId;
      this.duplicateFormName = formName + '_copy';
    },
    cloneTemplate: function cloneTemplate() {
      var _this7 = this;

      this.isDisableBtnClone = true;

      this.axios.get(this.$store.state.apiUrl + 'form/' + this.duplicateFormId).then(function (responseForm) {
        var formData = responseForm.data[0];

        formData.name = _this7.duplicateFormName;

        formData.status = 'Disabled';

        formData.enableForQuestionnaire = false;

        delete formData._id;

        _this7.createNewForm(formData);
      });
    },
    createNewForm: function createNewForm(formData) {
      var _this8 = this;

      this.axios.post(this.$store.state.apiUrl + 'form/add', formData).then(function (responseAddForm) {
        _this8.axios.get(_this8.$store.state.apiUrl + 'template/list/' + _this8.duplicateFormId).then(function (response) {
          var templates = response.data;

          _this8.createNewTemplates({
            templates: templates,
            newFormId: responseAddForm.data.formId
          });

          _this8.axios.get(_this8.$store.state.apiUrl + 'form/list').then(function (response) {
            _this8.$store.commit('setForms', response.data);
          });
        });
      });
    },
    createNewTemplates: function createNewTemplates(payload) {
      var _this9 = this;

      payload.templates.forEach(function (newTemplate) {
        newTemplate.formId = payload.newFormId;

        var oldTemplateId = newTemplate._id;

        delete newTemplate._id;

        _this9.$store.dispatch('uploadTemplate', newTemplate).then(function (responseTemplate) {
          if (responseTemplate.data.success) {
            _this9.$bus.emit('addNotification', {
              title: 'Template Added',
              body: 'The global and default template were added successfully.',
              type: 'success'
            });

            if (newTemplate.name === 'default') {
              _this9.createNewAutofill({
                newFormId: payload.newFormId,
                newTemplateId: responseTemplate.data.id
              });
            }

            _this9.axios.get(_this9.$store.state.apiUrl + 'questionnaire/list/' + oldTemplateId).then(function (response) {
              var questionnaire = response.data[0];

              if (questionnaire === undefined) return;

              questionnaire.templateId = responseTemplate.data.id;

              delete questionnaire._id;

              _this9.createNewQuestionnaire({
                questionnaire: questionnaire,
                newTemplateId: responseTemplate.data.id
              });
            });
          } else {
            _this9.$bus.emit('addNotification', {
              title: 'Template Error',
              body: 'There was an error adding the new global template to this form. Please review the data and try again',
              type: 'error'
            });
          }

          _this9.isModal = false;
        });
      });
    },
    createNewAutofill: function createNewAutofill(payload) {
      var _this10 = this;

      // CREATE NEW AUTOFILL

      var autofill = {
        formId: payload.newFormId,
        templateId: payload.newTemplateId,
        name: 'global',
        caseTypeId: 0,
        createdAt: new Date(),
        updatedAt: new Date()
      };

      this.$store.dispatch('addAutofill', autofill).then(function (response) {
        _this10.createNewAutofillDetails({
          newAutofillId: response.data.autofillId,
          newTemplateId: payload.newTemplateId
        });
      });
    },
    createNewAutofillDetails: function createNewAutofillDetails(payload) {
      var _this11 = this;

      this.$store.dispatch('getAutofill', this.duplicateFormId).then(function (responseAutofill) {
        var oldAutofillId = responseAutofill.data[0]._id;

        _this11.axios.get(_this11.$store.state.apiUrl + 'autofillDetails/autofill-id/?autofillId=' + oldAutofillId).then(function (responseAutofill) {
          var newAutofillDetails = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(responseAutofill.data));

          newAutofillDetails.forEach(function (autofillDetail, indexAutofillDetail) {
            autofillDetail.autofillId = payload.newAutofillId;

            autofillDetail.templateId = payload.newTemplateId;

            delete autofillDetail._id;

            autofillDetail.createdAt = new Date();
            autofillDetail.updatedAt = new Date();

            newAutofillDetails[indexAutofillDetail] = autofillDetail;
          });

          _this11.$store.dispatch('addAutofillDetail', newAutofillDetails).then(function (responseAddAutofillDetail) {
            if (responseAddAutofillDetail.data.success === true) {
              window.vueBus.emit('addNotification', {
                title: 'Autofill details',
                body: 'Autofill details added successfully.',
                type: 'success'
              });
            } else {
              window.vueBus.emit('addNotification', {
                title: 'Autofill details',
                body: 'Ocurred an error, try one more time.',
                type: 'error'
              });
            }
          });
        });
      });
    },
    createNewQuestionnaire: function createNewQuestionnaire(payload) {
      var _this12 = this;

      this.$store.dispatch('uploadDefaultQuestionnaire', payload.newTemplateId).then(function (responseQuestionnaire) {
        if (responseQuestionnaire.data.success) {
          _this12.$bus.emit('addNotification', {
            title: 'Questionnaire Added',
            body: 'Succesfully adding the questionnaire to this form.',
            type: 'success'
          });

          _this12.updateNewQuestionnaire({
            newQuestionnaireId: responseQuestionnaire.data.id,
            newQuestionnaire: payload.questionnaire
          });
        } else {
          _this12.$bus.emit('addNotification', {
            title: 'Questionnaire Error',
            body: 'There was an error adding the default questionnaire to this form. Please review the data and try again',
            type: 'error'
          });
        }
      });
    },
    updateNewQuestionnaire: function updateNewQuestionnaire(payload) {
      var _this13 = this;

      var requestData = {
        questionnaireId: payload.newQuestionnaireId,
        newData: payload.newQuestionnaire
      };

      this.axios.post(this.$store.state.apiUrl + 'questionnaire/update', requestData).then(function (response) {
        _this13.$bus.emit('addNotification', {
          title: 'Questionnaire Updated',
          body: 'Succesfully updated the new questionnaire to this form.',
          type: 'success'
        });
      });
    },
    onBtnExportDataAsCsv: function onBtnExportDataAsCsv() {
      var options = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: true,
        title: 'My Awesome CSV',
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true
      };

      var csvExporter = new __WEBPACK_IMPORTED_MODULE_15_export_to_csv__["ExportToCsv"](options);

      var dataCsv = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.rows));

      // REMOVE COLUMNS
      dataCsv.forEach(function (form) {
        delete form.properties;
        delete form.deletedAt;
        delete form._id;
        delete form.data;
        delete form.__v;
      });

      csvExporter.generateCsv(dataCsv);
    },
    showRolesModal: function showRolesModal() {
      this.isModalRoles = true;

      this.roles = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.$store.state.formRoles));
    },
    showModelsModal: function showModelsModal() {
      this.isModalModels = true;

      // this.models = JSON.parse(JSON.stringify(this.$store.state.models))
      this.getOfficialModels();
    },
    addNewRol: function addNewRol() {
      var _this14 = this;

      this.roles.push({
        id: Math.random().toString(36).substring(7),
        name: '',
        type: '',
        isNew: true
      });

      setTimeout(function () {
        document.getElementById(_this14.roles.length - 1).scrollIntoView({ block: 'end', behavior: 'smooth' });
        document.getElementById('inputName' + (_this14.roles.length - 1)).focus();
      }, 500);
    },
    addNewModel: function addNewModel() {
      var _this15 = this;

      this.models.push({
        id: Math.random().toString(36).substring(7),
        category: '',
        desc: '',
        field: '',
        fieldType: '',
        label: '',
        prefix: '',
        properties: '',
        route: '',
        subcategory: '',
        type: '',
        isNew: true
      });

      setTimeout(function () {
        document.getElementById(_this15.models.length - 1).scrollIntoView({ block: 'end', behavior: 'smooth' });
        document.getElementById('inputName' + (_this15.models.length - 1)).focus();
      }, 500);
    },
    prevToSaveRole: function prevToSaveRole(indexRole) {
      var currentRole = this.roles[indexRole];

      if (currentRole.isNew && currentRole.name !== '' && currentRole.type !== '') {
        if (this.newRolesToSave.map(function (a) {
          return a.id;
        }).indexOf(currentRole.id) === -1) {
          this.newRolesToSave.push(currentRole);
        } else {
          this.newRolesToSave[this.newRolesToSave.map(function (a) {
            return a.id;
          }).indexOf(currentRole.id)] = currentRole;
        }
      } else {
        if (this.rolesToUpdate.map(function (a) {
          return a._id;
        }).indexOf(currentRole._id) === -1) {
          this.rolesToUpdate.push(currentRole);
        } else {
          this.rolesToUpdate[this.rolesToUpdate.map(function (a) {
            return a._id;
          }).indexOf(currentRole._id)] = currentRole;
        }
      }
    },
    prevToSaveModel: function prevToSaveModel(indexModel) {
      var currentModel = this.models[indexModel];

      if (currentModel.isNew && currentModel.field !== '' && currentModel.type !== '') {
        if (this.newModelsToSave.map(function (a) {
          return a.id;
        }).indexOf(currentModel.id) === -1) {
          this.newModelsToSave.push(currentModel);
        } else {
          this.newModelsToSave[this.newModelsToSave.map(function (a) {
            return a.id;
          }).indexOf(currentModel.id)] = currentModel;
        }
      } else {
        if (this.modelsToUpdate.map(function (a) {
          return a._id;
        }).indexOf(currentModel._id) === -1) {
          this.modelsToUpdate.push(currentModel);
        } else {
          this.modelsToUpdate[this.modelsToUpdate.map(function (a) {
            return a._id;
          }).indexOf(currentModel._id)] = currentModel;
        }
      }
    },
    saveRoles: function saveRoles() {
      var _this16 = this;

      this.roles.forEach(function (role, indexRole) {
        if (role.isNew && (role.name === '' || role.type === '')) _this16.roles.splice(indexRole, 1);
      });

      this.addRoles();
      this.updateRoles();
    },
    saveModels: function saveModels() {
      var _this17 = this;

      this.models.forEach(function (model, indexModel) {
        if (model.isNew && (model.field === '' || model.type === '')) _this17.models.splice(indexModel, 1);
      });

      this.addModels();
      this.updateModels();
    },
    addRoles: function addRoles() {
      var _this18 = this;

      this.contInserts = 0;

      this.newRolesToSave.forEach(function (newRole) {
        _this18.$store.dispatch('addRole', newRole).then(function (response) {
          _this18.contInserts++;

          if (_this18.rolesToUpdate.length + _this18.newRolesToSave.length === _this18.contUpdates + _this18.contInserts) {
            _this18.closeRolesModal();
          }
        });
      });
    },
    updateRoles: function updateRoles() {
      var _this19 = this;

      this.contUpdates = 0;

      this.rolesToUpdate.forEach(function (role) {
        var roleId = role._id;
        var newData = role;

        _this19.$store.dispatch('updateRole', {
          roleId: roleId,
          newData: newData
        }).then(function (response) {
          _this19.contUpdates++;

          if (_this19.rolesToUpdate.length + _this19.newRolesToSave.length === _this19.contUpdates + _this19.contInserts) {
            _this19.closeRolesModal();
          }
        });
      });
    },
    addModels: function addModels() {
      var _this20 = this;

      this.contInserts = 0;

      this.newModelsToSave.forEach(function (newModel) {
        _this20.$store.dispatch('addModel', newModel).then(function (response) {
          _this20.contInserts++;

          if (_this20.modelsToUpdate.length + _this20.newModelsToSave.length === _this20.contUpdates + _this20.contInserts) {
            _this20.closeModelsModal();
          }
        });
      });
    },
    updateModels: function updateModels() {
      var _this21 = this;

      this.contUpdates = 0;

      this.modelsToUpdate.forEach(function (model) {
        var modelId = model._id;
        var newData = model;

        _this21.$store.dispatch('updateModel', {
          modelId: modelId,
          newData: newData
        }).then(function (response) {
          _this21.contUpdates++;

          if (_this21.modelsToUpdate.length + _this21.newModelsToSave.length === _this21.contUpdates + _this21.contInserts) {
            _this21.closeModelsModal();
          }
        });
      });
    },
    closeRolesModal: function closeRolesModal() {
      this.$store.commit('setFormRoles', this.roles);
      this.isModalRoles = false;
      this.newRolesToSave = [];
      this.rolesToUpdate = [];
    },
    closeModelsModal: function closeModelsModal() {
      this.$store.commit('setModels', this.models);
      this.isModalModels = false;
      this.newModelsToSave = [];
      this.modelsToUpdate = [];
    },
    addJsonToSelectedForms: function addJsonToSelectedForms() {
      if (btoa(this.passToAddJson) !== this.passwordToAddJson) {
        this.isInvalidPassword = true;

        return;
      }

      this.isSpinnerMassUpdate = true;

      var elFilters = document.querySelectorAll('.ag-floating-filter-input');

      this.$store.commit('setBlankFilters');

      var allFilters = [];

      elFilters.forEach(function (filter) {
        allFilters.push(filter.value);
      });

      this.$store.commit('setAllFilters', {
        filters: allFilters
      });

      this.formsToUpdate = this.$refs['forms-table'].selectedRows.length;

      this.$bus.emit('updateTemplatesMassive', {
        formsCheckedList: this.$refs['forms-table'].selectedRows
      });
    },
    openModalAddJSONGitHub: function openModalAddJSONGitHub() {
      if (!this.$refs['forms-table'].selectedRows.length || this.$refs['forms-table'].selectedRows.length === 0) return;

      this.isModalMassUpdate = true;
      this.isAddDataJSON = true;
      this.bulkActionsModalLabel = 'Load JSON from GitHub Repository';
    },
    openModalEnbaleDisable: function openModalEnbaleDisable() {
      if (!this.$refs['forms-table'].selectedRows.length || this.$refs['forms-table'].selectedRows.length === 0) return;

      this.isModalMassUpdate = true;
      this.isEnableDisable = true;
      this.bulkActionsModalLabel = 'Enable / Disable';
    },
    closeBulkActionsModal: function closeBulkActionsModal() {
      this.isModalMassUpdate = false;
      this.passwordToAddJson = '';
      this.isAddDataJSON = false;
      this.isEnableDisable = false;
      this.isAddInternalTag = false;
      this.isAddSection = false;
      this.isAddLibrary = false;
      this.isAddPracticeArea = false;
      this.isAddRevisionDate = false;
      this.isAddExpirationDate = false;
      this.isAddVersion = false;

      this.isSpinnerMassUpdate = false;

      this.bulkActionsModalLabel = '';
      this.labelButtonBulkAction = '';

      this.internalTagsForForms = [];
      this.sectionBulkAction = '';
      this.libraryBulkAction = '';
      this.practiceAreaForForms = [];
      this.revisionDateBulkAction = '';
      this.expirationDateBulkAction = '';
      this.versionBulkAction = '';

      this.formsUpdated = 0;
      this.formsToUpdate = 0;
      this.formsInvalidPath = [];

      this.formsCheckedList = [];
    },
    enableForms: function enableForms() {
      this.setMassUpdate({
        status: 'Enabled'
      });
    },
    disableForms: function disableForms() {
      this.setMassUpdate({
        status: 'Disabled'
      });
    },
    timeout: function timeout(ms) {
      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    setMassUpdate: function setMassUpdate(payload) {
      var _this22 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _loop, contForm;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this22.formsToUpdate = _this22.$refs['forms-table'].selectedRows.length;
                _this22.isSpinnerMassUpdate = true;
                _this22.isLoading = true;

                _loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _loop(contForm) {
                  var newData, formData;
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _loop$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          newData = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(_this22.$store.state.forms.filter(function (form) {
                            return form._id === _this22.$refs['forms-table'].selectedRows[contForm]._id;
                          })[0]));


                          if (_this22.isEnableDisable) newData.status = payload.status;else if (_this22.isAddInternalTag === true) {
                            payload.tags.forEach(function (tag, tagIndex) {
                              if (newData.internalTag.indexOf(tag) === -1) newData.internalTag.push(tag);
                            });
                          } else if (_this22.isAddSection === true) newData.practiceAreaSection = payload.section;else if (_this22.isAddLibrary === true) newData.practiceArea = payload.library;else if (_this22.isAddPracticeArea === true) {
                            payload.practiceAreas.forEach(function (tag, tagIndex) {
                              if (newData.practiceAreaTag.indexOf(tag) === -1) newData.practiceAreaTag.push(tag);
                            });
                          } else if (_this22.isAddRevisionDate === true) newData.revisionDate = payload.revisionDate;else if (_this22.isAddExpirationDate === true) newData.expirationDate = payload.expirationDate;else if (_this22.isAddVersion === true) newData.version = payload.version;

                          formData = {
                            formId: newData._id,
                            newData: newData
                          };


                          _this22.formData = formData;

                          _context.next = 6;
                          return _this22.updateForm({
                            formData: formData
                          });

                        case 6:

                          _this22.$bus.emit('setFormUpdated');

                          _context.next = 9;
                          return _this22.timeout(1);

                        case 9:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _loop, _this22);
                });
                contForm = 0;

              case 5:
                if (!(contForm < _this22.$refs['forms-table'].selectedRows.length)) {
                  _context2.next = 10;
                  break;
                }

                return _context2.delegateYield(_loop(contForm), 't0', 7);

              case 7:
                contForm++;
                _context2.next = 5;
                break;

              case 10:

                _this22.getFormList();

                // CLOSE MODAL BULK ACTIONS & PROPS

                _this22.isModalMassUpdate = false;
                _this22.isSpinnerMassUpdate = false;
                _this22.isEnableDisable = false;
                _this22.isAddInternalTag = false;
                _this22.isAddSection = false;
                _this22.isAddLibrary = false;
                _this22.isAddPracticeArea = false;
                _this22.isAddRevisionDate = false;
                _this22.isAddExpirationDate = false;
                _this22.isAddVersion = false;

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee, _this22);
      }))();
    },
    updateForm: function updateForm(payload) {
      var _this23 = this;

      this.$store.dispatch('updateForm', {
        formData: payload.formData
      }).then(function (response) {
        if (response.data.success) {
          _this23.$bus.emit('addNotification', {
            title: 'Form Updated',
            body: 'The form was updated successfully.',
            type: 'success'
          });
        } else {
          _this23.$bus.emit('addNotification', {
            title: 'Update Error',
            body: 'There was an error updating this form. Please check the data and try again.',
            type: 'error'
          });
        }
      });
    },
    openModalAddInternalTag: function openModalAddInternalTag() {
      var _this24 = this;

      if (!this.$refs['forms-table'].selectedRows.length || this.$refs['forms-table'].selectedRows.length === 0) return;

      this.isModalMassUpdate = true;
      this.isAddInternalTag = true;

      if (this.internalTagsForForms.length === 0) {
        this.$store.dispatch('getFormTags', {
          tagType: 'internal'
        }).then(function (response) {
          if (response.data !== undefined && response.data !== null) _this24.tagsFormInternal = response.data;
        });
      }

      this.bulkActionsModalLabel = 'Internal Tags';
      this.labelButtonBulkAction = 'Upload';
    },
    addInternalTagMassUpdate: function addInternalTagMassUpdate() {
      this.setMassUpdate({
        tags: this.internalTagsForForms
      });
    },
    openModalAddSection: function openModalAddSection() {
      var _this25 = this;

      if (!this.$refs['forms-table'].selectedRows.length || this.$refs['forms-table'].selectedRows.length === 0) return;

      this.isModalMassUpdate = true;
      this.isAddSection = true;

      if (this.allSections.length === 0) {
        this.$store.state.practiceAreas.map(function (a) {
          return a.sections;
        }).forEach(function (groupSection) {
          _this25.allSections = _this25.allSections.concat(groupSection);
        });
      }

      this.bulkActionsModalLabel = 'Sections';
      this.labelButtonBulkAction = 'Upload';
    },
    addSectionsMassUpdate: function addSectionsMassUpdate() {
      this.setMassUpdate({
        section: this.sectionBulkAction
      });
    },
    setBulkAction: function setBulkAction() {
      if (this.isAddInternalTag === true) this.addInternalTagMassUpdate();else if (this.isAddSection === true) this.addSectionsMassUpdate();else if (this.isAddLibrary === true) this.addLibraryMassUpdate();else if (this.isAddPracticeArea === true) this.addPracticeAreaMassUpdate();else if (this.isAddRevisionDate === true) this.addRevisionDateMassUpdate();else if (this.isAddExpirationDate === true) this.addExpirationDateMassUpdate();else if (this.isAddVersion === true) this.addVersionMassUpdate();
    },
    openModalAddLibrary: function openModalAddLibrary() {
      if (!this.$refs['forms-table'].selectedRows.length || this.$refs['forms-table'].selectedRows.length === 0) return;

      this.isModalMassUpdate = true;
      this.isAddLibrary = true;

      this.bulkActionsModalLabel = 'Library';
      this.labelButtonBulkAction = 'Upload';
    },
    addLibraryMassUpdate: function addLibraryMassUpdate() {
      this.setMassUpdate({
        library: this.libraryBulkAction.name
      });
    },
    openModalAddPracticeArea: function openModalAddPracticeArea() {
      var _this26 = this;

      if (!this.$refs['forms-table'].selectedRows.length || this.$refs['forms-table'].selectedRows.length === 0) return;

      this.isModalMassUpdate = true;
      this.isAddPracticeArea = true;

      if (this.practiceAreas.length === 0) {
        this.$store.dispatch('getFormTags', {
          tagType: 'practiceArea'
        }).then(function (response) {
          if (response.data !== undefined && response.data !== null) _this26.practiceAreas = response.data;
        });
      }

      this.bulkActionsModalLabel = 'Practice Area';
      this.labelButtonBulkAction = 'Upload';
    },
    addPracticeAreaMassUpdate: function addPracticeAreaMassUpdate() {
      this.setMassUpdate({
        practiceAreas: this.practiceAreaForForms
      });
    },
    openModalAddRevisionDate: function openModalAddRevisionDate() {
      if (!this.$refs['forms-table'].selectedRows.length || this.$refs['forms-table'].selectedRows.length === 0) return;

      this.isModalMassUpdate = true;
      this.isAddRevisionDate = true;

      this.bulkActionsModalLabel = 'Revision Date';
      this.labelButtonBulkAction = 'Upload';
    },
    addRevisionDateMassUpdate: function addRevisionDateMassUpdate() {
      this.setMassUpdate({
        revisionDate: this.revisionDateBulkAction
      });
    },
    openModalAddExpirationDate: function openModalAddExpirationDate() {
      if (!this.$refs['forms-table'].selectedRows.length || this.$refs['forms-table'].selectedRows.length === 0) return;

      this.isModalMassUpdate = true;
      this.isAddExpirationDate = true;

      this.bulkActionsModalLabel = 'Expiration Date';
      this.labelButtonBulkAction = 'Upload';
    },
    addExpirationDateMassUpdate: function addExpirationDateMassUpdate() {
      this.setMassUpdate({
        expirationDate: this.expirationDateBulkAction
      });
    },
    openModalAddVersion: function openModalAddVersion() {
      if (!this.$refs['forms-table'].selectedRows.length || this.$refs['forms-table'].selectedRows.length === 0) return;

      this.isModalMassUpdate = true;
      this.isAddVersion = true;

      this.bulkActionsModalLabel = 'Version';
      this.labelButtonBulkAction = 'Upload';
    },
    addVersionMassUpdate: function addVersionMassUpdate() {
      this.setMassUpdate({
        version: this.versionBulkAction
      });
    },


    // METHODS REMOTE VUE-GOOD-TABLE

    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onSearch: function onSearch(params) {
      var _this27 = this;

      window.clearTimeout(this.timeSearch);

      this.timeSearch = setTimeout(function () {
        _this27.isLoading = true;
        _this27.updateParams({
          page: 1,
          searchTerm: {
            value: params.searchTerm,
            fields: _this27.columns.map(function (column) {
              return column.field;
            })
          }
        });
        _this27.getFormList();
      }, 800);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getFormList();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.getFormList();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: params[0]
      });
      this.getFormList();
    },
    onColumnFilter: function onColumnFilter(params) {
      params.page = 1;
      this.updateParams(params);
      this.getFormList();
    },
    getFormList: function getFormList() {
      var _this28 = this;

      this.$store.dispatch('getFormList', this.serverParams).then(function (response) {
        _this28.$store.commit('setForms', response.list);

        _this28.rows = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(response.list));

        _this28.rows.forEach(function (form) {
          // PRACTICE AREA => PRACTICE AREA TAG
          form.practiceAreaTag = String(form.practiceAreaTag);

          // INTERNAL TAG
          form.internalTag = String(form.internalTag);

          // FORMAT EXPIRATION DATE
          form.expirationDate = _this28.moment(form.expirationDate).format('YYYY-MM-DD') !== 'Invalid date' ? _this28.moment(form.expirationDate).format('YYYY-MM-DD') : '';

          // FORMAT REVISION DATE
          form.revisionDate = _this28.moment(form.revisionDate).format('YYYY-MM-DD') !== 'Invalid date' ? _this28.moment(form.revisionDate).format('YYYY-MM-DD') : '';

          // FORMAT LAST UPDATED
          form.updatedAt = _this28.moment(form.updatedAt).format('YYYY-MM-DD') !== 'Invalid date' ? _this28.moment(form.updatedAt).format('YYYY-MM-DD') : '';
        });

        _this28.rows = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], _this28.rows, _this28.rows);

        if (_this28.serverParams.searchTerm !== undefined) {
          _this28.rows = _this28.serverParams.searchTerm.value !== '' ? _this28.rows.sort(_this28.compararObjetos) : _this28.rows;
        }

        _this28.totalRecords = response.totalRecords;
      });
    },
    compararObjetos: function compararObjetos(a, b) {
      if (a.status < b.status) {
        return -1;
      }
      if (a.status > b.status) {
        return 1;
      }

      if (a.version < b.version) {
        return -1;
      }
      if (a.version > b.version) {
        return 1;
      }

      return 0;
    },
    onCellClick: function onCellClick(params) {
      if (params.column.field !== 'actions' && params.column.field !== '_id') {
        this.$bus.emit('openFormApp', {
          formId: params.row._id
        });
        return;
      }
      if (params.column.field === '_id') {
        this.$copyText(params.row._id).then(function () {
          window.Sweetalert2.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'Copied!',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 800
          });
        });
      }
    },
    getOfficialModels: function getOfficialModels() {
      var _this29 = this;

      this.rowsOModels = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.rowsOModels, this.rowsOModels);

      this.$store.dispatch('getOfficialModelsList', this.serverParamsOModels).then(function (response) {
        _this29.rowsOModels = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(response.list));

        _this29.rowsOModels = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], _this29.rowsOModels, _this29.rowsOModels);

        if (_this29.serverParamsOModels.searchTerm !== undefined) {
          _this29.rowsOModels = _this29.serverParamsOModels.searchTerm.value !== '' ? _this29.rowsOModels.sort(_this29.compararObjetosOModels) : _this29.rowsOModels;
        }

        _this29.totalRecordsOModels = response.totalRecords;
        if (_this29.totalRecordsOModels === 0) {
          _this29.isAutocompleteModel = true;
          _this29.autocompleteModelData = {};
          _this29.autocompleteModelData.top = _this29.screenHeight * 0.27;
          _this29.autocompleteModelData.left = _this29.screenWidth * 0.25;
          _this29.autocompleteModel = _this29.serverParamsOModels.searchTerm.value.toString();
        } else {
          _this29.isAutocompleteModel = false;
        }
      });
    },
    updateParamsOfficialModels: function updateParamsOfficialModels(newProps) {
      this.serverParamsOModels = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.serverParamsOModels, newProps);
    },
    onSearchOModels: function onSearchOModels(params) {
      var _this30 = this;

      window.clearTimeout(this.timeSearch);

      this.timeSearch = setTimeout(function () {
        _this30.isLoading = true;
        _this30.updateParamsOfficialModels({
          page: 1,
          searchTerm: {
            value: params.searchTerm,
            fields: _this30.columnsOModels.map(function (column) {
              return column.field;
            })
          }
        });
        _this30.getOfficialModels();
      }, 800);
    },
    onPageChangeOModels: function onPageChangeOModels(params) {
      this.updateParamsOfficialModels({ page: params.currentPage });
      this.getOfficialModels();
    },
    onPerPageChangeOModels: function onPerPageChangeOModels(params) {
      this.updateParamsOfficialModels({ perPage: params.currentPerPage });
      this.getOfficialModels();
    },
    onSortChangeOModels: function onSortChangeOModels(params) {
      this.updateParamsOfficialModels({
        sort: params[0]
      });
      this.getOfficialModels();
    },
    onColumnFilterOModels: function onColumnFilterOModels(params) {
      params.page = 1;
      this.updateParamsOfficialModels(params);
      this.getOfficialModels();
    },
    compararObjetosOModels: function compararObjetosOModels(a, b) {
      if (a.model < b.model) {
        return -1;
      }
      if (a.model > b.model) {
        return 1;
      }
      return 0;
    },
    onCellClickOModels: function onCellClickOModels(params) {
      var jona = params.row.model;
      alert(jona);
    },
    closeModalModels: function closeModalModels() {
      var _this31 = this;

      this.isModalModels = false;
      this.serverParamsOModels.searchTerm.value = '';
      setTimeout(function () {
        _this31.isAutocompleteModel = false;
      }, 500);
      this.getOfficialModels();
    },
    closeCreateButtonModels: function closeCreateButtonModels() {
      var _this32 = this;

      this.serverParamsOModels.searchTerm.value = '';
      setTimeout(function () {
        _this32.isAutocompleteModel = false;
      }, 500);
      this.getOfficialModels();
    },
    logOut: function logOut() {
      var _this33 = this;

      window.sweetAlert({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: ['Cancel', 'Yes, log out']
      }).then(function (res) {
        if (res === true) {
          localStorage.removeItem('accesToken');
          _this33.$router.push('/login');
        }
      });
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('openForm');
    this.$bus.$off('openModalDuplicateForm');
    this.$bus.$off('confirmDelete');
    this.$bus.$off('showEditFormModal');
    this.$bus.$off('setFormUpdated');
    this.$bus.$off('setFormInvalidPath');
    this.$bus.$off('reloadFormsList');
    this.$bus.$off('filterGrid');
    this.$bus.$off('closeBulkActionsModal');
    this.$bus.$off('setFilters');
    this.$bus.$off('getFormList');
    window.removeEventListener('resize', this.updateScreenSize);
    this.$bus.off('hideAutocompleteModel');
  }
});

/***/ }),

/***/ "Zoia":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenuPageList_vue__ = __webpack_require__("CFYr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e3f888b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenuPageList_vue__ = __webpack_require__("AAp8");
function injectStyle (ssrContext) {
  __webpack_require__("iT53")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e3f888b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenuPageList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e3f888b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenuPageList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZzGP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/factorylogo.28fa2ef.jpg";

/***/ }),

/***/ "a/Yx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutocompleteModel_vue__ = __webpack_require__("zGc8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_595fc345_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutocompleteModel_vue__ = __webpack_require__("UFk9");
function injectStyle (ssrContext) {
  __webpack_require__("NwBc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutocompleteModel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_595fc345_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutocompleteModel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ajFt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-expand-lg navbar-light bg-light navMovil"},[_c('a',{staticClass:"navbar-brand"},[_vm._v("Forms List")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarSupportedContent"}},[_c('ul',{staticClass:"navbar-nav navbar-left mr-auto"},[_c('li',{staticClass:"active"},[_c('a',{staticStyle:{"cursor":"pointer","color":"#555","background-color":"#e7e7e7","padding":"15px","display":"block"},on:{"click":_vm.showRolesModal}},[_vm._v("Roles")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_c('a',{staticStyle:{"cursor":"pointer","color":"#555","background-color":"#e7e7e7","padding":"15px","display":"block"},on:{"click":_vm.showModelsModal}},[_vm._v("Models")])])]),_vm._v(" "),_c('ul',{staticClass:"nav navbar-nav navbar-logo",staticStyle:{"margin-right":"auto !important"}},[_c('li',[_c('img',{attrs:{"src":__webpack_require__("ZzGP"),"width":"300px"}}),_vm._v(" "),_c('span',{staticClass:"small",staticStyle:{"position":"absolute","bottom":"0","right":"50%","top":"40px"}},[_vm._v("\n            Version "+_vm._s(_vm.actualVersion)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"nav navbar-nav navbar-right"},[_c('div',{staticClass:"nav-item dropdown"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",staticStyle:{"width":"200px"},attrs:{"aria-labelledby":"navbarDropdown"}},_vm._l((_vm.columns),function(column,columnIndex){return _c('a',{key:columnIndex,staticClass:"dropdown-item",style:(column.hidden ? 'background-color: #e2e1e1;' : '')},[_vm._v("\n              "+_vm._s(column.label)+"\n              "),(column.hidden)?_c('i',{staticClass:"fas fa-eye float-right",on:{"click":function($event){column.hidden = false}}}):_c('i',{staticClass:"fas fa-eye-slash float-right",on:{"click":function($event){column.hidden = true}}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"nav-item",style:(_vm.$store.state.forms !== undefined && _vm.$store.state.forms !== null && Object.keys(_vm.$store.state.forms).length > 0 ? '' : 'pointer-events:none;')},[_c('a',{staticClass:"nav-link",staticStyle:{"cursor":"pointer"},on:{"click":_vm.onBtnExportDataAsCsv}},[_vm._v("Export CSV")])]),_vm._v(" "),_c('div',{staticClass:"nav-item",style:(_vm.$store.state.forms !== undefined && _vm.$store.state.forms !== null && Object.keys(_vm.$store.state.forms).length > 0 ? '' : 'pointer-events:none;')},[_c('a',{staticClass:"nav-link",staticStyle:{"cursor":"pointer"},on:{"click":_vm.showAddFormModal}},[_vm._v("Add Form")])]),_vm._v(" "),_c('div',{staticClass:"nav-item",style:(_vm.$store.state.forms !== undefined && _vm.$store.state.forms !== null && Object.keys(_vm.$store.state.forms).length > 0 ? '' : 'pointer-events:none;')},[_c('a',{staticClass:"nav-link",staticStyle:{"cursor":"pointer"},on:{"click":_vm.logOut}},[_vm._v("Log Out")])])])])]),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"formGrid"}},[_c('add-form-modal',{directives:[{name:"show",rawName:"v-show",value:(_vm.addFormModalVisible),expression:"addFormModalVisible"}],ref:"addModal"}),_vm._v(" "),_c('edit-form-modal',{directives:[{name:"show",rawName:"v-show",value:(_vm.editFormModalVisible),expression:"editFormModalVisible"}],ref:"editModal"}),_vm._v(" "),_c('modal-dialog'),_vm._v(" "),(_vm.rows !== undefined && _vm.rows !== null)?_c('div',{staticClass:"heightGrid p-4"},[_c('vue-good-table',{ref:"forms-table",attrs:{"mode":"remote","styleClass":"vgt-table striped","totalRows":_vm.totalRecords,"isLoading":_vm.isLoading,"search-options":{
          enabled: true,
          placeholder: 'Search this table',
        },"select-options":{
          enabled: true,
          selectOnCheckboxOnly: true,
          selectionText: 'Officials Models selected',
        },"pagination-options":{
          enabled: true,
          perPage: 20,
          perPageDropdown: [10, 20, 30, 40, 50, 100, 200, 500, 1000, 3000],
          dropdownAllowAll: false,
          mode: 'pages'
        },"rows":_vm.rows,"columns":_vm.columns,"max-height":"750px","min-height":"740px","fixed-header":true},on:{"on-search":_vm.onSearch,"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange,"on-cell-click":_vm.onCellClick,"update:isLoading":function($event){_vm.isLoading=$event},"update:is-loading":function($event){_vm.isLoading=$event}},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field === 'actions')?_c('span',[_c('span',[_c('i',{staticClass:"fas fa-clone",staticStyle:{"margin-left":"2px","cursor":"pointer"},on:{"click":function($event){return _vm.openModalDuplicateForm(props.formattedRow._id, props.formattedRow.name)}}}),_vm._v(" "),_c('i',{staticClass:"fas fa-trash",staticStyle:{"margin-left":"1px","cursor":"pointer"},on:{"click":function($event){return _vm.confirmDelete(props.formattedRow._id)}}}),_vm._v(" "),_c('i',{staticClass:"fas fa-edit",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.showEditFormModal(props.formattedRow._id)}}})])]):(props.column.field === 'name' || props.column.field === 'title')?_c('span',{style:(props.formattedRow.status === 'Disabled' ? 'color: #f47373;' : '')},[_c('div',{staticStyle:{"width":"200px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"},attrs:{"data-toggle":"tooltip","data-placement":"top","title":props.formattedRow[props.column.field]}},[_vm._v("\n                "+_vm._s(props.column.field === 'name'
                    ? props.formattedRow.name.length > 11
                      ? props.formattedRow.name.substr(0, 10) + '...'
                      : props.formattedRow.name
                    : props.formattedRow.title.length > 20
                    ? props.formattedRow.title.substr(0, 19) + '...'
                    : props.formattedRow.title)+"\n              ")])]):(props.column.field === 'enableForQuestionnaire')?_c('span',[_c('span',[(_vm.$store.state.forms.find(function (form) { return form._id === props.formattedRow._id; }))?_c('div',[(
                      _vm.$store.state.forms.find(function (form) { return form._id === props.formattedRow._id; })
                        .enableForQuestionnaire
                    )?_c('i',{staticClass:"fas fa-check-circle pull-left",staticStyle:{"color":"#00C853","margin-top":"3px","margin-right":"3px"}}):_c('i',{staticClass:"fas fa-check-circle pull-left",staticStyle:{"color":"gray","margin-top":"3px","margin-right":"3px"}})]):_vm._e()])]):_c('span',{style:(props.formattedRow.status === 'Disabled' ? 'color: #f47373;' : '')},[_vm._v("\n              "+_vm._s(props.formattedRow[props.column.field])+"\n            ")])]}}],null,false,1963612682)},[_c('div',{attrs:{"slot":"selected-row-actions"},slot:"selected-row-actions"},[_c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","id":"navbarDropdownBulk","data-toggle":"dropdown","role":"button","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("Bulk Actions "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu mr-5",staticStyle:{"left":"-50px","width":"320px"},attrs:{"aria-labelledby":"navbarDropdown"}},[_c('a',{staticClass:"dropdown-item",on:{"click":_vm.openModalAddJSONGitHub}},[_vm._v("Load JSON from GitHub Repository")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":_vm.openModalEnbaleDisable}},[_vm._v("Enable / Disable")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":_vm.openModalAddLibrary}},[_vm._v("Library")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":_vm.openModalAddSection}},[_vm._v("Section")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":_vm.openModalAddPracticeArea}},[_vm._v("Practice Area")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":_vm.openModalAddInternalTag}},[_vm._v("Internal Tag")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":_vm.openModalAddVersion}},[_vm._v("Version")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":_vm.openModalAddExpirationDate}},[_vm._v("Expiration Date")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":_vm.openModalAddRevisionDate}},[_vm._v("Revision Date")])])]),_vm._v(" "),_vm._v(" "),_c('div',{attrs:{"slot":"emptystate"},slot:"emptystate"},[_vm._v("\n          There are no rows\n        ")])])],1):_c('div',{staticStyle:{"left":"50%","position":"absolute","top":"25%"}},[_c('f-spinner'),_vm._v(" "),_c('span',[_vm._v("Loading ...")])],1),_vm._v(" "),_c('notifications')],1),_vm._v(" "),(_vm.isModal === true)?_c('global-modal',[_c('template',{slot:"header"},[_c('b',[_vm._v("Duplicate Form")])]),_vm._v(" "),_c('template',{slot:"body"},[_c('p',{staticClass:"mb-1"},[_vm._v("Form name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.duplicateFormName),expression:"duplicateFormName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Type Name"},domProps:{"value":(_vm.duplicateFormName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.duplicateFormName=$event.target.value}}})]),_vm._v(" "),_c('template',{slot:"footer"},[_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.isModal = false}}},[_vm._v("\n        Cancel\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"disabled":_vm.isDisableBtnClone},on:{"click":_vm.cloneTemplate}},[_vm._v("\n        Clone\n      ")])])],2):_vm._e(),_vm._v(" "),(_vm.isModalRoles === true)?_c('global-modal',{staticClass:"modalEditRoles"},[_c('template',{slot:"header"},[_c('b',[_vm._v("Edit Roles")]),_vm._v(" "),_c('i',{staticClass:"fas fa-times float-right",on:{"click":function($event){_vm.isModalRoles = false}}})]),_vm._v(" "),_c('template',{slot:"body"},[_c('button',{staticClass:"btn btn-success float-right mt-n4",staticStyle:{"margin-bottom":"10px"},attrs:{"disabled":_vm.roles[_vm.roles.length - 1].name === '' || _vm.roles[_vm.roles.length - 1].type === '' ? true : false},on:{"click":_vm.addNewRol}},[_vm._v("New")]),_vm._v(" "),_c('div',[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-light"},[_c('thead',[_c('tr',[_c('th',{},[_vm._v("Name")]),_vm._v(" "),_c('th',{},[_vm._v("Type")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.roles),function(role,indexRole){return _c('tr',{key:indexRole,attrs:{"id":indexRole}},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(role.name),expression:"role.name"}],staticClass:"form-control form-control-sm",attrs:{"id":'inputName' + indexRole,"type":"text"},domProps:{"value":(role.name)},on:{"change":function($event){return _vm.prevToSaveRole(indexRole)},"input":function($event){if($event.target.composing){ return; }_vm.$set(role, "name", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(role.type),expression:"role.type"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(role.type)},on:{"change":function($event){return _vm.prevToSaveRole(indexRole)},"input":function($event){if($event.target.composing){ return; }_vm.$set(role, "type", $event.target.value)}}})])])}),0)])])]),_vm._v(" "),_c('template',{slot:"footer"},[_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.isModalRoles = false}}},[_vm._v("\n        Cancel\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"disabled":_vm.newRolesToSave.length > 0 || _vm.rolesToUpdate.length > 0 ? false : true},on:{"click":_vm.saveRoles}},[_vm._v("\n        Save\n      ")])])],2):_vm._e(),_vm._v(" "),(_vm.isModalMassUpdate === true)?_c('global-modal',{staticClass:"modalEditRoles",attrs:{"height":30}},[_c('template',{slot:"header"},[_c('b',[_vm._v(_vm._s(_vm.bulkActionsModalLabel))]),_vm._v(" "),_c('i',{staticClass:"fas fa-times float-right",on:{"click":_vm.closeBulkActionsModal}})]),_vm._v(" "),_c('template',{slot:"body"},[(_vm.isSpinnerMassUpdate === true)?_c('div',[_c('h5',[_c('b',[_vm._v(_vm._s(_vm.formsUpdated)+" forms updated of "+_vm._s(_vm.formsToUpdate))])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.formsInvalidPath.length > 0)?_c('div',[_c('h5',{staticStyle:{"color":"red"}},[_vm._v("Forms with invalid Path")]),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"auto","height":"300px"}},[_c('b',_vm._l((_vm.formsInvalidPath),function(form,formIndex){return _c('small',{key:formIndex},[_vm._v(_vm._s(form.name)),_c('br')])}),0)])]):_vm._e()]):_c('div',[(_vm.isAddDataJSON === true)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.passwordToAddJson),expression:"passwordToAddJson"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.passwordToAddJson)},on:{"input":function($event){if($event.target.composing){ return; }_vm.passwordToAddJson=$event.target.value}}}),_vm._v(" "),(_vm.isInvalidPassword === true)?_c('small',{staticStyle:{"color":"red"}},[_vm._v("Invalid password")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isEnableDisable === true)?_c('div',[_c('button',{staticClass:"form-control btn btn-success mb-2",on:{"click":_vm.enableForms}},[_vm._v("Enable")]),_vm._v(" "),_c('button',{staticClass:"form-control btn btn-danger",on:{"click":_vm.disableForms}},[_vm._v("Disable")])]):_vm._e(),_vm._v(" "),(_vm.isAddInternalTag === true)?_c('div',[_c('search-select',{attrs:{"multiple":true,"options":_vm.tagsFormInternal},model:{value:(_vm.internalTagsForForms),callback:function ($$v) {_vm.internalTagsForForms=$$v},expression:"internalTagsForForms"}}),_vm._v(" "),_c('small',{staticStyle:{"color":"red"}},[_vm._v("Press enter to assign Internal Tags")])],1):_vm._e(),_vm._v(" "),(_vm.isAddSection === true)?_c('div',[_c('search-select',{attrs:{"options":_vm.allSections},model:{value:(_vm.sectionBulkAction),callback:function ($$v) {_vm.sectionBulkAction=$$v},expression:"sectionBulkAction"}})],1):_vm._e(),_vm._v(" "),(_vm.isAddLibrary === true)?_c('div',[_c('search-select',{attrs:{"options":_vm.$store.state.practiceAreas,"label":"name"},model:{value:(_vm.libraryBulkAction),callback:function ($$v) {_vm.libraryBulkAction=$$v},expression:"libraryBulkAction"}})],1):_vm._e(),_vm._v(" "),(_vm.isAddPracticeArea === true)?_c('div',[_c('search-select',{attrs:{"taggable":true,"multiple":true,"options":_vm.practiceAreas},model:{value:(_vm.practiceAreaForForms),callback:function ($$v) {_vm.practiceAreaForForms=$$v},expression:"practiceAreaForForms"}}),_vm._v(" "),_c('small',{staticStyle:{"color":"red"}},[_vm._v("Press enter to assign Practice Area")])],1):_vm._e(),_vm._v(" "),(_vm.isAddRevisionDate === true)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.revisionDateBulkAction),expression:"revisionDateBulkAction"},{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],staticClass:"form-control",attrs:{"type":"text","id":"revisionDateBulkAction","placeholder":"MM/DD/YYYY"},domProps:{"value":(_vm.revisionDateBulkAction)},on:{"input":function($event){if($event.target.composing){ return; }_vm.revisionDateBulkAction=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.isAddExpirationDate === true)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.expirationDateBulkAction),expression:"expirationDateBulkAction"},{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],staticClass:"form-control",attrs:{"type":"text","id":"expirationDateBulkAction","placeholder":"MM/DD/YYYY"},domProps:{"value":(_vm.expirationDateBulkAction)},on:{"input":function($event){if($event.target.composing){ return; }_vm.expirationDateBulkAction=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.isAddVersion === true)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.versionBulkAction),expression:"versionBulkAction"}],staticClass:"form-control",attrs:{"type":"text","id":"versionBulkAction"},domProps:{"value":(_vm.versionBulkAction)},on:{"input":function($event){if($event.target.composing){ return; }_vm.versionBulkAction=$event.target.value}}})]):_vm._e()])]),_vm._v(" "),_c('template',{slot:"footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"disabled":_vm.isSpinnerMassUpdate},on:{"click":_vm.closeBulkActionsModal}},[_vm._v("\n        Cancel\n      ")]),_vm._v(" "),(_vm.isAddDataJSON === true)?_c('button',{staticClass:"btn btn-success",attrs:{"disabled":_vm.passwordToAddJson !== '' && _vm.isSpinnerMassUpdate === false ? false : true},on:{"click":_vm.addJsonToSelectedForms}},[_vm._v("\n        Upload Data\n      ")]):(_vm.labelButtonBulkAction !== '')?_c('button',{staticClass:"btn btn-success",attrs:{"disabled":_vm.isSpinnerMassUpdate},on:{"click":_vm.setBulkAction}},[_vm._v("\n        "+_vm._s(_vm.labelButtonBulkAction)+"\n      ")]):_vm._e()])],2):_vm._e(),_vm._v(" "),(_vm.isModalModels === true)?_c('global-modal',{staticClass:"modalEditModels"},[_c('template',{slot:"header"},[_c('b',[_vm._v("Official Models")]),_vm._v(" "),_c('i',{staticClass:"fas fa-times float-right",on:{"click":_vm.closeModalModels}})]),_vm._v(" "),_c('template',{slot:"body"},[_c('vue-good-table',{ref:"official-models-table",attrs:{"mode":"remote","styleClass":"vgt-table striped","totalRows":_vm.totalRecordsOModels,"isLoading":_vm.isLoading,"search-options":{
          enabled: true,
          placeholder: 'Search this table Official Models',
        },"pagination-options":{
          enabled: true,
          perPage: 20,
          perPageDropdown: [10, 20, 30, 40, 50, 100, 200, 500, 1000, 3000],
          dropdownAllowAll: false,
          mode: 'pages'
        },"rows":_vm.rowsOModels,"columns":_vm.columnsOModels,"max-height":"750px","min-height":"740px","fixed-header":true},on:{"on-search":_vm.onSearchOModels,"on-page-change":_vm.onPageChangeOModels,"on-sort-change":_vm.onSortChangeOModels,"on-per-page-change":_vm.onPerPageChangeOModels,"on-cell-click":_vm.onCellClickOModels,"update:isLoading":function($event){_vm.isLoading=$event},"update:is-loading":function($event){_vm.isLoading=$event}}})],1),_vm._v(" "),_c('template',{slot:"footer"},[_c('span')])],2):_vm._e(),_vm._v(" "),(_vm.isAutocompleteModel === true)?_c('create-button-model',{attrs:{"data":_vm.autocompleteModelData,"model":_vm.autocompleteModel}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler",staticStyle:{"border":"none"},attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent","aria-controls":"navbarSupportedContent","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"navbar-toggler-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"href":"#","id":"navbarDropdownBulk","data-toggle":"dropdown","role":"button","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("Columns "),_c('span',{staticClass:"caret"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ar7n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InlineHelpModal_vue__ = __webpack_require__("scEy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cf61074_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InlineHelpModal_vue__ = __webpack_require__("9dYb");
function injectStyle (ssrContext) {
  __webpack_require__("NJ5a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6cf61074"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InlineHelpModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cf61074_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InlineHelpModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bASS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget widget-combo",attrs:{"data-field":_vm.fieldName,"id":_vm.fieldName}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],class:['form-control form-control-sm', _vm.autoWidth ? 'auto-width' : '', _vm.readOnly ? 'readOnly' : ''],attrs:{"disabled":!_vm.editable},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.value=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onChange]}},_vm._l((_vm.options),function(option,index){return _c('option',{key:index,domProps:{"value":option,"selected":option === _vm.initialValue ? 'selected' : ''}},[_vm._v(_vm._s(option))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bUew":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'spinner'
});

/***/ }),

/***/ "bq6u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bytR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dRDt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dXps":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dlTg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_questionnaires_InlineHelpModal__ = __webpack_require__("ar7n");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'field-group-widget',

  components: {
    InlineHelpModal: __WEBPACK_IMPORTED_MODULE_4__components_questionnaires_InlineHelpModal__["a" /* default */]
  },

  mounted: function mounted() {
    var that = this;
    this.setTypeFields();

    this.$bus.on('moveFieldGroupField', function (dataMove) {
      that.move(dataMove.moveIndex, dataMove.up);
    });
  },


  props: {
    fieldIndex: {
      type: String,
      required: true
    },
    checkboxes: {
      type: Object,
      required: true
    },
    maxChecked: {
      type: Number,
      default: 1
    },
    initialValue: {
      type: String,
      required: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    autoWidth: {
      type: Boolean,
      default: false
    },
    model: {
      type: String,
      default: ''
    },
    fieldName: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      checkedBoxes: [],
      fields: {}
    };
  },


  methods: {
    restoreInlineHelp: function restoreInlineHelp(fieldName) {
      var _this = this;

      var that = this;
      window.swal({
        title: 'Restore Inline Help?',
        text: 'You are about to restore this field inline help. This action cannot be undone. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (restore) {
        if (restore) {
          var dataInlineHelp = _this.$store.getters.getInlineHelpFromTemplate(fieldName);
          if (dataInlineHelp === null) return;else {
            _this.$store.commit('changeInlineHelp', {
              questionnaireId: that.fieldIndex,
              name: fieldName,
              label: dataInlineHelp.label,
              inlineHelp: dataInlineHelp.text
            });
            _this.$store.commit('saveInlineHelpDb');
            // this.$bus.emit('setQuestionnairesFields')
            _this.$store.dispatch('saveTemplate');
            _this.$bus.emit('updateQuestionnaire');
          }
        }
      });
    },
    showQuestionHelp: function showQuestionHelp(fieldName, desc) {
      var that = this;
      this.$refs.inlineHelpModal.$emit('showInlineHelp');
      this.$bus.emit('sendInlineHelp', {
        questionnaireId: that.fieldIndex,
        text: desc,
        name: fieldName,
        one: true
      });
    },
    move: function move(moveIndex, up) {
      var fieldKeys = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.fields);

      var tmpFields = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.fields));

      fieldKeys.forEach(function (key, index) {
        if (key === moveIndex) {
          var tmpTabOrder = tmpFields[moveIndex].tabOrder;
          var indexChange = index;

          if (up === true && index > 0) indexChange--;else indexChange++;

          tmpFields[moveIndex].tabOrder = tmpFields[fieldKeys[indexChange]].tabOrder;

          tmpFields[fieldKeys[indexChange]].tabOrder = tmpTabOrder;
        }
      });

      this.fields = this.setOrderFields(tmpFields);

      this.$store.commit('setFieldGroupFields', {
        nameGroup: this.fieldName,
        fields: this.fields
      });
      this.$store.dispatch('saveTemplate');
    },
    setOrderFields: function setOrderFields(objFields) {
      var orderFields = [];

      orderFields = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(objFields);

      orderFields = orderFields.sort(function (a, b) {
        return a.tabOrder > b.tabOrder ? 1 : -1;
      });

      var tmpFields = {};

      orderFields.forEach(function (field) {
        tmpFields[field.id] = field;
      });

      return tmpFields;
    },
    setTypeFields: function setTypeFields() {
      var _this2 = this;

      var that = this;
      var newFields = {};
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.checkboxes).forEach(function (fieldId) {
        var dataField = _this2.$store.getters.getTemplateData(fieldId);
        if (dataField === null) return;
        if (_this2.checkboxes[fieldId].translations === undefined) {
          that.checkboxes[fieldId].translations = dataField.translations;
          _this2.$store.commit('setFieldGroupFields', {
            nameGroup: that.fieldName,
            fields: that.checkboxes
          });
          _this2.$store.dispatch('saveTemplate');
          _this2.$bus.emit('updateQuestionnaire');
        }
        newFields[fieldId] = that.checkboxes[fieldId];
      });
      this.fields = this.setOrderFields(newFields);
    },
    highLightCheckbox: function highLightCheckbox(dataField) {
      this.$bus.emit('setFieldPage', dataField);
    },


    getCheck: function getCheck(index) {
      return this.checkedBoxes[index];
    },

    onChange: function onChange(e) {
      var checked = this.$el.querySelectorAll(':checked');
      var checkKey = e.target.value;
      if (this.checkedBoxes.indexOf(checkKey) !== -1) {
        this.checkedBoxes.splice(this.checkedBoxes.indexOf(checkKey));
      } else if (checked.length <= this.maxChecked) {
        this.checkedBoxes.push(checkKey);
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$el.querySelectorAll('input[type=checkbox]')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var checkbox = _step.value;

          checkbox.checked = this.checkedBoxes.indexOf(checkbox.getAttribute('data-key')) !== -1;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$parent.$emit('widgetChanged', { index: this.fieldIndex, value: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.checkedBoxes) });
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('moveFieldGroupField');
  }
});

/***/ }),

/***/ "e8pP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isRestoredFields: false,
      fieldsList: [],
      title: ''
    };
  },
  created: function created() {
    var _this = this;

    this.$bus.$on('showRestoredFieldsModal', function (restoredFields) {
      _this.isRestoredFields = true;

      if (restoredFields.isNotFileName) {
        _this.title = 'File name does not match';
      } else if (restoredFields.length > 0) {
        _this.fieldsList = restoredFields;
        _this.title = 'Restored Fields';
      } else _this.title = 'There are no deleted fields';
    });
  },


  methods: {
    colseRestoredFieldsModal: function colseRestoredFieldsModal() {
      this.isRestoredFields = false;

      this.fieldsList = [];
    }
  }
});

/***/ }),

/***/ "eAa5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModal)?_c('div',{staticClass:"field-group-edit-modal"},[_c('div',{staticClass:"modalHeader",staticStyle:{"border-radius":"9px 9px 0px 0px !important"}},[_c('span',{staticClass:"title"},[_vm._v("Edit Field Group")]),_vm._v(" "),_c('span',{staticClass:"btn-close float-right",on:{"click":_vm.closeModal}},[_c('i',{staticClass:"fas fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"modalBody"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editName),expression:"editName"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.editName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editLabel),expression:"editLabel"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.editLabel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editLabel=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.editHelp),expression:"editHelp"}],staticClass:"form-control form-control-sm",domProps:{"value":(_vm.editHelp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editHelp=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefix),expression:"prefix"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.prefix)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prefix=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMaxChecked),expression:"editMaxChecked"}],staticClass:"form-control form-control-sm",attrs:{"type":"number","min":"1","step":"1"},domProps:{"value":(_vm.editMaxChecked)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editMaxChecked=$event.target.value}}})]),_vm._v(" "),_c('table',{staticClass:"table table-sm table-bordered table-striped"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Field ID")]),_vm._v(" "),_c('th',[_vm._v("Actions")]),_vm._v(" "),(_vm.isAb === true)?_c('th',[_vm._v("Yes/No")]):_vm._e()])]),_vm._v(" "),_c('tbody',_vm._l((_vm.fieldList),function(field,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(field.translations.en.label))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-light",on:{"click":function($event){return _vm.editFormField(index)}}},[_vm._v("Edit Form Field")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.deleteFieldGroupField(index)}}},[_vm._v("Remove")]),_vm._v(" "),_c('i',{staticClass:"fas fa-angle-double-up",on:{"click":function($event){return _vm.move(index, true)}}}),_vm._v(" "),_c('i',{staticClass:"fas fa-angle-double-down",on:{"click":function($event){return _vm.move(index, false)}}})]),_vm._v(" "),(_vm.isAb === true)?_c('td',[(Object.keys(_vm.fieldList).indexOf(index) === 0)?_c('search-select',{attrs:{"options":['Yes', 'No']},on:{"input":_vm.setTypeA},model:{value:(_vm.typeA),callback:function ($$v) {_vm.typeA=$$v},expression:"typeA"}}):_vm._e(),_vm._v(" "),(Object.keys(_vm.fieldList).indexOf(index) === 1)?_c('search-select',{attrs:{"options":['Yes', 'No']},on:{"input":_vm.setTypeB},model:{value:(_vm.typeB),callback:function ($$v) {_vm.typeB=$$v},expression:"typeB"}}):_vm._e()],1):_vm._e()])}),0)]),_vm._v(" "),_c('div',{staticClass:"button-box mr-0 float-right"},[_c('button',{staticClass:"btn btn-success",on:{"click":_vm.saveEdit}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",on:{"click":_vm.closeModal}},[_vm._v("Close")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('hr'),_vm._v(" "),_c('div',[_c('questionnaire-tags',{attrs:{"fieldGroupId":_vm.fieldId,"isGroupActions":_vm.isGroupActions}})],1),_vm._v(" "),_c('div',{staticClass:"row modal-section",attrs:{"id":"AbGroupWatchersGroup"}},[_vm._v("\\\n        "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('ab-group-watchers',{attrs:{"isGroup":true,"fieldData":{ index: _vm.fieldId, watchers: _vm.watchers, tagVisible: _vm.tagVisible }}})],1)])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Name:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Label:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Help Text:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Prefix:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Max Checked:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eIAY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notifications',

  data: function data() {
    return {
      queue: {},
      intervals: [],
      timeout: 3000
    };
  },
  mounted: function mounted() {
    var that = this;

    this.$bus.on('addNotification', function (data) {
      that.queue = {};
      var id = Date.now();
      if (typeof data.type === 'undefined') data['type'] = 'default';
      window.Vue.set(that.queue, id, data);
      var interval = setTimeout(function () {
        that.closeNotification(id);
      }, 2500);
      that.intervals.push(interval);
    });
  },


  methods: {
    closeNotification: function closeNotification(id) {
      clearTimeout(id);
      window.Vue.delete(this.intervals, id);
      window.Vue.delete(this.queue, id);
    }
  },

  computed: {
    sortedQueue: function sortedQueue() {
      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.queue);
      keys.sort();
      return keys;
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('addNotification');
  }
});

/***/ }),

/***/ "eIgr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fieldsData !== undefined)?_c('div',{style:({ top: _vm.offsetTop + 'px', left: _vm.offsetLeft + 'px' }),attrs:{"id":"pageFields"}},[((
      _vm.$store.state.showFields &&
      typeof _vm.$store.state.templates[_vm.$store.state.currentTemplateName] !== 'undefined'
    ))?[_vm._l((_vm.fieldsData),function(field,index){return (field.type !== undefined)?[(field !== null && field.height > 35 || field.type.toLowerCase() === 'textarea')?[_c('form-textarea',{key:index,staticClass:"behind",attrs:{"id":field.id,"model":field.model,"width":(field.width * _vm.$store.state.pageScale),"height":(field.height * _vm.$store.state.pageScale),"left":(field.x * _vm.$store.state.pageScale),"top":(field.y * _vm.$store.state.pageScale),"fontSize":(_vm.$store.getters.fontScale()),"tabOrder":field.tabOrder,"listOfficialModels":_vm.listOfficialModels},on:{"set-autocomplete:model":_vm.setAutcompleteModel}})]:(field !== null && field.type.toLowerCase() === 'text')?[_c('form-text',{key:index,staticClass:"behind",attrs:{"id":field.id,"model":field.model,"width":(field.width * _vm.$store.state.pageScale),"height":(field.height * _vm.$store.state.pageScale),"left":(field.x * _vm.$store.state.pageScale),"top":(field.y * _vm.$store.state.pageScale),"fontSize":(_vm.$store.getters.fontScale()),"tabOrder":field.tabOrder,"type":field.type,"listOfficialModels":_vm.listOfficialModels},on:{"set-autocomplete:model":_vm.setAutcompleteModel}})]:(field !== null && (field.type.toLowerCase() === 'checkbox' || field.type.toLowerCase() === 'button'))?[_c('form-checkbox',{key:index,staticClass:"front",attrs:{"id":field.id,"model":field.model,"width":(field.width * _vm.$store.state.pageScale),"height":(field.height * _vm.$store.state.pageScale),"left":(field.x * _vm.$store.state.pageScale),"top":(field.y * _vm.$store.state.pageScale),"tabOrder":field.tabOrder,"value":field.value,"listOfficialModels":_vm.listOfficialModels}})]:(field !== null && field.type.toLowerCase() === 'select')?[_c('form-select',{key:index,staticClass:"front",attrs:{"id":field.id,"model":field.model,"width":(field.width * _vm.$store.state.pageScale),"height":(field.height * _vm.$store.state.pageScale),"left":(field.x * _vm.$store.state.pageScale),"top":(field.y * _vm.$store.state.pageScale),"options":field.choiceData,"tabOrder":field.tabOrder,"listOfficialModels":_vm.listOfficialModels}})]:(field !== null && field.type.toLowerCase() === 'radio')?[_c('form-checkbox',{key:index,staticClass:"front",attrs:{"id":field.id,"model":field.model,"width":(field.width * _vm.$store.state.pageScale),"height":(field.height * _vm.$store.state.pageScale),"left":(field.x * _vm.$store.state.pageScale),"top":(field.y * _vm.$store.state.pageScale),"tabOrder":field.tabOrder}})]:_vm._e()]:_vm._e()})]:_vm._e(),_vm._v(" "),(_vm.isAutocompleteModel === true)?_c('autocomplete-model',{attrs:{"data":_vm.autocompleteModelData,"model":_vm.autocompleteModel}}):_vm._e()],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eQkI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12",attrs:{"id":"editFormModal","tabindex":"-1"}},[_c('div',{staticClass:"header"},[_c('span',{staticClass:"title"},[_vm._v("Edit Form")]),_vm._v(" "),_c('span',{staticClass:"btn-close float-right",on:{"click":_vm.closeModal}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"forms-wrapper"},[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],class:['form-control', _vm.invalidFields.indexOf('name') === -1 ? '' : 'invalid'],attrs:{"type":"text","id":"name","placeholder":"Name of the form"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"title"}},[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],class:['form-control', _vm.invalidFields.indexOf('title') === -1 ? '' : 'invalid'],attrs:{"type":"text","id":"title","placeholder":"Title of the form"},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"viewer-url"}},[_vm._v("Viewer URL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.viewer_url),expression:"viewer_url"}],class:['form-control', _vm.invalidFields.indexOf('viewer_url') === -1 ? '' : 'invalid'],attrs:{"type":"text","id":"viewer_url","placeholder":"The path to the SVG and thumbnail output"},domProps:{"value":(_vm.viewer_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.viewer_url=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"status"}},[_vm._v("Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"DEV"}},[_vm._v("DEV")]),_vm._v(" "),_c('option',{attrs:{"value":"Enabled"}},[_vm._v("Enabled")]),_vm._v(" "),_c('option',{attrs:{"value":"Disabled"}},[_vm._v("Disabled")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"revision-date"}},[_vm._v("Revision Date")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"},{name:"model",rawName:"v-model",value:(_vm.displayRevisionDate),expression:"displayRevisionDate"}],class:['form-control', _vm.invalidFields.indexOf('revisionDate') === -1 ? '' : 'invalid'],attrs:{"type":"text","id":"revisionDate","placeholder":"01/31/2018"},domProps:{"value":(_vm.displayRevisionDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.displayRevisionDate=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"expiration-date"}},[_vm._v("Expiration Date")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"},{name:"model",rawName:"v-model",value:(_vm.displayExpirationDate),expression:"displayExpirationDate"}],class:['form-control', _vm.invalidFields.indexOf('expirationDate') === -1 ? '' : 'invalid'],attrs:{"type":"text","id":"expirationDate","placeholder":"12/31/2018"},domProps:{"value":(_vm.displayExpirationDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.displayExpirationDate=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"version"}},[_vm._v("Version")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.version),expression:"version"}],class:['form-control', _vm.invalidFields.indexOf('version') === -1 ? '' : 'invalid'],attrs:{"type":"number","id":"version"},domProps:{"value":(_vm.version)},on:{"input":function($event){if($event.target.composing){ return; }_vm.version=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"practice-area"}},[_vm._v("Library")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.practiceArea),expression:"practiceArea"}],staticClass:"form-control",attrs:{"id":"practice-area"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.practiceArea=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.setPracticeAreaSections]}},_vm._l((_vm.$store.state.practiceAreas),function(area,index){return _c('option',{key:index,domProps:{"value":area.name}},[_vm._v("\n                "+_vm._s(area.name)+"\n              ")])}),0)])]),_vm._v(" "),(!_vm.isReplacedTemplate)?_c('div',{staticClass:"col-sm-4"},[_c('input',{attrs:{"accept":".json","type":"file","id":"selectFilesEdit","value":"Import"}}),_vm._v(" "),_c('input',{staticClass:"btn btn-info",attrs:{"id":"replaceTemplates","type":"button","value":"Replace Template"},on:{"click":_vm.getJsonFile}})]):_c('div',{staticClass:"col-sm-4"},[_c('h4',[_vm._v("Global Template Ready")]),_vm._v(" "),_c('p',[_vm._v("Processed "+_vm._s(_vm.totalFields)+" fields in "+_vm._s(_vm.totalPages)+" pages.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"primaId"}},[_vm._v("Prima ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.primaId),expression:"primaId"}],class:['form-control', _vm.invalidFields.indexOf('primaId') === -1 ? '' : 'invalid'],attrs:{"type":"number","id":"primaId"},domProps:{"value":(_vm.primaId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.primaId=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-between"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"practice-area-section"}},[_vm._v("Sections")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.practiceAreaSection),expression:"practiceAreaSection"}],staticClass:"form-control",attrs:{"id":"practice-area-section"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.practiceAreaSection=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.practiceAreaSections),function(section,index){return _c('option',{key:index,domProps:{"value":section,"selected":_vm.selectPracticeAreaSection(section)}},[_vm._v("\n                "+_vm._s(section)+"\n              ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"practice-area-section"}},[_vm._v("Enable for Questionnaire")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.enableForQ},on:{"click":function($event){_vm.enableForQ = !_vm.enableForQ}}})])])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-between"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"practice-area-section"}},[_vm._v("Practice Area")]),_vm._v(" "),_c('search-select',{attrs:{"multiple":true,"options":_vm.tagsFormPA},model:{value:(_vm.practiceAreaTag),callback:function ($$v) {_vm.practiceAreaTag=$$v},expression:"practiceAreaTag"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"practice-area-section"}},[_vm._v("Internal Tag")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('search-select',{attrs:{"taggable":true,"multiple":true,"options":_vm.tagsFormInternal},model:{value:(_vm.internalTag),callback:function ($$v) {_vm.internalTag=$$v},expression:"internalTag"}})],1)])])]),_vm._v(" "),_c('h2',[_vm._v("Roles")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"role"}},[_vm._v("Role")]),_vm._v(" "),_c('search-select',{attrs:{"id":"addFormRole1","label":"name","options":_vm.$store.state.formRoles},model:{value:(_vm.role1),callback:function ($$v) {_vm.role1=$$v},expression:"role1"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"prefix"}},[_vm._v("Prefix")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefix1),expression:"prefix1"}],staticClass:"form-control",attrs:{"type":"text","id":"prefix"},domProps:{"value":(_vm.prefix1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prefix1=$event.target.value}}})])]),_vm._v(" "),(_vm.role1 !== '' && _vm.role1 !== '0' && _vm.role1._id !== undefined)?_c('div',{staticClass:"col-sm-2",staticStyle:{"margin-top":"12px"}},[_c('label'),_vm._v(" "),_c('input',{staticClass:"btn btn-sm btn-primary btn-block",attrs:{"type":"button","value":"Max Items","id":"maxRole"},on:{"click":function($event){return _vm.showMaxItemsModal('role1')}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"role2"}},[_vm._v("Role 2")]),_vm._v(" "),_c('search-select',{attrs:{"id":"addFormRole2","label":"name","options":_vm.$store.state.formRoles},model:{value:(_vm.role2),callback:function ($$v) {_vm.role2=$$v},expression:"role2"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"prefix2"}},[_vm._v("Prefix 2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefix2),expression:"prefix2"}],staticClass:"form-control",attrs:{"type":"text","id":"prefix2"},domProps:{"value":(_vm.prefix2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prefix2=$event.target.value}}})])]),_vm._v(" "),(_vm.role2 !== '' && _vm.role2 !== '0' && _vm.role2._id !== undefined)?_c('div',{staticClass:"col-sm-2",staticStyle:{"margin-top":"12px"}},[_c('label'),_vm._v(" "),_c('input',{staticClass:"btn btn-sm btn-primary btn-block",attrs:{"type":"button","value":"Max Items","id":"maxRole2"},on:{"click":function($event){return _vm.showMaxItemsModal('role2')}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"role3"}},[_vm._v("Role 3")]),_vm._v(" "),_c('search-select',{attrs:{"id":"addFormRole3","label":"name","options":_vm.$store.state.formRoles},model:{value:(_vm.role3),callback:function ($$v) {_vm.role3=$$v},expression:"role3"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"prefix3"}},[_vm._v("Prefix 3")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefix3),expression:"prefix3"}],staticClass:"form-control",attrs:{"type":"text","id":"prefix3"},domProps:{"value":(_vm.prefix3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prefix3=$event.target.value}}})])]),_vm._v(" "),(_vm.role3 !== '' && _vm.role3 !== '0' && _vm.role3._id !== undefined)?_c('div',{staticClass:"col-sm-2",staticStyle:{"margin-top":"12px"}},[_c('label'),_vm._v(" "),_c('input',{staticClass:"btn btn-sm btn-primary btn-block",attrs:{"type":"button","value":"Max Items","id":"maxRole3"},on:{"click":function($event){return _vm.showMaxItemsModal('role3')}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"role4"}},[_vm._v("Role 4")]),_vm._v(" "),_c('search-select',{attrs:{"id":"addFormRole4","label":"name","options":_vm.$store.state.formRoles},model:{value:(_vm.role4),callback:function ($$v) {_vm.role4=$$v},expression:"role4"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"prefix4"}},[_vm._v("Prefix 4")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefix4),expression:"prefix4"}],staticClass:"form-control",attrs:{"type":"text","id":"prefix4"},domProps:{"value":(_vm.prefix4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prefix4=$event.target.value}}})])]),_vm._v(" "),(_vm.role4 !== '' && _vm.role4 !== '0' && _vm.role4._id !== undefined)?_c('div',{staticClass:"col-sm-2",staticStyle:{"margin-top":"12px"}},[_c('label'),_vm._v(" "),_c('input',{staticClass:"btn btn-sm btn-primary btn-block",attrs:{"type":"button","value":"Max Items","id":"maxRole4"},on:{"click":function($event){return _vm.showMaxItemsModal('role4')}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"role5"}},[_vm._v("Role 5")]),_vm._v(" "),_c('search-select',{attrs:{"id":"addFormRole5","label":"name","options":_vm.$store.state.formRoles},model:{value:(_vm.role5),callback:function ($$v) {_vm.role5=$$v},expression:"role5"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"prefix5"}},[_vm._v("Prefix 5")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefix5),expression:"prefix5"}],staticClass:"form-control",attrs:{"type":"text","id":"prefix5"},domProps:{"value":(_vm.prefix5)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prefix5=$event.target.value}}})])]),_vm._v(" "),(_vm.role5 !== '' && _vm.role5 !== '0' && _vm.role5._id !== undefined)?_c('div',{staticClass:"col-sm-2",staticStyle:{"margin-top":"12px"}},[_c('label',{attrs:{"for":""}}),_vm._v(" "),_c('input',{staticClass:"btn btn-sm btn-primary btn-block",attrs:{"type":"button","value":"Max Items","id":"maxRole5"},on:{"click":function($event){return _vm.showMaxItemsModal('role5')}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"role6"}},[_vm._v("Role 6")]),_vm._v(" "),_c('search-select',{attrs:{"id":"addFormRole6","label":"name","options":_vm.$store.state.formRoles},model:{value:(_vm.role6),callback:function ($$v) {_vm.role6=$$v},expression:"role6"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"prefix6"}},[_vm._v("Prefix 6")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefix6),expression:"prefix6"}],staticClass:"form-control",attrs:{"type":"text","id":"prefix6"},domProps:{"value":(_vm.prefix6)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prefix6=$event.target.value}}})])]),_vm._v(" "),(_vm.role6 !== '' && _vm.role6 !== '0' && _vm.role6._id !== undefined)?_c('div',{staticClass:"col-sm-2",staticStyle:{"margin-top":"12px"}},[_c('label',{attrs:{"for":""}}),_vm._v(" "),_c('input',{staticClass:"btn btn-sm btn-primary btn-block",attrs:{"type":"button","value":"Max Items","id":"maxRole6"},on:{"click":function($event){return _vm.showMaxItemsModal('role6')}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"role7"}},[_vm._v("Role 7")]),_vm._v(" "),_c('search-select',{attrs:{"id":"addFormRole7","label":"name","options":_vm.$store.state.formRoles},model:{value:(_vm.role7),callback:function ($$v) {_vm.role7=$$v},expression:"role7"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"prefix7"}},[_vm._v("Prefix 7")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefix7),expression:"prefix7"}],staticClass:"form-control",attrs:{"type":"text","id":"prefix7"},domProps:{"value":(_vm.prefix7)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prefix7=$event.target.value}}})])]),_vm._v(" "),(_vm.role7 !== '' && _vm.role7 !== '0' && _vm.role7._id !== undefined)?_c('div',{staticClass:"col-sm-2",staticStyle:{"margin-top":"12px"}},[_c('label',{attrs:{"for":""}}),_vm._v(" "),_c('input',{staticClass:"btn btn-sm btn-primary btn-block",attrs:{"type":"button","value":"Max Items","id":"maxRole7"},on:{"click":function($event){return _vm.showMaxItemsModal('role7')}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"role"}},[_vm._v("Role 8")]),_vm._v(" "),_c('search-select',{attrs:{"id":"addFormRole8","label":"name","options":_vm.$store.state.formRoles},model:{value:(_vm.role8),callback:function ($$v) {_vm.role8=$$v},expression:"role8"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"prefix8"}},[_vm._v("Prefix 8")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefix8),expression:"prefix8"}],staticClass:"form-control",attrs:{"type":"text","id":"prefix8"},domProps:{"value":(_vm.prefix8)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prefix8=$event.target.value}}})])]),_vm._v(" "),(_vm.role8 !== '' && _vm.role8 !== '0' && _vm.role8._id !== undefined)?_c('div',{staticClass:"col-sm-2",staticStyle:{"margin-top":"12px"}},[_c('label',{attrs:{"for":""}}),_vm._v(" "),_c('input',{staticClass:"btn btn-sm btn-primary btn-block",attrs:{"type":"button","value":"Max Items","id":"maxRole8"},on:{"click":function($event){return _vm.showMaxItemsModal('role8')}}})]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":_vm.uploadForm}},[_vm._v("Save Form")]),_vm._v(" "),_c('div',{staticClass:"scroll-padding"})]),_vm._v(" "),(_vm.isMaxItemsModal === true)?_c('max-items-modal',{attrs:{"role":_vm.currentRole,"formId":_vm.formId,"maxItems":_vm.maxItems},on:{"close":function($event){_vm.isMaxItemsModal = false},"update-maxitems":_vm.updateMaxItems}}):_vm._e(),_vm._v(" "),(_vm.showDialog)?_c('div',{staticClass:"modal-dialog"},[_c('h1',[_vm._v(_vm._s(_vm.titleModal))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.descModal))]),_vm._v(" "),_c('button',{on:{"click":_vm.confirm}},[_vm._v(_vm._s(_vm.confirmText))]),_vm._v(" "),_c('button',{on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eeQv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenuToolbox_vue__ = __webpack_require__("TsMP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d304af6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenuToolbox_vue__ = __webpack_require__("/lDL");
function injectStyle (ssrContext) {
  __webpack_require__("LbmV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d304af6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenuToolbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d304af6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenuToolbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ej7N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'menu-bottom',

  data: function data() {
    return {
      currentPage: 1
    };
  },
  mounted: function mounted() {
    var that = this;
    this.$bus.on('pageChange', function (pageNum) {
      that.currentPage = Number(pageNum);
    });

    var observer = new MutationObserver(function (mutations) {
      that.$store.commit('setDisablePageNavigation', false);
    });

    var options = {
      attributes: false,
      childList: true,
      characterData: false
    };

    observer.observe(document.getElementById('pageFields'), options);
  },


  methods: {
    setPage: function setPage() {
      if (typeof Number(this.currentPage) === 'number') {
        var pageNum = Math.floor(Number(this.currentPage));
        if (pageNum < 1 || pageNum > this.$store.state.totalPages) {
          this.currentPage = this.$store.state.fileCurrentPage;
          return;
        } else {
          this.$store.commit('setDisablePageNavigation', true);
          this.$store.commit('setCurrentPage', Math.floor(Number(this.currentPage)));
          this.$bus.emit('pageChange', Math.floor(Number(this.currentPage)));
        }
      } else {
        this.currentPage = this.$store.state.fileCurrentPage;
      }

      this.$bus.emit('hidePageFields');
    },
    firstPage: function firstPage() {
      if (this.$store.state.fileCurrentPage === 1) return;
      this.$store.commit('setDisablePageNavigation', true);
      this.$store.commit('setCurrentPage', 1);
      this.$bus.emit('pageChange', 1);
      this.$bus.emit('hidePageFields');
    },
    lastPage: function lastPage() {
      if (this.$store.state.fileCurrentPage === this.$store.state.totalPages) return;
      this.$store.commit('setDisablePageNavigation', true);
      this.$store.commit('setCurrentPage', this.$store.state.totalPages);
      this.$bus.emit('pageChange', this.$store.state.totalPages);

      this.$bus.emit('hidePageFields');
    },
    nextPage: function nextPage() {
      var pageNum = this.$store.state.fileCurrentPage + 1;
      if (pageNum <= this.$store.state.totalPages) {
        // this.$store.commit('setDisablePageNavigation', true)
        this.$store.commit('setCurrentPage', this.$store.state.fileCurrentPage + 1);
        this.$bus.emit('pageChange', pageNum);

        this.$bus.emit('hidePageFields');
      }
    },
    prevPage: function prevPage() {
      var pageNum = this.$store.state.fileCurrentPage - 1;
      if (pageNum > 0) {
        // this.$store.commit('setDisablePageNavigation', true)
        this.$store.commit('setCurrentPage', this.$store.state.fileCurrentPage - 1);
        this.$bus.emit('pageChange', pageNum);

        this.$bus.emit('hidePageFields');
      }
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('pageChange');
    this.$store.commit('setCurrentPage', 1);
  }
});

/***/ }),

/***/ "ejIc":
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ "ek/o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_questionnaires_widgets_ComboWidget__ = __webpack_require__("3H5q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_questionnaires_widgets_TextWidget__ = __webpack_require__("wjq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_questionnaires_widgets_CheckboxWidget__ = __webpack_require__("Jgco");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_questionnaires_widgets_SectionWidget__ = __webpack_require__("KV46");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_questionnaires_widgets_FieldGroupWidget__ = __webpack_require__("pcBj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_questionnaires_FieldGroupModal__ = __webpack_require__("kR17");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_questionnaires_CheckboxGroupModal__ = __webpack_require__("B+oi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_questionnaires_FieldGroupEditModal__ = __webpack_require__("Frkg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_questionnaires_CheckboxGroupEditModal__ = __webpack_require__("KEp1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_questionnaires_SectionEditModal__ = __webpack_require__("qlWQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_questionnaires_EditModal__ = __webpack_require__("5VAr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_questionnaires_widget_group_GroupEditModal__ = __webpack_require__("/vRh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_questionnaires_SectionModal__ = __webpack_require__("V6xl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_questionnaires_UploadTooltipsModal__ = __webpack_require__("OcME");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_questionnaires_widget_group_WidgetGroup__ = __webpack_require__("3Fre");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_questionnaires_InlineHelpModal__ = __webpack_require__("ar7n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_questionnaires_RestoreInlineHelpModal__ = __webpack_require__("/IWr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_editor_main_TooltipIcons__ = __webpack_require__("/Ygi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_questionnaires_WidgetLabelsModal__ = __webpack_require__("wiFD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_editor_modals_GlobalModal__ = __webpack_require__("ROUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__brevortriverstudios_vue_core__ = __webpack_require__("Ilu2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__brevortriverstudios_vue_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__brevortriverstudios_vue_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_questionnaires_Spinner_vue__ = __webpack_require__("Qm8n");







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

























/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'questionnaire-view',

  components: {
    ComboWidget: __WEBPACK_IMPORTED_MODULE_7__components_questionnaires_widgets_ComboWidget__["a" /* default */],
    TextWidget: __WEBPACK_IMPORTED_MODULE_8__components_questionnaires_widgets_TextWidget__["a" /* default */],
    CheckboxWidget: __WEBPACK_IMPORTED_MODULE_9__components_questionnaires_widgets_CheckboxWidget__["a" /* default */],
    SectionWidget: __WEBPACK_IMPORTED_MODULE_10__components_questionnaires_widgets_SectionWidget__["a" /* default */],
    FieldGroupModal: __WEBPACK_IMPORTED_MODULE_12__components_questionnaires_FieldGroupModal__["a" /* default */],
    CheckboxGroupModal: __WEBPACK_IMPORTED_MODULE_13__components_questionnaires_CheckboxGroupModal__["a" /* default */],
    FieldGroupEditModal: __WEBPACK_IMPORTED_MODULE_14__components_questionnaires_FieldGroupEditModal__["a" /* default */],
    CheckboxGroupEditModal: __WEBPACK_IMPORTED_MODULE_15__components_questionnaires_CheckboxGroupEditModal__["a" /* default */],
    SectionEditModal: __WEBPACK_IMPORTED_MODULE_16__components_questionnaires_SectionEditModal__["a" /* default */],
    FieldGroupWidget: __WEBPACK_IMPORTED_MODULE_11__components_questionnaires_widgets_FieldGroupWidget__["a" /* default */],
    WidgetGroup: __WEBPACK_IMPORTED_MODULE_21__components_questionnaires_widget_group_WidgetGroup__["a" /* default */],
    EditModal: __WEBPACK_IMPORTED_MODULE_17__components_questionnaires_EditModal__["a" /* default */],
    GroupEditModal: __WEBPACK_IMPORTED_MODULE_18__components_questionnaires_widget_group_GroupEditModal__["a" /* default */],
    SectionModal: __WEBPACK_IMPORTED_MODULE_19__components_questionnaires_SectionModal__["a" /* default */],
    UploadTooltipsModal: __WEBPACK_IMPORTED_MODULE_20__components_questionnaires_UploadTooltipsModal__["a" /* default */],
    InlineHelpModal: __WEBPACK_IMPORTED_MODULE_22__components_questionnaires_InlineHelpModal__["a" /* default */],
    RestoreInlineHelpModal: __WEBPACK_IMPORTED_MODULE_23__components_questionnaires_RestoreInlineHelpModal__["a" /* default */],
    TooltipIcons: __WEBPACK_IMPORTED_MODULE_24__components_editor_main_TooltipIcons__["a" /* default */],
    WidgetLabelsModal: __WEBPACK_IMPORTED_MODULE_25__components_questionnaires_WidgetLabelsModal__["a" /* default */],
    GlobalModal: __WEBPACK_IMPORTED_MODULE_26__components_editor_modals_GlobalModal__["a" /* default */],
    PfQuestionnaireForm: __WEBPACK_IMPORTED_MODULE_27__brevortriverstudios_vue_core__["PfQuestionnaireForm"],

    FSpinner: __WEBPACK_IMPORTED_MODULE_28__components_questionnaires_Spinner_vue__["a" /* default */]
  },

  data: function data() {
    return {
      modelDisplay: false,
      idDisplay: false,
      lastHighlightedModel: '',
      formattedData: null,
      noRows: true,
      visibleWidgets: [],
      loading: true,
      tooltipRemove: false,
      descriptionRemove: 'Remove All Questionnaire',
      leftIconRemove: 0,
      tooltipUploadTooltips: false,
      descriptionUploadTooltips: 'Upload Tooltips',
      leftIconUploadTooltips: 0,
      tooltipGenerateFields: false,
      descriptionGenerateFields: 'Generate From Fields',
      leftIconGenerateFields: 0,
      tooltipParseInlineHelp: false,
      descriptionParseInlineHelp: 'Parse all Inline Help',
      leftIconParseInlineHelp: 0,
      tooltipRestoreInlineHelp: false,
      descriptionRestoreInlineHelp: 'Restore all Inline Help',
      leftIconRestoreInlineHelp: 0,
      tooltipFieldGroups: false,
      descriptionFieldGroups: 'Field Groups',
      leftIconFieldGroups: 0,
      tooltipCheckboxGroups: false,
      descriptionCheckboxGroups: 'Checkbox Groups',
      leftIconCheckboxGroups: 0,
      tooltipAddSection: false,
      descriptionAddSection: 'Add Section',
      leftIconAddSection: 0,
      tooltipWidgetLabels: false,
      descriptionWidgetLabels: 'Widget Labels',
      leftIconWidgetLabels: 0,
      tooltipQuestionnairePreview: false,
      descriptionQuestionnairePreview: 'Questionnaire Preview',
      leftIconQuestionnairePreview: 0,

      showWidgetLabelsModal: false,
      showQuestionnairePreviewModal: false,

      isSpinner: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.leftIconRemove = document.getElementById('iconRemove').offsetLeft;
    this.leftIconUploadTooltips = document.getElementById('iconUploadTooltips').offsetLeft;
    this.leftIconGenerateFields = document.getElementById('iconGenerateFields').offsetLeft;
    this.leftIconParseInlineHelp = document.getElementById('iconParseInlineHelp').offsetLeft;
    this.leftIconRestoreInlineHelp = document.getElementById('iconRestoreInlineHelp').offsetLeft;
    this.leftIconFieldGroups = document.getElementById('iconFieldGroups').offsetLeft;
    this.leftIconCheckboxGroups = document.getElementById('iconCheckboxGroups').offsetLeft;
    this.leftIconAddSection = document.getElementById('iconAddSection').offsetLeft;
    this.leftIconWidgetLabels = document.getElementById('iconWidgetLabels').offsetLeft;
    this.leftIconQuestionnairePreview = document.getElementById('iconQuestionnairePreview').offsetLeft;

    var that = this;
    this.$on('widgetChanged', function (data) {
      that.widgetChanged(data);
    });

    this.$on('saveEdit', function (data) {
      that.saveEdit(data);
    });

    this.$bus.on('scrollToElement', that.scrollToElement);

    this.$bus.on('setCurrentTemplateName', function (templateName) {
      that.templateChanged(templateName);
    });

    // INIT PROCESS QUESTIONNAIRE

    this.$bus.on('reloadQuestionnaire', function () {
      that.templateChanged(_this.$store.state.currentTemplateName);
    });

    this.$bus.on('updateQuestionnaire', function () {
      that.updateQuestionnaire();
    });

    this.$bus.on('setOnlyFieldGroup', function (newGroupId) {
      that.setOnlyFieldGroup(newGroupId);
    });

    this.$bus.on('initialUpdate', function () {
      that.initialUpdate();
    });

    this.$bus.on('setFieldPage', function (dataField) {
      that.setFieldPage(dataField);
    });

    this.$bus.on('pageChange', function () {
      that.modelDisplay = false;
      that.idDisplay = false;
      that.$bus.emit('toggleModelDisplay', that.modelDisplay);
    });

    this.$bus.on('removeSection', function (sectionName) {
      that.deleteSection(sectionName);
    });

    setTimeout(this.noDataFound, 7000);
  },


  methods: {
    setABQuestion: function setABQuestion(payload) {
      var checked = document.getElementById(payload.checkboxId).checked;

      this.$store.commit('editFieldGroup', {
        index: payload.field.fieldName,
        name: payload.field.name,
        label: payload.field.title,
        help: payload.field.desc,
        abQuestion: checked
      });

      this.$bus.emit('saveTriggered');
    },
    setIndentationGroup: function setIndentationGroup(payload) {
      this.setClassIndent(payload);

      this.$store.commit('editFieldGroup', {
        index: payload.field.fieldName,
        name: payload.field.name,
        label: payload.field.title,
        help: payload.field.desc,
        indent: payload.field.indent
      });

      this.$bus.emit('saveTriggered');
    },
    setIndentation: function setIndentation(payload) {
      this.setClassIndent(payload);

      this.$bus.emit('saveTriggered');
    },
    setClassIndent: function setClassIndent(payload) {
      var el = document.getElementById(payload.containerId);

      var arrayClass = [];

      el.classList.forEach(function (classEl) {
        arrayClass.push(classEl);
      });

      if (arrayClass.indexOf('indent-level3') !== -1) {
        el.classList.remove('indent-level3');
        payload.field.indent = 0;
        if (payload.indentation === false) {
          payload.field.indent = 2;
          el.classList.add('indent-level2');
        }
      } else if (arrayClass.indexOf('indent-level2') !== -1) {
        el.classList.remove('indent-level2');
        if (payload.indentation === true) {
          payload.field.indent = 3;
          el.classList.add('indent-level3');
        } else {
          payload.field.indent = 1;
          el.classList.add('indent-level1');
        }
      } else if (arrayClass.indexOf('indent-level1') !== -1) {
        payload.field.indent = 0;
        el.classList.remove('indent-level1');
        if (payload.indentation === true) {
          payload.field.indent = 2;
          el.classList.add('indent-level2');
        }
      } else {
        if (payload.indentation === true) {
          payload.field.indent = 1;
          el.classList.add('indent-level1');
        } else {
          payload.field.indent = 3;
          el.classList.add('indent-level3');
        }
      }
    },
    setMessageWidget: function setMessageWidget(foundWidget) {
      this.$store.commit('setMessageWidgetData', foundWidget);
    },
    restoreAllInlineHelp: function restoreAllInlineHelp() {
      var _this2 = this;

      window.swal({
        title: 'Restore All Inline Help?',
        text: 'You are about to restore those fields inline help. This action cannot be undone. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (restore) {
        var that = _this2;
        if (restore) {
          _this2.$refs.restoreInlineHelpModal.$emit('showRestoreInlineHelp');
          _this2.$bus.emit('showProcessInlineHelp', {
            state: true,
            process: 'Restore Processing...'
          });
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(that.formattedData).forEach(function (field) {
              var questionnaireFields = that.$store.state.questionnaires[that.$store.state.currentTemplateName]['data'];
              if (questionnaireFields[field] === undefined) return;
              var fieldName = '';
              var fieldKey = field;
              if (questionnaireFields[field].checkboxes) {
                __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(questionnaireFields[field].checkboxes).forEach(function (name) {
                  fieldName = name;
                  that.generateOriginInlineHelp(fieldName, fieldKey).then(function () {
                    return;
                  });
                });
              } else {
                fieldName = questionnaireFields[field].fieldName;
                that.generateOriginInlineHelp(fieldName, fieldKey).then(function () {
                  return;
                });
              }
            });
            that.$store.dispatch('saveTemplate');
            that.$bus.emit('reloadQuestionnaire');
            that.$bus.emit('showProcessInlineHelp', {
              state: false,
              process: 'Done'
            });
          }, 500);
        }
      });
    },
    restoreInlineHelp: function restoreInlineHelp(fieldName, fieldKey) {
      var _this3 = this;

      window.swal({
        title: 'Restore Inline Help?',
        text: 'You are about to restore this field inline help. This action cannot be undone. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (restore) {
        if (restore) {
          _this3.generateOriginInlineHelp(fieldName, fieldKey).then(function () {
            _this3.$bus.emit('reloadQuestionnaire');
          });
        }
      });
    },
    generateOriginInlineHelp: function generateOriginInlineHelp(fieldName, fieldKey) {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var dataInlineHelp = _this4.$store.getters.getInlineHelpFromTemplate(fieldName);
        if (dataInlineHelp === null) {
          resolve(false);
        } else {
          _this4.$store.commit('changeInlineHelp', {
            questionnaireId: fieldKey,
            name: fieldName,
            label: dataInlineHelp.label,
            inlineHelp: dataInlineHelp.text
          });
          resolve(true);
        }
      });
    },
    generateAllInlineHelp: function generateAllInlineHelp() {
      var allDataInlineHelp = this.$store.getters.getAllQuestionnaireFileds();
      this.$refs.inlineHelpModal.$emit('showInlineHelp');
      this.$bus.emit('sendInlineHelp', allDataInlineHelp);
    },
    showQuestionHelp: function showQuestionHelp(fieldName, desc, fieldKey) {
      this.$refs.inlineHelpModal.$emit('showInlineHelp');
      this.$bus.emit('sendInlineHelp', {
        questionnaireId: fieldKey,
        name: fieldName,
        text: desc,
        one: true
      });
    },
    showUploadTooltips: function showUploadTooltips() {
      this.$refs.uploadModal.$emit('showUploadModal');
    },
    showFieldGroupModal: function showFieldGroupModal() {
      this.$refs.fieldGroupModal.$emit('showModal');
    },
    showCheckboxGroupModal: function showCheckboxGroupModal() {
      this.$refs.checkboxGroupModal.$emit('showModal');
    },
    showSectionModal: function showSectionModal() {
      this.$refs.sectionModal.$emit('showModal');
    },


    // VERIFY IF THERE IS QUESTIONNAIRE INFO LOAD AND CHANGE KEY ID FOR EACH FIELD

    templateChanged: function templateChanged(templateName) {
      var newData = {};
      if (typeof this.$store.state.questionnaires[templateName] !== 'undefined') {
        newData = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.$store.state.questionnaires[templateName].data));
      }
      var objFields = {};
      __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(newData).forEach(function (fieldId, index) {
        objFields[index + '-' + Math.random().toString(36).split('.')[1]] = newData[fieldId];
      });
      this.setupData(objFields);
    },


    // SET LOCAL INFO ONLY FOR FIELD GROUPS

    setOnlyFieldGroup: function setOnlyFieldGroup(newGroupId) {
      var _this5 = this;

      var newData = this.$store.state.questionnaires[this.$store.state.currentTemplateName].data;
      var groupFields = [];
      var newGroup = null;
      var dataGroups = [];
      var positionFieldGroup = null;
      var pageFieldGroup = null;
      var tabsOrderModel = [];
      var tabsOrderId = [];

      if (this.$store.state.templates[this.$store.state.currentTemplateName] === undefined) return;
      var fieldGroup = this.$store.state.templates[this.$store.state.currentTemplateName]['checkboxGroups'];
      if (fieldGroup !== null && typeof fieldGroup !== 'undefined' && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(fieldGroup).length) {
        for (var key in this.$store.state.templates[this.$store.state.currentTemplateName]['checkboxGroups']) {
          newGroup = {};

          if (this.$store.state.templates[this.$store.state.currentTemplateName]['checkboxGroups'].hasOwnProperty(key)) {
            if (key === newGroupId) {
              (function () {
                var fieldGroup = _this5.$store.state.templates[_this5.$store.state.currentTemplateName]['checkboxGroups'][key];

                if (fieldGroup.hide !== true) {
                  var groupModel = '';
                  var dataFieldGroupFields = {};
                  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(fieldGroup.fields).forEach(function (field) {
                    groupFields.push(field);
                    var dataField = _this5.$store.getters.getTemplateData(field);
                    if (dataField.model !== '') tabsOrderModel.push(dataField.tabOrder);else tabsOrderId.push(dataField.tabOrder);

                    if (fieldGroup.fields[field].tabOrder === undefined || fieldGroup.fields[field].tabOrder === null) {
                      var objetoFieldGroupField = {
                        label: dataField.translations.en.label,
                        desc: dataField.translations.en.text,
                        tabOrder: dataField.tabOrder
                      };
                      fieldGroup.fields[field] = objetoFieldGroupField;
                    }
                    dataFieldGroupFields[field] = fieldGroup.fields[field];
                  });

                  var fieldGroupFields = _this5.$store.getters.orderFieldGroupFields(dataFieldGroupFields);
                  if (tabsOrderModel.length > 0) {
                    positionFieldGroup = Math.min.apply(null, tabsOrderModel);
                    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(fieldGroup.fields).forEach(function (field) {
                      var dataField = _this5.$store.getters.getTemplateData(field);
                      if (positionFieldGroup === dataField.tabOrder) {
                        pageFieldGroup = dataField.fieldPage;
                        groupModel = dataField.model;
                      }
                    });
                  } else {
                    positionFieldGroup = Math.min.apply(null, tabsOrderId);
                    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(fieldGroup.fields).forEach(function (field) {
                      var dataField = _this5.$store.getters.getTemplateData(field);
                      if (positionFieldGroup === dataField.tabOrder) {
                        pageFieldGroup = dataField.fieldPage;
                        groupModel = dataField.model;
                      }
                    });
                  }

                  newGroup = {
                    type: 'checkbox-group',
                    fieldName: key,
                    state: 'OK',
                    originalValue: '',
                    newValue: '',
                    itemId: 23,
                    model: groupModel,
                    deleted: false,
                    approved: true,
                    editable: true,
                    values: [],
                    fieldAdd: fieldGroup.fieldAdd,
                    name: fieldGroup.name,
                    title: fieldGroup.title,
                    desc: fieldGroup.desc,
                    checkboxes: fieldGroupFields,
                    checked: fieldGroup.checked,
                    maxChecked: _this5.$store.getters.fieldGroupMaxFields(fieldGroup.fieldId),
                    tabOrder: positionFieldGroup,
                    page: pageFieldGroup,
                    indent: fieldGroup.indent,
                    tags: fieldGroup.tags,
                    actionTags: fieldGroup.actionTags !== undefined ? fieldGroup.actionTags : [],
                    tagVisible: fieldGroup.tagVisible,
                    prefix: fieldGroup.prefix
                  };

                  if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(newGroup.checkboxes).length === 2) newGroup.abQuestion = fieldGroup.abQuestion !== undefined ? fieldGroup.abQuestion : false;

                  dataGroups.push(newGroup);
                }
              })();
            }
          }
          tabsOrderModel = [];
          tabsOrderId = [];
        }
      }

      newData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(newData);

      for (var index = 0; index < newData.length; index++) {
        var newField = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(newData[index]));

        if (newField.type === 'section' && newField.page === undefined && newField.tabOrder === undefined) {
          newField.page = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(newData[index + 1].page));
          newField.tabOrder = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(newData[index + 1].tabOrder));

          newData[index] = newField;
        } else if (newField.type === 'checkbox-group') newData.splice(index, 1);
      }

      dataGroups.forEach(function (group) {
        var nameFields = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(group.checkboxes);

        if (newData.map(function (a) {
          return a.name;
        }).indexOf(group.name) !== -1) newData.splice(newData.map(function (a) {
          return a.name;
        }).indexOf(group.name), 1);

        nameFields.forEach(function (fieldName) {
          if (newData.map(function (a) {
            return a.fieldName;
          }).indexOf(fieldName) !== -1) newData.splice(newData.map(function (a) {
            return a.fieldName;
          }).indexOf(fieldName), 1);
        });
      });

      newData = newData.concat(dataGroups);

      // Order definitly

      var tmpFormatted = {};

      tmpFormatted = this.setOrderFields(newData);

      // Set Questionnaires db and render

      this.$store.commit('setQuestionnaireFields', tmpFormatted);

      this.$bus.emit('reloadQuestionnaire');
    },


    // ORDER FIELDS FOR PAGE AND TAB ORDER

    setOrderFields: function setOrderFields(objFields) {
      var questionnaireFields = [];
      var tmpFormatted = {};

      var _loop = function _loop(countPage) {
        var pageFields = objFields.filter(function (c) {
          return Number(c.page) === countPage;
        });

        pageFields.forEach(function (field, index) {
          if (index + 1 < pageFields.length && field.tabOrder === pageFields[index + 1].tabOrder) pageFields[index + 1].tabOrder = field.tabOrder + 1;
        });

        var tmpPageFields = [];

        tmpPageFields = pageFields.sort(function (a, b) {
          return a.tabOrder > b.tabOrder ? 1 : -1;
        });

        questionnaireFields = questionnaireFields.concat(tmpPageFields);
      };

      for (var countPage = 1; countPage <= this.$store.state.totalPages; countPage++) {
        _loop(countPage);
      }

      questionnaireFields.forEach(function (field, index) {
        tmpFormatted[index + '-' + Math.random().toString(36).split('.')[1]] = field;
      });

      return tmpFormatted;
    },


    // SET INFORMATION FOR FIELDS AND FIELD GROUPS

    setupData: function setupData(newData) {
      var _this6 = this;

      var sortByTabOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.formattedData = {};

      var keys = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(newData);

      // IF THERE ISN'T INFORMATION HIDE SPINNER AND SHOW MESSAGE

      if (!keys.length) {
        this.isSpinner = false;

        this.noRows = true;
        return;
      }

      var newGroup = null;
      var dataGroups = [];
      var fieldGroup = {};

      if (this.$store.state.templates[this.$store.state.currentTemplateName] === undefined) return;

      fieldGroup = this.$store.state.templates[this.$store.state.currentTemplateName]['checkboxGroups'];

      if (fieldGroup !== null && typeof fieldGroup !== 'undefined' && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(fieldGroup).length) {
        for (var key in this.$store.state.templates[this.$store.state.currentTemplateName]['checkboxGroups']) {
          newGroup = {};

          if (this.$store.state.templates[this.$store.state.currentTemplateName]['checkboxGroups'].hasOwnProperty(key)) {
            var _fieldGroup = this.$store.state.templates[this.$store.state.currentTemplateName]['checkboxGroups'][key];

            if (_fieldGroup.hide !== true) {
              var groupModel = '';

              newGroup = {
                type: 'checkbox-group',
                fieldName: key,
                state: 'OK',
                originalValue: '',
                newValue: '',
                itemId: 23,
                model: groupModel,
                deleted: false,
                approved: true,
                editable: true,
                values: [],
                fieldAdd: _fieldGroup.fieldAdd,
                name: _fieldGroup.name,
                title: _fieldGroup.title,
                desc: _fieldGroup.desc,
                checkboxes: _fieldGroup.fields,
                checked: _fieldGroup.checked,
                maxChecked: _fieldGroup.maxChecked,
                tabOrder: _fieldGroup.tabOrder,
                page: _fieldGroup.page,
                indent: _fieldGroup.indent,
                tags: _fieldGroup.tags,
                actionTags: _fieldGroup.actionTags !== undefined ? _fieldGroup.actionTags : [],
                tagVisible: _fieldGroup.tagVisible,
                prefix: _fieldGroup.prefix
              };

              if (_fieldGroup.watchers) newGroup.watchers = _fieldGroup.watchers;

              if (newGroup.checkboxes && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(newGroup.checkboxes).length === 2) newGroup.abQuestion = _fieldGroup.abQuestion !== undefined ? _fieldGroup.abQuestion : false;

              if (!newGroup.checkboxes) newGroup.checkboxes = {};

              dataGroups.push(newGroup);
            }
          }
        }
      }

      newData = [];

      newData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.$store.state.questionnaires[this.$store.state.currentTemplateName].data)));

      for (var index = 0; index < newData.length; index++) {
        var newField = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(newData[index]));

        // SET POSITION FOR SECTIONS

        if (newField.type === 'section' && newField.page === undefined && newField.tabOrder === undefined) {
          if (newData[index + 1] !== undefined && newData[index + 1] !== null) {
            if (newData[index + 1].page !== undefined && newData[index + 1].page !== null) newField.page = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(newData[index + 1].page));

            if (newData[index + 1].tabOrder !== undefined && newData[index + 1].tabOrder !== null) newField.tabOrder = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(newData[index + 1].tabOrder) - 1);
          }

          newData[index] = newField;

          // IF THERE IS CREATED FIELD GROUPS, REMOVE THEM
        } else if (newField.type === 'checkbox-group') newData.splice(index, 1);
      }

      // SET EMPTY AB FIELDS WATCHERS

      this.$store.commit('resetAbFieldsWatcher');

      // SET FIELD GROUPS ON LIST INFORMATION

      dataGroups.forEach(function (group) {
        if (group.checkboxes && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(group.checkboxes).length === 2 && group.checkboxes[__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(group.checkboxes)[0]].type === 'checkbox' && group.checkboxes[__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(group.checkboxes)[1]].type === 'checkbox') {
          _this6.$store.commit('setAbFieldWatcher', group.tags);
        }

        var nameFields = group.checkboxes ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(group.checkboxes) : [];

        if (newData.map(function (a) {
          return a.name;
        }).indexOf(group.name) !== -1) newData.splice(newData.map(function (a) {
          return a.name;
        }).indexOf(group.name), 1);

        nameFields.forEach(function (fieldName) {
          if (newData.map(function (a) {
            return a.fieldName;
          }).indexOf(fieldName) !== -1) newData.splice(newData.map(function (a) {
            return a.fieldName;
          }).indexOf(fieldName), 1);
        });
      });

      newData = newData.concat(dataGroups);

      // SET ORDER WITH PAGE FIELD AND TAB ORDER

      var tmpFormatted = {};

      tmpFormatted = this.setOrderFields(newData);

      // SET QUESTIONNAIRES ON DB AND RENDER LIST

      this.noRows = !__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(tmpFormatted).length;
      this.formattedData = {};
      this.formattedData = tmpFormatted;
      this.$store.commit('setQuestionnaireFields', this.formattedData);

      this.updateQuestionnaire();
      this.isSpinner = false;
    },


    // UPDTE LOCAL INFO WHEN DELETE FIELD OR FIELD GROUP

    setQuestionnairesFields: function setQuestionnairesFields() {
      this.formattedData = {};
      var questionnaireFields = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.$store.state.questionnaires[this.$store.state.currentTemplateName]['data']));
      var keys = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(questionnaireFields);
      var newData = [];
      if (keys.length > 0) newData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(questionnaireFields);

      var tmpFormatted = {};

      for (var index = 0; index < newData.length; index++) {
        var newField = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(newData[index]));

        tmpFormatted[index + '-' + Math.random().toString(36).split('.')[1]] = newField;
      }

      this.noRows = !__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(tmpFormatted).length;
      this.formattedData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.formattedData, tmpFormatted);
    },


    // SHOW HIGHLIGHT FOR SELECTED FIELD

    setFieldPage: function setFieldPage(fieldData) {
      // MARK FIELDGROUP

      if (fieldData.type === 'checkbox-group') {
        var tmpPageFields = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(fieldData.fields);

        tmpPageFields = tmpPageFields.sort(function (a, b) {
          return a.tabOrder > b.tabOrder ? 1 : -1;
        });

        fieldData.name = tmpPageFields[0].id;
        fieldData.type = tmpPageFields[0].type;
      }

      // MARK FIELD

      for (var contadorPage = 1; contadorPage <= __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(this.$store.state.templates[this.$store.state.currentTemplateName]['pages']).length; contadorPage++) {
        for (var contadorField = 0; contadorField < this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][contadorPage].length; contadorField++) {
          if (this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][contadorPage][contadorField] === null) continue;
          if (this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][contadorPage][contadorField].name === fieldData.name) {
            var pageData = {
              name: this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][contadorPage][contadorField].name,
              fieldPage: this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][contadorPage][contadorField].fieldPage,
              type: this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][contadorPage][contadorField].type
            };
            if (parseInt(pageData.fieldPage) === this.$store.state.fileCurrentPage) {
              var highlighted = document.querySelectorAll('.id-highlight');
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(highlighted), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var highlight = _step.value;

                  highlight.classList.remove('id-highlight');
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              this.$bus.emit('hideTooltip');
              if (fieldData.type !== 'text') this.$bus.emit('scrollToElement', pageData.name);else document.getElementById(pageData.name).focus();
              this.$bus.emit('showTooltip', pageData.name);
              var dataField = this.$store.getters.getTemplateData(pageData.name);
              if (dataField.type !== 'text') {
                var targetEl = document.getElementById(dataField.name);
                if (targetEl === null) return;
                targetEl.classList.add('id-highlight');
              }
            } else {
              this.$bus.emit('hideTooltip');
              this.$store.commit('setDisablePageNavigation', true);
              this.$store.commit('setCurrentPage', Math.floor(Number(pageData.fieldPage)));
              this.$bus.emit('pageChange', Math.floor(Number(pageData.fieldPage)));
              this.$bus.emit('showTooltip', pageData.name);
              this.$bus.emit('hidePageFields');
            }
          }
        }
      }
    },
    saveEdit: function saveEdit(data) {
      var field = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.formattedData[data.key]));
      var storeField = this.$store.getters.templateFieldById(field.fieldName);
      var fieldIndex = this.$store.getters.currentTemplateFieldIndex(storeField.id, storeField.fieldPage);
      this.$store.commit('setTemplateFieldQuestionText', {
        index: fieldIndex,
        page: storeField.fieldPage,
        title: data.data.title,
        helpText: data.data.desc
      });
      this.$store.dispatch('saveTemplate');

      var tmpFormatted = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.formattedData));
      tmpFormatted[data.key] = data.data;
      this.formattedData = tmpFormatted;
      this.updateQuestionnaireStore();
      this.updateQuestionnaire();
    },
    updateQuestionnaireStore: function updateQuestionnaireStore() {
      var _this7 = this;

      if (this.$store.state.currentTemplateName === 'global') return;
      if (typeof this.$store.state.questionnaires[this.$store.state.currentTemplateName] === 'undefined') return;

      var tmpQuestionnaires = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.$store.state.questionnaires));
      var backFields = [];

      __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(tmpQuestionnaires[this.$store.state.currentTemplateName].data).forEach(function (fieldId, index) {
        var foundWidget = _this7.$store.getters.modelWidget(tmpQuestionnaires[_this7.$store.state.currentTemplateName].data[fieldId].model);
        if (foundWidget !== null) backFields.push({ name: _this7.$store.getters.modelWidget(tmpQuestionnaires[_this7.$store.state.currentTemplateName].data[fieldId].model), position: index });
      });

      tmpQuestionnaires[this.$store.state.currentTemplateName].data = this.formattedData;
      this.$store.commit('setQuestionnaires', tmpQuestionnaires);
    },
    deleteField: function deleteField(fieldKey) {
      var _this8 = this;

      window.swal({
        title: 'Delete Questionnaire Field?',
        text: 'You are about to delete this questionnaire field. This action cannot be undone. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (deleted) {
        if (deleted) {
          _this8.$store.commit('removeSection', fieldKey);
          _this8.setQuestionnairesFields();
          _this8.updateQuestionnaire();
        }
      });
    },
    deleteGroup: function deleteGroup(groupId) {
      var _this9 = this;

      window.swal({
        title: 'Delete Field Group?',
        text: 'You are about to delete this field group. This action cannot be undone. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (deleted) {
        if (deleted) {
          _this9.$store.commit('removeFieldGroupFromQuestionnaire', groupId);
          _this9.setQuestionnairesFields();
          _this9.$store.dispatch('saveTemplate');
        }
      });
    },
    editGroup: function editGroup(fieldKey) {
      this.$bus.emit('fieldGroupEditModal', fieldKey);
    },
    getDataField: function getDataField(fieldKey) {
      var field = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.formattedData[fieldKey]));
      var storeField = this.$store.getters.templateFieldById(field.fieldName);
      if (typeof storeField.questionTitle === 'undefined' || typeof storeField.questionHelp === 'undefined') {
        var fieldIndex = this.$store.getters.currentTemplateFieldIndex(storeField.id, storeField.fieldPage);
        this.$store.commit('setTemplateFieldQuestionText', {
          index: fieldIndex,
          page: storeField.fieldPage,
          title: storeField.id,
          helpText: ''
        });
        this.$store.dispatch('saveTemplate');
      }

      field['fieldDisplayName'] = storeField.name;
      return field;
    },
    editField: function editField(fieldKey) {
      var field = this.getDataField(fieldKey);
      this.$bus.emit('openFieldMenu', {
        id: field.fieldName,
        page: field.page
      });
    },
    editSection: function editSection(fieldKey) {
      this.$bus.$emit('sectionEditModal', fieldKey);
    },
    deleteSection: function deleteSection(sectionId) {
      var _this10 = this;

      window.swal({
        title: 'Delete Questionnaire Section?',
        text: 'You are about to delete this questionnaire section. This action cannot be undone. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (deleted) {
        if (deleted) {
          _this10.$store.commit('removeSection', sectionId);
          _this10.$bus.emit('reloadQuestionnaire');
        }
      });
    },
    move: function move(moveIndex, up) {
      var _this11 = this;

      var fieldKeys = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(this.formattedData);

      var tmpFields = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.formattedData));

      fieldKeys.forEach(function (key, index) {
        if (key === moveIndex) {
          var tmpPage = tmpFields[moveIndex].page;
          var tmpTabOrder = tmpFields[moveIndex].tabOrder;
          var indexChange = index;

          if (up === true && index > 0) indexChange--;else indexChange++;

          tmpFields[moveIndex].tabOrder = tmpFields[fieldKeys[indexChange]].tabOrder;
          tmpFields[moveIndex].page = tmpFields[fieldKeys[indexChange]].page;

          tmpFields[fieldKeys[indexChange]].tabOrder = tmpTabOrder;
          tmpFields[fieldKeys[indexChange]].page = tmpPage;

          // Save fieldGroups tab Order in template
          if (tmpFields[moveIndex].name !== undefined) {
            _this11.$store.commit('editFieldGroup', {
              index: tmpFields[moveIndex].fieldName,
              name: tmpFields[moveIndex].name,
              label: tmpFields[moveIndex].title,
              help: tmpFields[moveIndex].desc,
              tabOrder: tmpFields[moveIndex].tabOrder,
              prefix: tmpFields[moveIndex].prefix,
              page: tmpFields[moveIndex].page
            });
          }

          if (tmpFields[fieldKeys[indexChange]].name !== undefined) {
            _this11.$store.commit('editFieldGroup', {
              index: tmpFields[fieldKeys[indexChange]].fieldName,
              name: tmpFields[fieldKeys[indexChange]].name,
              label: tmpFields[fieldKeys[indexChange]].title,
              help: tmpFields[fieldKeys[indexChange]].desc,
              tabOrder: tmpFields[fieldKeys[indexChange]].tabOrder,
              prefix: tmpFields[fieldKeys[indexChange]].prefix,
              page: tmpFields[moveIndex].page
            });
          }
        }
      });

      this.$store.dispatch('saveTemplate');

      var orderFields = [];

      orderFields = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(tmpFields);

      this.formattedData = {};

      this.formattedData = this.setOrderFields(orderFields);

      this.$store.commit('setQuestionnaireFields', this.formattedData);
      this.updateQuestionnaire();
    },
    widgetChanged: function widgetChanged(data) {
      var tmpFormatted = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.formattedData));
      if (this.formattedData[data.index].type === 'grid') {
        tmpFormatted[data.index].data = data.value;
      } else tmpFormatted[data.index].newValue = data.value;
      this.formattedData = tmpFormatted;
      this.updateQuestionnaireStore();
      this.updateQuestionnaire();
    },
    scrollToElement: function scrollToElement(fieldName) {
      var el = document.querySelector('[data-field="' + fieldName + '"');
      if (el === null) {
        var nameWidget = this.$store.getters.getIdWidgetGroup(fieldName);
        var nameFieldGroup = this.$store.getters.fieldGroup(fieldName);
        if (nameWidget !== null) fieldName = nameWidget;
        if (nameFieldGroup !== null) fieldName = nameFieldGroup;
        el = document.querySelector('[data-field="' + fieldName + '"');
      }
      if (el === null) return;
      this.$store.commit('setSelectedQuestionnaireField', fieldName);
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(document.querySelectorAll('.active-widget')), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var activeEl = _step2.value;

          activeEl.classList.remove('active-widget');
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (fieldName !== this.lastHighlightedModel) {
        el.parentElement.classList.add('active-widget');
        el.scrollIntoView({ block: 'center', behavior: 'smooth' });
        this.lastHighlightedModel = fieldName;
      } else this.lastHighlightedModel = '';
    },
    toggleModelDisplay: function toggleModelDisplay() {
      this.modelDisplay = !this.modelDisplay;
      this.$bus.emit('toggleModelDisplay', this.modelDisplay);
    },
    toggleIdDisplay: function toggleIdDisplay() {
      this.idDisplay = !this.idDisplay;
      this.$bus.emit('toggleIdDisplay', this.idDisplay);
    },
    updateQuestionnaire: function updateQuestionnaire() {
      var apiUrl = this.$store.state.apiUrl;

      if (!this.$store.state.questionnaires[this.$store.state.currentTemplateName] || this.$store.state.questionnaires[this.$store.state.currentTemplateName] === null) return;

      var currentQuestionnaire = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.$store.state.questionnaires[this.$store.state.currentTemplateName]));

      var newFields = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(currentQuestionnaire.data)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var field = _step3.value;

          var newField = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(field));
          newFields.push(newField);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      currentQuestionnaire['data'] = newFields;

      var requestData = {
        questionnaireId: currentQuestionnaire._id,
        newData: currentQuestionnaire
      };
      var that = this;
      this.axios.post(apiUrl + 'questionnaire/update', requestData).then(function (response) {
        that.$store.commit('setLastSaved', Date.now());
      });
    },
    initialUpdate: function initialUpdate() {
      var newData = {};
      if (typeof this.$store.state.questionnaires[this.$store.state.currentTemplateName] !== 'undefined') {
        newData = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.$store.state.questionnaires[this.$store.state.currentTemplateName].data));
      }
      newData.generate = true;
      this.setupData(newData, true);
    },
    generateFields: function generateFields() {
      var _this12 = this;

      this.loading = true;
      window.swal({
        title: 'Generate Questions?',
        text: 'You are about to generate questionnaire questions using the form fields. This will replace your current questionnaire data. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (generate) {
        if (generate) {
          var _ret3 = function () {
            var existingModels = [];
            var newQuestionnaireData = [];
            var currentTemplateName = _this12.$store.state.currentTemplateName;
            if (_this12.$store.state.templates[_this12.$store.state.currentTemplateName] === undefined) return {
                v: void 0
              };

            var _loop2 = function _loop2(pageIndex) {
              if (_this12.$store.state.templates[currentTemplateName]['pages'].hasOwnProperty(pageIndex)) {
                var page = _this12.$store.state.templates[currentTemplateName]['pages'][pageIndex];
                if (page === null) return 'continue';
                page.forEach(function (field) {
                  if (field === null) {
                    return;
                  } else {
                    if (field.model === null || field.model === undefined) field.model = '';
                    if (field.model.length && existingModels.indexOf(field.model) !== -1) return;
                    var prefix = '';
                    if (field.prefix) prefix = field.prefix;
                    var newField = {
                      type: field.type,
                      fieldName: field.id,
                      state: 'OK',
                      originalValue: typeof field.value !== 'undefined' && field.value.length ? field.value : '',
                      newValue: '',
                      itemId: 23,
                      model: field.model,
                      prefix: prefix,
                      deleted: false,
                      approved: true,
                      editable: true,
                      values: [],
                      title: field.id,
                      desc: '',
                      tabOrder: field.tabOrder,
                      page: pageIndex,
                      render: true,
                      tags: field.tags,
                      maxCharacter: Number(field.maxCharacter)
                    };

                    if (field.forceShow !== undefined) {
                      newField.forceShow = field.forceShow;
                    }

                    if (typeof field.translations !== 'undefined') {
                      if (typeof field.translations[_this12.$store.state.currentLocale] !== 'undefined') {
                        newField.title = field.translations[_this12.$store.state.currentLocale]['label'];
                        newField.desc = field.translations[_this12.$store.state.currentLocale]['text'];
                      }
                    }

                    if (newField.type === 'textarea') newField.type = 'text';else if (newField.type === 'radio') newField.type = 'checkbox';else if (newField.type === 'button') newField.type = 'checkbox';else if (newField.type === 'select') {
                      newField.type = 'combobox';
                      newField.values = field.choiceData;
                    }
                    existingModels.push(field.model);
                    if (field.model === '' || field.forceShow === true) newQuestionnaireData.push(newField);
                  }
                });
              }
            };

            for (var pageIndex in _this12.$store.state.templates[currentTemplateName]['pages']) {
              var _ret4 = _loop2(pageIndex);

              if (_ret4 === 'continue') continue;
            }

            var tmpQuestionnaires = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(_this12.$store.state.questionnaires));
            if (typeof tmpQuestionnaires[currentTemplateName] === 'undefined') {
              tmpQuestionnaires[currentTemplateName] = {
                templateId: _this12.$store.state.templates[_this12.$store.state.currentTemplateName]['_id'],
                data: newQuestionnaireData
              };
            } else {
              tmpQuestionnaires[currentTemplateName].data = newQuestionnaireData;
            }
            tmpQuestionnaires[currentTemplateName].data = tmpQuestionnaires[_this12.$store.state.currentTemplateName].data;
            _this12.$store.commit('setQuestionnaires', tmpQuestionnaires);
            _this12.initialUpdate();
          }();

          if ((typeof _ret3 === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret3)) === "object") return _ret3.v;
        } else {
          _this12.loading = false;
        }
      });
    },
    removeAll: function removeAll() {
      var _this13 = this;

      this.loading = false;
      window.swal({
        title: 'Remove Questions?',
        text: 'You are about to remove all of the current questionnaire fields. This action cannot be undone. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (deleted) {
        if (!deleted) return;
        var tmpQuestionnaires = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(_this13.$store.state.questionnaires));
        tmpQuestionnaires[_this13.$store.state.currentTemplateName].data = [];
        _this13.$store.commit('setQuestionnaires', tmpQuestionnaires);
        var tmpTemplates = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(_this13.$store.state.templates));
        _this13.$store.commit('setTemplates', tmpTemplates);
        _this13.$store.dispatch('saveTemplate');
        _this13.formattedData = {};
        _this13.templateChanged(_this13.$store.state.currentTemplateName);
        _this13.updateQuestionnaire();
      });
    },
    noDataFound: function noDataFound() {
      if (this.formattedData === null || this.formattedData === undefined) {
        this.isSpinner = false;
        this.formattedData = {};
        this.loading = true;
      }
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$off('widgetChanged');
    this.$off('saveEdit');
    this.$bus.$off('scrollToElement');
    this.$bus.$off('setCurrentTemplateName');
    this.$bus.$off('reloadQuestionnaire');
    this.$bus.$off('updateQuestionnaire');
    this.$bus.$off('setOnlyFieldGroup');
    this.$bus.$off('initialUpdate');
    this.$bus.$off('setFieldPage');
    this.$bus.$off('pageChange');
    this.$bus.$off('removeSection');
  }
});

/***/ }),

/***/ "f+sn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-group",attrs:{"data-field":_vm.templateObject.widget_id,"id":_vm.templateObject.widget_id}},[_c('div',{staticClass:"widget-header"},[_c('h3',{staticClass:"float-left"},[_vm._v(_vm._s(_vm.templateObject.properties.title))]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-success float-right btnAddRow",on:{"click":_vm.addRow}},[_vm._v("Add")])]),_vm._v(" "),_c('div',[_c('h4',[_vm._v(_vm._s(_vm.messageWidget))])]),_vm._v(" "),_c('div',{staticClass:"tableWidget"},[_c('table',{directives:[{name:"show",rawName:"v-show",value:(_vm.tableView),expression:"tableView"}],staticClass:"table table-sm table-bordered table-striped"},[_c('thead',[_c('tr',[_vm._l((_vm.templateData.columns),function(column,key){return _c('th',{key:key,attrs:{"data-fieldname":column.fieldName}},[_vm._v(_vm._s(column.title))])}),_vm._v(" "),_c('th',[_vm._v("Actions")])],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.templateData.fields),function(fieldObject,fieldObjectKey){return _c('tr',{key:fieldObjectKey,attrs:{"data-objectkey":fieldObjectKey}},[_vm._l((_vm.templateData.columns),function(column,columnKey){return _c('td',{key:columnKey,attrs:{"data-fieldname":column.fieldName}},[_vm._l((fieldObject),function(field,fieldKey){return [(column.fieldName === field.fieldName)?[(column.type === 'combobox')?_c('combo-widget',{key:fieldKey,ref:fieldObjectKey+','+fieldKey,refInFor:true,attrs:{"fieldIndex":fieldObjectKey+','+fieldKey,"initialValue":field.newValue.length ? field.newValue : field.originalValue,"fieldName":field.fieldName,"options":column.values,"editable":field.editable,"autoWidth":true,"readOnly":true}}):(column.type === 'text')?_c('text-widget',{key:fieldKey,ref:fieldObjectKey+','+fieldKey,refInFor:true,attrs:{"fieldIndex":fieldObjectKey+','+fieldKey,"initialValue":field.newValue.length ? field.newValue : field.originalValue,"fieldName":field.fieldName,"editable":field.editable,"autoWidth":true,"readOnly":true}}):(field.type === 'checkbox')?_c('checkbox-widget',{key:fieldKey,ref:fieldObjectKey+','+fieldKey,refInFor:true,attrs:{"fieldIndex":fieldObjectKey+','+fieldKey,"initialValue":field.newValue.length ? field.newValue : field.originalValue,"fieldName":field.fieldName,"editable":field.editable,"autoWidth":true,"readOnly":true}}):_vm._e()]:_vm._e()]})],2)}),_vm._v(" "),_c('td',{staticClass:"box-actions",attrs:{"data-priority":"-100"}},[(_vm.showHiddenMessage)?_c('button',{staticClass:"btn btn-info",attrs:{"href":"#"},on:{"click":function($event){return _vm.editWidget(fieldObjectKey)}}},[_vm._v("Edit/Show")]):_c('button',{staticClass:"btn btn-info",attrs:{"href":"#"},on:{"click":function($event){return _vm.editWidget(fieldObjectKey)}}},[_vm._v("Edit")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"href":"#"},on:{"click":function($event){return _vm.deleteRow(fieldObjectKey)}}},[_vm._v("Delete")])])],2)}),0)])]),_vm._v(" "),(_vm.showHiddenMessage)?_c('div',[_c('p',{staticStyle:{"color":"#777"}},[_vm._v("Some fields are not visible due to your resolution")])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.tableView),expression:"!tableView"}],staticStyle:{"margin-bottom":"15px"}},[_vm._l((_vm.templateData.columns),function(column,key){return (_vm.templateData.fields.length === 0)?_c('section',{key:key,staticStyle:{"box-shadow":"1px 1px 2px 2px black","padding":"5px"},attrs:{"data-fieldname":column.fieldName}},[_vm._v(_vm._s(column.title))]):_vm._e()}),_vm._v(" "),_vm._l((_vm.templateData.fields),function(fieldObject,fieldObjectKey){return _c('div',{key:fieldObjectKey,staticClass:"widget-box"},[_vm._l((fieldObject),function(field,fieldKey){return _c('div',{key:fieldKey,staticClass:"widget-input"},[_c('span',{staticClass:"widget-label"},[_vm._v(_vm._s(field.title)+":")]),_vm._v(" "),(field.type === 'combobox')?_c('combo-widget',{key:fieldKey,ref:fieldObjectKey+','+fieldKey,refInFor:true,attrs:{"fieldIndex":fieldObjectKey+','+fieldKey,"initialValue":field.newValue.length ? field.newValue : field.originalValue,"fieldName":field.fieldName,"options":field.values,"editable":field.editable,"readOnly":true}}):(field.type === 'text')?_c('text-widget',{key:fieldKey,ref:fieldObjectKey+','+fieldKey,refInFor:true,attrs:{"fieldIndex":fieldObjectKey+','+fieldKey,"initialValue":field.newValue.length ? field.newValue : field.originalValue,"fieldName":field.fieldName,"editable":field.editable,"readOnly":true}}):(field.type === 'checkbox')?_c('checkbox-widget',{key:fieldKey,ref:fieldObjectKey+','+fieldKey,refInFor:true,attrs:{"fieldIndex":fieldObjectKey+','+fieldKey,"initialValue":field.newValue.length ? field.newValue : field.originalValue,"fieldName":field.fieldName,"editable":field.editable,"readOnly":true}}):_vm._e()],1)}),_vm._v(" "),_c('button',{staticClass:"widget-box-edit btn btn-info",attrs:{"href":"#"},on:{"click":function($event){return _vm.editWidget(fieldObjectKey)}}},[_vm._v("Edit")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.deleteRow(fieldObjectKey)}}},[_vm._v("Delete")])],2)})],2),_vm._v(" "),_c('group-edit-modal',{ref:"editModal"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fBKx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      value: '',
      isAutocompleteClick: false
    };
  },

  props: {
    type: {
      type: String
    },

    listOfficialModels: {
      type: Array
    }
  },

  watch: {
    model: function model(val) {
      this.value = val;
    }
  },

  mounted: function mounted() {
    this.value = this.model;
  },

  methods: {
    hideAutocomplete: function hideAutocomplete() {
      var _this = this;

      setTimeout(function () {
        _this.$emit('set-autocomplete:model', {
          hide: true
        });
      }, 500);
    },
    setAutocompleteModel: function setAutocompleteModel() {
      this.$emit('set-autocomplete:model', {
        show: true,
        left: this.left,
        top: this.top,
        model: this.value,
        fieldId: this.id,
        type: this.type,
        page: this.$store.state.fileCurrentPage
      });
    }
  }
});

/***/ }),

/***/ "fC0H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'function-toolbox',

  methods: {
    addItem: function addItem(symbol) {
      this.$parent.$emit('addItem', symbol);
    }
  }
});

/***/ }),

/***/ "fFDX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fPTq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-select",style:(_vm.style)},[(_vm.$store.state.assigningIndexes)?_c('span',{staticClass:"tab-index",style:(_vm.tabOrderStyle),on:{"click":_vm.inputClick}},[_vm._v("\n    "+_vm._s((_vm.$store.getters.templateTabOrder(_vm.id) > -1) ? _vm.$store.getters.templateTabOrder(_vm.id) : '?')+"\n  ")]):_vm._e(),_vm._v(" "),_c('select',{staticClass:"input-select",style:(_vm.inputStyle),attrs:{"id":_vm.id,"tabindex":_vm.$store.getters.templateTabOrder(_vm.id),"data-model":_vm.model},on:{"click":_vm.focusInput,"contextmenu":_vm.inputClick}},_vm._l((_vm.options),function(option,index){return _c('option',{key:index},[_vm._v("\n      "+_vm._s(option)+"\n    ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fh2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-slider slide"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],style:(_vm.style),attrs:{"type":"range","tabindex":"-1","min":_vm.min,"max":_vm.max,"step":_vm.step},domProps:{"value":(_vm.value)},on:{"change":_vm.valueUpdate,"__r":function($event){_vm.value=$event.target.value}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fzij":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaxItemsModal_vue__ = __webpack_require__("26Jz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_309e7276_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaxItemsModal_vue__ = __webpack_require__("xEYj");
function injectStyle (ssrContext) {
  __webpack_require__("72RX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-309e7276"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaxItemsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_309e7276_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaxItemsModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g6mk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gFR7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_questionnaires_QuestionnaireTags__ = __webpack_require__("tODX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_questionnaires_ABGroupWatchers__ = __webpack_require__("GGn3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__searchSelect_SearchSelect_vue__ = __webpack_require__("QiEr");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'field-group-edit-modal',

  mounted: function mounted() {
    var that = this;
    this.$bus.on('fieldGroupEditModal', function (fieldId) {
      that.fieldId = fieldId;
      var storeGroup = that.$store.state.templates[that.$store.state.currentTemplateName]['checkboxGroups'][fieldId];
      that.editName = storeGroup.name;
      that.editLabel = storeGroup.title;
      that.editHelp = storeGroup.desc;
      that.editMaxChecked = that.$store.getters.fieldGroupMaxFields(storeGroup.fieldId);
      that.fieldList = storeGroup.fields;
      that.prefix = storeGroup.prefix;
      that.showModal = true;
      that.watchers = storeGroup.watchers !== undefined ? storeGroup.watchers : [];
      that.isAb = storeGroup.abQuestion;
      that.tagVisible = storeGroup.tagVisible;

      var showActions = false;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(that.fieldList).forEach(function (field) {
        if (that.fieldList[field].type === 'checkbox') showActions = true;
      });

      if (that.isAb === true) {
        that.typeA = that.fieldList[__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(that.fieldList)[0]].typeAb;
        that.typeB = that.fieldList[__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(that.fieldList)[1]].typeAb;
      }

      that.isGroupActions = showActions;
    });

    document.addEventListener('keyup', this.keyCheck);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keyup', this.keyCheck, false);

    this.$bus.$off('fieldGroupEditModal');
  },
  data: function data() {
    return {
      fieldId: '',
      showModal: false,
      editName: '',
      editLabel: '',
      editHelp: '',
      editMaxChecked: 1,
      fieldList: [],
      isGroupActions: false,
      prefix: '',
      watchers: [],
      isAb: false,
      typeA: '',
      typeB: '',
      tagVisible: true
    };
  },


  components: {
    QuestionnaireTags: __WEBPACK_IMPORTED_MODULE_3__components_questionnaires_QuestionnaireTags__["a" /* default */],
    AbGroupWatchers: __WEBPACK_IMPORTED_MODULE_4__components_questionnaires_ABGroupWatchers__["a" /* default */],
    SearchSelect: __WEBPACK_IMPORTED_MODULE_5__searchSelect_SearchSelect_vue__["a" /* default */]
  },

  methods: {
    setTypeA: function setTypeA(e) {
      this.typeA = e;

      if (e === 'Yes') this.typeB = 'No';else if (e === 'No') this.typeB = 'Yes';

      var listCheckboxes = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.fieldList));

      listCheckboxes[__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.fieldList)[0]].typeAb = this.typeA;
      listCheckboxes[__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.fieldList)[1]].typeAb = this.typeB;

      this.$store.commit('editFieldGroup', {
        index: this.fieldId,
        checkboxes: listCheckboxes
      });
    },
    setTypeB: function setTypeB(e) {
      this.typeB = e;

      if (e === 'Yes') this.typeA = 'No';else if (e === 'No') this.typeA = 'Yes';

      var listCheckboxes = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.fieldList));

      listCheckboxes[__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.fieldList)[0]].typeAb = this.typeA;
      listCheckboxes[__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.fieldList)[1]].typeAb = this.typeB;

      this.$store.commit('editFieldGroup', {
        index: this.fieldId,
        checkboxes: listCheckboxes
      });
    },
    deleteFieldGroupField: function deleteFieldGroupField(index) {
      this.$store.commit('deleteExistOnFieldGroups', index);
      this.$bus.emit('reloadQuestionnaire');
      this.$store.dispatch('saveTemplate');

      var list = [];
      list = this.fieldList;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(list).forEach(function (id) {
        if (id === index) delete list[id];
      });

      this.fieldList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.fieldList, list);
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.fieldList).length === 0) this.showModal = false;
    },
    move: function move(moveIndex, up) {
      var tmpContainer = {};
      var targetIndex = -1;
      var keys = [];
      keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.fieldList);

      for (var index = 0; index < keys.length; index++) {
        tmpContainer[index] = keys[index];
        if (moveIndex === keys[index]) targetIndex = index;
      }

      if (targetIndex === -1) return;
      if (up && targetIndex - 1 < 0) return;
      if (!up && targetIndex + 1 > keys.length - 1) return;
      var newTarget = up ? targetIndex - 1 : targetIndex + 1;

      var tabOrderTarget = this.fieldList[moveIndex].tabOrder;
      var tabOrderMove = this.fieldList[keys[newTarget]].tabOrder;

      this.fieldList[moveIndex].tabOrder = tabOrderMove;
      this.fieldList[keys[newTarget]].tabOrder = tabOrderTarget;

      keys.splice(newTarget < 0 ? keys.length + newTarget : newTarget, 0, keys.splice(targetIndex, 1)[0]);

      var newData = {};
      for (var _index = 0; _index < keys.length; _index++) {
        var element = keys[_index];
        newData[element] = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.fieldList[element]));
      }

      this.fieldList = newData;

      this.$bus.emit('moveFieldGroupField', {
        moveIndex: moveIndex,
        up: up
      });
    },
    keyCheck: function keyCheck(evt) {
      if (evt.keyCode === 27) this.closeModal();
    },
    closeModal: function closeModal() {
      this.showModal = false;
    },
    saveEdit: function saveEdit() {
      this.$store.commit('editFieldGroup', {
        index: this.fieldId,
        name: this.editName,
        label: this.editLabel,
        help: this.editHelp,
        prefix: this.prefix,
        maxChecked: Number(this.editMaxChecked)
      });

      this.$store.dispatch('saveTemplate');
      this.$bus.emit('reloadQuestionnaire');

      this.showModal = false;
    },
    editFormField: function editFormField(index) {
      this.$bus.emit('openFieldMenu', {
        id: index
      });
      this.showModal = false;
    }
  }
});

/***/ }),

/***/ "gUy7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalEditField_vue__ = __webpack_require__("w8HO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f724cc56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalEditField_vue__ = __webpack_require__("ZarL");
function injectStyle (ssrContext) {
  __webpack_require__("V3jz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f724cc56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalEditField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f724cc56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalEditField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gavN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModal)?_c('div',{staticClass:"checkbox-group-edit-modal"},[_c('div',{staticClass:"modalHeader"},[_c('span',{staticClass:"title"},[_vm._v("Edit Checkbox Group")]),_vm._v(" "),_c('span',{staticClass:"btn-close float-right",on:{"click":_vm.closeModal}},[_c('i',{staticClass:"fas fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"modalBody"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editName),expression:"editName"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.editName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editLabel),expression:"editLabel"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.editLabel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editLabel=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.editHelp),expression:"editHelp"}],staticClass:"form-control form-control-sm",domProps:{"value":(_vm.editHelp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editHelp=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"button-box float-right"},[_c('button',{staticClass:"btn btn-success",on:{"click":_vm.saveEdit}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":_vm.closeModal}},[_vm._v("Close")])]),_vm._v(" "),_c('table',{staticClass:"table table-sm table-bordered table-striped"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.checkboxList),function(checkbox,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(checkbox.translations.en.label))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-default",on:{"click":function($event){return _vm.editFormField(index)}}},[_vm._v("Edit Form Checkbox")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.deleteCheckboxGroupCheck(index)}}},[_vm._v("Remove")]),_vm._v(" "),_c('i',{staticClass:"fas fa-angle-double-up",on:{"click":function($event){return _vm.move(index, true)}}}),_vm._v(" "),_c('i',{staticClass:"fas fa-angle-double-down",on:{"click":function($event){return _vm.move(index, false)}}})])])}),0)])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"font14"},[_c('b',[_vm._v("Name:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"font14"},[_c('b',[_vm._v("Label:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"font14"},[_c('b',[_vm._v("Help Text:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Checkbox ID")]),_vm._v(" "),_c('th',[_vm._v("Actions")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gbl9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__ = __webpack_require__("eIAY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3650b072_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__ = __webpack_require__("gfWk");
function injectStyle (ssrContext) {
  __webpack_require__("Hjgw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3650b072"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3650b072_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gceK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'field-group-modal',

  mounted: function mounted() {
    var that = this;
    this.$on('showModal', function (fieldData) {
      that.showModal = true;
      that.groups = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(that.$store.getters.groupFields()));
    });

    document.addEventListener('keyup', this.keyCheck);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keyup', this.keyCheck, false);

    this.$off('showModal');
  },
  data: function data() {
    return {
      showModal: false,
      groups: {}
    };
  },


  methods: {
    sendToQuestionnaire: function sendToQuestionnaire(nameFieldGroup) {
      var _this = this;

      var newGroup = null;
      var groupModel = '';
      var positionFieldGroup = null;
      var pageFieldGroup = null;
      var tabsOrderModel = [];
      var tabsOrderId = [];
      var fieldGroupsTemplate = this.$store.state.templates[this.$store.state.currentTemplateName]['checkboxGroups'];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(fieldGroupsTemplate).forEach(function (fieldGroupId) {
        if (fieldGroupId === nameFieldGroup) {
          var fieldGroup = fieldGroupsTemplate[fieldGroupId];

          fieldGroup.hide = false;

          var dataFieldGroupFields = {};
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(fieldGroup.fields).forEach(function (field) {
            var dataField = _this.$store.getters.getTemplateData(field);
            if (dataField.model !== '') tabsOrderModel.push(dataField.tabOrder);else tabsOrderId.push(dataField.tabOrder);

            dataFieldGroupFields[field] = dataField;
          });

          var fieldGroupFields = dataFieldGroupFields;

          if (tabsOrderModel.length > 0) {
            positionFieldGroup = Math.min.apply(null, tabsOrderModel);
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(fieldGroup.fields).forEach(function (field) {
              var dataField = _this.$store.getters.getTemplateData(field);
              if (positionFieldGroup === fieldGroup.fields[field].tabOrder) {
                pageFieldGroup = dataField.fieldPage;
                groupModel = dataField.model;
              }
            });
          } else {
            positionFieldGroup = Math.min.apply(null, tabsOrderId);
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(fieldGroup.fields).forEach(function (field) {
              var dataField = _this.$store.getters.getTemplateData(field);
              if (positionFieldGroup === fieldGroup.fields[field].tabOrder) {
                pageFieldGroup = dataField.fieldPage;
                groupModel = dataField.model;
              }
            });
          }

          newGroup = {
            type: 'checkbox-group',
            fieldName: fieldGroupId,
            state: 'OK',
            originalValue: '',
            newValue: '',
            itemId: 23,
            model: groupModel,
            deleted: false,
            approved: true,
            editable: true,
            values: [],
            fieldAdd: fieldGroup.fieldAdd,
            name: fieldGroup.name,
            title: fieldGroup.title,
            desc: fieldGroup.desc,
            checkboxes: fieldGroupFields,
            checked: fieldGroup.checked,
            maxChecked: _this.$store.getters.fieldGroupMaxFields(fieldGroup.fieldId),
            tabOrder: positionFieldGroup,
            page: pageFieldGroup
          };
        }
      });
      var questionnaireFields = this.$store.state.questionnaires[this.$store.state.currentTemplateName]['data'];
      var tmpQuestionnaireFields = {};

      var contadorTabOrder = 0;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(questionnaireFields).forEach(function (fieldId, index) {
        if (questionnaireFields[fieldId].page === newGroup.page && contadorTabOrder === 0) {
          if (questionnaireFields[fieldId].tabOrder > newGroup.tabOrder && contadorTabOrder === 0) {
            tmpQuestionnaireFields[index + '-' + Math.random().toString(36).split('.')[1]] = newGroup;
            tmpQuestionnaireFields[index + '-' + Math.random().toString(36).split('.')[1]] = questionnaireFields[fieldId];
            contadorTabOrder++;
          } else if (contadorTabOrder === 0) {
            tmpQuestionnaireFields[index + '-' + Math.random().toString(36).split('.')[1]] = questionnaireFields[fieldId];
          }
        } else if (questionnaireFields[fieldId].page > newGroup.page && contadorTabOrder === 0) {
          tmpQuestionnaireFields[index + '-' + Math.random().toString(36).split('.')[1]] = newGroup;
          tmpQuestionnaireFields[index + '-' + Math.random().toString(36).split('.')[1]] = questionnaireFields[fieldId];
          contadorTabOrder++;
        } else {
          tmpQuestionnaireFields[index + '-' + Math.random().toString(36).split('.')[1]] = questionnaireFields[fieldId];
        }
      });
      if (contadorTabOrder === 0) tmpQuestionnaireFields[0 + '-' + Math.random().toString(36).split('.')[1]] = newGroup;
      this.$store.commit('setQuestionnaireFields', tmpQuestionnaireFields);
      this.$bus.emit('reloadQuestionnaire');
      this.$store.dispatch('saveTemplate');

      this.showModal = false;
    },
    verifyFieldGroupOnQuestionnaire: function verifyFieldGroupOnQuestionnaire(nameField) {
      var response = true;
      var questionnaireFields = this.$store.state.questionnaires[this.$store.state.currentTemplateName]['data'];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(questionnaireFields).forEach(function (fieldId) {
        if (questionnaireFields[fieldId].fieldName === nameField) response = false;
      });
      return response;
    },
    keyCheck: function keyCheck(evt) {
      if (evt.keyCode === 27) this.closeModal();
    },
    closeModal: function closeModal() {
      this.showModal = false;
    },
    editGroup: function editGroup(index) {
      this.$bus.emit('fieldGroupEditModal', index);
      this.showModal = false;
    },
    deleteGroup: function deleteGroup(groupId) {
      var _this2 = this;

      window.swal({
        title: 'Delete Field Group?',
        text: 'You are about to delete this field group. This action cannot be undone. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (deleted) {
        if (deleted) {
          // Save fields on Questionnaire

          _this2.saveGroupFieldsOnQuestionnaire(_this2.groups[groupId].fields);

          _this2.$store.commit('removeFieldGroup', groupId);
          _this2.$store.dispatch('saveTemplate');
          var groupsExist = _this2.groups;
          delete groupsExist[groupId];
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.groups, groupsExist);
          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.groups).length === 0) _this2.showModal = false;
          _this2.$bus.emit('reloadQuestionnaire');
        }
      });
    },
    saveGroupFieldsOnQuestionnaire: function saveGroupFieldsOnQuestionnaire(fields) {
      var _this3 = this;

      var questionnaire = this.$store.state.questionnaires[this.$store.state.currentTemplateName].data;
      var newQuestionnaireData = [];

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(questionnaire).forEach(function (fieldKey) {
        newQuestionnaireData.push(questionnaire[fieldKey]);
      });

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(fields).forEach(function (fieldKey) {
        var field = fields[fieldKey];

        var newField = {
          type: field.type,
          fieldName: field.id,
          state: 'OK',
          originalValue: typeof field.value !== 'undefined' && field.value.length ? field.value : '',
          newValue: '',
          itemId: 23,
          model: field.model,
          prefix: field.prefix !== undefined ? field.prefix : '',
          deleted: false,
          approved: true,
          editable: true,
          values: [],
          title: field.id,
          desc: '',
          tabOrder: field.tabOrder,
          page: field.fieldPage,
          render: true,
          tags: field.tags,
          maxCharacter: Number(field.maxCharacter)
        };

        if (field.forceShow !== undefined) {
          newField.forceShow = field.forceShow;
        }

        if (typeof field.translations !== 'undefined') {
          if (typeof field.translations[_this3.$store.state.currentLocale] !== 'undefined') {
            newField.title = field.translations[_this3.$store.state.currentLocale]['label'];
            newField.desc = field.translations[_this3.$store.state.currentLocale]['text'];
          }
        }

        if (newField.type === 'textarea') newField.type = 'text';else if (newField.type === 'radio') newField.type = 'checkbox';else if (newField.type === 'button') newField.type = 'checkbox';else if (newField.type === 'select') {
          newField.type = 'combobox';
          newField.values = field.choiceData;
        }

        if (field.model === '' || field.forceShow === true) newQuestionnaireData.push(newField);
      });

      var orderQuestionnaire = this.$store.getters.orderFieldsForPage(newQuestionnaireData);

      this.$store.commit('setQuestionnaireFields', orderQuestionnaire);
    }
  }
});

/***/ }),

/***/ "gfWk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(Object.keys(_vm.queue).length),expression:"Object.keys(queue).length"}],attrs:{"id":"notifications"}},[_c('transition-group',{attrs:{"appear":"","name":"fade"}},_vm._l((_vm.sortedQueue),function(notificationId){return _c('div',{key:notificationId,class:['notification', _vm.queue[notificationId]['type']]},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.queue[notificationId].title))]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v(_vm._s(_vm.queue[notificationId].body))]),_vm._v(" "),_c('i',{staticClass:"fas fa-close",on:{"click":function($event){return _vm.closeNotification(notificationId)}}})])}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gfot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gsLd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"descIcon",style:('margin-left:' + _vm.left + 'px;')},[_c('h6',[_vm._v(_vm._s(_vm.descriptionIcons))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hL3L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModal)?_c('div',{staticClass:"checkbox-group-modal"},[_c('div',{staticClass:"modalHeader",staticStyle:{"border-radius":"9px 9px 0px 0px !important"}},[_c('span',{staticClass:"title"},[_vm._v("Manage Checkbox Groups")]),_vm._v(" "),_c('span',{staticClass:"btn-close float-right",on:{"click":_vm.closeModal}},[_c('i',{staticClass:"fas fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"modalBody"},[_c('table',{staticClass:"table table-bordered table-striped table-hover table-sm"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.groups),function(group,index){return (group.checkboxes !== undefined)?_c('tr',{key:index},[_c('td',[_vm._v(_vm._s(group.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(group.title))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(group.desc))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(Object.keys(group.checkboxes).length))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-light",on:{"click":function($event){return _vm.editGroup(index)}}},[_vm._v("Edit")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.deleteGroup(index)}}},[_vm._v("Delete")])])]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"button-box float-right mb-3 mr-0"},[_c('button',{staticClass:"btn btn-secondary",on:{"click":_vm.closeModal}},[_vm._v("Close")])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Label")]),_vm._v(" "),_c('th',[_vm._v("Help Text")]),_vm._v(" "),_c('th',[_vm._v("# Fields")]),_vm._v(" "),_c('th',[_vm._v("Actions")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hRS4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[(_vm.isAddBarcode === true)?_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return [_c('b',[_vm._v(_vm._s(_vm.typeModal)+" Barcode")])]})],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",function(){return [_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('label',[_c('b',[_vm._v("Page")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pageBarcode),expression:"pageBarcode"}],staticClass:"form-control form-control-sm",attrs:{"type":"number"},domProps:{"value":(_vm.pageBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pageBarcode=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('label',[_c('b',[_vm._v("PDF Field Name")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pdfFieldBarcode),expression:"pdfFieldBarcode"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.pdfFieldBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pdfFieldBarcode=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('label',[_c('b',[_vm._v("Model")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.barcodeModel),expression:"barcodeModel"}],staticClass:"form-control form-control-sm",attrs:{"id":"barcodeModel","rows":"10"},domProps:{"value":(_vm.barcodeModel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.barcodeModel=$event.target.value}}})])])]})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.isAddBarcode = false}}},[_vm._v("\n              Cancel\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"disabled":_vm.pageBarcode !== '' && _vm.pdfFieldBarcode !== '' && _vm.barcodeModel !== '' ? false : true},on:{"click":_vm.addBarcodeTemplate}},[_vm._v("\n              Save\n            ")])]})],2)]):(_vm.isDeleteBarcode === true)?_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return [_c('b',[_vm._v("Delete Barcode")])]})],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",function(){return [_c('center',[_c('h3',[_vm._v("Are you sure delete this barcode.?")])])]})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.confirmDelete}},[_vm._v("\n              Delete\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.isDeleteBarcode = false}}},[_vm._v("\n              Cancel\n            ")])]})],2)]):_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return [_c('b',[_vm._v("Barcode Template")]),_vm._v(" "),_c('a',{staticClass:"btn btn-success text-white float-right",on:{"click":_vm.addBarcodeModal}},[_vm._v("Add")])]})],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",function(){return [(_vm.listBarcode !== undefined && _vm.listBarcode.length > 0)?_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Page")]),_vm._v(" "),_c('th',[_vm._v("PDF Field name")]),_vm._v(" "),_c('th',[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.listBarcode),function(barcode,index){return _c('tr',{key:index},[_c('td',[_vm._v("\n                    "+_vm._s(barcode.page)+"\n                  ")]),_vm._v(" "),_c('td',[_vm._v("\n                    "+_vm._s(barcode.pdfFieldBarcode)+"\n                  ")]),_vm._v(" "),_c('td',[_c('a',{staticStyle:{"color":"#007bff !important"},on:{"click":function($event){return _vm.getBarcode({
                      barcodeId: barcode._id,
                      index: index
                    })}}},[_vm._v("Edit")]),_vm._v(" |\n                    "),_c('a',{staticStyle:{"color":"#007bff !important"},on:{"click":function($event){return _vm.deleteBarcode({
                      barcodeId: barcode._id,
                      index: index
                    })}}},[_vm._v("Delete")])])])}),0)]):_c('h5',[_vm._v("\n              No barcode templates recorded.\n            ")])]})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_c('button',{staticClass:"btn btn-secondary modal-danger-button",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("\n              Close\n            ")])]})],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hkvO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i8L+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TreeView_vue__ = __webpack_require__("CXgT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05411afa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TreeView_vue__ = __webpack_require__("JOsq");
function injectStyle (ssrContext) {
  __webpack_require__("dRDt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05411afa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TreeView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05411afa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TreeView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iGM8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drag-index',

  data: function data() {
    return {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      drawing: false,
      currentMatches: []
    };
  },
  mounted: function mounted() {
    this.$bus.on('confirmTabOrderUpdate', this.confirmIndexUpdate);
    this.$bus.on('cancelTabOrderUpdate', this.cancelIndexUpdate);
    document.onmousedown = this.mouseDown; // TODO: Move this to draw mode toggle
  },


  computed: {
    drawStyle: function drawStyle() {
      if (!this.drawing) return 'top:' + (this.y - 55) + 'px;left:' + this.x + 'px;';else return 'display:block;top:' + (this.y - 55) + 'px;left:' + this.x + 'px;width:' + this.width + 'px;height:' + this.height + 'px;';
    }
  },

  methods: {
    confirmIndexUpdate: function confirmIndexUpdate() {
      for (var i = 0; i < this.currentMatches.length; i++) {
        var topIndex = this.$store.getters.topTabOrder();
        var element = this.currentMatches[i];
        this.$store.commit('setTabOrder', { id: element.fieldName, index: topIndex + 1 });
        this.$bus.emit('setTabOrder', { id: element.fieldName, index: topIndex + 1 });
      }
      var prevValue = this.$store.state.assigningIndexes;
      this.$store.commit('setAssigningIndexes', !prevValue);
      this.$store.commit('setAssigningIndexes', prevValue);
      this.$store.dispatch('saveTemplate');
      this.currentMatches = [];
    },
    cancelIndexUpdate: function cancelIndexUpdate() {
      this.currentMatches = [];
    },
    mouseCoords: function mouseCoords(e) {
      var posx = -1;
      var posy = -1;
      if (e.pageX || e.pageY) {
        posx = e.clientX;
        posy = e.clientY;
      }
      return { x: posx, y: posy };
    },
    mouseDown: function mouseDown(ev) {
      if (this.drawing || !this.$store.state.dragIndex) return; // TODO: Draw mode
      var coords = this.mouseCoords(ev);
      this.x = coords.x;
      this.y = coords.y;
      this.width = 0;
      this.height = 0;
      this.drawing = true;
      document.onmousemove = this.mouseUpdate;
      document.onmouseup = this.mouseUp;
    },
    mouseUpdate: function mouseUpdate(ev) {
      var coords = this.mouseCoords(ev);
      if (this.drawing) {
        this.width = coords.x - this.x;
        this.height = coords.y - this.y;
      } else {
        this.x = coords.x;
        this.y = coords.y;
      }
    },
    mouseUp: function mouseUp(ev) {
      this.drawing = false;
      document.onmouseup = null;
      document.onmousemove = null;
      this.calculateFields();
    },
    compare: function compare(a, b) {
      if (a.y1 < b.y1) return -1;
      if (a.y1 > b.y1) return 1;
      if (a.y1 === b.y1 && a.x1 < b.x1) return -1;
      if (a.y1 === b.y1 && a.x1 > b.x1) return 1;
      return 0;
    },
    calculateFields: function calculateFields() {
      var _this = this;

      var pos = {
        x: this.x,
        y: this.y
      };
      var region = {
        x1: pos.x,
        y1: pos.y,
        x2: pos.x + this.width,
        y2: pos.y + this.height
      };
      this.currentMatches = [];

      this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][this.$store.state.fileCurrentPage].forEach(function (element) {
        if (document.getElementById(element.id) !== null) {
          var elRect = document.getElementById(element.id).getBoundingClientRect();

          var elRegion = {
            fieldName: element.id,
            x1: Number(elRect.left + window.scrollX),
            y1: Number(elRect.top + window.scrollY),
            x2: Number(elRect.left + window.scrollX + elRect.width),
            y2: Number(elRect.top + window.scrollY + elRect.height)
          };

          if (elRegion.x1 >= region.x1 && elRegion.x1 <= region.x2 && elRegion.x2 <= region.x2) {
            if (elRegion.y1 >= region.y1 && elRegion.y2 <= region.y2 && elRegion.y2 <= region.y2) {
              _this.currentMatches.push(elRegion);
            }
          }
        }
      });
      if (!this.currentMatches.length) return;
      this.$store.commit('setDragIndex', false);
      this.currentMatches = this.currentMatches.sort(this.compare);
      this.$bus.emit('showDialog', {
        title: 'Assign Tab Indexes?',
        desc: 'You are about to update ' + this.currentMatches.length + ' fields. Do you want to continue?',
        confirmAction: 'confirmTabOrderUpdate',
        cancelAction: 'cancelTabOrderUpdate'
      });
    }
  }

  // beforeDestroy () {
  //   this.$bus.$off('confirmTabOrderUpdate')
  //   this.$bus.$off('cancelTabOrderUpdate')
  // }
});

/***/ }),

/***/ "iOjQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select__ = __webpack_require__("T1ft");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'create-button-model',

  data: function data() {
    return {
      list: [],
      isSpinner: true,

      timeSearch: null
    };
  },


  props: {
    data: {
      type: Object
    },

    model: {
      type: String
    }
  },

  components: {
    VSelect: __WEBPACK_IMPORTED_MODULE_0_vue_select__["default"]
  },

  watch: {
    model: function model() {
      this.isSpinner = true;
      this.didYouMeanModel();
    }
  },

  mounted: function mounted() {
    this.didYouMeanModel();
  },


  methods: {
    didYouMeanModel: function didYouMeanModel() {
      var _this = this;

      // if (this.model.length <= 6) return

      clearTimeout(this.timeSearch);

      this.timeSearch = setTimeout(function () {
        _this.isSpinner = false;

        _this.list = _this.$store.state.allOfficialModels && _this.$store.state.allOfficialModels !== null ? _this.$store.state.allOfficialModels.filter(function (a) {
          return a.model.indexOf(_this.model) !== -1;
        }).map(function (a) {
          return a.model;
        }).sort() : [];
      });
    },
    setOfficialModel: function setOfficialModel(model) {
      this.$store.dispatch('addOfficialModel', { model: model });
      this.$bus.emit('closeCreateButtonModels');
    }
  }
});

/***/ }),

/***/ "iPbD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Localizations_vue__ = __webpack_require__("jgFm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15c484f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Localizations_vue__ = __webpack_require__("tsKY");
function injectStyle (ssrContext) {
  __webpack_require__("1WlR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15c484f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Localizations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15c484f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Localizations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iT53":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ilIk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-bottom":"20px"}},[_c('h2',[_vm._v("A/B Group Watchers")]),_vm._v(" "),_c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-sm-4"},[_c('h3',[_vm._v("Tags")]),_vm._v(" "),_c('search-select',{attrs:{"multiple":true,"options":_vm.$store.state.abFieldsWatcher,"taggable":true,"label":'label'},on:{"input":_vm.setTagWatcher},model:{value:(_vm.watchers),callback:function ($$v) {_vm.watchers=$$v},expression:"watchers"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h3',[_vm._v("Value")]),_vm._v(" "),_c('span',{staticStyle:{"margin-right":"20px"}},[_c('label',{attrs:{"for":"onValueAB"}},[_c('input',{attrs:{"id":"onValueAB","type":"radio","name":"valueAbTag"},domProps:{"checked":_vm.valueOnAb},on:{"click":function($event){_vm.valueOnAb = true}}}),_vm._v(" Yes")])]),_vm._v(" "),_c('span',[_c('label',{attrs:{"for":"offValueAB"}},[_c('input',{attrs:{"id":"offValueAB","type":"radio","name":"valueAbTag"},domProps:{"checked":!_vm.valueOnAb},on:{"click":function($event){_vm.valueOnAb = false}}}),_vm._v(" No")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('h3',[_vm._v("Visible")]),_vm._v(" "),_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.valueVisibleAb},on:{"click":_vm.setVisibility}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j0cY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_editor_js__ = __webpack_require__("fBKx");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'form-textarea',

  data: function data() {
    return {
      editMode: false
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_editor_js__["a" /* default */]],

  props: ['id', 'width', 'height', 'left', 'top', 'fontSize', 'model'],

  methods: {
    noFocus: function noFocus() {
      this.$bus.emit('scrollToElement', this.id);

      this.hideAutocomplete();
    },
    inputClick: function inputClick(e) {
      e.preventDefault();
      this.$bus.emit('openFieldMenu', {
        id: this.id,
        pos: { x: e.pageX, y: e.pageY },
        tabOrder: this.tabOrder
      });
    },
    focusInput: function focusInput() {
      var highlighted = document.querySelectorAll('.id-highlight');
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(highlighted), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var highlight = _step.value;

          highlight.classList.remove('id-highlight');
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$bus.emit('scrollToElement', this.id);
    },
    showAutocompleteModel: function showAutocompleteModel(e) {
      if (typeof e !== 'number') this.setAutocompleteModel();
    }
  },

  computed: {
    style: function style() {
      var styleStr = 'position: absolute;';
      styleStr += 'width: ' + this.width + 'px;';
      styleStr += 'height: ' + this.height + 'px;';
      styleStr += 'left: ' + this.left + 'px;';
      styleStr += 'top: ' + this.top + 'px;';
      styleStr += 'font-size: ' + this.fontSize + 'px;';
      return styleStr;
    },
    tabOrderStyle: function tabOrderStyle() {
      var tabStyleStr = '';
      tabStyleStr += 'width: ' + 20 * this.$store.state.pageScale + 'px;';
      tabStyleStr += 'height: ' + 20 * this.$store.state.pageScale + 'px;';
      tabStyleStr += 'font-size: ' + 14 * this.$store.state.pageScale + 'px;';
      tabStyleStr += 'left: -' + 22 * this.$store.state.pageScale + 'px;';
      return tabStyleStr;
    }
  }
});

/***/ }),

/***/ "j9/o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j9NX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jGWI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalTooltip_vue__ = __webpack_require__("lb4I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50ee57a5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalTooltip_vue__ = __webpack_require__("L84T");
function injectStyle (ssrContext) {
  __webpack_require__("XUo2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50ee57a5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalTooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50ee57a5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalTooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jWvQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-checkbox",style:(_vm.style)},[(_vm.$store.state.assigningIndexes)?_c('span',{staticClass:"tab-index",style:(_vm.tabOrderStyle),on:{"click":_vm.inputClick}},[_vm._v("\n    "+_vm._s((_vm.$store.getters.templateTabOrder(_vm.id) > -1) ? _vm.$store.getters.templateTabOrder(_vm.id) : '?')+"\n  ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"checkbox-wide",staticStyle:{"position":"absolute","top":"0","left":"0","width":"100%","height":"100%"},style:(_vm.inputStyle),attrs:{"id":_vm.id,"data-model":_vm.model},on:{"click":_vm.toggleCheck,"contextmenu":_vm.inputClick}},[(_vm.value === 'on')?_c('img',{staticStyle:{"position":"absolute","top":"0","left":"0","width":"100%","height":"100%"},attrs:{"draggable":_vm.checked,"src":"static/checkmark.svg"}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jgFm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'localizations',

  props: {
    translations: {
      type: Object,
      default: {}
    },

    fieldId: {
      type: String,
      required: true
    },

    currentModel: {
      type: String,
      required: true
    }
  },

  mounted: function mounted() {
    this.localizations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.translations));
    var that = this;
    this.$on('updateLocalizations', function (localizationData) {
      that.localizations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(localizationData));
    });

    this.$bus.on('setFieldId', this.restoreInlineHelp);
  },
  data: function data() {
    return {
      localizations: {},
      editIndex: -1,
      editLanguage: '',
      editLabel: '',
      editText: '',
      data: '',
      fieldData: {},

      // https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
      languages: [{ code: 'en', name: 'English' }, { code: 'es', name: 'Spanish' }, { code: 'zh', name: 'Chinese' }, { code: 'cs', name: 'Czech' }, { code: 'da', name: 'Danish' }, { code: 'nl', name: 'Dutch' }, { code: 'eo', name: 'Esperanto' }, { code: 'fi', name: 'Finnish' }, { code: 'fr', name: 'French' }, { code: 'ka', name: 'Georgian' }, { code: 'de', name: 'German' }, { code: 'el', name: 'Greek' }, { code: 'it', name: 'Italian' }, { code: 'ja', name: 'Japanese' }, { code: 'ko', name: 'Korean' }, { code: 'ku', name: 'Kurdish' }, { code: 'fa', name: 'Perisian' }, { code: 'pl', name: 'Polish' }, { code: 'pt', name: 'Portugese' }, { code: 'ro', name: 'Romanian' }, { code: 'ru', name: 'Russian' }, { code: 'sv', name: 'Swedish' }, { code: 'tr', name: 'Turkish' }, { code: 'ur', name: 'Urdu' }]
    };
  },


  methods: {
    restoreInlineHelp: function restoreInlineHelp(fieldData) {
      this.fieldData = fieldData;
    },
    changeInlineHelp: function changeInlineHelp(inlineHelp) {
      var that = this;
      this.$store.commit('changeInlineHelp', {
        name: that.fieldData.name,
        label: inlineHelp.label,
        inlineHelp: inlineHelp.text
      });
    },
    restoreIndexEdit: function restoreIndexEdit() {
      var that = this;
      this.$bus.emit('getFieldId');
      var inlineHelp = this.$store.getters.getInlineHelpFromTemplate(this.fieldData.name);
      if (inlineHelp !== null) {
        this.editLabel = inlineHelp.label;
        this.editText = inlineHelp.text;
        this.changeInlineHelp({
          label: that.editLabel,
          text: that.editText
        });
      }
      this.saveInlineHelp();
    },
    restoreIndexStatic: function restoreIndexStatic(data) {
      var that = this;
      this.data = data;
      this.$bus.emit('getFieldId');
      var inlineHelp = this.$store.getters.getInlineHelpFromTemplate(this.fieldData.name);
      if (inlineHelp !== null) {
        this.data.label = inlineHelp.label;
        this.data.text = inlineHelp.text;
        this.changeInlineHelp({
          label: that.data.label,
          text: that.data.text
        });
      }
      this.saveInlineHelp();
    },
    labelToTextStatic: function labelToTextStatic(data) {
      var that = this;
      this.data = data;
      this.$bus.emit('getFieldId');
      this.data.text = data.label;
      this.changeInlineHelp({
        label: that.data.label,
        text: that.data.text
      });
      this.saveInlineHelp();
    },
    textToLabelStatic: function textToLabelStatic(data) {
      var that = this;
      this.data = data;
      this.$bus.emit('getFieldId');
      this.data.label = data.text;
      this.changeInlineHelp({
        label: that.data.label,
        text: that.data.text
      });
      this.saveInlineHelp();
    },
    labelToTextEdit: function labelToTextEdit() {
      var that = this;
      this.$bus.emit('getFieldId');
      this.editText = this.editLabel;
      this.changeInlineHelp({
        label: that.editLabel,
        text: that.editText
      });
      this.saveInlineHelp();
    },
    textToLabelEdit: function textToLabelEdit() {
      var that = this;
      this.$bus.emit('getFieldId');
      this.editLabel = this.editText;
      this.changeInlineHelp({
        label: that.editLabel,
        text: that.editText
      });
      this.saveInlineHelp();
    },
    saveInlineHelp: function saveInlineHelp() {
      this.saveEdit();
    },
    addRecord: function addRecord() {
      this.editLanguage = '';
      this.editLabel = '';
      this.editText = '';
      this.localizations.new = {};
      this.setEditIndex('new');
    },
    setEditIndex: function setEditIndex(language) {
      this.editIndex = language;
      this.editLanguage = language;
      this.editLabel = this.localizations[language]['label'];
      this.editText = this.localizations[language]['text'];
    },
    saveEdit: function saveEdit() {
      if (this.editLanguage !== 'new' && this.editLabel.length) {
        this.localizations[this.editLanguage] = {
          label: this.editLabel,
          text: this.editText
        };

        if (this.editLanguage !== this.editIndex) {
          delete this.localizations[this.editIndex];
        }
        this.localizations[this.editLanguage] = {
          label: this.editLabel,
          text: this.editText
        };
      }
      delete this.localizations.new;
      this.editIndex = '';
      this.editLanguage = '';
      this.editLabel = '';
      this.editText = '';
      this.$parent.$emit('updateTranslations', this.localizations);
    },
    modelImport: function modelImport() {
      var _this = this;

      var newLabel = '';
      var newText = '';

      var apiUrl = this.$store.state.apiUrl;
      this.axios.get(apiUrl + 'model/list').then(function (response) {
        _this.$store.commit('setModels', response.data);
      });

      var foundModel = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.getters.searchModels(this.currentModel)));
      if (typeof foundModel._id === 'undefined') return;
      if (typeof foundModel.label === 'undefined' || !foundModel.label.length) newLabel = this.fieldId;else newLabel = foundModel.label;

      var templateField = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.getters.currentTemplateField(this.fieldId)));
      newText = templateField.questionHelp;

      this.localizations['en'] = {
        label: this.editLabel,
        text: this.editText
      };
      if (this.editIndex !== 'en') delete this.localizations['en'];
      this.localizations['en'] = {
        label: newLabel,
        text: newText
      };
      this.$parent.$emit('updateTranslations', this.localizations);
    },
    cancelEdit: function cancelEdit() {
      this.editIndex = '';
      this.editLanguage = '';
      this.editLabel = '';
      this.editText = '';
    },
    deleteIndex: function deleteIndex(language) {
      delete this.localizations[language];
      this.$parent.$emit('updateTranslations', this.localizations);
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$off('updateLocalizations');
    this.$bus.$off('setFieldId');
  }
});

/***/ }),

/***/ "jv/H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kBYB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'checkbox-widget',

  props: {
    fieldIndex: {
      type: String,
      required: true
    },
    initialValue: {
      type: String,
      required: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    autoWidth: {
      type: Boolean,
      default: false
    },
    model: {
      type: String,
      default: ''
    },
    fieldName: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      value: ''
    };
  },
  mounted: function mounted() {
    this.value = this.initialValue === 'true';

    var that = this;
    this.$on('setValue', function (val) {
      that.value = val === 'true';
    });
  },


  methods: {
    onChange: function onChange(e) {
      this.value = e.target.checked;
      this.$parent.$emit('widgetChanged', { index: this.fieldIndex, value: this.value.toString() });
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$off('setValue');
  }
});

/***/ }),

/***/ "kIlm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultipleSelect_vue__ = __webpack_require__("TXPm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cad4720_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultipleSelect_vue__ = __webpack_require__("Byux");
function injectStyle (ssrContext) {
  __webpack_require__("5qvI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7cad4720"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultipleSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cad4720_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultipleSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kR17":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FieldGroupModal_vue__ = __webpack_require__("gceK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca7a447c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FieldGroupModal_vue__ = __webpack_require__("TPvD");
function injectStyle (ssrContext) {
  __webpack_require__("ZNkg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FieldGroupModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca7a447c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FieldGroupModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kZJi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_ListView__ = __webpack_require__("uJdz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_EditorQuestionnaireView__ = __webpack_require__("FZ2H");
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'layout',

  data: function data() {
    return {
      isFormList: true,
      formId: null
    };
  },


  components: {
    ListView: __WEBPACK_IMPORTED_MODULE_0__views_ListView__["a" /* default */],
    EditorQuestionnaireView: __WEBPACK_IMPORTED_MODULE_1__views_EditorQuestionnaireView__["a" /* default */]
  },

  mounted: function mounted() {
    var _this = this;

    window.vueBus = this.$bus;

    this.$store.dispatch('getAllOfficialModels');

    this.$bus.on('openFormApp', function (payload) {
      _this.isFormList = false;

      _this.$store.commit('setCurrentFormId', payload.formId);
    });

    this.$bus.on('showList', function (payload) {
      _this.isFormList = true;

      _this.$store.commit('setCurrentFormId', null);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('openFormApp');
    this.$bus.$off('showList');
  }
});

/***/ }),

/***/ "kdWv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.drawStyle),attrs:{"id":"dragIndex"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "koX5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestionnaireView_vue__ = __webpack_require__("ek/o");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77074d1d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestionnaireView_vue__ = __webpack_require__("vCCv");
function injectStyle (ssrContext) {
  __webpack_require__("uxpc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77074d1d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestionnaireView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77074d1d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestionnaireView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kyx1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{class:['annotation-el', 'annotation', 'annotation-image', _vm.selected ? 'selected': '', _vm.moveMode ? 'no-cursor': ''],style:(_vm.elStyle),attrs:{"draggable":"false","src":'/static/' + _vm.name + '.svg'},on:{"click":_vm.showControls}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l+ro":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-duplicate-template',

  data: function data() {
    return {
      showDialog: false,
      newTemplateName: '',
      sourceTemplateName: 'global'
    };
  },
  mounted: function mounted() {
    var that = this;
    this.sourceTemplateName = this.$store.state.currentTemplateName;
    this.$bus.on('showTemplateDuplicateDialog', function () {
      that.showDialog = true;
    });
  },


  methods: {
    duplicate: function duplicate() {
      var _this = this;

      var templateData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.state.templates[this.sourceTemplateName]));
      templateData['name'] = this.newTemplateName;
      if (typeof templateData['pages'] === 'undefined') templateData['pages'] = {};
      delete templateData['_id'];

      var apiUrl = this.$store.state.apiUrl;
      this.axios.post(apiUrl + 'template/add', templateData).then(function (response) {
        if (response.data.success) {
          templateData['_id'] = response.data.id;

          var questionnaireData = {};
          if (typeof _this.$store.state.questionnaires[_this.sourceTemplateName] !== 'undefined') {
            questionnaireData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.$store.state.questionnaires[_this.sourceTemplateName]));
            delete questionnaireData['_id'];
            questionnaireData['templateId'] = response.data.id;
          }

          _this.axios.post(apiUrl + 'questionnaire/add', questionnaireData).then(function (response) {
            if (response.data.success) {
              templateData['questionnaire_id'] = response.data.id;
              _this.$store.commit('addTemplate', {
                id: _this.newTemplateName,
                data: templateData
              });

              _this.$store.commit('addQuestionnaire', {
                index: templateData.name,
                data: {
                  '_id': response.data.id,
                  templateId: templateData['_id'],
                  data: {}
                }
              });

              _this.$bus.emit('addNotification', {
                title: 'Template Created',
                body: 'The template was created successfully',
                type: 'success'
              });

              // Reactivity Hacks
              _this.$store.commit('setShowAnnotationMenu', true);
              _this.$store.commit('setDrawAnnotations', true);
              _this.$store.commit('setShowBottomMenu', false);
              _this.$store.commit('setShowAnnotationMenu', false);
              _this.$store.commit('setDrawAnnotations', false);
              _this.$store.commit('setShowBottomMenu', true);

              _this.closeModal();
            } else {
              _this.$bus.emit('addNotification', {
                title: 'Template Questionnaire Error',
                body: 'There was an error creating the template questionnaire. Please review the data and try again',
                type: 'error'
              });
            }
          });
        } else {
          _this.$bus.emit('addNotification', {
            title: 'Template Error',
            body: 'There was an error creating the template. Please review the data and try again',
            type: 'error'
          });
        }
      });
      this.$store.commit('setLastSaved', Date.now());
    },
    closeModal: function closeModal() {
      this.showDialog = false;
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('showTemplateDuplicateDialog');
  }
});

/***/ }),

/***/ "lHBV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnnotationTextarea_vue__ = __webpack_require__("qjeR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e5b51ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnnotationTextarea_vue__ = __webpack_require__("LoMM");
function injectStyle (ssrContext) {
  __webpack_require__("QClc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e5b51ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnnotationTextarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e5b51ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnnotationTextarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lHOH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lK5h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_questionnaires_QuestionnaireTags__ = __webpack_require__("tODX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_questionnaires_ABGroupWatchers__ = __webpack_require__("GGn3");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'section-edit-modal',

  mounted: function mounted() {
    var that = this;
    this.$bus.on('sectionEditModal', function (fieldId) {
      that.fieldId = fieldId;
      var storeSection = that.$store.state.questionnaires[that.$store.state.currentTemplateName].data[fieldId];

      if (storeSection === undefined) {
        storeSection = fieldId;
        that.fieldData = fieldId;
      } else that.fieldData = that.$store.state.questionnaires[that.$store.state.currentTemplateName].data[that.fieldId];

      that.editName = storeSection.fieldName;
      that.editLabel = storeSection.originalValue;
      that.editHelp = storeSection.desc;
      that.fieldList = storeSection.fieldsAdded;
      that.prefix = storeSection.prefix;
      that.showModal = true;
    });

    document.addEventListener('keyup', this.keyCheck);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keyup', this.keyCheck, false);

    this.$bus.$off('sectionEditModal');
  },
  data: function data() {
    return {
      fieldId: '',
      showModal: false,
      editName: '',
      editLabel: '',
      editHelp: '',
      fieldList: {},
      fieldData: {},
      prefix: ''
    };
  },


  components: {
    QuestionnaireTags: __WEBPACK_IMPORTED_MODULE_2__components_questionnaires_QuestionnaireTags__["a" /* default */],
    AbGroupWatchers: __WEBPACK_IMPORTED_MODULE_3__components_questionnaires_ABGroupWatchers__["a" /* default */]
  },

  methods: {
    deleteField: function deleteField(index) {
      var list = [];
      list = this.fieldList;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(list).forEach(function (id) {
        if (id === index) delete list[id];
      });

      this.fieldList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.fieldList, list);
      this.$store.commit('setFieldsAddedToSection', {
        dataFields: this.fieldList,
        sectionIndex: this.fieldId
      });
      // this.$bus.emit('updateQuestionnaire')
      this.$bus.emit('reloadQuestionnaire');
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.fieldList).length === 0) this.showModal = false;
    },
    move: function move(moveIndex, up) {
      var tmpContainer = {};
      var targetIndex = -1;
      var keys = [];
      keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.fieldList);

      for (var index = 0; index < keys.length; index++) {
        tmpContainer[index] = keys[index];
        if (moveIndex === keys[index]) targetIndex = index;
      }

      if (targetIndex === -1) return;
      if (up && targetIndex - 1 < 0) return;
      if (!up && targetIndex + 1 > keys.length - 1) return;
      var newTarget = up ? targetIndex - 1 : targetIndex + 1;

      keys.splice(newTarget < 0 ? keys.length + newTarget : newTarget, 0, keys.splice(targetIndex, 1)[0]);

      var newData = {};
      for (var _index = 0; _index < keys.length; _index++) {
        var element = keys[_index];
        newData[element + '-' + Math.random().toString(36).split('.')[1]] = this.fieldList[element];
      }

      this.fieldList = newData;
      this.$store.commit('setFieldsAddedToSection', {
        dataFields: this.fieldList,
        sectionIndex: this.fieldId
      });
      // this.$bus.emit('updateQuestionnaire')
      this.$bus.emit('reloadQuestionnaire');
    },
    keyCheck: function keyCheck(evt) {
      if (evt.keyCode === 27) this.closeModal();
    },
    closeModal: function closeModal() {
      this.showModal = false;
    },
    saveEdit: function saveEdit() {
      this.$store.commit('editSection', {
        index: this.fieldId,
        name: this.editName,
        label: this.editLabel,
        help: this.editHelp,
        prefix: this.prefix
      });

      // this.$bus.emit('updateQuestionnaire')
      this.$bus.emit('reloadQuestionnaire');
      this.showModal = false;
    },
    editFormField: function editFormField(index) {
      this.$bus.emit('openFieldMenu', {
        id: index
      });
      this.showModal = false;
    }
  }
});

/***/ }),

/***/ "lMJV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog)?_c('div',{staticClass:"modal-dialog myMoDi",attrs:{"id":"modalDuplicateTemplate"}},[_c('div',{staticClass:"modalHeader"},[_c('span',{staticClass:"title"},[_vm._v("Duplicate Template")]),_vm._v(" "),_c('span',{staticClass:"btn-close float-right",on:{"click":_vm.closeModal}},[_c('i',{staticClass:"fas fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"modalBody"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"duplicateSource"}},[_vm._v("Source Template:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sourceTemplateName),expression:"sourceTemplateName"}],staticClass:"form-control form-control-sm",attrs:{"id":"duplicateSource"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sourceTemplateName=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.$store.state.templates),function(template,index){return _c('option',{key:index},[_vm._v("\n          "+_vm._s(template.name)+"\n        ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"newTemplateName"}},[_vm._v("New Template Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newTemplateName),expression:"newTemplateName"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","id":"newTemplateName"},domProps:{"value":(_vm.newTemplateName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newTemplateName=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":_vm.duplicate}},[_vm._v("Duplicate")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.closeModal}},[_vm._v("Cancel")])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lPIg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Spinner_vue__ = __webpack_require__("Qm8n");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'restore-inline-help-modal',

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_0__Spinner_vue__["a" /* default */]
  },

  data: function data() {
    return {
      showInlineHelp: false,
      loading: false,
      btnFinish: false,
      msgProcessing: '',
      indiceProcessing: false
    };
  },
  mounted: function mounted() {
    var that = this;
    this.$bus.on('showProcessInlineHelp', this.showOnlyProcessSpinner);
    this.$on('showRestoreInlineHelp', function () {
      that.showInlineHelp = true;
      that.loading = false;
      that.btnFinish = false;
      that.msgProcessing = '';
      that.indiceProcessing = false;
    });
  },

  methods: {
    showOnlyProcessSpinner: function showOnlyProcessSpinner(msg) {
      this.loading = msg.state;
      this.indiceProcessing = true;
      this.msgProcessing = msg.process;
      this.btnFinish = !this.loading;
    },
    closeModal: function closeModal() {
      this.showInlineHelp = false;
      this.loading = false;
      this.indiceProcessing = false;
    }
  },

  beforeDestroy: function beforeDestroy() {
    // this.$bus.$off('showProcessInlineHelp')
    // this.$off('showRestoreInlineHelp')
  }
});

/***/ }),

/***/ "lSQg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lV/8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Questionnaire")]),_vm._v(" "),_c('div',{staticClass:"row mt-4"},[_c('div',{class:_vm.isModel === true ? 'col-sm-2' : 'col-sm-4'},[_c('h3',[_vm._v("Visibility")]),_vm._v(" "),_c('label',{staticStyle:{"cursor":"pointer"},attrs:{"for":"visibleQuestionnaire"}},[_c('input',{staticStyle:{"cursor":"pointer"},attrs:{"id":"visibleQuestionnaire","type":"checkbox"},domProps:{"checked":_vm.isVisible},on:{"click":_vm.setVisiblity}}),_vm._v(" Visible\n      ")])]),_vm._v(" "),(_vm.isModel === true)?_c('div',{staticClass:"col-sm-3"},[_c('h3',[_vm._v("Model Field")]),_vm._v(" "),_c('label',{staticStyle:{"cursor":"pointer"},attrs:{"for":"forceModel"}},[_c('input',{staticStyle:{"cursor":"pointer"},attrs:{"id":"forceModel","type":"checkbox","title":_vm.messageForceModel},domProps:{"checked":_vm.isForceShow},on:{"click":_vm.setForceModel}}),_vm._v(" Force show field with autofill model.\n      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('h3',[_vm._v("Tags")]),_vm._v(" "),_c('search-select',{attrs:{"taggable":true,"multiple":true,"options":_vm.tagsForm},on:{"input":_vm.setTags},model:{value:(_vm.tags),callback:function ($$v) {_vm.tags=$$v},expression:"tags"}})],1)]),_vm._v(" "),_c('br'),_vm._v(" "),(
      _vm.fieldGroupId !== undefined ||
      (
        _vm.fieldData &&
        _vm.fieldData.type === 'checkbox'
      ) ||
      (
        _vm.fieldData &&
        _vm.fieldData.type === 'select'
      )
    )?_c('div',{staticClass:"row",staticStyle:{"padding":"14px"}},[_c('div',{staticClass:"col-12 pl-0 pr-0 mb-2"},[_c('div',[_c('h3',{staticClass:"float-left mb-0"},[_vm._v("Actions")]),_vm._v(" "),(_vm.isAddAction === true)?_c('button',{staticClass:"btn btn-success float-right mt-n1",staticStyle:{"margin-top":"10px"},on:{"click":_vm.addActionTag}},[_vm._v("Add\n        ")]):_vm._e()])]),_vm._v(" "),_c('table',{staticClass:"table table-sm table-bordered table-striped"},[_c('thead',[_c('tr',[(_vm.fieldGroupId || (_vm.fieldData && _vm.fieldData.type === 'checkbox'))?_c('th',[_vm._v("Value")]):_vm._e(),_vm._v(" "),_c('th',[_vm._v("Action")]),_vm._v(" "),(_vm.fieldGroupId !== undefined)?_c('th',[_vm._v("Checkbox")]):_vm._e(),_vm._v(" "),(_vm.fieldData && _vm.fieldData.type === 'select')?_c('th',[_vm._v("Option")]):_vm._e(),_vm._v(" "),_c('th',[_vm._v("Tags")])])]),_vm._v(" "),_vm._l((_vm.actionTags),function(action,index){return _c('tbody',{key:index},[_c('tr',[(_vm.fieldGroupId || _vm.fieldData.type === 'checkbox')?_c('td',[_c('div',{staticClass:"dropdown"},[_c('button',{staticClass:"dropdown-toggle",class:action.value === 'off' ? 'btn btn-danger' : 'btn btn-success',attrs:{"type":"button","id":"dropdownMenuButton","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n                "+_vm._s(action.value)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('ul',{staticStyle:{"list-style":"none","top":"100px"}},[_c('li',{staticStyle:{"margin-left":"-40px"}},[_c('button',{staticClass:"btn btn-primary form-control form-control-sm",on:{"click":function($event){return _vm.controlAction({
                      index: index,
                      type: 'value',
                      value: 'off'
                    })}}},[_vm._v("off")])]),_vm._v(" "),_c('li',{staticStyle:{"margin-left":"-40px"}},[_c('button',{staticClass:"btn btn-primary form-control form-control-sm",on:{"click":function($event){return _vm.controlAction({
                      index: index,
                      type: 'value',
                      value: 'on'
                    })}}},[_vm._v("on")])])])])])]):_vm._e(),_vm._v(" "),_c('td',[_c('div',{staticClass:"dropdown"},[_c('button',{staticClass:"btn btn-secondary dropdown-toggle",attrs:{"type":"button","id":"dropdownMenuButton","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n                "+_vm._s(action.action)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('ul',{staticStyle:{"list-style":"none","top":"100px"}},[_c('li',{staticStyle:{"margin-left":"-40px"}},[_c('button',{staticClass:"btn btn-primary form-control",on:{"click":function($event){return _vm.controlAction({
                      index: index,
                      type: 'action',
                      value: 'show'
                    })}}},[_vm._v("Show")])]),_vm._v(" "),_c('li',{staticStyle:{"margin-left":"-40px"}},[_c('button',{staticClass:"btn btn-primary form-control",on:{"click":function($event){return _vm.controlAction({
                      index: index,
                      type: 'action',
                      value: 'hide'
                    })}}},[_vm._v("Hide")])])])])])]),_vm._v(" "),(_vm.fieldGroupId || _vm.fieldData.type === 'select')?_c('td',{staticStyle:{"min-width":"400px"}},[(_vm.fieldGroupId)?_c('search-select',{attrs:{"options":_vm.checkboxes,"label":"label"},on:{"input":_vm.setTagsDb},model:{value:(action.checkbox),callback:function ($$v) {_vm.$set(action, "checkbox", $$v)},expression:"action.checkbox"}}):_c('search-select',{attrs:{"options":_vm.selectOptions,"label":"label"},on:{"input":_vm.setTagsDb},model:{value:(action.select),callback:function ($$v) {_vm.$set(action, "select", $$v)},expression:"action.select"}})],1):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"min-width":"300px"}},[_c('span',[_c('search-select',{attrs:{"multiple":true,"options":_vm.tagsForm},on:{"input":function($event){return _vm.setTagsToAction({
                  tags: action.tags,
                  index: index
                })}},model:{value:(action.tags),callback:function ($$v) {_vm.$set(action, "tags", $$v)},expression:"action.tags"}})],1)])])])})],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lb4I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'global-tooltip',

  data: function data() {
    return {
      visible: false,
      tooltipData: {}
    };
  },
  mounted: function mounted() {
    var that = this;
    this.$bus.on('showTooltip', function (fieldId) {
      var fieldIndex = that.$store.getters.templateFieldIndex(that.$store.state.currentTemplateName, fieldId, that.$store.state.fileCurrentPage);

      if (fieldIndex === undefined) return;
      that.tooltipData = that.$store.getters.fieldTooltip(that.$store.state.fileCurrentPage, fieldIndex);
      that.visible = true;
    });

    this.$bus.on('hideTooltip', function () {
      that.visible = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('showTooltip');
    this.$bus.$off('hideTooltip');
  }
});

/***/ }),

/***/ "lst1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDuplicateTemplate_vue__ = __webpack_require__("l+ro");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61bf061a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalDuplicateTemplate_vue__ = __webpack_require__("lMJV");
function injectStyle (ssrContext) {
  __webpack_require__("j9/o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61bf061a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDuplicateTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61bf061a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalDuplicateTemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mQ5X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalAddTemplate_vue__ = __webpack_require__("HahR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3d41dbe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalAddTemplate_vue__ = __webpack_require__("Qi2M");
function injectStyle (ssrContext) {
  __webpack_require__("+37F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f3d41dbe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalAddTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3d41dbe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalAddTemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mV8n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nQFH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget widget-section",attrs:{"data-field":_vm.fieldName,"id":_vm.fieldName}},[_c('p',{class:['label', _vm.subSection ? 'sub-label' : '' ]},[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),_c('p',{staticClass:"sub-label"},[_vm._v(_vm._s(_vm.help))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nQmy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FunctionToolbox_vue__ = __webpack_require__("fC0H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e70875f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FunctionToolbox_vue__ = __webpack_require__("yymv");
function injectStyle (ssrContext) {
  __webpack_require__("6WJd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e70875f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FunctionToolbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e70875f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FunctionToolbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oJS0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-text",style:(_vm.style)},[(_vm.$store.state.assigningIndexes)?_c('span',{staticClass:"tab-index",style:(_vm.tabOrderStyle),on:{"click":_vm.inputClick}},[_vm._v("\n    "+_vm._s((_vm.$store.getters.templateTabOrder(_vm.id) > -1) ? _vm.$store.getters.templateTabOrder(_vm.id) : '?')+"\n  ")]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.getMask),expression:"getMask"},{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],class:_vm.fieldClass,style:(_vm.inputStyle),attrs:{"type":"text","id":_vm.id,"tabindex":_vm.$store.getters.templateTabOrder(_vm.id),"data-model":_vm.model},domProps:{"value":(_vm.value)},on:{"focus":_vm.focusInput,"blur":_vm.noFocus,"keyup":_vm.scaleText,"contextmenu":_vm.inputClick,"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}}),_vm._v(" "),_c('div',{style:(_vm.hiddenDiv),attrs:{"id":'hidden-' +_vm.id}},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "otfv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p/r/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"},on:{"contextmenu":_vm.rightClick}},[_c('router-view',{class:'router-view'})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p3tc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pcBj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FieldGroupWidget_vue__ = __webpack_require__("dlTg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40748a24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FieldGroupWidget_vue__ = __webpack_require__("xuVG");
function injectStyle (ssrContext) {
  __webpack_require__("US1G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40748a24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FieldGroupWidget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40748a24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FieldGroupWidget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qAPS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginView_vue__ = __webpack_require__("AGU5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a352de9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginView_vue__ = __webpack_require__("/i/V");
function injectStyle (ssrContext) {
  __webpack_require__("uEci")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a352de9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a352de9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qjeR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'annotation-textarea',

  mounted: function mounted() {
    var that = this;

    this.setup();

    this.$bus.$on('setFontSize', function (sizeData) {
      if (sizeData.index !== that.index) return;
      that.fontSize = sizeData.size;
      that.$store.commit('setAnnotationDataKey', {
        index: that.index,
        key: 'fontSize',
        value: that.fontSize
      });
      // that.$store.dispatch('saveAll')
    });

    this.$bus.$on('setReadOnly', function (annotationData) {
      if (annotationData.index === that.index) {
        if (!that.readOnly && annotationData.value) {
          that.$store.commit('setAnnotationData', {
            index: that.index,
            data: {
              fontSize: that.fontSize,
              text: that.value
            }
          });
          // that.$store.dispatch('saveAll')
        }
        that.readOnly = annotationData.value;
      }
    });
  },
  data: function data() {
    return {
      fontSize: 10,
      highlight: false,
      readOnly: true,
      value: ''
    };
  },


  props: ['index', 'width', 'height', 'rotation', 'storeData'],

  methods: {
    setup: function setup() {
      console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.storeData));
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.storeData).length) {
        this.value = this.storeData['text'];
        this.fontSize = this.storeData['fontSize'];
        console.log('Set fontSize', this.fontSize);
      }
    },
    showControls: function showControls() {
      var elPos = this.$el.getBoundingClientRect();
      this.$bus.emit('showAnnotationControls', {
        index: this.index,
        type: 'textarea',
        x: elPos.left,
        y: elPos.top + elPos.height
      });
    }
  },

  computed: {
    rotateStyle: function rotateStyle() {
      return 'transform: rotate(' + this.rotation + 'deg);';
    },

    getStyle: function getStyle() {
      var style = 'width:' + this.width + 'px;height:' + this.height + 'px;font-size:' + this.fontSize + 'px;';
      if (this.highlight) style += 'border: 2px solid black;';
      return style;
    }
  }
});

/***/ }),

/***/ "qlWQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionEditModal_vue__ = __webpack_require__("lK5h");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_380855aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionEditModal_vue__ = __webpack_require__("xkbj");
function injectStyle (ssrContext) {
  __webpack_require__("fFDX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-380855aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionEditModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_380855aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionEditModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qxRI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DragIndex_vue__ = __webpack_require__("iGM8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41a46836_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DragIndex_vue__ = __webpack_require__("kdWv");
function injectStyle (ssrContext) {
  __webpack_require__("A+FN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41a46836"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DragIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41a46836_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DragIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rxau":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditorView_vue__ = __webpack_require__("IdK9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5be5898e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditorView_vue__ = __webpack_require__("EFdF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditorView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5be5898e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditorView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sQFY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_questionnaires_widgets_ComboWidget__ = __webpack_require__("3H5q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_questionnaires_widgets_TextWidget__ = __webpack_require__("wjq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_questionnaires_widgets_CheckboxWidget__ = __webpack_require__("Jgco");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'group-edit-modal',

  components: {
    ComboWidget: __WEBPACK_IMPORTED_MODULE_0__components_questionnaires_widgets_ComboWidget__["a" /* default */],
    TextWidget: __WEBPACK_IMPORTED_MODULE_1__components_questionnaires_widgets_TextWidget__["a" /* default */],
    CheckboxWidget: __WEBPACK_IMPORTED_MODULE_2__components_questionnaires_widgets_CheckboxWidget__["a" /* default */]
  },

  mounted: function mounted() {
    var that = this;
    this.$on('showModal', function (data) {
      that.index = data.index;
      that.fields = data.fields;
      that.showModal = true;
      that.msgWidget = data.msg;
      that.dataWidget = data.data;
      that.getMatchedModels();
    });

    this.$on('widgetChanged', function (data) {
      this.fields[data.index]['newValue'] = data.value;
    });
  },
  data: function data() {
    return {
      showModal: false,
      index: null,
      fields: {},
      msgWidget: '',
      dataWidget: {},
      matchedModels: {}
    };
  },


  methods: {
    getMatchedModels: function getMatchedModels() {
      var fields = this.$store.getters.getMatchedWidgetFields(this.dataWidget.widget_id);
      this.matchedModels = fields;
    },
    closeModal: function closeModal() {
      this.showModal = false;
    },
    saveEdit: function saveEdit() {
      this.$store.commit('saveMsgWidget', {
        msg: this.msgWidget,
        model: this.dataWidget.model
      });

      this.$bus.emit('msgWidget', {
        message: this.msgWidget,
        model: this.dataWidget.model
      });
      this.$bus.emit('updateQuestionnaire');
      this.closeModal();
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$off('showModal');
    this.$off('widgetChanged');
  }
});

/***/ }),

/***/ "sSL2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sVsC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateButtonModel_vue__ = __webpack_require__("iOjQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6949c038_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateButtonModel_vue__ = __webpack_require__("Gz7E");
function injectStyle (ssrContext) {
  __webpack_require__("MSKw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateButtonModel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6949c038_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateButtonModel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "scEy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Spinner_vue__ = __webpack_require__("Qm8n");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inline-help-modal',

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_0__Spinner_vue__["a" /* default */]
  },

  data: function data() {
    return {
      showInlineHelp: false,
      optionsSeparator: ['.', ',', '-'],
      text: '',
      label: '',
      toLabel: '4',
      inlineHelp: '',
      separatorSelected: '.',
      questionnaireId: '',
      fieldName: '',
      allInlineHelp: [],
      loading: false,
      btnParse: false,
      btnFinish: false,
      msgProcessing: 'Processing...',
      indiceProcessing: false,
      inResult: false,
      checked: true,
      checkBoxExcludeModel: false
    };
  },
  mounted: function mounted() {
    var that = this;
    this.$bus.on('sendInlineHelp', this.originDesc);
    this.$on('showInlineHelp', function () {
      that.showInlineHelp = true;
      that.text = '';
      that.label = '';
      that.toLabel = '4';
      that.inlineHelp = '';
      that.questionnaireId = '';
      that.fieldName = '';
      that.allInlineHelp = [];
      that.loading = false;
      that.btnParse = false;
      that.btnFinish = false;
      that.msgProcessing = 'Processing...';
      that.indiceProcessing = false;
      that.inResult = false;
      that.checked = true;
      that.checkBoxExcludeModel = false;
    });
  },

  computed: {
    parseText: function parseText() {
      var dataText = {
        text: this.text,
        toLabel: this.toLabel,
        separator: this.separatorSelected
      };
      var objLabel = this.$store.getters.getInlineHelp(dataText);
      if (objLabel === undefined || objLabel === null) return;
      this.label = objLabel.label;
      this.inlineHelp = objLabel.inlineHelp;
      this.btnParse = true;
    }
  },
  methods: {
    originDesc: function originDesc(fieldData) {
      this.parseInlineHelp = true;
      if (fieldData.one) {
        this.inResult = true;
        this.questionnaireId = fieldData.questionnaireId;
        this.fieldName = fieldData.name;
        this.text = fieldData.text;
        this.allInlineHelp = [];
      } else {
        this.allInlineHelp = fieldData;
        this.btnParse = true;
        this.label = 'anything';
        this.checkBoxExcludeModel = true;
      }
    },
    parseData: function parseData() {
      var that = this;
      this.btnParse = false;
      if (this.allInlineHelp.length === 0) {
        this.$store.commit('changeInlineHelp', {
          questionnaireId: this.questionnaireId,
          name: this.fieldName,
          label: this.label,
          inlineHelp: this.inlineHelp
        });
        this.$bus.emit('reloadQuestionnaire');
        this.$store.dispatch('saveTemplatePages');
        this.closeModal();
      } else {
        that.indiceProcessing = true;
        that.loading = true;
        setTimeout(function () {
          that.generateInliniHelp();
          that.loading = false;
          that.btnFinish = true;
          that.msgProcessing = 'Done';
          that.label = '';
          that.inlineHelp = '';
        }, 500);
      }
    },
    generateInliniHelp: function generateInliniHelp() {
      var that = this;
      if (this.checked) {
        var idFieldsInlineHelp = [];
        this.allInlineHelp.forEach(function (field) {
          if (field.model === '') {
            idFieldsInlineHelp.push(field);
          }
        });
        this.allInlineHelp = idFieldsInlineHelp;
      }
      this.allInlineHelp.forEach(function (field) {
        var dataText = {
          text: field.desc,
          toLabel: that.toLabel,
          separator: that.separatorSelected
        };
        var objLabel = that.$store.getters.getInlineHelp(dataText);
        if (objLabel === undefined) return;
        that.label = objLabel.label;
        that.inlineHelp = objLabel.inlineHelp;
        that.$store.commit('changeInlineHelp', {
          questionnaireId: field.questionnaireId,
          name: field.name,
          label: that.label,
          inlineHelp: that.inlineHelp
        });
      });
      // this.$store.commit('saveInlineHelpDb')
      // this.$bus.emit('setQuestionnairesFields')
      this.$bus.emit('reloadQuestionnaire');
      this.$store.dispatch('saveTemplatePages');
    },
    closeModal: function closeModal() {
      this.showInlineHelp = false;
      this.loading = false;
      this.indiceProcessing = false;
      this.btnParse = true;
    }
  },

  beforeDestroy: function beforeDestroy() {
    // this.$bus.$off('sendInlineHelp')
    // this.$off('showInlineHelp')
  }
});

/***/ }),

/***/ "sfA9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnnotationImage_vue__ = __webpack_require__("ImuZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_439939a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnnotationImage_vue__ = __webpack_require__("kyx1");
function injectStyle (ssrContext) {
  __webpack_require__("ZdWi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-439939a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnnotationImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_439939a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnnotationImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sgTc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_editor_js__ = __webpack_require__("fBKx");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'form-select',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_editor_js__["a" /* default */]],

  props: ['id', 'width', 'height', 'left', 'top', 'options', 'model'],

  methods: {
    inputClick: function inputClick(e) {
      e.preventDefault();
      this.$bus.emit('openFieldMenu', {
        id: this.id,
        pos: { x: e.pageX, y: e.pageY },
        tabOrder: this.tabOrder
      });
    },
    focusInput: function focusInput() {
      this.$bus.emit('scrollToElement', this.id);
    }
  },

  computed: {
    style: function style() {
      var styleStr = 'position: absolute;';
      styleStr += 'width: ' + this.width + 'px;';
      styleStr += 'height: ' + this.height + 'px;';
      styleStr += 'left: ' + this.left + 'px;';
      styleStr += 'top: ' + this.top + 'px;';
      styleStr += 'font-size: ' + 12 * this.$store.state.pageScale + 'px;';
      return styleStr;
    },
    tabOrderStyle: function tabOrderStyle() {
      var tabStyleStr = '';
      tabStyleStr += 'width: ' + 20 * this.$store.state.pageScale + 'px;';
      tabStyleStr += 'height: ' + 20 * this.$store.state.pageScale + 'px;';
      tabStyleStr += 'font-size: ' + 14 * this.$store.state.pageScale + 'px;';
      tabStyleStr += 'left: -' + 25 * this.$store.state.pageScale + 'px;';
      return tabStyleStr;
    },
    inputStyle: function inputStyle() {
      return this.model !== '' && this.listOfficialModels.length > 0 && this.listOfficialModels.map(function (a) {
        return a.model;
      }).indexOf(this.model) === -1 ? 'font-size:' + this.displayFontSize + 'px;position:absolute;top:0;left:0;outline:red solid 1px;' : 'font-size:' + this.displayFontSize + 'px;position:absolute;top:0;left:0;';
    }
  }
});

/***/ }),

/***/ "stxC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":""}},[_c('restored-fields-modal'),_vm._v(" "),_c('nav',{staticClass:"row"},[_c('div',{staticClass:"bar-icons"},[_c('div',{staticClass:"iconsall"},[_c('div',{staticClass:"icons-individual",on:{"mouseout":function($event){_vm.tooltipReturnList = false},"mouseover":function($event){_vm.tooltipReturnList = true}}},[_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconReturnList","tabindex":"-1"},on:{"click":_vm.goToList}},[_c('i',{staticClass:"fas fa-list"})]),_vm._v(" "),(_vm.tooltipReturnList == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionReturnList,"left":_vm.leftIconReturnList}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"icons-individual dropdown",attrs:{"id":"iconShowHide"},on:{"mouseout":function($event){_vm.tooltipShowHide = false},"mouseover":function($event){_vm.tooltipShowHide = true}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuShowHide"}},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":_vm.toggleAssignIndexes}},[(_vm.$store.state.assigningIndexes)?_c('span',[_c('i',{staticClass:"fas fa-eye-slash"}),_vm._v(" Hide Tab Indexes ")]):_c('span',[_c('i',{staticClass:"fas fa-eye"}),_vm._v(" Show Tab Indexes ")])]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":_vm.toggleShowFields}},[(_vm.$store.state.showFields)?_c('span',[_c('i',{staticClass:"far fa-eye-slash"}),_vm._v(" Hide Inputs")]):_c('span',[_c('i',{staticClass:"fas fa-eye"}),_vm._v(" Show Inputs")])])])]),_vm._v(" "),(_vm.tooltipShowHide == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionShowHide,"left":_vm.leftIconShowHide}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"icons-individual",on:{"mouseout":function($event){_vm.tooltipDragIndex = false},"mouseover":function($event){_vm.tooltipDragIndex = true}}},[(_vm.$store.state.dragIndex)?_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconDisableDragIndex","disabled":_vm.$store.state.currentTemplateName === 'global',"tabindex":"-1"},on:{"click":_vm.toggleDragIndex}},[_c('i',{staticClass:"fas fa-toggle-on"})]):_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconEnableDragIndex","disabled":_vm.$store.state.currentTemplateName === 'global',"tabindex":"-1"},on:{"click":_vm.toggleDragIndex}},[_c('i',{staticClass:"fas fa-toggle-off"})])]),_vm._v(" "),(_vm.tooltipDragIndex == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionDragIndex,"left":_vm.leftIconDragIndex}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"icons-individual"},[_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconResetTabIndexes","disabled":_vm.$store.state.currentTemplateName === 'global',"tabindex":"-1"},on:{"mouseout":function($event){_vm.tooltipResetTabIndexes = false},"mouseover":function($event){_vm.tooltipResetTabIndexes = true},"click":_vm.resetIndexes}},[_c('i',{staticClass:"fas fa-undo"})]),_vm._v(" "),(_vm.tooltipResetTabIndexes == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionResetTabIndexes,"left":_vm.leftIconResetTabIndexes}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"icons-individual"},[_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconCreateField","disabled":_vm.$store.state.currentTemplateName === 'global',"tabindex":"-1"},on:{"mouseout":function($event){_vm.tooltipCreateField = false},"mouseover":function($event){_vm.tooltipCreateField = true},"click":_vm.addField}},[_c('i',{staticClass:"fas fa-plus"})]),_vm._v(" "),(_vm.tooltipCreateField == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionCreateField,"left":_vm.leftIconCreateField}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"icons-individual"},[_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconSaveTemplate","disabled":_vm.$store.state.currentTemplateName === 'global',"tabindex":"-1"},on:{"mouseout":function($event){_vm.tooltipSaveTemplate = false},"mouseover":function($event){_vm.tooltipSaveTemplate = true},"click":_vm.saveData}},[_c('i',{staticClass:"far fa-save"})]),_vm._v(" "),(_vm.tooltipSaveTemplate == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionSaveTemplate,"left":_vm.leftIconSaveTemplate}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"icons-individual",on:{"mouseout":function($event){_vm.tooltipMultipleSelect = false},"mouseover":function($event){_vm.tooltipMultipleSelect = true}}},[(_vm.$store.state.multipleSelect)?_c('button',{staticClass:"btn btn-default mybutton backgroundIcon",attrs:{"id":"iconDisableMS","disabled":_vm.$store.state.currentTemplateName === 'global',"tabindex":"-1"},on:{"click":_vm.multipleSelect}},[_c('i',{staticClass:"fas fa-list-ol"})]):_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconEnableMS","disabled":_vm.$store.state.currentTemplateName === 'global',"tabindex":"-1"},on:{"click":_vm.multipleSelect}},[_c('i',{staticClass:"fas fa-list-ol"})])]),_vm._v(" "),(_vm.tooltipMultipleSelect == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionMultipleSelect,"left":_vm.leftIconMultipleSelect}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"icons-individual"},[_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconImportModels","disabled":_vm.$store.state.currentTemplateName === 'global',"tabindex":"-1"},on:{"mouseout":function($event){_vm.tooltipImportModels = false},"mouseover":function($event){_vm.tooltipImportModels = true},"click":_vm.importModels}},[_c('i',{staticClass:"fas fa-file-import"})]),_vm._v(" "),(_vm.tooltipImportModels == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionImportModels,"left":_vm.leftIconImportModels}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"icons-individual"},[_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconImportAllTranslations","disabled":_vm.$store.state.currentTemplateName === 'global',"tabindex":"-1"},on:{"mouseout":function($event){_vm.tooltipImportAllTranslations = false},"mouseover":function($event){_vm.tooltipImportAllTranslations = true},"click":_vm.importAllTranslationModel}},[_c('i',{staticClass:"fas fa-language"})]),_vm._v(" "),(_vm.tooltipImportAllTranslations == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionImportAllTranslations,"left":_vm.leftIconImportAllTranslations}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"icons-individual"},[_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconRestoreFields","disabled":_vm.$store.state.currentTemplateName === 'global',"tabindex":"-1"},on:{"mouseout":function($event){_vm.tooltipRestoreFields = false},"mouseover":function($event){_vm.tooltipRestoreFields = true},"click":_vm.restoreFieldsDataJson}},[_c('i',{staticClass:"fas fa-window-restore"})]),_vm._v(" "),(_vm.tooltipRestoreFields == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionRestoreFields,"left":_vm.leftIconRestoreFields}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"icons-individual dropdown",attrs:{"id":"iconHighlighter"},on:{"mouseout":function($event){_vm.tooltipHighlighter = false},"mouseover":function($event){_vm.tooltipHighlighter = true}}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuHighLight"}},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":_vm.toggleModelDisplay}},[(_vm.modelDisplay)?_c('span',[_c('i',{staticClass:"fas fa-highlighter colorIcon01"}),_vm._v(" Disable Model")]):_c('span',[_c('i',{staticClass:"fas fa-highlighter colorIcon01"}),_vm._v(" Enable Model")])]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":_vm.toggleIdDisplay}},[(_vm.idDisplay)?_c('span',[_c('i',{staticClass:"fas fa-highlighter colorIcon02"}),_vm._v(" Disable Id Field ")]):_c('span',[_c('i',{staticClass:"fas fa-highlighter colorIcon02"}),_vm._v(" Enable Id Field ")])])])]),_vm._v(" "),(_vm.tooltipHighlighter == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionHighlighter,"left":_vm.leftIconHighlighter}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"icons-individual"},[_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconBarcodeTemplate","disabled":_vm.$store.state.currentTemplateName === 'global',"tabindex":"-1"},on:{"mouseout":function($event){_vm.tooltipBarcodeTemplate = false},"mouseover":function($event){_vm.tooltipBarcodeTemplate = true},"click":function($event){_vm.isBarcode = true}}},[_c('i',{staticClass:"fas fa-barcode"})]),_vm._v(" "),(_vm.tooltipBarcodeTemplate == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionBarcodeTemplate,"left":_vm.leftIconBarcodeTemplate}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"icons-individual"},[_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconMergeData","disabled":_vm.$store.state.currentTemplateName === 'global',"tabindex":"-1"},on:{"mouseout":function($event){_vm.tooltipMergeData = false},"mouseover":function($event){_vm.tooltipMergeData = true},"click":_vm.mergeFieldsData}},[_c('i',{staticClass:"fas fa-object-ungroup"})]),_vm._v(" "),(_vm.tooltipMergeData == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionMergeData,"left":_vm.leftIconMergeData}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"float-right",attrs:{"id":"formZoom"},on:{"mouseout":function($event){_vm.tooltipZoom = false},"mouseover":function($event){_vm.tooltipZoom = true}}},[_c('form-slider',{attrs:{"id":"iconZoom"},on:{"form-slider-changed":_vm.setScale}})],1),_vm._v(" "),(_vm.tooltipZoom == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionZoom,"left":_vm.leftIconZoom}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group select-group"},[_c('label',{staticClass:"mb-1"},[_vm._v("Current Template")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentTemplateName),expression:"currentTemplateName"}],staticClass:"form-control template-select",staticStyle:{"height":"23px","font-size":"10pt","padding":"0"},attrs:{"id":"currentTemplate"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentTemplateName=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changeTemplate]}},_vm._l((_vm.$store.state.templates),function(template,index){return _c('option',{key:index},[_vm._v("\n              "+_vm._s(template.name)+"\n            ")])}),0)])],1)]),_vm._v(" "),_c('input',{ref:"importedModels",attrs:{"type":"file","accept":".json","id":"uploadModels","hidden":""},on:{"change":_vm.handleModels}}),_vm._v(" "),_c('input',{ref:"importedDataFields",attrs:{"type":"file","accept":".json","id":"uploadDataFields","hidden":""},on:{"change":_vm.handleDataFields}}),_vm._v(" "),_c('input',{ref:"importedDataMerge",attrs:{"type":"file","accept":".json","id":"uploadDataMerge","hidden":""},on:{"change":_vm.handleDataMerge}})]),_vm._v(" "),(_vm.isBarcode === true)?_c('barcode-template-modal',{on:{"close":function($event){_vm.isBarcode = false}}}):_vm._e(),_vm._v(" "),(_vm.isModal === true)?_c('global-modal',{attrs:{"width":90}},[_c('template',{slot:"header"},[_c('b',[_vm._v("Update Fields")])]),_vm._v(" "),_c('template',{slot:"body"},[(_vm.isMessageNoMatchForm === false)?_c('div',{staticClass:"row",attrs:{"id":"changesMerge"}},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"text-center text-success",staticStyle:{"margin-bottom":"15px"}},[_c('span',[_c('i',{staticClass:"fas fa-plus-square"}),_vm._v(" "),_c('b',[_vm._v("Add "+_vm._s(_vm.newFields.length)+" fields")])])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1.2em","color":"green"}},[_c('div',{staticStyle:{"overflow":"auto","height":"180px"}},_vm._l((_vm.newFields),function(newField,indexNew){return _c('div',{key:indexNew},[_c('small',{staticStyle:{"display":"block ruby"}},[_c('b',[_vm._v(_vm._s(newField.fieldPage))]),_vm._v(" | "+_vm._s(newField.name))])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"text-center text-danger",staticStyle:{"margin-bottom":"15px"}},[_c('span',[_c('i',{staticClass:"fas fa-minus-square"}),_vm._v(" "),_c('b',[_vm._v("Delete "+_vm._s(_vm.oldFields.length)+" fields")])])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1.2em","color":"Tomato"}},[_c('div',{staticStyle:{"overflow":"auto","height":"180px"}},_vm._l((_vm.oldFields),function(oldField,indexOld){return _c('div',{key:indexOld},[_c('small',{staticStyle:{"display":"block ruby"}},[_c('b',[_vm._v(_vm._s(oldField.fieldPage))]),_vm._v(" | "+_vm._s(oldField.id))])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"text-center text-primary",staticStyle:{"margin-bottom":"15px"}},[_c('span',[_c('i',{staticClass:"fas fa-exchange-alt"}),_vm._v(" "),_c('b',[_vm._v("Modify "+_vm._s(_vm.vPropFields.length)+" fields")])])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1.2em","color":"Mediumslateblue"}},[_c('div',{staticStyle:{"overflow":"auto","height":"180px"}},_vm._l((_vm.vPropFields),function(vPropField,indexMod){return _c('div',{key:indexMod},[_c('small',{staticStyle:{"display":"block ruby"}},[_c('b',[_vm._v(_vm._s(vPropField.fieldPage))]),_vm._v(" | "+_vm._s(vPropField.name))])])}),0)])])]):_vm._e(),_vm._v(" "),(_vm.isMessageNoMatchForm === true)?_c('div',[_c('p',{staticClass:"mb-0",staticStyle:{"color":"red"}},[_vm._v("Number of pages do not match.")])]):_vm._e()]),_vm._v(" "),_c('template',{staticClass:"ssss",slot:"footer"},[_c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.isModal = false}}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"disabled":_vm.isDisableBtnMerge || (_vm.newFields.length === 0 && _vm.oldFields.length === 0 && _vm.vPropFields.length === 0)},on:{"click":_vm.mergeData}},[_vm._v("\n          Merge\n        ")])]),_vm._v(" "),_c('small',{staticStyle:{"color":"red","position":"absolute","margin-top":"32px"}},[_vm._v("The deleted fields, also will be removed in questionnaire")])])],2):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default mybutton dropdown-toggle",attrs:{"type":"button","id":"dropdownMenuShowHide","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('i',{staticClass:"far fa-eye"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default mybutton dropdown-toggle",attrs:{"type":"button","id":"dropdownMenuHighLight","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('i',{staticClass:"fas fa-highlighter"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sv8m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageFields_vue__ = __webpack_require__("zQUo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dc8c9b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageFields_vue__ = __webpack_require__("eIgr");
function injectStyle (ssrContext) {
  __webpack_require__("QvN3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageFields_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dc8c9b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageFields_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sx2R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAnnotationControls),expression:"showAnnotationControls"}],style:(_vm.getStyle),attrs:{"id":"annotationControls"}},[(_vm.type === 'textarea')?_c('span',[_vm._v(_vm._s(_vm.fontSize)+"px")]):_vm._e(),_vm._v(" "),(_vm.type === 'textarea')?_c('button',{on:{"click":_vm.increaseFontSize}},[_c('i',{staticClass:"fas fa-plus"})]):_vm._e(),_vm._v(" "),(_vm.type === 'textarea')?_c('button',{on:{"click":_vm.decreaseFontSize}},[_c('i',{staticClass:"fas fa-minus"})]):_vm._e(),_vm._v(" "),(_vm.type === 'textarea')?_c('button',{on:{"click":_vm.toggleEdit}},[_c('i',{class:['fa', _vm.readOnly ? 'fa-pencil' : 'fa-save']})]):_vm._e(),_vm._v(" "),_c('button',{attrs:{"alt":"Resize"},on:{"click":_vm.resize}},[_c('i',{staticClass:"fas fa-expand"})]),_vm._v(" "),_c('button',{attrs:{"alt":"Move"},on:{"click":_vm.move}},[_c('i',{staticClass:"fas fa-arrows"})]),_vm._v(" "),_c('button',{attrs:{"alt":"Rotate"},on:{"click":_vm.rotate}},[_c('i',{staticClass:"fas fa-refresh"})]),_vm._v(" "),_c('button',{attrs:{"alt":"Remove"},on:{"click":_vm.remove}},[_c('i',{staticClass:"fas fa-times"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t0mM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModal)?_c('div',{staticClass:"edit-modal"},[_c('div',{staticClass:"modalHeader"},[_c('span',{staticClass:"title"},[_vm._v("View Questionnaire Field")]),_vm._v(" "),_c('span',{staticClass:"btn-close float-right",on:{"click":_vm.closeModal}},[_c('i',{staticClass:"fas fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"modalBody"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Field ID:")]),_vm._v(" "),_c('div',{staticClass:"fieldName"},[_vm._v(_vm._s(_vm.fieldName))]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-secondary btn-edit-field",on:{"click":_vm.editFormField}},[_vm._v("Edit Form Field")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"fieldTitle"}},[_vm._v("Field Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldTitle),expression:"fieldTitle"}],staticClass:"form-control form-control-sm",attrs:{"disabled":"","type":"text","id":"fieldTitle"},domProps:{"value":(_vm.fieldTitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldTitle=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"helpText"}},[_vm._v("Inline Help Text")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldDesc),expression:"fieldDesc"}],staticClass:"form-control form-control-sm",attrs:{"disabled":"","id":"helpText"},domProps:{"value":(_vm.fieldDesc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldDesc=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"model"}},[_vm._v("Model")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldModel),expression:"fieldModel"}],staticClass:"form-control form-control-sm",attrs:{"disabled":"","id":"model"},domProps:{"value":(_vm.fieldModel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldModel=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"button-box float-right"},[_c('button',{staticClass:"btn btn-secondary",on:{"click":_vm.closeModal}},[_vm._v("Close")])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t6RW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_editor_annotations_AnnotationControls__ = __webpack_require__("EZkO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_editor_annotations_AnnotationTextarea__ = __webpack_require__("lHBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_editor_annotations_AnnotationImage__ = __webpack_require__("sfA9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_editor_annotations_AnnotationHighlight__ = __webpack_require__("Q7/M");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'annotations',

  components: {
    AnnotationControls: __WEBPACK_IMPORTED_MODULE_0__components_editor_annotations_AnnotationControls__["a" /* default */],
    AnnotationTextarea: __WEBPACK_IMPORTED_MODULE_1__components_editor_annotations_AnnotationTextarea__["a" /* default */],
    AnnotationImage: __WEBPACK_IMPORTED_MODULE_2__components_editor_annotations_AnnotationImage__["a" /* default */],
    AnnotationHighlight: __WEBPACK_IMPORTED_MODULE_3__components_editor_annotations_AnnotationHighlight__["a" /* default */]
  },

  mounted: function mounted() {
    var that = this;
    this.$bus.$on('setAnnotationMode', function (type) {
      that.currentAnnotation.type = type;
    });

    this.$bus.$on('removeAnnotation', function (index) {
      that.$store.commit('removeAnnotation', index);
      that.$bus.emit('hideControls');
    });

    this.$bus.$on('pageChange', function () {
      that.setup();
    });

    this.$bus.$on('setSelected', function (index) {
      console.log('Set Selected', index);
      for (var i = 0; i < that.$store.state.annotations.length; i++) {
        if (i === index) that.$store.commit('setSelected', { index: i, val: false });else that.$store.commit('setSelected', { index: i, val: true });
      }
    });

    this.$bus.on('moveAnnotation', this.setMoveMode);
    this.$bus.on('resizeAnnotation', this.setResizeMode);
    this.$bus.on('rotateAnnotation', this.setRotateMode);

    document.addEventListener('mousedown', this.mouseDown, false);
    document.addEventListener('mouseup', this.mouseUp, false);
    document.addEventListener('mousemove', this.mouseMove, false);
    document.addEventListener('keyup', this.keyPress, false);
  },
  data: function data() {
    return {
      annotations: [],
      currentAnnotation: {
        x: 0,
        y: 0,
        rotation: 0,
        width: 10,
        height: 10,
        type: 'text',
        selected: false,
        data: {}
      },

      drawMode: false,
      rotateMode: false,
      moveMode: false,
      resizeMode: false,
      targetIndex: -1
    };
  },


  methods: {
    setup: function setup() {
      var annotations = this.$store.getters.pageAnnotations(this.$store.state.fileCurrentPage);
      this.$store.commit('setAnnotations', annotations);
    },
    updateControlsPosition: function updateControlsPosition() {
      var type = this.$store.state.annotations[this.targetIndex]['type'];
      var annotationEl = document.querySelector('#annotation-' + this.targetIndex + ' .annotationEl');
      var elPos = annotationEl.getBoundingClientRect();
      this.$bus.emit('showAnnotationControls', {
        index: this.targetIndex,
        type: type,
        x: elPos.left,
        y: elPos.top + elPos.height
      });
    },
    setResizeMode: function setResizeMode(index) {
      this.$bus.emit('hideControls');
      this.targetIndex = index;
      this.resizeMode = true;
      console.log('resize', index);
    },
    setMoveMode: function setMoveMode(index) {
      this.$bus.emit('hideControls');
      this.targetIndex = index;
      this.moveMode = true;
    },
    setRotateMode: function setRotateMode(index) {
      this.$bus.emit('hideControls');
      this.targetIndex = index;
      this.rotateMode = true;
      console.log('rotate', index);
    },
    mouseDown: function mouseDown(e) {
      if (this.$store.state.drawingAnnotation) this.drawStart(e);
    },
    mouseUp: function mouseUp(e) {
      if (this.drawMode) this.drawEnd(e);else if (this.rotateMode) this.rotateEnd(e);else if (this.moveMode) this.moveEnd(e);else if (this.resizeMode) this.resizeEnd(e);
    },
    mouseMove: function mouseMove(e) {
      if (this.drawMode) this.drawMove(e);else if (this.rotateMode) this.rotateMove(e);else if (this.moveMode) this.moveMove(e);else if (this.resizeMode) this.resizeMove(e);
    },
    keyPress: function keyPress(e) {},
    moveMove: function moveMove(e) {
      var pos = {
        x: e.pageX - 10,
        y: e.pageY - 10
      };
      this.$store.commit('setAnnotationPosition', { index: this.targetIndex, pos: pos });
    },
    moveEnd: function moveEnd(e) {
      this.moveMove(e);
      this.moveMode = false;
      this.updateControlsPosition();
      // this.$store.dispatch('saveAll')
    },
    rotateMove: function rotateMove(e) {
      var mousePos = { x: e.pageX, y: e.pageY };
      var elRect = document.querySelector('#annotation-' + this.targetIndex).getBoundingClientRect();

      var mouseTravel = elRect.left - mousePos.x;
      var rotationAmount = mouseTravel / 5;
      this.$store.commit('setAnnotationRotation', { index: this.targetIndex, amount: rotationAmount });
    },
    rotateEnd: function rotateEnd(e) {
      this.rotateMove(e);
      this.rotateMode = false;
      // this.$store.dispatch('saveAll')
    },
    resizeMove: function resizeMove(e) {
      var mousePos = { x: e.pageX, y: e.pageY };
      var elRect = document.querySelector('#annotation-' + this.targetIndex).getBoundingClientRect();
      var elPos = {
        x: elRect.left,
        y: elRect.top
      };

      var size = {
        width: elRect.width,
        height: elRect.height
      };

      if (mousePos.x > elPos.x) size.width = mousePos.x - elPos.x;
      if (mousePos.y > elPos.y) size.height = mousePos.y - elPos.y;
      this.$store.commit('setAnnotationSize', { index: this.targetIndex, size: size });
    },
    resizeEnd: function resizeEnd(e) {
      this.resizeMove(e);
      this.resizeMode = false;
      // this.$store.dispatch('saveAll')
    },
    drawStart: function drawStart(e) {
      if (this.drawMode) return;
      this.currentAnnotation.width = 0;
      this.currentAnnotation.height = 0;
      this.currentAnnotation.x = e.pageX;
      this.currentAnnotation.y = e.pageY;
      this.drawMode = true;
    },
    drawMove: function drawMove(e) {
      if (!this.$store.state.drawingAnnotation) return;
      if (!this.drawMode) return;

      if (e.pageX > this.currentAnnotation.x && e.pageY > this.currentAnnotation.y) {
        this.currentAnnotation.width = e.pageX - this.currentAnnotation.x;
        this.currentAnnotation.height = e.pageY - this.currentAnnotation.y;
      }
    },
    drawEnd: function drawEnd(e) {
      if (!this.$store.state.drawingAnnotation) return;
      if (!this.drawMode) return;
      if (this.currentAnnotation.width > 10 && this.currentAnnotation.height > 10) {
        this.$store.commit('addAnnotation', {
          x: this.currentAnnotation.x,
          y: this.currentAnnotation.y,
          width: this.currentAnnotation.width,
          height: this.currentAnnotation.height,
          type: this.currentAnnotation.type,
          selected: true,
          fontSize: typeof this.currentAnnotation.fontSize !== 'undefined' ? this.currentAnnotation.fontSize : -1,
          rotation: 0,
          data: {}
        });
        // this.$store.dispatch('saveAll')
      }
      this.drawMode = false;
    }
  },

  computed: {
    currentAnnotationStyle: function currentAnnotationStyle() {
      return 'top:' + this.currentAnnotation.y + 'px;left:' + this.currentAnnotation.x + 'px;width:' + this.currentAnnotation.width + 'px;height:' + this.currentAnnotation.height + 'px;';
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('setAnnotationMode');
    this.$bus.$off('removeAnnotation');
    this.$bus.$off('pageChange');
    this.$bus.$off('setSelected');
    this.$bus.$off('moveAnnotation');
    this.$bus.$off('resizeAnnotation');
    this.$bus.$off('rotateAnnotation');
  }
});

/***/ }),

/***/ "tNxN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tODX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestionnaireTags_vue__ = __webpack_require__("Eu1a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_520ec0fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestionnaireTags_vue__ = __webpack_require__("lV/8");
function injectStyle (ssrContext) {
  __webpack_require__("sSL2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestionnaireTags_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_520ec0fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestionnaireTags_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "toJk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tsKY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row modal-section",attrs:{"id":"localizations"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"header"},[_c('h2',{staticClass:"d-inline"},[_vm._v("Localization")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-sm float-right mr-0",attrs:{"disabled":_vm.$store.state.currentTemplateName === 'global'},on:{"click":_vm.modelImport}},[_vm._v("Import From Model")]),_vm._v(" "),(Object.keys(this.localizations).length !== 0)?_c('button',{staticClass:"btn btn-success btn-sm float-right",attrs:{"disabled":_vm.$store.state.currentTemplateName === 'global'},on:{"click":_vm.addRecord}},[_vm._v("Add")]):_vm._e()]),_vm._v(" "),_c('table',{staticClass:"table table-sm table-bordered table-striped table-hover"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.localizations),function(data,language){return _c('tr',{key:language,staticStyle:{"font-size":"14px"}},[(_vm.editIndex !== language)?[_c('td',{staticClass:"verticalMiddle"},[_vm._v(_vm._s(language))]),_vm._v(" "),_c('td',{staticClass:"verticalMiddle"},[(data.label !== undefined && data.label !== '')?_c('button',{staticClass:"btn btn-sm btn-primary btnTableLocalization",on:{"click":function($event){return _vm.labelToTextStatic(data)}}},[_c('i',{staticClass:"fas fa-angle-double-right"})]):_vm._e(),_vm._v(_vm._s(data.label))]),_vm._v(" "),_c('td',{staticClass:"verticalMiddle"},[(data.text !== undefined && data.text !== '')?_c('button',{staticClass:"btn btn-sm btn-primary btnTableLocalization",on:{"click":function($event){return _vm.textToLabelStatic(data)}}},[_c('i',{staticClass:"fas fa-angle-double-left"})]):_vm._e(),_vm._v(_vm._s(data.text))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-secondary",on:{"click":function($event){return _vm.setEditIndex(language)}}},[_vm._v("Edit")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.deleteIndex(language)}}},[_vm._v("Delete")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-success",on:{"click":function($event){return _vm.restoreIndexStatic(data)}}},[_vm._v("Restore")])])]:[_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.editLanguage),expression:"editLanguage"}],staticClass:"form-control form-control-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.editLanguage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.languages),function(language,index){return _c('option',{key:index,attrs:{"name":language.code},domProps:{"value":language.code}},[_vm._v("\n                  "+_vm._s(language.code)+" - "+_vm._s(language.name)+"\n                ")])}),0)]),_vm._v(" "),_c('td',[(_vm.editLabel !== undefined && _vm.editLabel !== '' && _vm.editLanguage !== 'new')?_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.labelToTextEdit()}}},[_c('i',{staticClass:"fas fa-angle-double-right"})]):_vm._e(),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editLabel),expression:"editLabel"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.editLabel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editLabel=$event.target.value}}})]),_vm._v(" "),_c('td',[(_vm.editText !== undefined && _vm.editText !== '' && _vm.editLanguage !== 'new')?_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.textToLabelEdit()}}},[_c('i',{staticClass:"fas fa-angle-double-left"})]):_vm._e(),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editText),expression:"editText"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.editText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editText=$event.target.value}}})]),_vm._v(" "),_c('td',[(_vm.editLanguage !== 'new' && _vm.editLabel !== undefined && _vm.editText !== undefined)?_c('button',{staticClass:"btn btn-sm btn-success",on:{"click":_vm.saveEdit}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-secondary",on:{"click":_vm.cancelEdit}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-success",on:{"click":_vm.restoreIndexEdit}},[_vm._v("Restore")])])]],2)}),0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Language")]),_vm._v(" "),_c('th',[_vm._v("Label")]),_vm._v(" "),_c('th',[_vm._v("Help Text")]),_vm._v(" "),_c('th',[_vm._v("Actions")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u20J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'page-background',

  beforeDestroy: function beforeDestroy() {
    this.$store.commit('setOutputPath', '');
  }
});

/***/ }),

/***/ "u5It":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'upload-tooltips-modal',

  mounted: function mounted() {
    var that = this;
    this.$on('showUploadModal', function (fieldData) {
      that.showModal = true;
    });

    document.addEventListener('keyup', this.keyCheck);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keyup', this.keyCheck, false);

    this.$off('showUploadModal');
  },
  data: function data() {
    return {
      showModal: false,
      uploadLanguage: 'en',
      languages: [{ code: 'en', name: 'English' }, { code: 'es', name: 'Spanish' }, { code: 'zh', name: 'Chinese' }, { code: 'cs', name: 'Czech' }, { code: 'da', name: 'Danish' }, { code: 'nl', name: 'Dutch' }, { code: 'eo', name: 'Esperanto' }, { code: 'fi', name: 'Finnish' }, { code: 'fr', name: 'French' }, { code: 'ka', name: 'Georgian' }, { code: 'de', name: 'German' }, { code: 'el', name: 'Greek' }, { code: 'it', name: 'Italian' }, { code: 'ja', name: 'Japanese' }, { code: 'ko', name: 'Korean' }, { code: 'ku', name: 'Kurdish' }, { code: 'fa', name: 'Perisian' }, { code: 'pl', name: 'Polish' }, { code: 'pt', name: 'Portugese' }, { code: 'ro', name: 'Romanian' }, { code: 'ru', name: 'Russian' }, { code: 'sv', name: 'Swedish' }, { code: 'tr', name: 'Turkish' }, { code: 'ur', name: 'Urdu' }]
    };
  },


  methods: {
    keyCheck: function keyCheck(evt) {
      if (evt.keyCode === 27) this.closeModal();
    },
    getJsonFile: function getJsonFile() {
      var files = document.getElementById('selectFilesTooltips').files;

      if (files.length !== 1) {
        return false;
      }

      var fr = new FileReader();
      fr.readAsText(files.item(0));

      var that = this;
      fr.onload = function (e) {
        var tooltips = e.target.result.split('\n');
        for (var i = 0; i < tooltips.length; i++) {
          var y = tooltips[i].split('\t');
          tooltips[i] = y;
        }
        that.processTooltips(tooltips);
        that.closeModal();
      };
    },
    closeModal: function closeModal() {
      this.showModal = false;
    },
    processTooltips: function processTooltips(tooltipData) {
      var _this = this;

      var tmpTemplate = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.state.templates[this.$store.state.currentTemplateName]));

      for (var page in tmpTemplate['pages']) {
        if (this.$store.state.templates[this.$store.state.currentTemplateName]['pages'].hasOwnProperty(page)) {
          var fields = this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][page];
          fields.forEach(function (field) {
            tooltipData.forEach(function (tooltip) {
              var tooltipId = tooltip[0].replace(/\./g, '_');
              if (tooltipId === field['id']) {
                var newLabel = field['id'];
                if (field.model.length) {
                  var foundModel = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.$store.getters.searchModels(field.model)));
                  if (typeof foundModel._id !== 'undefined') {
                    if (typeof foundModel.label !== 'undefined' && foundModel.label.length) newLabel = foundModel.label;
                  }
                }

                field['questionHelp'] = tooltip[1];
                if (typeof field['translations'] === 'undefined' || field['translations'] === null) field['translations'] = {};
                field['translations'][_this.uploadLanguage] = {
                  label: newLabel,
                  text: field['questionHelp']
                };
                if (typeof field['importedInlineHelp'] === 'undefined' || field['importedInlineHelp'] === null) field['importedInlineHelp'] = {};
                field['importedInlineHelp'][_this.uploadLanguage] = {
                  label: newLabel,
                  text: field['questionHelp']
                };
              }
            });
          });
          tmpTemplate['pages'][page] = fields;
        }
      }

      this.$store.commit('setCurrentTemplateData', tmpTemplate);
      this.$bus.emit('reloadQuestionnaire');
      this.$store.dispatch('saveTemplatePages');
    }
  }
});

/***/ }),

/***/ "u6cj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSlider_vue__ = __webpack_require__("La9k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e310cd2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSlider_vue__ = __webpack_require__("fh2j");
function injectStyle (ssrContext) {
  __webpack_require__("3DBJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e310cd2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e310cd2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uEci":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uEk4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog)?_c('div',{staticClass:"modal-dialog"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.desc))]),_vm._v(" "),_c('button',{on:{"click":_vm.confirm}},[_vm._v(_vm._s(_vm.confirmText))]),_vm._v(" "),_c('button',{on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uJdz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListView_vue__ = __webpack_require__("ZjLC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf73fae8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListView_vue__ = __webpack_require__("ajFt");
function injectStyle (ssrContext) {
  __webpack_require__("Pyam")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bf73fae8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf73fae8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uxpc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v+gJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDialog_vue__ = __webpack_require__("6dB7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_369b2f94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalDialog_vue__ = __webpack_require__("uEk4");
function injectStyle (ssrContext) {
  __webpack_require__("8CZR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-369b2f94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_369b2f94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vCCv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"questionnaire"},[_c('edit-modal',{ref:"editModal"}),_vm._v(" "),_c('group-edit-modal',{ref:"widgetEditModal"}),_vm._v(" "),_c('section-modal',{ref:"sectionModal"}),_vm._v(" "),_c('upload-tooltips-modal',{ref:"uploadModal"}),_vm._v(" "),_c('field-group-modal',{ref:"fieldGroupModal"}),_vm._v(" "),_c('checkbox-group-modal',{ref:"checkboxGroupModal"}),_vm._v(" "),_c('inline-help-modal',{ref:"inlineHelpModal"}),_vm._v(" "),_c('restore-inline-help-modal',{ref:"restoreInlineHelpModal"}),_vm._v(" "),_c('field-group-edit-modal'),_vm._v(" "),_c('checkbox-group-edit-modal'),_vm._v(" "),_c('section-edit-modal'),_vm._v(" "),(_vm.showWidgetLabelsModal === true)?_c('widget-labels-modal',{on:{"close":function($event){_vm.showWidgetLabelsModal = false}}}):_vm._e(),_vm._v(" "),(_vm.showQuestionnairePreviewModal === true)?_c('global-modal',{attrs:{"width":90},on:{"close":function($event){_vm.showQuestionnairePreviewModal = false}}},[_c('template',{slot:"header"},[_c('b',{staticStyle:{"margin-left":"-15px"}},[_vm._v("Questionnaire Preview")]),_vm._v(" "),_c('i',{staticClass:"fas fa-times pull-right",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.showQuestionnairePreviewModal = false}}})]),_vm._v(" "),_c('template',{slot:"body"},[_c('div',{staticStyle:{"height":"700px","overflow-y":"auto","overflow-x":"hidden"}},[(_vm.formattedData !== null)?_c('pf-questionnaire-form',{attrs:{"data":Object.values(_vm.formattedData),"forms":[{}]}}):_vm._e()],1)]),_vm._v(" "),_c('template',{slot:"footer"},[_c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.showQuestionnairePreviewModal = false}}},[_vm._v("\n          Close\n        ")])])])],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bar-icons"},[_c('div',{staticClass:"icons-individual"},[_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconRemove","disabled":_vm.noRows},on:{"mouseout":function($event){_vm.tooltipRemove = false},"mouseover":function($event){_vm.tooltipRemove = true},"click":_vm.removeAll}},[_c('i',{staticClass:"fas fa-trash-alt"})]),_vm._v(" "),(_vm.tooltipRemove == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionRemove,"left":_vm.leftIconRemove}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"icons-individual"},[_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconUploadTooltips","disabled":_vm.$store.state.currentTemplateName === 'global'},on:{"mouseout":function($event){_vm.tooltipUploadTooltips = false},"mouseover":function($event){_vm.tooltipUploadTooltips = true},"click":_vm.showUploadTooltips}},[_c('i',{staticClass:"fas fa-upload"})]),_vm._v(" "),(_vm.tooltipUploadTooltips == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionUploadTooltips,"left":_vm.leftIconUploadTooltips}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"icons-individual"},[_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconGenerateFields","disabled":_vm.$store.state.currentTemplateName === 'global'},on:{"mouseout":function($event){_vm.tooltipGenerateFields = false},"mouseover":function($event){_vm.tooltipGenerateFields = true},"click":_vm.generateFields}},[_c('i',{staticClass:"far fa-file-alt"})]),_vm._v(" "),(_vm.tooltipGenerateFields == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionGenerateFields,"left":_vm.leftIconGenerateFields}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"icons-individual"},[_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconParseInlineHelp","disabled":_vm.$store.state.currentTemplateName === 'global'},on:{"mouseout":function($event){_vm.tooltipParseInlineHelp = false},"mouseover":function($event){_vm.tooltipParseInlineHelp = true},"click":_vm.generateAllInlineHelp}},[_c('i',{staticClass:"fas fa-cut"})]),_vm._v(" "),(_vm.tooltipParseInlineHelp == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionParseInlineHelp,"left":_vm.leftIconParseInlineHelp}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"icons-individual"},[_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconRestoreInlineHelp","disabled":_vm.$store.state.currentTemplateName === 'global'},on:{"mouseout":function($event){_vm.tooltipRestoreInlineHelp = false},"mouseover":function($event){_vm.tooltipRestoreInlineHelp = true},"click":_vm.restoreAllInlineHelp}},[_c('i',{staticClass:"fas fa-window-restore"})]),_vm._v(" "),(_vm.tooltipRestoreInlineHelp == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionRestoreInlineHelp,"left":_vm.leftIconRestoreInlineHelp}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"icons-individual"},[_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconFieldGroups","disabled":_vm.$store.state.currentTemplateName === 'global'},on:{"mouseout":function($event){_vm.tooltipFieldGroups = false},"mouseover":function($event){_vm.tooltipFieldGroups = true},"click":_vm.showFieldGroupModal}},[_c('i',{staticClass:"fas fa-object-group"})]),_vm._v(" "),(_vm.tooltipFieldGroups == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionFieldGroups,"left":_vm.leftIconFieldGroups}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"icons-individual"},[_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconCheckboxGroups","disabled":_vm.$store.state.currentTemplateName === 'global'},on:{"mouseout":function($event){_vm.tooltipCheckboxGroups = false},"mouseover":function($event){_vm.tooltipCheckboxGroups = true},"click":_vm.showCheckboxGroupModal}},[_c('i',{staticClass:"far fa-object-group"})]),_vm._v(" "),(_vm.tooltipCheckboxGroups == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionCheckboxGroups,"left":_vm.leftIconCheckboxGroups}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"icons-individual"},[_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconAddSection","disabled":_vm.$store.state.currentTemplateName === 'global'},on:{"mouseout":function($event){_vm.tooltipAddSection = false},"mouseover":function($event){_vm.tooltipAddSection = true},"click":_vm.showSectionModal}},[_c('i',{staticClass:"fas fa-plus"})]),_vm._v(" "),(_vm.tooltipAddSection == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionAddSection,"left":_vm.leftIconAddSection}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"icons-individual"},[_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconWidgetLabels","disabled":_vm.$store.state.currentTemplateName === 'global'},on:{"mouseout":function($event){_vm.tooltipWidgetLabels = false},"mouseover":function($event){_vm.tooltipWidgetLabels = true},"click":function($event){_vm.showWidgetLabelsModal = true}}},[_c('i',{staticClass:"fas fa-file-word"})]),_vm._v(" "),(_vm.tooltipWidgetLabels == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionWidgetLabels,"left":_vm.leftIconWidgetLabels}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"icons-individual"},[_c('button',{staticClass:"btn btn-default mybutton",attrs:{"id":"iconQuestionnairePreview","disabled":_vm.$store.state.currentTemplateName === 'global'},on:{"mouseout":function($event){_vm.tooltipQuestionnairePreview = false},"mouseover":function($event){_vm.tooltipQuestionnairePreview = true},"click":function($event){_vm.showQuestionnairePreviewModal = true}}},[_c('i',{staticClass:"fas fa-eye"})]),_vm._v(" "),(_vm.tooltipQuestionnairePreview == true)?_c('tooltip-icons',{attrs:{"descriptionIcons":_vm.descriptionQuestionnairePreview,"left":_vm.leftIconQuestionnairePreview}}):_vm._e()],1)]),_vm._v(" "),_c('div',{attrs:{"id":"questionnaireBody"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSpinner === true),expression:"isSpinner === true"}]},[_c('center',[_c('f-spinner'),_vm._v(" "),_c('span',[_vm._v("Loading ...")])],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.formattedData !== null && this.loading && !Object.keys(_vm.formattedData).length && _vm.isSpinner === false),expression:"formattedData !== null && this.loading && !Object.keys(formattedData).length && isSpinner === false"}]},[_c('center',[_c('h1',{staticStyle:{"margin-top":"300px"}},[_vm._v("No Questions.")])])],1),_vm._v(" "),_vm._l((_vm.formattedData),function(field,fieldKey){return [(field !== null && field.render !== false)?_c('section',{key:fieldKey},[(field.type === 'grid')?_c('div',{key:fieldKey,staticClass:"widget-row group-box"},[_c('widget-group',{key:fieldKey,attrs:{"fieldModel":field.model,"fieldIndex":fieldKey.toString(),"fieldName":field.fieldName,"templateObject":field}}),_vm._v(" "),_c('div',{key:fieldKey + Math.random(1024),staticClass:"widget-sort"},[_c('i',{staticClass:"fas fa-eye",on:{"click":function($event){return _vm.editWidget(fieldKey)}}}),_vm._v(" "),_c('i',{staticClass:"fas fa-arrow-circle-up",on:{"click":function($event){return _vm.move(fieldKey, true, true)}}}),_vm._v(" "),_c('i',{staticClass:"fas fa-arrow-circle-down",on:{"click":function($event){return _vm.move(fieldKey, false, true)}}})])],1):(field.type === 'checkbox-group')?_c('div',{key:fieldKey,staticClass:"widget-row single-widget",class:field.indent === 1 || field.indent === '1' ? 'indent-level1' : field.indent === 2 || field.indent === '2' ? 'indent-level2' : field.indent === 3 || field.indent === '3' ? 'indent-level3' : '',staticStyle:{"background-color":"rgb(232, 232, 232)"},attrs:{"id":fieldKey + 'widget'}},[(field.checkboxes && Object.keys(field.checkboxes).length === 2 && field.checkboxes[Object.keys(field.checkboxes)[0]].type === 'checkbox' && field.checkboxes[Object.keys(field.checkboxes)[1]].type === 'checkbox')?_c('div',[_c('div',{staticClass:"float-right"},[_c('label',{staticStyle:{"cursor":"pointer"},attrs:{"for":'ABQuestion' + fieldKey}},[_c('input',{staticStyle:{"cursor":"pointer"},attrs:{"type":"checkbox","id":'ABQuestion' + fieldKey},domProps:{"checked":field.abQuestion},on:{"change":function($event){return _vm.setABQuestion({
                  field: field,
                  checkboxId: 'ABQuestion' + fieldKey
                })}}}),_vm._v(" A/B Question")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"widget-label"},[_vm._v(_vm._s(field.title))]),_vm._v(" "),_c('h5',{staticClass:"input-subtext"},[_vm._v(_vm._s(field.desc))]),_vm._v(" "),(field.type === 'checkbox-group')?_c('field-group-widget',{key:fieldKey,ref:fieldKey,refInFor:true,attrs:{"fieldIndex":fieldKey.toString(),"fieldName":field.fieldName,"initialValue":field.newValue.length ? field.newValue : field.originalValue,"checkboxes":field.checkboxes,"maxChecked":field.maxChecked,"options":field.values,"editable":field.editable,"readOnly":true,"model":field.model}}):_vm._e(),_vm._v(" "),(field.type !== 'section' && field.type !== 'checkbox-group')?_c('div',{staticClass:"widget-label"},[_vm._v("Page: "+_vm._s(field.page))]):_vm._e(),_vm._v(" "),(field.type !== 'section' && field.type !== 'checkbox-group')?_c('div',{staticClass:"widget-label"},[_vm._v("Tab order: "+_vm._s(field.tabOrder))]):_vm._e(),_vm._v(" "),_c('div',{key:fieldKey + Math.random(1024),staticClass:"widget-sort"},[_c('i',{staticClass:"fas fa-angle-double-left",on:{"click":function($event){return _vm.setFieldPage({fields: field.checkboxes, type: field.type})}}}),_vm._v(" "),(field.type === 'checkbox-group')?_c('i',{staticClass:"fas fa-eye",on:{"click":function($event){return _vm.editGroup(field.fieldName)}}}):_vm._e(),_vm._v(" "),_c('i',{staticClass:"fas fa-arrow-circle-up",on:{"click":function($event){return _vm.move(fieldKey, true)}}}),_vm._v(" "),_c('i',{staticClass:"fas fa-arrow-circle-down",on:{"click":function($event){return _vm.move(fieldKey, false)}}}),_vm._v(" "),(field.type === 'checkbox-group')?_c('i',{staticClass:"fas fa-trash",on:{"click":function($event){return _vm.deleteGroup(field.fieldName)}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"font14",staticStyle:{"margin-top":"20px"}},[_c('i',{staticClass:"fas fa-chevron-left fa-lg",staticStyle:{"margin-right":"20px","cursor":"pointer"},on:{"click":function($event){return _vm.setIndentationGroup({
                indentation: false,
                containerId: fieldKey + 'widget',
                field: field
              })}}}),_vm._v(" "),_c('i',{staticClass:"fas fa-chevron-right fa-lg",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setIndentationGroup({
                indentation: true,
                containerId: fieldKey + 'widget',
                field: field
              })}}})])],1):(field.model === '' || field.forceShow === true)?[_c('div',{key:fieldKey,staticClass:"widget-row single-widget",class:field.indent === 1 ? 'indent-level1' : field.indent === 2 ? 'indent-level2' : field.indent === 3 ? 'indent-level3' : '',attrs:{"id":fieldKey + 'widget'}},[(field.type !== 'section')?_c('span',{staticClass:"widget-label"},[_vm._v(_vm._s(field.title))]):_vm._e(),_vm._v(" "),(field.type !== 'section')?_c('div',{staticClass:"input-subtext"},[_vm._v(_vm._s(field.desc))]):_vm._e(),_vm._v(" "),(field.type === 'section')?_c('section-widget',{key:fieldKey,ref:fieldKey,refInFor:true,attrs:{"fieldIndex":fieldKey.toString(),"fieldName":field.fieldName,"initialValue":field.newValue.length ? field.newValue : field.originalValue,"subSection":field.subSection,"model":field.model,"inlineHelp":field.desc}}):_vm._e(),_vm._v(" "),(field.type === 'combobox')?_c('combo-widget',{key:fieldKey,ref:fieldKey,refInFor:true,attrs:{"fieldIndex":fieldKey.toString(),"fieldName":field.fieldName,"initialValue":field.newValue.length ? field.newValue : field.originalValue,"options":typeof field.values === 'array' ? field.values : [],"editable":field.editable,"readOnly":true,"model":field.model}}):(field.type === 'text')?_c('text-widget',{key:fieldKey,ref:fieldKey,refInFor:true,attrs:{"fieldIndex":fieldKey.toString(),"fieldName":field.fieldName,"initialValue":field.newValue.length ? field.newValue : field.originalValue,"editable":field.editable,"readOnly":true,"model":field.model}}):(field.type === 'checkbox')?_c('checkbox-widget',{key:fieldKey,ref:fieldKey,refInFor:true,attrs:{"fieldIndex":fieldKey.toString(),"fieldName":field.fieldName,"initialValue":field.newValue.length ? field.newValue : field.originalValue,"editable":field.editable,"readOnly":true,"model":field.model}}):_vm._e(),_vm._v(" "),(field.type !== 'section' && field.type !== 'checkbox-group')?_c('div',{staticClass:"widget-label"},[_c('p',{staticClass:"mb-0",staticStyle:{"margin-top":"15px"}},[_vm._v("Page: "+_vm._s(field.page))])]):_vm._e(),_vm._v(" "),(field.type !== 'section' && field.type !== 'checkbox-group')?_c('div',{staticClass:"widget-label mb-0"},[_c('p',{staticClass:"mb-0"},[_vm._v("Tab order: "+_vm._s(field.tabOrder))])]):_vm._e(),_vm._v(" "),_c('div',{key:fieldKey + Math.random(1024),staticClass:"widget-sort"},[(field.type !== 'section' && field.type !== 'checkbox-group')?_c('i',{staticClass:"fas fa-angle-double-left",on:{"click":function($event){return _vm.setFieldPage({name: field.fieldName, type: field.type})}}}):_vm._e(),_vm._v(" "),(field.type === 'checkbox-group')?_c('i',{staticClass:"fas fa-pencil",on:{"click":function($event){return _vm.editGroup(field.fieldName)}}}):(field.type === 'section')?_c('i',{staticClass:"fas fa-pencil",on:{"click":function($event){return _vm.editSection({ key: fieldKey, section: field.originalValue, subSection: field.subSection })}}}):_c('i',{staticClass:"fas fa-eye",on:{"click":function($event){return _vm.editField(fieldKey)}}}),_vm._v(" "),(field.type === 'section')?_c('i',{staticClass:"fas fa-eye",on:{"click":function($event){return _vm.editSection(fieldKey)}}}):_vm._e(),_vm._v(" "),(field.type === 'checkbox-group')?_c('i',{staticClass:"fas fa-trash",on:{"click":function($event){return _vm.deleteGroup(field.fieldName)}}}):_vm._e(),_vm._v(" "),_c('i',{staticClass:"fas fa-arrow-circle-up",on:{"click":function($event){return _vm.move(fieldKey, true)}}}),_vm._v(" "),_c('i',{staticClass:"fas fa-arrow-circle-down",on:{"click":function($event){return _vm.move(fieldKey, false)}}}),_vm._v(" "),(field.type === 'section' && field.type !== 'checkbox-group')?_c('i',{staticClass:"fas fa-trash",on:{"click":function($event){return _vm.deleteSection(field.fieldName)}}}):_vm._e(),_vm._v(" "),(field.type !== 'section' && field.type !== 'checkbox-group')?_c('i',{staticClass:"fas fa-trash",on:{"click":function($event){return _vm.deleteField(field.fieldName)}}}):_vm._e()]),_vm._v(" "),(field.type !== 'section' && field.type !== 'checkbox-group')?_c('button',{staticClass:"classic btn btn-light",on:{"click":function($event){return _vm.showQuestionHelp(field.fieldName, field.desc, fieldKey)}}},[_vm._v("Parse Inline Help")]):_vm._e(),_vm._v(" "),(field.type !== 'section' && field.type !== 'checkbox-group')?_c('button',{staticClass:"classic btn btn-light",on:{"click":function($event){return _vm.restoreInlineHelp(field.fieldName, fieldKey)}}},[_vm._v("Restore Inline Help")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"font14",staticStyle:{"margin-top":"20px"}},[_c('i',{staticClass:"fas fa-chevron-left fa-lg",staticStyle:{"margin-right":"20px","cursor":"pointer"},on:{"click":function($event){return _vm.setIndentation({
                  indentation: false,
                  containerId: fieldKey + 'widget',
                  field: field
                })}}}),_vm._v(" "),_c('i',{staticClass:"fas fa-chevron-right fa-lg",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setIndentation({
                  indentation: true,
                  containerId: fieldKey + 'widget',
                  field: field
                })}}})])],1)]:_vm._e()],2):_vm._e()]})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vEa5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.autofillDetails !== null && _vm.$store.state.officialModels !== null)?_c('div',{attrs:{"id":"editorQuestionnaireView"}},[_c('editor-view',{staticClass:"col-6 master border"}),_vm._v(" "),_c('questionnaire-view',{staticClass:"col-6 master2"})],1):_c('div',{staticStyle:{"left":"50%","position":"absolute","top":"25%"}},[_c('f-spinner'),_vm._v(" "),_c('span',[_vm._v("Loading ...")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w8HO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_editor_modal_edit_TreeView__ = __webpack_require__("i8L+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_editor_modal_edit_FunctionToolbox__ = __webpack_require__("nQmy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_editor_modal_edit_Localizations__ = __webpack_require__("iPbD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_questionnaires_QuestionnaireTags__ = __webpack_require__("tODX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_questionnaires_ABGroupWatchers__ = __webpack_require__("GGn3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_editor_modal_edit_AutocompleteModel_vue__ = __webpack_require__("a/Yx");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-edit-field',

  components: {
    TreeView: __WEBPACK_IMPORTED_MODULE_2__components_editor_modal_edit_TreeView__["a" /* default */],
    FunctionToolbox: __WEBPACK_IMPORTED_MODULE_3__components_editor_modal_edit_FunctionToolbox__["a" /* default */],
    Localizations: __WEBPACK_IMPORTED_MODULE_4__components_editor_modal_edit_Localizations__["a" /* default */],
    QuestionnaireTags: __WEBPACK_IMPORTED_MODULE_5__components_questionnaires_QuestionnaireTags__["a" /* default */],
    AbGroupWatchers: __WEBPACK_IMPORTED_MODULE_6__components_questionnaires_ABGroupWatchers__["a" /* default */],
    AutocompleteModel: __WEBPACK_IMPORTED_MODULE_7__components_editor_modal_edit_AutocompleteModel_vue__["a" /* default */]
  },

  mounted: function mounted() {
    var _this = this;

    var that = this;
    this.saveDelete = false;

    if (!this.$store.state.widgets.length) {
      var _apiUrl = this.$store.state.apiUrl;
      this.axios.get(_apiUrl + 'widget/list').then(function (response) {
        _this.$store.commit('setWidgets', response.data);
      });
    }
    var apiUrl = this.$store.state.apiUrl;
    this.axios.get(apiUrl + 'model/list').then(function (response) {
      _this.$store.commit('setModels', response.data);
    });

    this.$bus.on('saveTriggered', function () {
      if (that.$store.state.currentTemplateName === 'global') that.closeModal();else that.saveField();
    });

    this.$bus.on('openFieldMenu', this.setupModal);

    this.$bus.on('getFieldId', function () {
      that.$bus.emit('setFieldId', that.fieldData);
    });

    this.$bus.$on('setCurrentTemplateName', function (templateName) {
      console.log(templateName);
      if (!that.visible) return;
      var fieldIndex = that.$store.getters.templateFieldIndex(templateName, that.fieldId, that.$store.state.fileCurrentPage);
      if (fieldIndex !== null) {
        that.fieldData = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(that.$store.state.templates[templateName]['pages'][that.$store.state.fileCurrentPage][fieldIndex]));
        that.editorText = that.fieldData['model'];
        setTimeout(function () {
          if (that.$refs.localizations === undefined) return;
          if (typeof that.fieldData.translations === 'undefined') that.$refs.localizations.$emit('updateLocalizations', {});else that.$refs.localizations.$emit('updateLocalizations', that.fieldData.translations);
        }, 300);
      } else that.closeModal();
    });

    this.$bus.$on('setPageScale', function () {
      that.visible = false;
    });

    this.$bus.$on('pageChange', function () {
      that.visible = false;
    });

    this.$on('updateTranslations', function (translations) {
      that.fieldData['translations'] = translations;
      that.generalSave();
    });

    this.$on('addItem', function (item) {
      that.editorText += ' ' + item;
      that.editorText.trim();
    });

    this.$bus.on('closeModal', function () {
      that.closeModal();
    });

    this.$bus.on('confirmFieldDelete', function () {
      that.deleteField();
    });

    this.$bus.on('confirmFieldReset', function () {
      that.resetField();
    });

    document.addEventListener('keyup', function (evt) {
      if (evt.keyCode === 27) that.visible = false;
    });
  },
  data: function data() {
    return {
      visible: false,
      validTabIndex: true,
      translations: {},
      saveDelete: false,
      currentFieldGroup: 'none',
      currentCheckboxGroup: 'none',
      fieldGroup: 'none',
      checkboxGroup: 'none',
      isCheckbox: false,

      fieldId: '',
      fieldData: {},

      editorText: '',

      fieldNames: [],
      checkboxNames: [],

      maskTypes: [{
        maskType: 'None',
        description: 'No mask applied'
      }, {
        maskType: 'Date',
        description: '01/15/2018'
      }, {
        maskType: 'Date (ISO 8601)',
        description: '2018/01/15'
      }, {
        maskType: 'Phone (US)',
        description: '(123) 456-7890'
      }, {
        maskType: 'Phone (International)',
        description: '+11 123 4567890'
      }, {
        maskType: 'EIN',
        description: '12-3456789'
      }, {
        maskType: 'Alien Number',
        description: '123-456-789'
      }, {
        maskType: 'Email Address',
        description: 'user@test.com'
      }, {
        maskType: 'Zip Code',
        description: '12345-1234'
      }, {
        maskType: 'Social Security Number',
        description: '123-45-7890'
      }, {
        maskType: 'US Dollars',
        description: '$1,234,567.89'
      }],

      isAutocompleteModel: false,
      autocompleteModelData: null,
      autocompleteModel: '',
      isAutoCompleteClick: false,

      fieldValue: null
    };
  },


  computed: {
    setModelChange: function setModelChange() {
      this.editorText = this.fieldData.model;
    },

    showResetField: function showResetField() {
      var fieldIndex = this.$store.getters.templateFieldIndex('global', this.fieldData.id, this.$store.state.fileCurrentPage);
      return fieldIndex !== null;
    },


    choiceData: {
      get: function get() {
        if (typeof this.fieldData.choiceData === 'undefined') this.fieldData['choiceData'] = [];
        // choicedata damage ----> Props Expected Array
        if (this.fieldData.choiceData[0] === '[') return;
        return this.fieldData.choiceData.join(',');
      },

      set: function set(newVal) {
        if (!newVal.length) this.fieldData.choiceData = [];else this.fieldData.choiceData = newVal.split('|');
      }
    },

    showSendQuestionnaire: function showSendQuestionnaire() {
      var questionnaireField = this.$store.getters.searchQuestionnaire(this.fieldData.id);
      return questionnaireField;
    }
  },

  methods: {
    setAutocompleteModel: function setAutocompleteModel() {
      if (this.fieldData.model.length <= 6) return;

      this.isAutocompleteModel = true;

      this.autocompleteModelData = {};

      this.autocompleteModelData.top = document.getElementById('txtFieldModel').offsetTop;
      this.autocompleteModelData.left = document.getElementById('txtFieldModel').offsetLeft;
      this.autocompleteModel = this.fieldData.model;
      this.autocompleteModelData.fieldId = this.fieldData.id;
      this.autocompleteModelData.type = this.fieldData.type;
      this.autocompleteModelData.page = this.fieldData.fieldPage;
    },
    setOfficialModel: function setOfficialModel(payload) {
      this.fieldData.model = payload.model;
      this.isAutoCompleteClick = true;
    },
    hideAutocompleteModel: function hideAutocompleteModel() {
      var _this2 = this;

      setTimeout(function () {
        _this2.isAutocompleteModel = false;
      }, 500);
    },
    changeModelEdit: function changeModelEdit() {
      if (this.fieldData.value !== '' && this.fieldData.model !== '') {
        this.fieldData.model = '';

        alert('You can not have model and value at the same time.');

        return;
      }

      this.$store.commit('setOfficialModel', {
        model: this.fieldData.model,
        fieldId: this.fieldData.id,
        page: this.$store.state.fileCurrentPage
      });

      var updatePdfField = this.fieldData.id.replace(/]_/g, '].');

      var autofillDetail = {
        autofillId: this.$store.state.autofillId,
        templateId: this.$store.state.templates[this.$store.state.currentTemplateName]['_id'],
        pdfField: this.fieldData.id,
        model: this.fieldData.model,
        value: '',
        fieldType: this.fieldData.type,
        createdAt: new Date(),
        updatedAt: new Date()
      };

      this.$bus.emit('saveAutofillDetail', {
        modelValue: this.fieldData.model,
        updatePdfField: updatePdfField,
        elId: this.fieldData.id,
        autofillDetail: autofillDetail,
        model: true
      });
    },
    changeValueEdit: function changeValueEdit() {
      if (this.fieldData.model !== '' && this.fieldData.value !== '') {
        this.fieldData.value = '';

        alert('You can not have model and value at the same time.');

        return;
      }

      var fieldId = this.fieldData.id;

      fieldId = fieldId.replace(/]_/g, '].');

      if (this.$store.state.autofillDetails.map(function (a) {
        return a.pdfField;
      }).indexOf(fieldId) === -1) {
        var autofillDetail = {
          autofillId: this.$store.state.autofillId,
          templateId: this.$store.state.templates[this.$store.state.currentTemplateName]._id,
          value: this.fieldData.value,
          pdfField: fieldId,
          fieldType: this.fieldData.type === 'text' ? '1' : this.fieldData.type === 'combobox' ? '2' : this.fieldData.type === 'checkbox' ? '3' : '4',
          model: this.fieldData.model,
          createdAt: new Date(),
          updatedAt: new Date()
        };

        this.$bus.emit('saveAutofillDetail', {
          modelValue: this.fieldData.model,
          updatePdfField: autofillDetail.pdfField,
          autofillDetail: autofillDetail,
          value: true
        });
      } else {
        var _autofillDetail = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.$store.state.autofillDetails[this.$store.state.autofillDetails.map(function (a) {
          return a.pdfField;
        }).indexOf(fieldId)]));

        _autofillDetail.value = this.fieldData.value;

        this.$bus.emit('saveAutofillDetail', {
          modelValue: this.fieldData.model,
          updatePdfField: _autofillDetail.pdfField,
          autofillDetail: _autofillDetail,
          value: true
        });
      }
    },
    cancelField: function cancelField() {
      this.visible = false;
    },
    setupModal: function setupModal(fieldData) {
      this.resetModal();
      this.visible = true;
      this.fieldId = fieldData.id;
      var oldFieldId = this.fieldId;

      this.fieldValue = this.$store.state.autofillDetails.filter(function (a) {
        return a.pdfField === oldFieldId.replace(/]_/g, '].');
      })[0] !== undefined ? this.$store.state.autofillDetails.filter(function (a) {
        return a.pdfField === oldFieldId.replace(/]_/g, '].');
      })[0].value : '';

      var fData = null;

      fData = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.$store.getters.getTemplateData(this.fieldId)));
      fData.value = this.fieldValue;

      if (fData === null) return;

      fData.type = fData.type.toLowerCase();

      if (fData.type === 'button') fData.type = 'checkbox';

      // SET NO REVERSE

      if (fData.model.indexOf('#') !== -1 || fData.model.indexOf('(') !== -1 || fData.model.indexOf(')') !== -1 || fData.model.indexOf('+') !== -1 || fData.model.indexOf(',') !== -1 || fData.model.indexOf('attorney') !== -1 || fData.model.indexOf('verbose') !== -1) fData.noReverse = true;

      // END SET NO REVERSE

      this.compareInlineLabel(fData);

      if (fData.type === 'checkbox') this.isCheckbox = true;else this.isCheckbox = false;

      this.fieldData = fData;
      if (typeof fData.prefix === 'undefined') fData['prefix'] = '';
      this.editorText = fData['model'];
      if (typeof fData.translations === 'undefined') this.translations = {};else this.translations = fData.translations;
      this.fieldData = fData;
      this.fieldNames = this.$store.getters.groupFieldNames();
      this.checkboxNames = this.$store.getters.chGroupCheckboxNames();

      this.fieldGroup = this.$store.getters.fieldGroup(this.fieldId);
      if (this.fieldGroup === null || this.changeGroup === undefined) this.fieldGroup = 'none';
      this.currentFieldGroup = this.fieldGroup;

      this.checkboxGroup = this.$store.getters.checkboxGroup(this.fieldId);
      if (this.checkboxGroup === null || this.changeGroup === undefined) this.checkboxGroup = 'none';
      this.currentCheckboxGroup = this.checkboxGroup;
    },
    compareInlineLabel: function compareInlineLabel(formData) {
      var _this3 = this;

      if (formData.translations === undefined || this.$store.state.questionnaires.default === undefined) return;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.state.questionnaires.default.data).forEach(function (fieldKey) {
        if (_this3.$store.state.questionnaires.default.data[fieldKey].fieldName === formData.id) {
          var fieldQ = _this3.$store.state.questionnaires.default.data[fieldKey];

          if (formData.translations.en.text !== fieldQ.desc || formData.translations.en.label !== fieldQ.title) {
            formData.translations.en.text = fieldQ.desc;
            formData.translations.en.label = fieldQ.title;

            _this3.$store.commit('setTemplateFieldPage', formData);

            _this3.$store.dispatch('saveTemplate');
          }
        }

        if (_this3.$store.state.questionnaires.default.data[fieldKey].type === 'checkbox-group') {
          var fieldGroup = _this3.$store.state.questionnaires.default.data[fieldKey];

          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(fieldGroup.checkboxes).forEach(function (chKey) {
            if (chKey === formData.id) {
              var _fieldQ = fieldGroup.checkboxes[chKey];

              if (formData.translations.en.text !== _fieldQ.translations.en.text || formData.translations.en.label !== _fieldQ.translations.en.label) {
                formData.translations.en.text = _fieldQ.translations.en.text;
                formData.translations.en.label = _fieldQ.translations.en.label;

                _this3.$store.commit('setTemplateFieldPage', formData);

                _this3.$store.dispatch('saveTemplate');
              }
            }
          });
        }
      });
    },
    resetModal: function resetModal() {
      this.translations = {};
      this.fieldId = '';
      this.fieldData = {};
      this.editorText = '';
    },
    changeGroup: function changeGroup(e) {
      if (e.target.value === this.currentFieldGroup) return;

      if (this.currentFieldGroup !== 'none') {
        this.$store.commit('removeFieldFromGroup', {
          index: this.currentFieldGroup,
          fieldId: this.fieldId
        });
      }

      if (e.target.value !== 'none') {
        var dataField = this.$store.getters.getTemplateData(this.fieldId);

        this.$store.commit('addFieldToGroup', {
          index: e.target.value,
          fieldId: this.fieldId,
          dataField: dataField
        });
      }

      this.currentFieldGroup = e.target.value;

      this.$store.dispatch('saveTemplate');
      this.$bus.emit('reloadQuestionnaire');
      this.fieldNames = this.$store.getters.groupFieldNames();
    },
    createFieldGroup: function createFieldGroup() {
      var isWidget = this.$store.getters.getIfExistFieldOnWidget(this.fieldData.name);
      if (isWidget) {
        window.swal({
          title: 'You chose a field belong to a widget',
          text: 'Fields belong to widgets do not add to Field-Group',
          icon: 'warning',
          dangerMode: true
        });
      }
      if (isWidget) return;

      var that = this;
      this.$store.commit('deleteExistOnFieldGroups', this.fieldId);
      var newGroupId = Math.random().toString(36).split('.')[1];
      var newFields = {};

      var dataField = this.$store.getters.getTemplateData(this.fieldId);

      newFields[this.fieldId] = dataField;
      var newGroup = {
        name: 'New Group - ' + newGroupId,
        fieldAdd: that.fieldData.id,
        title: that.fieldData.translations['en'].label,
        desc: that.fieldData.translations['en'].text,
        checked: [],
        fields: newFields,
        tabOrder: that.fieldData.tabOrder,
        page: that.fieldData.fieldPage,
        prefix: that.fieldData.prefix
      };

      this.$store.dispatch('createFieldGroup', {
        index: newGroupId,
        data: newGroup
      });
      this.fieldNames = this.$store.getters.groupFieldNames();
      var newId = this.$store.getters.fieldGroup(this.fieldId);
      this.fieldGroup = newId;
      this.currentFieldGroup = newId;
      this.$bus.emit('setOnlyFieldGroup', newGroupId);
      this.$store.dispatch('saveTemplate');
    },
    changeCheckboxGroup: function changeCheckboxGroup(e) {
      if (e.target.value === this.currentCheckboxGroup) return;

      if (this.currentCheckboxGroup !== 'none') {
        this.$store.commit('removeCheckboxFromGroup', {
          index: this.currentCheckboxGroup,
          fieldId: this.fieldId
        });
      }

      if (e.target.value !== 'none') {
        var dataField = this.$store.getters.getTemplateData(this.fieldId);

        this.$store.commit('addCheckboxToGroup', {
          index: e.target.value,
          fieldId: this.fieldId,
          dataField: dataField
        });
      }

      this.currentCheckboxGroup = e.target.value;

      this.$store.dispatch('saveTemplate');
      this.$bus.emit('reloadQuestionnaire');
      this.checkboxNames = this.$store.getters.chGroupCheckboxNames();
    },
    createCheckboxGroup: function createCheckboxGroup() {
      var that = this;
      this.$store.commit('deleteExistOnCheckboxGroups', this.fieldId);
      var newGroupId = Math.random().toString(36).split('.')[1];
      var newFields = {};

      var dataField = this.$store.getters.getTemplateData(this.fieldId);

      newFields[this.fieldId] = dataField;
      var newGroup = {
        name: 'New Group - ' + newGroupId,
        fieldAdd: that.fieldData.id,
        title: that.fieldData.translations['en'].label,
        desc: that.fieldData.translations['en'].text,
        checked: [],
        checkboxes: newFields,
        tabOrder: that.fieldData.tabOrder,
        page: that.fieldData.fieldPage,
        prefix: that.fieldData.prefix
      };

      this.$store.dispatch('createCheckboxGroup', {
        index: newGroupId,
        data: newGroup
      });

      this.checkboxNames = this.$store.getters.chGroupCheckboxNames();
      var newId = this.$store.getters.checkboxGroup(this.fieldId);
      this.checkboxGroup = newId;
      this.currentCheckboxGroup = newId;
      this.$store.dispatch('saveTemplate');
    },
    resetField: function resetField() {
      var globalTemplateField = this.$store.getters.templateField('global', this.fieldData.id, this.$store.state.fileCurrentPage);
      var currentFieldIndex = this.$store.getters.currentTemplateFieldIndex(this.fieldData.id, this.$store.state.fileCurrentPage);

      var currentPage = this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][this.$store.state.fileCurrentPage];
      currentPage[currentFieldIndex] = globalTemplateField;

      this.$store.dispatch('saveTemplate');

      this.$store.commit('setCurrentTemplateName', 'global');
      this.$store.commit('setCurrentTemplateName', 'default');
      this.$bus.emit('updateQuestionnaire');
      this.$bus.emit('reloadQuestionnaire');
    },
    deleteField: function deleteField() {
      var fieldIndex = this.$store.getters.currentTemplateFieldIndex(this.fieldData.id, this.$store.state.fileCurrentPage);
      this.$store.commit('deleteField', fieldIndex);
      this.$store.commit('setCurrentTemplateName', 'global');
      this.$store.commit('setCurrentTemplateName', 'default');
      this.$bus.emit('updateQuestionnaire');
      this.$bus.emit('reloadQuestionnaire');
      this.saveDelete = true;
      this.saveField();
    },
    confirmDeleteField: function confirmDeleteField() {
      this.$bus.emit('showDialog', {
        title: 'Delete Field?',
        desc: 'You are about to delete ' + this.fieldData.name + ' from the ' + this.$store.state.currentTemplateName + ' template. Do you want to continue?',
        confirmAction: 'confirmFieldDelete'
      });
    },
    confirmResetField: function confirmResetField() {
      this.$bus.emit('showDialog', {
        title: 'Reset Field?',
        desc: 'You are about to reset ' + this.fieldData.name + ' with the data from the global template. Do you want to continue?',
        confirmAction: 'confirmFieldReset'
      });
    },
    sendQuestionnaireField: function sendQuestionnaireField() {
      var _this4 = this;

      window.swal({
        title: 'Generate Question?',
        text: 'You are about to generate questionnaire questions using the form fields. This is a new questionnaire. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (generate) {
        if (generate) {
          var dataQuestionnaires = _this4.$store.getters.addFieldQuestionnaire(_this4.fieldData);
          _this4.$store.commit('setQuestionnaires', dataQuestionnaires);
          _this4.$store.dispatch('saveTemplate');
          _this4.$bus.emit('updateQuestionnaire');
          _this4.$bus.emit('reloadQuestionnaire');
          _this4.visible = false;
        }
      });
    },
    closeModal: function closeModal() {
      if (this.fieldData.model !== undefined && this.fieldData.model !== null && this.fieldData.model !== '' && this.fieldData.value !== undefined && this.fieldData.value !== null && this.fieldData.value !== '') {
        document.getElementById('txtFieldValue').focus();

        alert('You can not have model and value at the same time.');

        return;
      }

      this.generalSave();
      this.visible = false;
    },
    generalSave: function generalSave() {
      var deletedField = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.fieldData.model !== undefined && this.fieldData.model !== null && this.fieldData.model !== '' && this.fieldData.value !== undefined && this.fieldData.value !== null && this.fieldData.value !== '') {
        document.getElementById('txtFieldValue').focus();

        alert('You can not have model and value at the same time.');

        return;
      }

      this.fieldData['model'] = this.editorText;
      this.fieldData['id'] = this.fieldId;

      var fieldIndex = this.$store.getters.templateFieldIndex(this.$store.state.currentTemplateName, this.fieldId, this.$store.state.fileCurrentPage);
      var currentPage = this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][this.$store.state.fileCurrentPage];
      this.fieldData.tabOrder = Number(this.fieldData.tabOrder);
      currentPage[fieldIndex] = this.fieldData;

      // NUCLEAR

      this.$store.commit('setTemplateField', {
        templateName: this.$store.state.currentTemplateName,
        page: this.$store.state.fileCurrentPage,
        fieldId: this.fieldId,
        data: this.fieldData
      });

      var groupId = this.$store.getters.fieldGroup(this.fieldId);
      if (groupId !== null) {
        var fieldLabel = this.fieldId;
        var fieldDesc = '';
        if (typeof this.fieldData.translations !== 'undefined') {
          if (typeof this.fieldData.translations[this.$store.state.currentLocale] !== 'undefined') {
            fieldLabel = this.fieldData.translations['en']['label'];
            fieldDesc = this.fieldData.translations['en']['text'];
          }
        }
        this.$store.commit('editFieldGroupFieldLabel', {
          index: groupId,
          fieldId: this.fieldId,
          fieldLabel: fieldLabel,
          fieldDesc: fieldDesc
        });
      }

      this.$bus.emit('addNotification', {
        title: this.saveDelete ? 'Field Deleted' : 'Field Updated',
        body: 'The field was ' + (this.saveDelete ? 'deleted' : 'updated') + ' successfully',
        type: 'success'
      });

      if (this.saveDelete) this.$store.commit('deleteQuestionnaireField', this.fieldId);else {
        this.$store.commit('updateQuestionnaireField', {
          name: this.fieldId,
          dataField: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.fieldData))
        });
      }

      this.$bus.emit('reloadQuestionnaire');
      this.$bus.emit('hidePageFields');

      this.$store.dispatch('saveTemplate');

      // END NUCLEAR
    },
    saveField: function saveField() {
      var deletedField = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.$store.commit('updatePrefixQuestionnaire', {
        fieldName: this.fieldData.name,
        prefix: this.fieldData.prefix
      });
      this.$bus.emit('hidePageFields');
      this.closeModal();
    },
    validateTabIndex: function validateTabIndex() {
      if (Number(this.fieldData.tabOrder) === Number(this.$store.getters.templateTabOrder(this.fieldId))) {
        this.validTabIndex = true;
        return;
      }
      this.validTabIndex = !this.$store.getters.tabOrderExists(this.fieldData.tabOrder);
    },
    setModelValue: function setModelValue(model) {
      this.fieldData.model = model;
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('saveTriggered');
    this.$bus.$off('openFieldMenu');
    this.$bus.$off('getFieldId');
    this.$bus.$off('setCurrentTemplateName');
    this.$bus.$off('setPageScale');
    this.$bus.$off('pageChange');
    this.$off('updateTranslations');
    this.$off('addItem');
    this.$bus.$off('closeModal');
    this.$bus.$off('confirmFieldDelete');
    this.$bus.$off('confirmFieldReset');
  }
});

/***/ }),

/***/ "wXzL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'annotation-controls',

  data: function data() {
    return {
      showAnnotationControls: false,
      fontSize: 10,
      index: -1,
      x: 0,
      y: 0,
      type: 'textarea',
      readOnly: true
    };
  },
  mounted: function mounted() {
    var that = this;
    this.$bus.$on('pageChange', function () {
      that.showAnnotationControls = false;
    });

    this.$bus.$on('hideControls', function () {
      that.showAnnotationControls = false;
    });

    var elPos = this.$el.getBoundingClientRect();
    this.$bus.emit('showAnnotationControls', {
      index: this.index,
      type: 'image',
      x: elPos.left,
      y: elPos.top + elPos.height
    });

    this.$bus.$on('showAnnotationControls', function (data) {
      if (that.$store.state.drawingAnnotation) return;
      if (data.index === that.index) {
        if (data.type === 'textarea') {
          var readOnly = document.getElementById('annotationTextarea-' + data.index).getAttribute('readonly');
          if (readOnly === null) return;
        }
        that.x = data.x + window.pageXOffset;
        that.y = data.y + window.pageYOffset;
        that.showAnnotationControls = !that.showAnnotationControls;
      } else {
        that.readOnly = true;
        that.$bus.emit('setReadOnly', {
          index: that.index,
          value: that.readOnly
        });

        that.type = data.type;
        that.showAnnotationControls = true;
        that.index = data.index;
        that.fontSize = typeof data.fontSize !== 'undefined' ? data.fontSize : 10;
        that.x = data.x + window.pageXOffset;
        that.y = data.y + window.pageYOffset;
      }
    });
  },


  methods: {
    toggleEdit: function toggleEdit() {
      this.readOnly = !this.readOnly;
      this.$bus.emit('setReadOnly', {
        index: this.index,
        value: this.readOnly
      });
    },
    increaseFontSize: function increaseFontSize() {
      this.fontSize++;
      this.$bus.emit('setFontSize', {
        index: this.index,
        size: this.fontSize
      });
      // this.$store.dispatch('saveAll')
    },
    decreaseFontSize: function decreaseFontSize() {
      if (this.fontSize - 1 <= 0) return;
      this.fontSize--;
      this.$bus.emit('setFontSize', {
        index: this.index,
        size: this.fontSize
      });
      // this.$store.dispatch('saveAll')
    },
    resize: function resize() {
      this.$bus.emit('resizeAnnotation', this.index);
    },
    move: function move() {
      this.$bus.emit('moveAnnotation', this.index);
    },
    remove: function remove() {
      this.$bus.$emit('removeAnnotation', this.index);
    },
    rotate: function rotate() {
      this.$bus.$emit('rotateAnnotation', this.index);
    }
  },

  computed: {
    getStyle: function getStyle() {
      return 'top:' + this.y + 'px;left:' + this.x + 'px;';
    }
  }
});

/***/ }),

/***/ "wiFD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetLabelsModal_vue__ = __webpack_require__("JUe8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cbdfa0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetLabelsModal_vue__ = __webpack_require__("02Rq");
function injectStyle (ssrContext) {
  __webpack_require__("O5dt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7cbdfa0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetLabelsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cbdfa0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetLabelsModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wjq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextWidget_vue__ = __webpack_require__("5hDI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59a0588e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextWidget_vue__ = __webpack_require__("VTGV");
function injectStyle (ssrContext) {
  __webpack_require__("g6mk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59a0588e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextWidget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59a0588e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextWidget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x46k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModal)?_c('div',{staticClass:"section-modal"},[_c('div',{staticClass:"modalHeader",staticStyle:{"border-radius":"9px 9px 0px 0px !important"}},[_c('span',{staticClass:"title"},[_vm._v("Add Section")]),_vm._v(" "),_c('span',{staticClass:"btn-close float-right",on:{"click":_vm.closeModal}},[_c('i',{staticClass:"fas fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"modalBody"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editSection),expression:"editSection"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.editSection)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editSection=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"font14"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editSubSection),expression:"editSubSection"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.editSubSection)?_vm._i(_vm.editSubSection,null)>-1:(_vm.editSubSection)},on:{"change":function($event){var $$a=_vm.editSubSection,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.editSubSection=$$a.concat([$$v]))}else{$$i>-1&&(_vm.editSubSection=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.editSubSection=$$c}}}}),_vm._v(" "),_c('b',[_vm._v("Sub-section")])])]),_vm._v(" "),_c('div',{staticClass:"button-box float-right mr-0"},[(!_vm.editing)?_c('button',{staticClass:"btn btn-success",on:{"click":_vm.addSection}},[_vm._v("Add")]):_c('button',{staticClass:"btn btn-success",on:{"click":_vm.saveSection}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",on:{"click":_vm.closeModal}},[_vm._v("Cancel")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("Manage Sections")]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover table-sm"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.sections),function(section,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(section.fieldName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(section.originalValue))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(section.desc))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(section.fieldsAdded !== undefined ? Object.keys(section.fieldsAdded).length : 0))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-light",on:{"click":function($event){return _vm.editSectionGroup(section)}}},[_vm._v("Edit")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.deleteSection(section.fieldName, index)}}},[_vm._v("Delete")])])])}),0)])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"font14"},[_c('b',[_vm._v("Section Name")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Label")]),_vm._v(" "),_c('th',[_vm._v("Help Text")]),_vm._v(" "),_c('th',[_vm._v("# Fields")]),_vm._v(" "),_c('th',[_vm._v("Actions")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xEYj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container modalMaxiItem"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return [_c('div',{staticClass:"text-center"},[_c('b',[_vm._v("Max Items "+_vm._s(_vm.role))])]),_vm._v(" "),_c('i',{staticClass:"fas fa-times float-right",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.$emit('close')}}})]})],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",function(){return [_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('label',{staticClass:"float-left",staticStyle:{"margin-top":"5px"},attrs:{"for":"maxItemsAddresses"}},[_vm._v("Addresses")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxRoleAddresses),expression:"maxRoleAddresses"}],staticClass:"form-control float-right",attrs:{"type":"text"},domProps:{"value":(_vm.maxRoleAddresses)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxRoleAddresses=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('label',{staticClass:"float-left",staticStyle:{"margin-top":"5px"},attrs:{"for":"maxItemsPreviousAddresses"}},[_vm._v("Previous Addresses")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxRolePreviousAddresses),expression:"maxRolePreviousAddresses"}],staticClass:"form-control float-right",attrs:{"type":"text"},domProps:{"value":(_vm.maxRolePreviousAddresses)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxRolePreviousAddresses=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('label',{staticClass:"float-left",staticStyle:{"margin-top":"5px"},attrs:{"for":"maxItemsPhones"}},[_vm._v("Phones")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxRolePhones),expression:"maxRolePhones"}],staticClass:"form-control float-right",attrs:{"type":"text"},domProps:{"value":(_vm.maxRolePhones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxRolePhones=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('label',{staticClass:"float-left",staticStyle:{"margin-top":"5px"},attrs:{"for":"maxItemsJobs"}},[_vm._v("Jobs")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxRoleJobs),expression:"maxRoleJobs"}],staticClass:"form-control float-right",attrs:{"type":"text"},domProps:{"value":(_vm.maxRoleJobs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxRoleJobs=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('label',{staticClass:"float-left",staticStyle:{"margin-top":"5px"},attrs:{"for":"maxItemsEducational"}},[_vm._v("Educational")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxRoleEducational),expression:"maxRoleEducational"}],staticClass:"form-control float-right",attrs:{"type":"text"},domProps:{"value":(_vm.maxRoleEducational)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxRoleEducational=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('label',{staticClass:"float-left",staticStyle:{"margin-top":"5px"},attrs:{"for":"maxItemsCriminal"}},[_vm._v("Criminal")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxRoleCriminal),expression:"maxRoleCriminal"}],staticClass:"form-control float-right",attrs:{"type":"text"},domProps:{"value":(_vm.maxRoleCriminal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxRoleCriminal=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('label',{staticClass:"float-left",staticStyle:{"margin-top":"5px"},attrs:{"for":"maxItemsEads"}},[_vm._v("Work Permit")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxRoleWorkPermit),expression:"maxRoleWorkPermit"}],staticClass:"form-control float-right",attrs:{"type":"text"},domProps:{"value":(_vm.maxRoleWorkPermit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxRoleWorkPermit=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('label',{staticClass:"float-left",staticStyle:{"margin-top":"5px"},attrs:{"for":"maxItemsPassports"}},[_vm._v("Passports")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxRolePassports),expression:"maxRolePassports"}],staticClass:"form-control float-right",attrs:{"type":"text"},domProps:{"value":(_vm.maxRolePassports)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxRolePassports=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('label',{staticClass:"float-left",staticStyle:{"margin-top":"5px"},attrs:{"for":"maxItemsTravel"}},[_vm._v("Travel")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxRoleTravel),expression:"maxRoleTravel"}],staticClass:"form-control float-right",attrs:{"type":"text"},domProps:{"value":(_vm.maxRoleTravel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxRoleTravel=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('label',{staticClass:"float-left",staticStyle:{"margin-top":"5px"},attrs:{"for":"maxItemsUsEntries"}},[_vm._v("Us Entries")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxRoleUsEntries),expression:"maxRoleUsEntries"}],staticClass:"form-control float-right",attrs:{"type":"text"},domProps:{"value":(_vm.maxRoleUsEntries)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxRoleUsEntries=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('label',{staticClass:"float-left",staticStyle:{"margin-top":"5px"},attrs:{"for":"maxItemsVisa"}},[_vm._v("Visa")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxRoleVisa),expression:"maxRoleVisa"}],staticClass:"form-control float-right",attrs:{"type":"text"},domProps:{"value":(_vm.maxRoleVisa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxRoleVisa=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('label',{staticClass:"float-left",staticStyle:{"margin-top":"5px"},attrs:{"for":"maxItemsMarriage"}},[_vm._v("Marriage")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxRoleMarriage),expression:"maxRoleMarriage"}],staticClass:"form-control float-right",attrs:{"type":"text"},domProps:{"value":(_vm.maxRoleMarriage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxRoleMarriage=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('label',{staticClass:"float-left",staticStyle:{"margin-top":"5px"},attrs:{"for":"maxItemsFamily"}},[_vm._v("Family")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxRoleFamily),expression:"maxRoleFamily"}],staticClass:"form-control float-right",attrs:{"type":"text"},domProps:{"value":(_vm.maxRoleFamily)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxRoleFamily=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('label',{staticClass:"float-left",staticStyle:{"margin-top":"5px"},attrs:{"for":"maxItemsChild"}},[_vm._v("Child")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxRoleChild),expression:"maxRoleChild"}],staticClass:"form-control float-right",attrs:{"type":"text"},domProps:{"value":(_vm.maxRoleChild)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxRoleChild=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('label',{staticClass:"float-left",staticStyle:{"margin-top":"5px"},attrs:{"for":"maxItemsSibling"}},[_vm._v("Sibling")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxRoleSibling),expression:"maxRoleSibling"}],staticClass:"form-control float-right",attrs:{"type":"text"},domProps:{"value":(_vm.maxRoleSibling)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxRoleSibling=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('label',{staticClass:"float-left",staticStyle:{"margin-top":"5px"},attrs:{"for":"maxItemsOther"}},[_vm._v("Family Other")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxRoleFamilyOther),expression:"maxRoleFamilyOther"}],staticClass:"form-control float-right",attrs:{"type":"text"},domProps:{"value":(_vm.maxRoleFamilyOther)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxRoleFamilyOther=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('label',{staticClass:"float-left",staticStyle:{"margin-top":"5px"},attrs:{"for":"maxItemsAdvance"}},[_vm._v("Advance")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxRoleAdvance),expression:"maxRoleAdvance"}],staticClass:"form-control float-right",attrs:{"type":"text"},domProps:{"value":(_vm.maxRoleAdvance)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxRoleAdvance=$event.target.value}}})])])]})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("\n              Close\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":_vm.saveMaxItemsRole}},[_vm._v("\n              Save\n            ")])]})],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',

  methods: {
    rightClick: function rightClick(e) {
      e.preventDefault();
    }
  }
});

/***/ }),

/***/ "xkbj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModal)?_c('div',{staticClass:"checkbox-group-edit-modal"},[_c('div',{staticClass:"modalHeader",staticStyle:{"border-radius":"9px 9px 0px 0px !important"}},[_c('span',{staticClass:"title"},[_vm._v("Edit Section")]),_vm._v(" "),_c('span',{staticClass:"btn-close float-right",on:{"click":_vm.closeModal}},[_c('i',{staticClass:"fas fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"modalBody"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editLabel),expression:"editLabel"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.editLabel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editLabel=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.editHelp),expression:"editHelp"}],staticClass:"form-control form-control-sm",domProps:{"value":(_vm.editHelp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editHelp=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefix),expression:"prefix"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.prefix)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prefix=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"button-box mr-0 float-right"},[_c('button',{staticClass:"btn btn-success",on:{"click":_vm.saveEdit}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",on:{"click":_vm.closeModal}},[_vm._v("Close")])]),_vm._v(" "),_c('table',{staticClass:"table table-sm table-bordered table-striped"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.fieldList),function(field,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(field))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-light",on:{"click":function($event){return _vm.editFormField(index)}}},[_vm._v("Edit Form Field")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.deleteField(index)}}},[_vm._v("Remove")]),_vm._v(" "),_c('i',{staticClass:"fas fa-angle-double-up",on:{"click":function($event){return _vm.move(index, true)}}}),_vm._v(" "),_c('i',{staticClass:"fas fa-angle-double-down",on:{"click":function($event){return _vm.move(index, false)}}})])])}),0)]),_vm._v(" "),_c('div',[_c('hr'),_vm._v(" "),_c('questionnaire-tags',{attrs:{"fieldData":_vm.fieldData}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row modal-section",attrs:{"id":"AbGroupWatchersSection"}},[_c('div',{staticClass:"col-sm-12"},[_c('ab-group-watchers',{attrs:{"isGroup":false,"fieldData":_vm.fieldData}})],1)])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"font14"},[_c('b',[_vm._v("Label:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"font14"},[_c('b',[_vm._v("Help Text:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"font14"},[_c('b',[_vm._v("Prefix:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Field ID")]),_vm._v(" "),_c('th',[_vm._v("Actions")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xlOv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xuVG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget widget-checkbox-group",attrs:{"data-field":_vm.fieldName}},[_c('inline-help-modal',{ref:"inlineHelpModal"}),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.fields),function(data,index){return (data !== null)?_c('label',{key:index},[_vm._v("\n    "+_vm._s(data.translations.en.label)+"\n    "),_c('h6',[_vm._v(_vm._s(data.translations.en.text))]),_vm._v(" "),_c('br'),_vm._v(" "),(data.type === 'checkbox')?[_c('p',[_c('input',{key:index,ref:index,refInFor:true,attrs:{"type":"checkbox","data-key":index},domProps:{"value":index},on:{"click":function($event){return _vm.highLightCheckbox({name:index, type: data.type})}}})])]:_vm._e(),_vm._v(" "),(data.type === 'text')?[_c('input',{key:index,ref:index,refInFor:true,staticClass:"form-control form-control-sm",attrs:{"type":"text","data-key":index},domProps:{"value":index},on:{"click":function($event){return _vm.highLightCheckbox({name:index, type: data.type})}}})]:_vm._e(),_vm._v(" "),(data.type === 'select')?[_c('select',{key:index,ref:index,refInFor:true,staticClass:"form-control form-control-sm",attrs:{"data-key":index},domProps:{"value":index},on:{"click":function($event){return _vm.highLightCheckbox({name:index, type: data.type})}}},[_c('option',[_vm._v("'ComboBox'")])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"widget-sort"},[_c('i',{staticClass:"fas fa-angle-double-up",on:{"click":function($event){return _vm.move(index, true)}}}),_vm._v(" "),_c('i',{staticClass:"fas fa-angle-double-down",on:{"click":function($event){return _vm.move(index, false)}}})]),_vm._v(" "),_c('button',{staticClass:"classic btn btn-light",on:{"click":function($event){return _vm.showQuestionHelp(data.name, data.translations.en.text)}}},[_vm._v("Parse Inline Help")]),_vm._v(" "),_c('button',{staticClass:"classic btn btn-light",on:{"click":function($event){return _vm.restoreInlineHelp(data.name)}}},[_vm._v("Restore Inline Help")]),_vm._v(" "),_c('hr')],2):_vm._e()}),_vm._v(" "),_c('br')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yT+8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yymv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"functionToolbox"}},[_c('div',{staticClass:"operator",on:{"click":function($event){return _vm.addItem('+')}}},[_c('div',{staticClass:"symbol float-left"},[_vm._v("+")]),_vm._v(" "),_c('div',{staticClass:"name float-right"},[_vm._v("Concatenate Models")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('p',{staticClass:"description font14"},[_vm._v("Combine the values of two or more models.")]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"operator",on:{"click":function($event){return _vm.addItem('cap(fieldName')}}},[_c('div',{staticClass:"symbol float-left"},[_vm._v("cap(fieldName)")]),_vm._v(" "),_c('div',{staticClass:"name float-right"},[_vm._v("Capitalize Model")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('p',{staticClass:"description font14"},[_vm._v("Capitalizes the first letter of a single word.")]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"operator",on:{"click":function($event){_vm.addItem('capwords(fieldName)')}}},[_c('div',{staticClass:"symbol float-left"},[_vm._v("capwords(field)")]),_vm._v(" "),_c('div',{staticClass:"name float-right"},[_vm._v("Capitalize Words")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('p',{staticClass:"description font14"},[_vm._v("Capitalize the first letter of each word.")]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"operator",on:{"click":function($event){_vm.addItem('getCh(1, 1, fieldName)')}}},[_c('div',{staticClass:"symbol float-left"},[_vm._v("getCh(A, B, field)")]),_vm._v(" "),_c('div',{staticClass:"name float-right"},[_vm._v("Get Character")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('p',{staticClass:"description font14"},[_vm._v("Gets a range of characters starting at index A, up through index B.")]),_vm._v(" "),_vm._m(3)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"example font14"},[_vm._v("Example: "),_c('span',{staticClass:"exampleText"},[_vm._v("first_name + last_name")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"example font14"},[_vm._v("Example: "),_c('span',{staticClass:"exampleText"},[_vm._v("cap(first_name)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"example font14"},[_vm._v("Example: "),_c('span',{staticClass:"exampleText"},[_vm._v("capwords(client_address_verbose)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"example font14"},[_vm._v("Example: "),_c('span',{staticClass:"exampleText"},[_vm._v("getCh(1, 1, client_bio_weight_full)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zGc8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select__ = __webpack_require__("T1ft");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'autocomplete-model',

  data: function data() {
    return {
      list: [],
      isSpinner: true,

      timeSearch: null
    };
  },


  props: {
    data: {
      type: Object
    },

    model: {
      type: String
    }
  },

  components: {
    VSelect: __WEBPACK_IMPORTED_MODULE_0_vue_select__["default"]
  },

  watch: {
    model: function model() {
      this.isSpinner = true;
      this.didYouMeanModel();
    }
  },

  mounted: function mounted() {
    this.didYouMeanModel();
  },


  methods: {
    didYouMeanModel: function didYouMeanModel() {
      var _this = this;

      if (this.model.length <= 6) return;

      clearTimeout(this.timeSearch);

      this.timeSearch = setTimeout(function () {
        _this.isSpinner = false;

        _this.list = _this.$store.state.allOfficialModels && _this.$store.state.allOfficialModels !== null ? _this.$store.state.allOfficialModels.filter(function (a) {
          return a.model.indexOf(_this.model) !== -1;
        }).map(function (a) {
          return a.model;
        }).sort() : [];
      });
    },
    setOfficialModel: function setOfficialModel(model) {
      this.model = model;
      if (document.getElementById('modalEditField') !== null) {
        this.$emit('set-model-value', model);
      }

      this.$store.commit('setOfficialModel', {
        model: model,
        fieldId: this.data.fieldId,
        page: this.$store.state.fileCurrentPage
      });

      this.$store.dispatch('addOfficialModel', { model: model });

      var updatePdfField = this.data.fieldId.replace(/]_/g, '].');

      var autofillDetail = {
        autofillId: this.$store.state.autofillId,
        templateId: this.$store.state.templates[this.$store.state.currentTemplateName]['_id'],
        pdfField: updatePdfField,
        model: model,
        value: '',
        fieldType: this.data.type,
        createdAt: new Date(),
        updatedAt: new Date()
      };

      this.$bus.emit('saveAutofillDetail', {
        modelValue: model,
        updatePdfField: updatePdfField,
        elId: this.data.fieldId,
        autofillDetail: autofillDetail,
        model: true
      });
    }
  }
});

/***/ }),

/***/ "zQUo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_editor_inputs_FormText__ = __webpack_require__("3Kon");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_editor_inputs_FormTextarea__ = __webpack_require__("+8cd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_editor_inputs_FormCheckbox__ = __webpack_require__("8OsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_editor_inputs_FormSelect__ = __webpack_require__("/3Id");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_editor_modal_edit_AutocompleteModel_vue__ = __webpack_require__("a/Yx");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'page-fields',

  data: function data() {
    return {
      offsetTop: 0,
      offsetLeft: 0,
      height: 0,
      width: 0,
      fieldsData: {},

      isAutocompleteModel: false,
      autocompleteModelData: null,
      autocompleteModel: '',
      listOfficialModels: []
    };
  },
  created: function created() {
    this.listOfficialModels = this.$store.state.officialModels;
  },
  mounted: function mounted() {
    var _this = this;

    var that = this;

    this.setup();
    this.$bus.on('pageChange', this.resetData);
    this.$bus.on('resetTabOrders', this.resetTabOrders);
    this.$bus.on('historyChange', this.resetData);
    this.$bus.on('toggleModelDisplay', this.toggleModelDisplay);
    this.$bus.on('toggleIdDisplay', this.toggleIdDisplay);
    this.$bus.on('setUp', this.setup);
    this.$bus.on('hideEditorFields', function () {
      _this.fieldsData = {};
    });
    this.$bus.on('hidePageFields', function () {
      _this.fieldsData = {};

      _this.fieldsData = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this.$store.state.templates[_this.$store.state.currentTemplateName]['pages'][_this.$store.state.fileCurrentPage]));
    });

    this.$bus.on('saveAutofillDetail', function (payload) {
      that.saveAutofillDetail(payload);
    });

    this.$bus.on('setAutocompleteModel', function (payload) {
      that.setAutcompleteModel(payload);
    });
  },


  components: {
    FormText: __WEBPACK_IMPORTED_MODULE_3__components_editor_inputs_FormText__["a" /* default */],
    FormTextarea: __WEBPACK_IMPORTED_MODULE_4__components_editor_inputs_FormTextarea__["a" /* default */],
    FormCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_editor_inputs_FormCheckbox__["a" /* default */],
    FormSelect: __WEBPACK_IMPORTED_MODULE_6__components_editor_inputs_FormSelect__["a" /* default */],
    AutocompleteModel: __WEBPACK_IMPORTED_MODULE_7__components_editor_modal_edit_AutocompleteModel_vue__["a" /* default */]
  },

  methods: {
    resetData: function resetData() {
      var modelHighlight = document.querySelectorAll('.model-highlight');
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(modelHighlight), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var highlight = _step.value;

          highlight.classList.remove('model-highlight');
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var highlighted = document.querySelectorAll('.id-highlight');
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(highlighted), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _highlight = _step2.value;

          _highlight.classList.remove('id-highlight');
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.fields = {};
      this.offsetTop = document.getElementById('backgroundImage').offsetTop;
      this.offsetLeft = document.getElementById('backgroundImage').offsetLeft;
      this.width = document.getElementById('backgroundImage').width;
      this.height = document.getElementById('backgroundImage').height;
      this.$store.commit('setShowPageList', false);
      this.$store.commit('setShowAnnotationMenu', false);
      this.$store.commit('setDragIndex', false);
      this.$store.commit('setAssigningIndexes', false);
      this.$bus.emit('hideControls');
    },
    setup: function setup() {
      this.resetData();
      this.getForm();
    },
    resetTabOrders: function resetTabOrders() {
      this.$store.commit('resetTabOrders');
      var prevValue = this.$store.state.assigningIndexes;
      this.$store.commit('setAssigningIndexes', !prevValue);
      this.$store.commit('setAssigningIndexes', prevValue);
      this.$store.dispatch('saveTemplate');
    },
    getForm: function getForm() {
      var that = this;
      var apiUrl = this.$store.state.apiUrl;
      this.axios.get(apiUrl + 'form/' + this.$store.state.currentFormId).then(function (response) {
        var formData = response.data[0];
        that.$store.commit('setCurrentFormId', formData._id);
        that.$store.commit('setOutputPath', that.$store.state.viewerStaticUrl + formData.viewer_url);
      });
    },
    toggleIdDisplay: function toggleIdDisplay(toggle) {
      var highlighted = document.querySelectorAll('.id-highlight');
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(highlighted), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var highlight = _step3.value;

          highlight.classList.remove('id-highlight');
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (!toggle) return;
      var questionnnaireData = this.$store.state.questionnaires[this.$store.state.currentTemplateName].data;

      for (var key in questionnnaireData) {
        if (questionnnaireData.hasOwnProperty(key)) {
          var field = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(questionnnaireData[key]));
          if (field.model.length) continue;
          var targetEl = document.getElementById(field.fieldName);

          // FIELD GROUPS

          if (field.type === 'checkbox-group') {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(field.checkboxes).forEach(function (fieldCh) {
              if (fieldCh.model === '') document.getElementById(fieldCh.id).classList.add('id-highlight');
            });
          }

          if (targetEl === null) continue;
          targetEl.classList.add('id-highlight');
        }
      }
    },
    toggleModelDisplay: function toggleModelDisplay(toggle) {
      var highlighted = document.querySelectorAll('.model-highlight');
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(highlighted), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var highlight = _step4.value;

          highlight.classList.remove('model-highlight');
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      if (!toggle) return;

      var elements = document.querySelectorAll('[data-model]');
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(elements), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var el = _step5.value;

          var model = el.getAttribute('data-model');
          if (!model.length) continue;
          var id = this.$store.getters.templateFieldByModel(model);
          if (id === null) continue;
          var targetEl = document.getElementById(id);
          targetEl.classList.add('model-highlight');
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    setAutcompleteModel: function setAutcompleteModel(payload) {
      if (payload.hide === true || payload.model.length <= 6) {
        this.isAutocompleteModel = false;

        return;
      }

      this.isAutocompleteModel = true;

      this.autocompleteModelData = {};

      this.autocompleteModelData.top = payload.top;
      this.autocompleteModelData.left = payload.left;
      this.autocompleteModel = payload.model;
      this.autocompleteModelData.fieldId = payload.fieldId;
      this.autocompleteModelData.type = payload.type;
      this.autocompleteModelData.page = payload.page;
    },
    saveAutofillDetail: function saveAutofillDetail(payload) {
      var _this2 = this;

      if (this.$store.state.autofillDetails.map(function (a) {
        return a.pdfField;
      }).indexOf(payload.updatePdfField) === -1) {
        this.$store.dispatch('addAutofillDetail', [payload.autofillDetail]).then(function (response) {
          if (response.data.success === true) {
            _this2.fieldsData[_this2.fieldsData.map(function (field) {
              return field.id;
            }).indexOf(payload.elId)].model = payload.modelValue;
            _this2.refreshAutofillDetails(payload);
          }
        });
      } else {
        delete payload.autofillDetail.createdAt;

        this.$store.dispatch('updateAutofillDetail', {
          autofillId: this.$store.state.autofillId,
          newData: payload.autofillDetail
        }).then(function (response) {
          if (response.data.success === true) {
            _this2.fieldsData[_this2.fieldsData.map(function (field) {
              return field.id;
            }).indexOf(payload.elId)].model = payload.modelValue;
            _this2.refreshAutofillDetails(payload);
          }
        });
      }
    },
    refreshAutofillDetails: function refreshAutofillDetails(payload) {
      var _this3 = this;

      this.$store.dispatch('getAutofill', this.$store.state.currentFormId).then(function (response) {
        var autofillId = response.data[0]._id;

        _this3.$store.dispatch('getAutofillDetails', autofillId).then(function () {
          _this3.setFlash(payload);
        });
      });
    },
    setFlash: function setFlash(payload) {
      var _this4 = this;

      this.$bus.emit('addNotification', {
        title: payload.model ? 'Model' : 'Value',
        body: payload.model ? 'Model saved succesfully.' : 'Value saved succesfully.',
        type: 'success'
      });

      this.listOfficialModels = [];

      this.$store.dispatch('getOfficialModel').then(function () {
        _this4.listOfficialModels = _this4.$store.state.officialModels;
      });

      if (payload.model) this.$bus.emit('permitChange');

      var elId = '';

      elId = payload.model ? 'txtFieldModel' : 'txtFieldValue';

      if (document.getElementById(elId) !== null) document.getElementById(elId).classList.add('flashSave');else if (document.getElementById(payload.elId) !== null) document.getElementById(payload.elId).classList.add('flashSave');

      setTimeout(function () {
        if (document.getElementById(elId) !== null) document.getElementById(elId).classList.remove('flashSave');else if (document.getElementById(payload.elId) !== null) document.getElementById(payload.elId).classList.remove('flashSave');
      }, 400);
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('saveAutofillDetail');
    this.$bus.$off('pageChange');
    this.$bus.$off('resetTabOrders');
    this.$bus.$off('historyChange');
    this.$bus.$off('toggleModelDisplay');
    this.$bus.$off('toggleIdDisplay');
    this.$bus.$off('setUp');
    this.$bus.$off('hideEditorFields');
    this.$bus.$off('hidePageFields');
    this.$bus.$off('setAutocompleteModel');
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.2647f8d3402edaf8d0ed.js